export default {
  "666": "666",
  "123123": "",
  "language.name": "Nederlands",
  "system.dataScreen": "Data Dashboard",
  "product.PleaseEnter": "Voer productnaam in",
  "product.PleaseEnterTheProductSerialNumber": "Voer productserienummer in",
  "product.PleaseEnterSubmodelNumber": "Voer submodelnummer in",
  "product.PleaseenterTheSubmodelSerialNumber": "Voer submodel serienummer in",
  "product.PleaseSelectTheDeviceType": "Selecteer apparaattype",
  "product.PleaseSelectDevelopmentType": "Selecteer ontwikkelingstype",
  "product.management": "Productbeheer",
  "product.name": "Productreeks",
  "product.reset": "Resetten",
  "product.search": "Zoeken",
  "product.ApplicationList": "Toepassingslijst",
  "product.newProduct": "Nieuw product",
  "product.editName": "Product bewerken",
  "product.DetailSetting": "Detailinstellingen",
  "product.delete": "Verwijderen",
  "product.serialNumber": "Productserienummer",
  "product.deviceType": "Apparaattype",
  "product.RandDtype": "O&O-type",
  "product.subType": "Subtype",
  "product.subTypeNumber": "Sub-serienummer",
  "product.updateTime": "Bijgewerkt op",
  "product.operation": "Actie",
  "product.shippingMarket": "Verzendmarkt",
  "product.deviceList": "Apparaatlijst (Verzendlogboek)",
  "product.parameterManagement": "Parameterbeheer",
  "product.updataManagement": "Updatebeheer",
  "product.ParentDevice": "Hoofdapparaat",
  "product.AssociatedPowerStationState": "Status gekoppelde energiecentrale",
  "product.ImportDeviceList": "Importeer apparaatlijst",
  "product.PlantDetails": "Energiecentrale details",
  "product.OwningPowerStation": "Eigendom van energiecentrale",
  "product.parameterName": "Parameternaam",
  "product.ParameterClass": "Parametercategorie",
  "product.ParameterSettingType": "Parameterinstellingstype",
  "product.ParameterOperationType": "Parameterbewerkingstype",
  "product.ImportParameter": "Importeer parameter",
  "product.OwningUpperLevelParameterCategory": "Behorende tot bovenliggende parametercategorie",
  "product.WhetherYoSupportBatchRead": "Ondersteunt batchlezen",
  "product.value": "Waarde",
  "product.scope": "Bereik",
  "product.unit": "Eenheid",
  "product.explain": "Uitleg",
  "product.remark": "Opmerking",
  "product.fileName": "Bestandsnaam",
  "product.fileAddress": "Bestandslocatie",
  "product.versionNumber": "Versienummer",
  "product.ProductOfOwnership": "Eigendom van product",
  "product.ProductDetailsSettings": "Balkon 1.0 - Productdetailinstellingen",
  "product.QueryResultList": "Zoekresultatenlijst",
  "product.AddFirmware": "Firmware toevoegen",
  "product.NewParameter": "Nieuwe parameter",
  "product.datalog": "Dataverzamelaar",
  "product.Inverter": "Omvormer",
  "product.storage": "Energieopslag",
  "product.battery": "Batterij",
  "product.socket": "Stopcontact",
  "product.DownloadTemplate": "Download sjabloon",
  "product.nation": "Land",
  "product.agent": "Agent",
  "product.expirationDate": "Garantieperiode",
  "product.UpdateTime": "Bijgewerkt op",
  "product.LastWeek": "Afgelopen week",
  "product.LastMonth": "Afgelopen maand",
  "product.LastThreeMonths": "Afgelopen drie maanden",
  "product.parameterType": "Parametertype",
  "product.ProtocolAddress": "Adres in parameterprotocol",
  "product.stepSize": "Stapgrootte",
  "product.PleaseEnterAParameterName": "Voer parameternaam in",
  "product.parameterCoding": "Parametercodering",
  "product.PleaseEnterTheParameterCode": "Voer parametercode in",
  "product.ParameterDataType": "Parametertype gegevens",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Voer adres in parameterprotocol in",
  "blockEncoding": "Groepscodering",
  "product.PleaseEnterABlockCode": "Voer groepcode in",
  "product.GroupName": "Groepsnaam",
  "product.PleaseEnterAGroupName": "Voer groepsnaam in",
  "product.PleaseEnterTheUnit": "Voer de minimale waarde in",
  "product.decimalPoint": "Decimalen",
  "product.PleaseEnterTheDecimalPoint": "Voer aantal decimalen in",
  "product.leastValue": "Minimale waarde",
  "product.maximumValue": "Maximale waarde",
  "product.PleaseEnterTheMaximumValue": "Voer maximale waarde in",
  "product.PleaseEnterTheStepSize": "Voer stapgrootte in",
  "product.addEquipment": "Apparaat toevoegen",
  "product.equipment": "Apparatuur",
  "product.remove": "Verwijderen",
  "product.sort": "Sorteren",
  "product.PleaseEnterTheOrder": "Voer volgorde in",
  "product.PleaseEnterTheParameterSettingType": "Voer parameterinstellingstype in",
  "product.PleaseSelectAFolderPath": "Selecteer maplocatie",
  "product.ReturnToSuperior": "Terug naar bovenliggende",
  "product.PleaseEnterTheVersionNumber": "Voer versienummer in",
  "product.firmwareSpecification": "Firmwarebeschrijving",
  "product.PleaseEnterFirmwareDescription": "Voer firmwarebeschrijving in",
  "product.FileName": "Bestandsnaam",
  "product.DeviceType": "Apparaattype",
  "product.FileAddress": "Bestandslocatie",
  "product.time": "Servicetijd",
  "sidebar.default": "Navigatiepagina",
  "sidebar.home": "Gegevensoverzicht",
  "sidebar.endbenutzer": "Gebruikersbeheer",
  "sidebar.plant": "Scenario beheer",
  "sidebar.plant_plant": "Energiecentrale beheer",
  "sidebar.device": "Apparaatbeheer",
  "sidebar.datalog": "Dataverzamelaarlijst",
  "sidebar.inverter": "Omvormerlijst",
  "sidebar.sotrage": "Opslaglijst",
  "sidebar.socket": "Stopcontactlijst",
  "sidebar.battery": "Batterijlijst",
  "sidebar.agent": "Agent beheer",
  "sidebar.systematicSupply": "Verzendlogboek",
  "sidebar.firmware": "Firmwalijst",
  "sidebar.firmware_up": "Firmware uploaden",
  "sidebar.firmware_log": "Updategeschiedenis",
  "sidebar.system": "Systeeminstellingen",
  "sidebar.system_datalog_log": "Dataverzamelaar logboek",
  "sidebar.system_log": "Actielogboek",
  "sidebar.system_tongxun": "Communicatielogboek",
  "sidebar.system_app": "App-versie",
  "sidebar.personal": "Gebruikersinformatie",
  "sidebar.logout": "Uitloggen",
  "sidebar.organizationalManagement": "Organisatiebeheer",
  "sidebar.auth_manage": "Rechtenbeheer",
  "login.email": "E-mail",
  "login.password": "Wachtwoord",
  "login.remember": "E-mail en wachtwoord onthouden",
  "login.rememberAccount": "Account en wachtwoord onthouden",
  "login.enteremail": "Voer e-mailadres in",
  "login.enterpassword": "Voer wachtwoord in",
  "login.enterAccount": "Voer e-mail of telefoonnummer in",
  "login.correctAccount": "Voer correct e-mail of telefoonnummer in",
  "login.accountPlaceholder": "Voer e-mail of telefoonnummer in",
  "login.accountNumber": "Account",
  "login.system": "Haier Energy Cloud",
  "login.read": "Lees en accepteer",
  "login.userAgreement": "Gebruikersovereenkomst",
  "login.privacyPolicy": "Privacybeleid",
  "login.temporarilyDisagree": "Tijdelijk niet akkoord",
  "login.agreeAndAccept": "Akkoord en accepteer",
  "login.retrievePassword": "Wachtwoord herstellen",
  "login.verCode": "Verificatiecode",
  "login.newPassword": "Nieuw wachtwoord",
  "login.sendverCode": "Verzend verificatiecode",
  "login.greenLife": "Innovatieve schone energie, bouwen aan een groen leven",
  "login.welcome": "Welkom bij Haier Energy Cloud",
  "login.downloadApp": "App downloaden",
  "login.sure": "Bevestigen",
  "home.echarts1.title": "Geregistreerde gebruikers",
  "home.echarts1.subhead": "Vandaag nieuw/totaal aantal gebruikers",
  "home.echarts2.title": "Ingelogde gebruikers",
  "home.echarts2.subhead": "Vandaag ingelogd/totaal aantal gebruikers",
  "home.echarts3.title": "Agents toegevoegd",
  "home.echarts3.subhead": "Vandaag ingelogd/totaal aantal agents",
  "home.echarts4.title": "Scenario's toegevoegd",
  "home.echarts4.subhead": "Nieuwe scenario's/totaal scenario's",
  "home.echarts4.title_plant": "Energiecentrales toegevoegd",
  "home.echarts4.subhead_plant": "Nieuwe energiecentrales/totaal energiecentrales",
  "home.echarts5.title": "Dataverzamelaars toegevoegd",
  "home.echarts5.subhead": "Nieuwe dataverzamelaars/totaal dataverzamelaars",
  "home.echarts6.title": "Apparaten toegevoegd",
  "home.echarts6.subhead": "Nieuwe apparaten/totaal apparaten",
  "End_user.input_email": "Voer gebruikerse-mail in",
  "End_user.btn_search": "Zoeken",
  "End_user.btn_add": "Toevoegen",
  "End_user.btn_delete": "Verwijderen",
  "End_user.btn_binding": "Koppelen",
  "End_user.add_station": "Scenario toevoegen",
  "End_user.lable_StationName": "Scenarionaam",
  "End_user.lable_StationType": "Scenariotype",
  "End_user.lable_PVCapacity": "Zonnepaneel capaciteit",
  "End_user.lable_InstalltionDate": "Installatiedatum",
  "End_user.lable_Country": "Land",
  "End_user.lable_City": "Stad",
  "End_user.lable_Address": "Adres",
  "End_user.lable_TimeZone": "Tijdzone",
  "End_user.lable_Energyprice": "Energieprijs",
  "End_user.lable_IncomeUnit": "Inkomsteneenheid",
  "End_user.input_StationName": "Voer scenarionaam in",
  "End_user.input_StationType": "Selecteer type",
  "End_user.input_PVCapacity": "Voer batterijcapaciteit in",
  "End_user.input_InstalltionDate": "Selecteer installatiedatum",
  "End_user.input_Country": "Selecteer land",
  "End_user.input_City": "Selecteer stad",
  "End_user.input_Address": "Voer adres in",
  "End_user.input_TimeZone": "Selecteer tijdzone",
  "End_user.input_Energyprice": "Voer prijs in",
  "End_user.input_IncomeUnit": "Selecteer inkomsteneenheid",
  "End_user.max_20": "Maximum 20 tekens",
  "End_user.max_5": "Maximum 5 tekens",
  "End_user.max_8": "Maximum 8 tekens",
  "End_user.format": "Voer correct formaat in",
  "End_user.close": "Sluiten",
  "End_user.submit": "Indienen",
  "End_user.title_delete": "Verwijderen?",
  "End_user.no": "Nee",
  "End_user.yes": "Ja",
  "End_user.Bingding_Agent": "Agent koppelen",
  "End_user.Agent_Code": "Agent:",
  "End_user.please_select": "Selecteer",
  "plant.input_email": "Voer gebruikerse-mail in",
  "plant.search": "Zoeken",
  "plant.edit": "Bewerken",
  "plant.delete": "Verwijderen",
  "plant.edit_plant": "Scenario bewerken",
  "plant.input_station": "Voer scenarionaam in",
  "plant.lable_StationName": "Scenarionaam",
  "plant.lable_StationType": "Scenariotype",
  "plant.lable_PVCapacity": "Zonnepaneel capaciteit",
  "plant.lable_InstalltionDate": "Installatiedatum",
  "plant.lable_Country": "Land",
  "plant.lable_City": "Stad",
  "plant.lable_Address": "Adres",
  "plant.lable_TimeZone": "Tijdzone",
  "plant.lable_Energyprice": "Energieprijs",
  "plant.lable_IncomeUnit": "Inkomsteneenheid",
  "plant.input_StationName": "Voer scenarionaam in",
  "plant.input_StationType": "Selecteer type",
  "plant.input_PVCapacity": "Voer batterijcapaciteit in",
  "plant.input_InstalltionDate": "Selecteer installatiedatum",
  "plant.input_Country": "Selecteer land",
  "plant.input_City": "Selecteer stad",
  "plant.input_Address": "Voer adres in",
  "plant.input_TimeZone": "Selecteer tijdzone",
  "plant.input_Energyprice": "Voer prijs in",
  "plant.input_IncomeUnit": "Selecteer inkomsteneenheid",
  "plant.max_20": "Maximum 20 tekens",
  "plant.max_5": "Maximum 5 tekens",
  "plant.max_8": "Maximum 8 tekens",
  "plant.format": "Voer correct formaat in",
  "plant.close": "Sluiten",
  "plant.submit": "Indienen",
  "plant.title_delete": "Verwijderen?",
  "plant.no": "Nee",
  "plant.yes": "Ja",
  "plant.plantName": "Naam energiecentrale",
  "plant.country": "Land/Regio",
  "plant.installer": "Installateur",
  "plant.installPerson": "Monteur",
  "plant.InstallationPlan": "Installatieplan",
  "plant.owner": "Eigenaar",
  "plant.photovoltaicCapacity": "PV capaciteit (kWh)",
  "plant.batteryCapacity": "Batterij capaciteit (kWh)",
  "plant.electricityConsumptionToday": "Huidige dag verbruik",
  "plant.electricityConsumptionMonth": "Huidige maand verbruik",
  "plant.electricityConsumptionTotal": "Totaal verbruik",
  "plant.runningState": "Bedrijfstoestand",
  "plant.buildState": "Bouwstatus",
  "plant.plantNum": "Aantal energiecentrales",
  "plant.totalPlantNum": "Totaal",
  "plant.building": "In aanbouw",
  "plant.delivered": "Geleverd",
  "plant.electricEnergy": "Gegenereerde energie",
  "plant.today": "Vandaag",
  "plant.month": "Deze maand",
  "plant.year": "Dit jaar",
  "plant.total": "Totaal",
  "plant.deleteSuccess": "Energiecentrale succesvol verwijderd",
  "plant.powerGeneration": "Energieopwekking",
  "plant.powerConsumption": "Energieverbruik",
  "plant.spontaneousSelfUse": "Zelfgebruik",
  "plant.selfSufficient": "Zelfvoorzienend",
  "plant.photovoltaicPowerGeneration": "PV vermogen",
  "plant.electricPowerConsumption": "Verbruiksvermogen",
  "plant.spontaneousSelfUsePower": "Zelfgebruiksvermogen",
  "plant.buyPowers": "Inkoopvermogen",
  "plant.sellPowers": "Verkoopvermogen",
  "plant.selfSufficientPower": "Zelfvoorzienend vermogen",
  "plant.batterySOC": "Batterij SOC",
  "plant.storageChargingPower": "Opslag laadvermogen",
  "plant.storageDischargePower": "Opslag ontlaadvermogen",
  "plant.life": "Levensduur",
  "plant.operatingData": "Bedrijfsgegevens",
  "plant.dataReportingTime": "Gegevens rapportagetijd",
  "plant.plantOverview": "Overzicht energiecentrale",
  "plant.deviceList": "Apparaatlijst",
  "plant.energyBalance": "Energiebalans (kWh)",
  "plant.onGridEnergy": "Netto energie",
  "plant.purchaseElectricity": "Gekochte energie",
  "plant.statisticalAnalysis": "Statistische analyse",
  "plant.energyAnalysis": "Energieanalyse",
  "plant.powerAnalysis": "Vermogensanalyse",
  "plant.updateTime": "Bijgewerkt op",
  "plant.stationInfo": "Informatie energiecentrale",
  "plant.userInfo": "Gebruikersinformatie",
  "plant.socialContribution": "Maatschappelijke bijdrage",
  "plant.equivalentIncome": "Equivalente inkomsten",
  "plant.priceSet": "Prijsinstellingen",
  "plant.co2emissionReduction": "CO2-reductie",
  "plant.plantPowerGeneration": "Cumulatieve stroomopwekking van de installatie",
  "plant.equivalentTreePlanting": "Equivalente bomen",
  "plant.saveStandardCoal": "Bespaarde standaard steenkool",
  "plant.photovoltaicPowerGenerations": "PV opwekking",
  "plant.weather": "Weer",
  "plant.sunriseSunset": "Zonsopkomst en -ondergang",
  "plant.temperature": "Temperatuur",
  "plant.humidity": "Luchtvochtigheid",
  "plant.windSpeed": "Windsnelheid",
  "plant.windDirection": "Windrichting",
  "plant.primaryUser": "Primaire gebruiker",
  "plant.receiveMode": "Ontvangmodus",
  "plant.dateOfReceipt": "Ontvangstdatum",
  "plant.familyName": "Gezinsnaam",
  "plant.familyMembers": "Aantal gezinsleden",
  "plant.currency": "Valuta",
  "plant.purchasePrice": "Inkoopprijs",
  "plant.sellingPrice": "Verkoopprijs",
  "plant.noUserInfo": "Nog niet aan gebruiker geleverd",
  "plant.noIncomeTip": "Voor een betere berekening van uw equivalente inkomsten, voer de inkoop- en verkoopprijs per kWh in",
  "plant.pleaseSelectDate": "Selecteer datum",
  "datalog.email": "Voer e-mailadres in",
  "datalog.datalogSn": "Voer serienummer dataverzamelaar in",
  "datalog.search": "Zoeken",
  "datalog.Version": "Versienummer",
  "datalog.setting": "Instellingen",
  "datalog.upgrade": "Upgraden",
  "datalog.delete": "Verwijderen",
  "datalog.title_datalog": "Dataverzamelaar instellingen",
  "datalog.span_info": "Informatie",
  "datalog.span_datalog": "Serienummer dataverzamelaar:",
  "datalog.span_name": "Alias:",
  "datalog.span_time": "Bijgewerkt op:",
  "datalog.span_firmware": "Signaal/firmwareversie:",
  "datalog.span_order": "Commando",
  "datalog.span_settingdns": "Domeinnaam instellen",
  "datalog.span_inputsetting": "Voer domeinnaam in",
  "datalog.span_upgrade": "Dataverzamelaar upgraden",
  "datalog.span_reset": "Dataverzamelaar herstarten",
  "datalog.span_setup": "Geavanceerde instellingen",
  "datalog.span_param": "Parameter",
  "datalog.span_value": "Waarde",
  "datalog.btn_setup": "Geavanceerde instellingen",
  "datalog.btn_setting": "Instellen",
  "datalog.btn_settingdns": "Domeinnaam instellen",
  "datalog.btn_upgrade": "Upgraden",
  "datalog.btn_reset": "Herstarten",
  "datalog.btn_read": "Lezen",
  "datalog.btn_close": "Annuleren",
  "datalog.methods_version": "Controleer op versie-update?",
  "datalog.no": "Nee",
  "datalog.yes": "Ja",
  "datalog.methods_delete": "Verwijderen?",
  "datalog.methods_rereset": "Herstarten?",
  "datalog.methodes_inputDns": "Voer domeinnaam in",
  "datalog.methodes_DNS": "Domeinnaam instellen?",
  "sotrage.select": "Selecteer",
  "sotrage.email": "Voer e-mailadres in",
  "sotrage.datalogSn": "Voer serienummer dataverzamelaar in",
  "sotrage.deviceSn": "Voer apparaat serienummer in",
  "sotrage.search": "Zoeken",
  "sotrage.sotrage": "Opslaginstellingen",
  "device.select": "Selecteer",
  "device.email": "Voer e-mailadres in",
  "device.datalogSn": "Voer serienummer dataverzamelaar in",
  "device.deviceSn": "Voer apparaat serienummer in",
  "device.search": "Zoeken",
  "device.title": "Omvormer instellingen",
  "device.setting": "Instellen",
  "device.setting_inverte": "Omvormer parameters instellen",
  "device.input_start_address": "Beginregisteradres",
  "device.input_ent_address": "Eindregisteradres",
  "device.input_setting_value": "Voer instellingswaarde in",
  "device.read_data": "Registergegevens lezen:",
  "device.input_start_read": "Beginregisteradres",
  "device.input_end_read": "Eindregisteradres",
  "device.btn_address": "Adres instellen",
  "device.btn_value": "Parameters instellen",
  "device.btn_read": "Lezen",
  "device.btn_close": "Terug",
  "device.selet_data": "Selecteer datum",
  "device.workMode": "Werkmodus",
  "device.alarmInfo": "Alarm informatie",
  "device.countryStandard": "Nationale standaard",
  "device.runningStatus": "Status",
  "device.inverterTemp": "Omvormer temperatuur",
  "device.dcdcTemp": "DC/DC temperatuur",
  "device.mpptTemp": "MPPT temperatuur",
  "device.drmStatus": "DRM status",
  "device.version": "Versie",
  "device.communicationEquipment": "Communicatieapparatuur",
  "device.basicInfo": "Basisinformatie",
  "device.productName": "Productnaam",
  "device.productType": "Producttype",
  "device.productModel": "Productmodel",
  "device.softVersion": "Softwareversie",
  "device.softUpdateTime": "Software bijgewerkt op",
  "device.plant": "Energiecentrale",
  "device.installer": "Installateur",
  "device.installPerson": "Monteur",
  "device.deviceRegisterDate": "Apparaat registratiedatum",
  "device.ownerEmail": "Eigenaar e-mail",
  "device.ownerReceiveTime": "Eigenaar ontvangsttijd",
  "device.ownerFamily": "Eigenaar familie",
  "device.versionInfo": "Versieinformatie",
  "device.searchSn": "Voer serienummer om te zoeken",
  "device.user": "Gebruiker",
  "device.userReceiveDate": "Gebruiker ontvangstdatum",
  "device.yuan": "Bron: PV",
  "device.totalPower": "Totaal vermogen",
  "device.todayPowerGeneration": "Vandaag gegenereerde energie",
  "device.dataGateway": "Datagateway",
  "device.optimizer": "Optimalisator",
  "device.chu": "Opslag: Batterij",
  "device.power": "Vermogen",
  "device.todayChargingCapacity": "Vandaag laadcapaciteit",
  "device.todayDischargingCapacity": "Vandaag ontlaadcapaciteit",
  "device.he": "Last: Verbruik",
  "device.todayElectricityConsumption": "Vandaag verbruik",
  "device.totalElectricityConsumption": "Totaal verbruik",
  "device.wang": "Net: Netwerkzijde",
  "device.totalFrequency": "Totale frequentie",
  "device.buyPowers": "Inkopen",
  "device.sellPowers": "Verkopen",
  "device.more": "Meer",
  "device.readWrite": "Direct lees/schrijf gereedschap",
  "device.chargeAndDisChargeSetting": "Laad- en ontlaadinstellingen",
  "device.mutipleSave": "Batch verzenden",
  "device.mutipleRead": "Batch lezen",
  "device.deviceSnisExist": "Controleer of apparaat-serienummer bestaat",
  "device.saveSuccess": "De parameteropdracht is verzonden. Vernieuw de pagina of klik op de knop [Lezen] om te bevestigen of de parameters van kracht zijn.",
  "device.saveFail": "Parameters verzenden mislukt",
  "device.getParamsSuccess": "Parameters succesvol opgehaald",
  "device.getParamsFail": "Parameters ophalen mislukt",
  "device.operationalDataAnalysis": "Bedrijfsgegevensanalyse",
  "device.pleaseSelect": "Selecteer gegevensitem aan de linkerkant",
  "device.maxFour": "Niet meer dan 4 eenheden",
  "device.maxFourOrTwenty": "Niet meer dan 4 en 20 opties zijn",
  "device.protocolDirectives": "Protocol instructies",
  "device.dateRangeError": "Datumbereik moet binnen 3 dagen zijn",
  "device.noDeviceDetail": "Geen apparaatdetails beschikbaar",
  "device.address": "Registeradres",
  "device.faultClearing": "Fouten wissen",
  "device.operationMonitoring": "Bedrijfsmonitoring",
  "device.parameterControl": "Parameter controle",
  "device.Fault&Alarm": "Fouten & Alarmen",
  "device.dynamicPriceTip": "Huishoudelijke eigenaar heeft AI-modus ingeschakeld, deze parameter kan niet handmatig worden gewijzigd.",
  "device.chargeSetting": "Laadinstellingen",
  "device.dischargeSetting": "Ontlaadinstellingen",
  "battery.select": "Selecteer",
  "battery.email": "Voer e-mailadres in",
  "battery.datalogSn": "Voer serienummer dataverzamelaar in",
  "battery.deviceSn": "Voer apparaat serienummer in",
  "battery.search": "Zoeken",
  "socket.title": "Stopcontact instellingen",
  "socket.setting": "Instellen",
  "socket.span": "Meerdere registeradressen ingesteld, waarden moeten ook meerdere zijn. Waarden scheiden met , bijvoorbeeld (1,2,3)",
  "socket.setting_device": "Omvormer parameters instellen:",
  "socket.startaddress": "Beginregisteradres",
  "socket.stopaddress": "Eindregisteradres",
  "socket.value": "Voer waarde in",
  "socket.readdata": "Registergegevens lezen:",
  "socket.setting_address": "Adres instellen",
  "socket.setting_value": "Parameter instellen",
  "socket.read": "Lezen",
  "socket.return": "Terug",
  "agent.close": "Annuleren",
  "agent.submit": "Indienen",
  "agent.input_email": "Voer e-mailadres in",
  "agent.search": "Zoeken",
  "agent.add_agent": "Agent toevoegen",
  "agent.import_device": "Apparaten importeren",
  "agent.edit": "Bewerken",
  "agent.title": "Agent toevoegen",
  "agent.email": "E-mail",
  "agent.password": "Wachtwoord",
  "agent.phone": "Telefoonnummer",
  "agent.company": "Bedrijf",
  "agent.language": "Taal",
  "agent.address": "Adres",
  "agent.input_password": "Voer wachtwoord in",
  "agent.input_phone": "Voer telefoonnummer in",
  "agent.input_company": "Selecteer bedrijf",
  "agent.input_language": "Voer taal in",
  "agent.input_address": "Voer adres in",
  "agent.relus_email": "Voer geldig e-mailadres in",
  "agent.title_edit": "Agent bewerken",
  "agent.title_device": "Uploaden",
  "agent.span": "Voorbeeld: Excel tabel",
  "agent.btn_upload": "Uploaden",
  "agent.delete": "Verwijderen",
  "agent.agent_delete": "Agent verwijderen?",
  "ship.starttime": "Begintijd",
  "ship.endtime": "Eindtijd",
  "ship.deviceSn": "Voer apparaat serienummer in",
  "ship.select": "Selecteer bedrijf",
  "ship.search": "Zoeken",
  "Firmware.file_name": "Voer bestandsnaam in",
  "Firmware.search": "Zoeken",
  "Firmware.add": "Toevoegen",
  "Firmware.delete": "Verwijderen",
  "Firmware.title": "Firmware uploaden",
  "Firmware.select_folder": "Selecteer map:",
  "Firmware.select_folder_type": "Selecteer maptype",
  "Firmware.craete_folder": "Nieuwe map maken",
  "Firmware.folder_path": "Maplocatie:",
  "Firmware.folder_name": "Bestandsnaam:",
  "Firmware.input_folder_name": "Voer bestandsnaam in",
  "Firmware.create": "Map maken",
  "Firmware.listed_files": "Bestandslijst:",
  "Firmware.import_folder": "Bestand importeren",
  "Firmware.uplad_folder": "Bestand uploaden",
  "Firmware.close": "Terug",
  "Upgrade.starttime": "Begintijd",
  "Upgrade.endtime": "Eindtijd",
  "Upgrade.deviceSn": "Voer apparaat serienummer in",
  "Upgrade.type": "Selecteer type",
  "Upgrade.search": "Zoeken",
  "Upgrade.datalog": "Dataverzamelaar",
  "Upgrade.Inverter": "Omvormer",
  "Upgrade.Control": "Controller",
  "datalogs_logs.starttime": "Begintijd",
  "datalogs_logs.endtime": "Eindtijd",
  "datalogs_logs.deviceSn": "Voer apparaat serienummer in",
  "datalogs_logs.Version": "Voer versie in",
  "datalogs_logs.search": "Zoeken",
  "Logs.starttime": "Begintijd",
  "Logs.endtime": "Eindtijd",
  "Logs.deviceSn": "Voer apparaat serienummer in",
  "Logs.type": "Selecteer type",
  "Logs.search": "Zoeken",
  "Special.starttime": "Begintijd",
  "Special.endtime": "Eindtijd",
  "Special.deviceSn": "Voer apparaat serienummer in",
  "Special.datalogSn": "Voer serienummer dataverzamelaar in",
  "Special.type": "Selecteer type",
  "Special.search": "Zoeken",
  "Special.save": "Opslaan",
  "Special.Examples": "Voorbeeld: (2305210230,2305210139)",
  "App.System_Config": "Systeemconfiguratie",
  "App.APP_Version": "App-versie publicatie",
  "App.Android_Version": "Android versie:",
  "App.IOS_Version": "IOS versie:",
  "App.APP_Type": "App-type:",
  "App.New_Version": "Nieuwe versie",
  "App.update_content": "Beschrijving update inhoud: (gebruik '/n' om te scheiden)",
  "App.Whether_update": "Verplichte update:",
  "App.no": "Nee",
  "App.yes": "Ja",
  "App.submit": "Indienen",
  "Tips.app_submit": "Informatie wijzigen bevestigen?",
  "Tips.firmware_delete": "Verwijderen bevestigen?",
  "Tips.firmware_deleteCDN": "Bestand in CDN verwijderen?",
  "Tips.yes": "Ja",
  "Tips.no": "Nee",
  "global.DataDetails": "Gegevensdetails",
  "global.device": "Omvormer instellingen",
  "global.device_data": "Omvormer parameters instellen:",
  "global.storage": "Opslag instellingen",
  "global.storage_data": "Opslag parameters instellen",
  "global.battery": "Batterij instellingen",
  "global.battery_data": "Batterij parameters instellen",
  "global.socket": "Stopcontact instellingen",
  "global.socket_data": "Stopcontact parameters instellen",
  "btn.setting_address": "Adres instellen",
  "btn.close": "Terug",
  "btn.submit": "Indienen",
  "btn.Setting_parameters": "Parameters instellen",
  "btn.Reading": "Lezen",
  "btn.search": "Zoeken",
  "btn.add": "Toevoegen",
  "btn.import": "Importeren",
  "btn.download": "Voorbeeld downloaden",
  "btn.edit": "Bewerken",
  "btn.login": "Inloggen",
  "btn.export": "Exporteren",
  "form.addShip": "Verzendapparaat toevoegen",
  "form.editShip": "Verzendapparaat bewerken",
  "form.import": "Apparaatinformatie importeren",
  "form.shipSN": "Verzend serienummer",
  "form.agent": "Agent",
  "form.networkCall": "Netwerkcallback uitvoeren",
  "form.warrantyPeriod": "Garantieperiode",
  "form.shiptime": "Verzendtijd",
  "form.shiptype": "Verzendtype",
  "form.classify": "Categorie",
  "form.file": "Sleep bestand hierheen of klik om te uploaden",
  "form.edit_plant": "Scenario bewerken",
  "form.input_station": "Voer scenarionaam in",
  "form.lable_StationName": "Scenarionaam",
  "form.lable_StationType": "Scenariotype",
  "form.input_StationName": "Voer scenarionaam in",
  "form.edit_plant_plant": "Energiecentrale bewerken",
  "form.input_station_plant": "Voer naam energiecentrale in",
  "form.lable_StationName_plant": "Naam energiecentrale",
  "form.lable_StationType_plant": "Type energiecentrale",
  "form.input_StationName_plant": "Voer de naam van het energiepark in",
  "placeholder.select": "Selecteer",
  "placeholder.choiceCountry": "Selecteer land",
  "placeholder.choiceTimezone": "Selecteer tijdzone",
  "placeholder.enterEmail": "Voer e-mailadres in",
  "placeholder.enterPhone": "Voer telefoonnummer in",
  "placeholder.verificationCode": "Voer verificatiecode in",
  "placeholder.enterPassword": "Voer wachtwoord in (6-20 tekens)",
  "placeholder.confirmPassword": "Bevestig wachtwoord",
  "placeholder.readAndAgree": "Ik heb het gelezen en ga akkoord",
  "placeholder.search": "Zoeken",
  "placeholder.searchPlantName": "Zoek op energieparknaam",
  "placeholder.searchDeviceName": "Zoek op apparaatnaam",
  "placeholder.searchDataloggerName": "Zoek op datalogger-naam",
  "placeholder.enterPlantName": "Voer energieparknaam in",
  "placeholder.enterPlantType": "Voer energieparktype in",
  "placeholder.enterPVCapacity": "Voer PV-capaciteit in",
  "placeholder.choiceInstallationDate": "Selecteer installatiedatum",
  "placeholder.enterPlantAddress": "Voer energieparkadres in",
  "placeholder.enterOldPassword": "Voer oud wachtwoord in",
  "placeholder.enterNewPassword": "Voer nieuw wachtwoord in",
  "placeholder.enterConfirmPassword": "Bevestig nieuw wachtwoord",
  "placeholder.enter": "Voer {scope} in",
  "placeholder.input": "Voer in",
  "placeholder.country": "Land",
  "placeholder.city": "Stad",
  "placeholder.scanCodeAddPlant": "Scan de code om energiepark toe te voegen!",
  "placeholder.currentNoPlant": "Geen energiepark aanwezig, klik om toe te voegen!",
  "placeholder.selectRepeatTime": "Selecteer herhalingsperiode",
  "placeholder.enterDatalogger": "Voer datalogger-serienummer in",
  "placeholder.enterDeviceSN": "Voer apparaat-serienummer in",
  "placeholder.startTime": "Starttijd",
  "placeholder.endTime": "Eindtijd",
  "placeholder.startDate": "Startdatum",
  "placeholder.endDate": "Einddatum",
  "setting.general.needGreat": "Moet groter zijn dan",
  "setting.general.needSmall": "Moet kleiner zijn dan",
  "setting.general.gapScope": "Interval van invoerparameter is",
  "setting.general.valScope": "Bereik van invoerparameter is",
  "setting.socket.switchStatus": "Schakelaar status",
  "setting.socket.repetition": "Herhalingsperiode",
  "setting.socket.enableOrNot": "Inschakelen of niet",
  "setting.socket.monday": "Maandag",
  "setting.socket.tuesday": "Dinsdag",
  "setting.socket.wednesday": "Woensdag",
  "setting.socket.thursday": "Donderdag",
  "setting.socket.friday": "Vrijdag",
  "setting.socket.saturday": "Zaterdag",
  "setting.socket.sunday": "Zondag",
  "setting.type3.dischargeScheduleMode": "Geschedulede ontladingsmodus",
  "setting.type3.timeDischarge": "Tijdgebaseerde ontlading",
  "setting.type3.workingDay": "Werkdagen",
  "setting.type3.weekend": "Weekend",
  "setting.type3.pureLightControlMode": "Zuivere lichtgestuurde modus",
  "setting.type3.stopDischarge": "SOC ondergrens voor stoppen ontladen",
  "setting.type3.chargeTransferDischarge": "SOC overschakeling naar ontlading bij volledige lading",
  "setting.type3.batterySOCSetting": "Batterij SOC instellingen",
  "setting.type3.lowBatteryAlam": "Batterij SOC ondergrens alarmwaarde",
  "setting.type3.lowBatteryShutdown": "Batterij SOC ondergrens uitschakelwaarde",
  "setting.type3.systemSetting": "Systeeminstellingen",
  "setting.type3.systemWorkMode": "Systeemwerkmodus",
  "setting.type3.restoreFactory": "Herstel fabrieksinstellingen",
  "setting.type3.loadMode": "Belastingsmodus",
  "setting.type3.timingDischarge": "Tijdgebaseerde ontladingsmodus",
  "setting.type3.DCOutputNormallyClosed": "DC-uitgang normaal gesloten modus",
  "setting.type3.DCOutputNormallyOpen": "DC-uitgang normaal geopend modus",
  "setting.type3.ForcedPowerProtection": "Geforceerde stroombeveiligingsmodus",
  "setting.type3.mode": "Modus",
  "setting.type3.startTime": "Starttijd",
  "setting.type3.stopTime": "Stoptijd",
  "setting.type3.onlyAddThree": "Maximaal 21 timers toevoegen",
  "setting.type3.startCompareEnd": "Starttijd van timer moet vroeger zijn dan eindtijd",
  "setting.type3.confirmClose": "Weet u zeker dat u wilt afsluiten?",
  "setting.type6.countryCode": "Landcode",
  "setting.type6.poweradjppm": "Vermogenaanpassingspercentage omvormer",
  "setting.type6.enaINVTR": "Externe in/uitschakeling",
  "setting.type6.enaSysProtIF_selfCheck": "Zelftest systeembeveiligingsinterface",
  "setting.type6.enaRestoretodefault": "Herstel standaardwaarden",
  "setting.type6.UV_resopnseTime": "{num}-niveau onder spanning reactietijd",
  "setting.type6.UF_resopnseTime": "{num}-niveau onder frequentie reactietijd",
  "setting.type6.OV_resopnseTime": "{num}-niveau boven spanning reactietijd",
  "setting.type6.OF_resopnseTime": "{num}-niveau boven frequentie reactietijd",
  "setting.type6.open": "Inschakelen",
  "setting.type6.recover": "Herstellen",
  "setting.type6.noHave": "Geen",
  "setting.type6.activePowerSwitch": "Actief vermogen schakelaar",
  "setting.type6.activePowerPermillage": "Actief vermogen per mille",
  "setting.type7.paramterSetting": "Parameter instellingen",
  "setting.type7.batteryVoltage": "Batterij spanning",
  "setting.type7.batteryCapacity": "Batterij capaciteit",
  "setting.type7.PVChargingCurrent": "PV-laadstroom",
  "setting.type7.overVoltage": "Overspanning",
  "setting.type7.chargingLimitVoltage": "Laadbeperkings spanning",
  "setting.type7.increaseChargeReturnVoltage": "Verhoog laadterugkeer spanning",
  "setting.type7.overDischargeVoltage": "Overontlaad spanning",
  "setting.type7.stopchangeCurrent": "Stop laadstroom",
  "setting.type7.inverter485Address": "485-adres",
  "setting.type7.passwordValue": "Gebruikerswachtwoord",
  "setting.type7.inputPassword": "Wachtwoord invoer",
  "setting.type7.recordFaultCodes": "Registreer foutcodes",
  "setting.type7.isOpen": "In/uitschakelcontrole",
  "setting.type7.equalizingChargeCmd": "Direct equaliseren starten",
  "setting.type7.reset": "Reset controle",
  "setting.type7.factory": "Herstel fabrieksinstellingen",
  "setting.type7.clearAlarm": "Wis huidige alarm",
  "setting.type7.clearHistory": "Wis geschiedenis",
  "setting.type7.generatorSwitchCmd": "Generator omschakeling",
  "setting.type7.nowTimeStr": "Huidige tijd",
  "setting.type7.setVal.reset": "Reset",
  "setting.type7.setVal.recover": "Herstel",
  "setting.type7.setVal.clearAlarm": "Wis alarm",
  "setting.type7.setVal.clearHistory": "Wis geschiedenis",
  "setting.type7.setVal.toggle": "Omschakelen",
  "setting.type8.systemSwitch": "Systeem schakelaar",
  "setting.type10.modeSelect": "Modus",
  "setting.type10.standbyMode": "Reservestroom modus",
  "setting.type10.PureOffGrid": "Zuivere off-grid opstartmodus",
  "setting.type10.energyNet": "Netkoppeling instellingen",
  "setting.type10.inverter0": "Omvormer levert stroom aan lokale belasting",
  "setting.type10.inverter1": "Omvormer levert stroom aan net",
  "setting.type10.inverter2": "Omvormer voor lokale belasting met CT",
  "setting.type10.inverter3": "Omvormer voor lokale belasting of slimme stopcontacten/slimme meter",
  "setting.type10.chargePriority": "Laadprioriteit",
  "setting.type10.PVPriority": "Zonnepanelen prioriteit",
  "setting.type10.utilityPriority": "Netstroom prioriteit",
  "setting.type10.hybridModel": "Hybride laden",
  "setting.type10.PVOnly": "Alleen zonnepanelen laden",
  "setting.type10.batteryLowAlarm": "Batterij laag alarm punt",
  "setting.type10.batteryLowShutdown": "Batterij laag uitschakel punt",
  "setting.type10.batteryFull": "Batterij vol uitschakel punt",
  "setting.type10.ACCharging": "Laadtijd",
  "setting.type10.startTime": "Starttijd",
  "setting.type10.endTime": "Eindtijd",
  "setting.type10.forcedDischarge": "Ontlaadtijd",
  "setting.type10.phaseGridSide": "Netzijde",
  "setting.type10.power": "Fase actief vermogen",
  "setting.type10.current": "Fase stroom",
  "setting.type10.gridConnectionStandard": "Netkoppelingsstandaard",
  "setting.type10.baudRate": "485 baudsnelheid",
  "setting.type10.disable": "Uitschakelen",
  "setting.type10.enable": "Inschakelen",
  "setting.type10.ApprovalStandards": "Certificeringsnormen",
  "setting.type10.antiRefluxPower": "Anti-terugstroom vermogen",
  "setting.type10.antiRefluxSet": "Anti-terugstroom inschakelen",
  "setting.type10.batFullSocSet": "Batterij vol SOC waarde (%)",
  "setting.type10.auxSourceSet": "Hulpbron schakelaar",
  "setting.type10.timeSharingGridConnectedDischarge": "Tijdsafhankelijke netkoppeling ontlading",
  "setting.type10.timeSharingGridConnection": "Tijdsafhankelijke netkoppeling instellingen",
  "setting.type10.outputPower": "Uitgangsvermogen",
  "setting.type10.onlyAddThree": "Maximaal {num} timers toevoegen",
  "setting.type10.productModelNumber": "Productmodel",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Schakel eerst de PCS-schakelaar in",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "Tijdsconflict tussen laden en ontladen",
  "setting.type10.ChargeDischargeTimeSetting": "Instellingen laad- & ontlaadtijd",
  "setting.type11.switchPCS": "In/uitschakelcontrole",
  "setting.type11.functionSwitch": "Functieschakelaar",
  "setting.type11.maxChargeVol": "Maximale laadspanning (V)",
  "setting.type11.onGridMinDischargeVol": "Netkoppeling minimale ontladingspanning (V)",
  "setting.type11.offGridOutputVol": "Off-grid uitgangsspanning (V)",
  "setting.type11.maxChargeCur": "Maximaal laadvermogen",
  "setting.type11.onGridMaxDischargeCur": "Netkoppeling maximale ontlaadstroom (A)",
  "setting.type11.offGridMaxDisChargeCur": "Off-grid maximale ontlaadstroom (A)",
  "setting.type11.minSocBMS": "BMS minimale SOC (%)",
  "setting.type11.minSocDischarge": "Slimme ontlading minimale SOC (%)",
  "setting.type11.maxSocDischarge": "Slimme ontlading maximale SOC (%)",
  "setting.type11.timeStr": "Apparaattijd",
  "setting.type11.timerSetting": "Timer instelling {num}",
  "setting.type11.chargeStartTime1": "Start laadtijd 1",
  "setting.type11.chargeLongTime1": "Laa-duur 1",
  "setting.type11.chargeTimeMaxSOC1": "Laadperiode 1 maximale SOC (%)",
  "setting.type11.chargeTimeCurrent1": "Laadperiode 1 laadstroom (A)",
  "setting.type11.dischargeStartTime1": "Start ontlaadtijd 1",
  "setting.type11.dischargeLongTime1": "Ontlaad-duur 1",
  "setting.type11.dischargeTimeMaxSOC1": "Ontlaadperiode 1 minimale SOC (%)",
  "setting.type11.dischargeTimeCurrent1": "Ontlaadperiode 1 ontlaadstroom (A)",
  "setting.type11.chargeStartTime2": "Start laadtijd 2",
  "setting.type11.chargeLongTime2": "Laa-duur 2",
  "setting.type11.chargeTimeMaxSOC2": "Laadperiode 2 maximale SOC (%)",
  "setting.type11.chargeTimeCurrent2": "Laadperiode 2 laadstroom (A)",
  "setting.type11.dischargeStartTime2": "Start ontlaadtijd 2",
  "setting.type11.dischargeLongTime2": "Ontlaad-duur 2",
  "setting.type11.dischargeTimeMaxSOC2": "Ontlaadperiode 2 minimale SOC (%)",
  "setting.type11.dischargeTimeCurrent2": "Ontlaadperiode 2 ontlaadstroom (A)",
  "setting.type11.chargeStartTime3": "Start laadtijd 3",
  "setting.type11.chargeLongTime3": "Laa-duur 3",
  "setting.type11.chargeTimeMaxSOC3": "Laadperiode 3 maximale SOC (%)",
  "setting.type11.chargeTimeCurrent3": "Laadperiode 3 laadstroom (A)",
  "setting.type11.dischargeStartTime3": "Start ontlaadtijd 3",
  "setting.type11.dischargeLongTime3": "Ontlaad-duur 3",
  "setting.type11.dischargeTimeMaxSOC3": "Ontlaadperiode 3 minimale SOC (%)",
  "setting.type11.dischargeTimeCurrent3": "Ontlaadperiode 3 ontlaadstroom (A)",
  "setting.type11.chargeStartTime4": "Start laadtijd 4",
  "setting.type11.chargeLongTime4": "Laa-duur 4",
  "setting.type11.chargeTimeMaxSOC4": "Laadperiode 4 maximale SOC (%)",
  "setting.type11.chargeTimeCurrent4": "Laadperiode 4 laadstroom (A)",
  "setting.type11.dischargeStartTime4": "Start ontlaadtijd 4",
  "setting.type11.dischargeLongTime4": "Ontlaad-duur 4",
  "setting.type11.dischargeTimeMaxSOC4": "Ontlaadperiode 4 minimale SOC (%)",
  "setting.type11.dischargeTimeCurrent4": "Ontlaadperiode 4 ontlaadstroom (A)",
  "setting.type11.functionSwitchObj.val1": "Slimme modus",
  "setting.type11.functionSwitchObj.val2": "Timer modus",
  "setting.type11.functionSwitchObj.val3": "Zelfconsumptie modus",
  "setting.type12.LEDSwitch": "LED schakelaar",
  "setting.type12.LEDSpeed": "LED snelheid",
  "setting.type12.LEDEffect": "LED effect",
  "setting.type12.LEDBrightness": "LED helderheid",
  "setting.type12.dataColor": "Gegevens kleurweergave",
  "setting.type12.LED1Color": "LED1 kleur",
  "setting.type12.LED2Color": "LED2 kleur",
  "setting.type12.LED3Color": "LED3 kleur",
  "setting.type12.buzzerAlarm": "Zoemer alarm",
  "setting.type12.overLoadToBypass": "Overbelasting naar bypass",
  "setting.type12.lcdRestartPage": "LCD herstel hoofdscherm na inactiviteit",
  "setting.type12.overloadReset": "Overbelasting herstart",
  "setting.type12.overloadTemperature": "Oververhitting herstart",
  "setting.type12.backLightOn": "LCD achtergrondverlichting bij inactiviteit",
  "setting.type12.inputSourceChangeAlarm": "Waarschuwing bij verandering invoerbron",
  "setting.type12.faultCodeRecord": "Communicatie software foutregistratie",
  "setting.type12.solarFeedToGird": "Zonne-energie injectie bij overschot",
  "setting.type12.switchOptions": "Schakelopties",
  "setting.type12.batteryParam": "Batterij parameters",
  "setting.type12.outputParam": "Uitgangsparameters",
  "setting.type12.ratedOutputVol": "Gespecificeerde uitgangsspanning",
  "setting.type12.ratedOutputFreq": "Gespecificeerde uitgangsfrequentie",
  "setting.type12.inputVolRange": "Invoerspanningsbereik",
  "setting.type12.outPutSourcePriority": "Uitgangsbron prioriteit",
  "setting.type12.batType": "Batterijtype",
  "setting.type12.batUnderVol": "Batterij cutoff spanning",
  "setting.type12.batBulkVol": "Batterij bulklaad spanning",
  "setting.type12.batFloatVol": "Batterij zweeflaad spanning",
  "setting.type12.maxChargingCur": "Maximale laadstroom",
  "setting.type12.maxAcChargingCur": "Maximale AC-laadstroom",
  "setting.type12.chargeSourcePriority": "Lader bron prioriteit",
  "setting.type12.batReChargeVol": "Herlaad spanning",
  "setting.type12.batFullRestoreDischargeVol": "Terug naar ontladen spanning",
  "setting.type12.solarSupplyPriority": "Zonne-energie leveringsprioriteit",
  "setting.type12.resetPvStorage": "Reset PV-statistieken",
  "setting.type12.countryRegulations": "Nationale voorschriften",
  "setting.type12.acChargeStartTime": "AC-lader starttijd",
  "setting.type12.acChargeEndTime": "AC-lader stoptijd",
  "setting.type12.acSupplyStartTime": "AC-voeding starttijd",
  "setting.type12.acSupplyEndTime": "AC-voeding stoptijd",
  "setting.type12.restoreFactorySet": "Herstel fabrieksinstellingen",
  "setting.type12.parallelMode": "Parallelle modus",
  "setting.type12.bulkChargeVol": "CV-laadspanning",
  "setting.type12.batEquSet": "Batterij equalisatiefunctie",
  "setting.type12.batEquTime": "Batterij equalisatietijd (min)",
  "setting.type12.batEquDay": "Batterij equalisatie-interval (d)",
  "setting.type12.batEquChargeVol": "Batterij equalisatiespanning (V)",
  "setting.type12.batEquTimeout": "Batterij equalisatie timeout (min)",
  "setting.type12.equInfoSet": "Equalisatie-informatie instellingen",
  "setting.type12.val.slow": "Langzaam",
  "setting.type12.val.medium": "Gemiddeld",
  "setting.type12.val.fast": "Snel",
  "setting.type12.val.low": "Laag",
  "setting.type12.val.high": "Hoog",
  "setting.type12.val.powerCycle": "Vermogen cyclus",
  "setting.type12.val.powerRotation": "Vermogen rotatie",
  "setting.type12.val.additionalPower": "Extra vermogen",
  "setting.type12.val.powerUnchanged": "Vermogen ongewijzigd",
  "setting.type12.val.solarPowerInput": "Zonne-energie input vermogen",
  "setting.type12.val.batteryCapacity": "Batterij capaciteit percentage",
  "setting.type12.val.percentageLoad": "Belasting percentage",
  "setting.type12.val.energySource": "Energiebron",
  "setting.type12.val.batteryStatus": "Batterij laad/ontlaad status",
  "setting.type12.val.blue": "Blauw",
  "setting.type12.val.cyan": "Cyaan",
  "setting.type12.val.green": "Groen",
  "setting.type12.val.pink": "Roze",
  "setting.type12.val.purple": "Paars",
  "setting.type12.val.orange": "Oranje",
  "setting.type12.val.yellow": "Geel",
  "setting.type12.val.white": "Wit",
  "setting.type12.val.inputOvlRange1": "APL modus (90-280V)",
  "setting.type12.val.inputOvlRange2": "UPS modus (170-280V)",
  "setting.type12.val.outputSource1": "Zonnepanelen->Net->Batterij",
  "setting.type12.val.outputSource2": "Zonnepanelen->Batterij->Net",
  "setting.type12.val.chargeSourcePriority1": "Zonnepanelen prioriteit",
  "setting.type12.val.chargeSourcePriority2": "Zonnepanelen en netstroom",
  "setting.type12.val.chargeSourcePriority3": "Alleen zonnepanelen",
  "setting.type12.val.solarSupplyPriority1": "Batterij-belasting-net",
  "setting.type12.val.solarSupplyPriority2": "Belasting-batterij-net",
  "setting.type12.val.countryRegulations1": "India",
  "setting.type12.val.countryRegulations2": "Duitsland",
  "setting.type12.val.countryRegulations3": "Zuid-Amerika",
  "setting.type12.val.parallelMode1": "Geen parallelle modus",
  "setting.type12.val.parallelMode2": "Enkelfasige parallelle modus",
  "setting.type12.val.outPutSourcePriority1": "Netstroom prioriteit",
  "setting.type12.val.outPutSourcePriority2": "Zonnepanelen prioriteit",
  "setting.type12.val.outPutSourcePriority3": "Zonnepanelen->Batterij->Netstroom",
  "setting.ops15.invSwitch": "Omvormer schakelaar",
  "setting.ops15.workMode": "Werkmodus",
  "setting.ops15.workMode1": "Netvoeding prioriteit",
  "setting.ops15.workMode2": "Off-grid modus",
  "setting.ops15.workMode3": "Zelfconsumptie",
  "setting.ops15.invTime": "Omvormer tijd",
  "setting.ops15.batType": "Batterijtype",
  "setting.ops15.batType1": "Geen batterij",
  "setting.ops15.batType2": "Algemene lithiumbatterij",
  "setting.ops15.batType3": "Loodzuurbatterij",
  "setting.ops15.batType4": "Lithiumbatterij",
  "setting.ops15.timingTime": "Geschedulede tijd",
  "setting.ops15.offGirdSoc": "Ontlaad SOC (%)",
  "setting.ops15.optimizeRevenue": "Optimaliseer opbrengst",
  "setting.type19.totalActivePower": "Actief vermogen",
  "setting.type19.offgridSettings": "Netkoppelings instellingen",
  "setting.type19.gridConnectedControlMode": "Netgekoppeld beheer",
  "setting.type19.offGridControlMode": "Off-grid beheer",
  "setting.type19.offgrid.gridNet": "Netgekoppeld",
  "setting.type19.offgrid.offNet": "Off-grid",
  "setting.type22.parameterScope": "Parameterbereik",
  "setting.type22.ACStartVoltage": "Startspanning/frequentie instellingen",
  "setting.type22.highVoltage": "AC start hoge spanning",
  "setting.type22.lowVoltage": "AC start lage spanning",
  "setting.type22.pvStartLowVol": "PV start lage spanning",
  "setting.type22.acUnderVol1": "AC onder spanning fase 1 (V)",
  "setting.type22.acOverVol1": "AC over spanning fase 1 (V)",
  "setting.type22.acUnderVolTime1": "AC onder spanning fase 1 tijd (s)",
  "setting.type22.acOverVolTime1": "AC over spanning fase 1 tijd (s)",
  "setting.type22.acUnderVol2": "AC onder spanning fase 2 (V)",
  "setting.type22.acOverVol2": "AC over spanning fase 2 (V)",
  "setting.type22.acUnderVolTime2": "AC onder spanning fase 2 tijd (s)",
  "setting.type22.acOverVolTime2": "AC over spanning fase 2 tijd (s)",
  "setting.type22.startDelayTime": "Start vertragingstijd",
  "setting.type22.restartDelayTime": "Herstart vertragingstijd",
  "setting.type22.ACStartFrequency": "Over/Onder spanning/frequentie instellingen",
  "setting.type22.highFrequency": "AC start hoge frequentie",
  "setting.type22.lowFrequency": "AC start lage frequentie",
  "setting.type22.acUnderFrequency1": "AC onder frequentie fase 1 (Hz)",
  "setting.type22.acOverFrequency1": "AC over frequentie fase 1 (Hz)",
  "setting.type22.acUnderFrequencyTime1": "AC onder frequentie fase 1 tijd (s)",
  "setting.type22.acOverFrequencyTime1": "AC over frequentie fase 1 tijd (s)",
  "setting.type22.acUnderFrequency2": "AC onder frequentie fase 2 (Hz)",
  "setting.type22.acOverFrequency2": "AC over frequentie fase 2 (Hz)",
  "setting.type22.acUnderFrequencyTime2": "AC onder frequentie fase 2 tijd (s)",
  "setting.type22.acOverFrequencyTime2": "AC over frequentie fase 2 tijd (s)",
  "setting.type22.systemSetting": "Apparaatinformatie instellingen",
  "setting.type22.SNset": "Serienummer instellingen",
  "setting.type22.reactiveControlMode": "Reactieve sturing methode",
  "setting.type22.inputMode": "Invoermodus",
  "setting.type22.startSolpe": "Start helling",
  "setting.type22.restartSolpe": "Herstart helling",
  "setting.type22.reactivePercentage": "Reactief vermogen percentage",
  "setting.type22.activePercentage": "Actief vermogen percentage",
  "setting.type22.shutdown": "Externe uitschakeling",
  "setting.type22.functionSelect": "Functie selectie",
  "setting.type22.manufacturer": "Fabrikant",
  "setting.type22.setFunctionSelect.val1": "Uitgeschakeld",
  "setting.type22.setFunctionSelect.val2": "Anti-terugstroom ingeschakeld",
  "setting.type22.setManufacturer.val1": "INVT",
  "setting.type22.setManufacturer.val2": "Skyworth",
  "setting.type22.reactiveControlModeChoice.val1": "Vermogensfactor controle",
  "setting.type22.reactiveControlModeChoice.val2": "Reactief vermogen percentage controle",
  "setting.type22.reactiveControlModeChoice.val3": "QV-curve controle",
  "setting.type22.inputModeChoice.val1": "Onafhankelijke invoermodus",
  "setting.type22.inputModeChoice.val2": "Parallelle invoermodus",
  "setting.type22.inputModeChoice.val3": "DC-bron modus",
  "title.login": "Inloggen",
  "title.vistorLogin": "Gast login",
  "title.createAccount": "Account aanmaken",
  "title.retrievePassword": "Wachtwoord herstellen",
  "title.userAgreement": "Gebruikersovereenkomst",
  "title.privacyPolicy": "Privacybeleid",
  "title.phone": "Telefoon",
  "title.addPlant": "Energiepark toevoegen",
  "title.editPlant": "Energiepark bewerken",
  "title.accountInfo": "Account informatie",
  "title.changePassword": "Wachtwoord wijzigen",
  "title.message": "Berichten",
  "title.systemMessage": "Systeemberichten",
  "title.faultMessage": "Foutberichten",
  "title.deviceMessage": "Apparaatberichten",
  "title.aboutUs": "Over ons",
  "title.device": "Apparaat",
  "title.datalogger": "Datalogger",
  "title.setting": "Instellingen",
  "title.socketSetting": "Stopcontact instellingen",
  "title.addSchedule": "Timer toevoegen",
  "title.editSchedule": "Timer bewerken",
  "title.repetitionTime": "Herhalingsperiode",
  "title.addDatalogger": "Apparaat toevoegen",
  "title.connectWifi": "Verbind met router",
  "title.distributionNetworkStatus": "Netwerkstatus",
  "title.language": "Taal",
  "title.selectCountry": "Selecteer land",
  "title.selectCity": "Selecteer stad",
  "bar.home": "Home",
  "bar.energy": "Analyse",
  "bar.plant": "Energiepark",
  "bar.user": "Gebruiker",
  "bar.endpoint": "Eindpunt",
  "bar.mine": "Mijn",
  "bar.my": "Mijn",
  "button.logOut": "Uitloggen",
  "button.rememberMe": "Account en wachtwoord onthouden",
  "button.forgetPassword": "Wachtwoord vergeten",
  "button.register": "Registreren",
  "button.ok": "Bevestig",
  "button.send": "Versturen",
  "button.auto": "Automatisch",
  "button.cancle": "Annuleren",
  "button.yes": "Ja",
  "button.close": "Sluiten",
  "button.refresh": "Vernieuwen",
  "button.next": "Volgende",
  "button.redistributionNetwork": "Opnieuw verbinden",
  "button.upload": "Uploaden",
  "button.confirm": "Bevestigen",
  "button.edit": "Bewerken",
  "button.delete": "Verwijderen",
  "button.save": "Opslaan",
  "button.allReady": "Alle gelezen",
  "button.selectAll": "Alles selecteren",
  "button.deselectAll": "Selectie opheffen",
  "button.unsubscribe": "Account opzeggen",
  "button.later": "Later",
  "button.upgrade": "Bijwerken",
  "button.unfollow": "Afmelden",
  "button.add": "Toevoegen",
  "subtitle.NeedMoreHelp": "Meer hulp nodig",
  "subtitle.VisitSupportCenter": "Bezoek de officiële website voor meer hulp",
  "subtitle.energyFlowDiagram": "Energiestroomdiagram",
  "subtitle.selectTimezone": "Selecteer tijdzone",
  "subtitle.selectPlantType": "Selecteer type zonne-energiecentrale",
  "subtitle.selectInstallationDate": "Selecteer installatiedatum",
  "subtitle.selectCurrency": "Selecteer valuta",
  "subtitle.selectDateType": "Selecteer datumtype",
  "subtitle.selectDeviceType": "Selecteer apparaattype",
  "subtitle.socketBluetooth": "Stopcontact Bluetooth",
  "subtitle.log": "Logboek",
  "subtitle.all": "Alles",
  "subtitle.online": "Online",
  "subtitle.offline": "Offline",
  "subtitle.normal": "Normaal",
  "subtitle.abnormal": "Afwijkend",
  "subtitle.on": "Aan",
  "subtitle.off": "Uit",
  "subtitle.todayEnergy": "Energie vandaag",
  "subtitle.totalEnergy": "Totale energie",
  "subtitle.totalRevenue": "Totale opbrengst",
  "subtitle.plantImage": "Foto zonne-energiecentrale",
  "subtitle.plantName": "Naam zonne-energiecentrale",
  "subtitle.plantType": "Type zonne-energiecentrale",
  "subtitle.PVCapacity": "PV capaciteit",
  "subtitle.installationDate": "Installatiedatum",
  "subtitle.plantAddress": "Adres zonne-energiecentrale",
  "subtitle.revenue": "Opbrengst",
  "subtitle.timeZone": "Tijdzone",
  "subtitle.updatePhone": "Update telefoonnummer",
  "subtitle.solar": "Zonne-energie",
  "subtitle.grid": "Net",
  "subtitle.battery": "Batterij",
  "subtitle.home": "Belasting",
  "subtitle.load": "Belasting",
  "subtitle.socket": "Stopcontact",
  "subtitle.today": "Dag",
  "subtitle.day": "Dag",
  "subttile.week": "Week",
  "subtitle.month": "Maand",
  "subtitle.year": "Jaar",
  "subtitle.total": "Totaal",
  "subtitle.time": "Tijd",
  "subtitle.Co2": "Koolstofdioxide",
  "subtitle.coal": "Kolen",
  "subtitle.deforestation": "Bescherming bossen",
  "subtitle.parameter": "Parameter",
  "subtitle.schedule": "Tijdschakelaar",
  "subtitle.countdown": "Aftellen",
  "subtitle.socketSwitch": "Stopcontact schakelaar",
  "subtitle.currency": "Valuta",
  "subtitle.energyPrice": "Energietarief",
  "subtitle.storagePlant": "Opslagcentrale",
  "subtitle.on-GridPlant": "Netgekoppelde centrale",
  "subtitle.photo": "Profielfoto",
  "subtitle.email": "E-mail",
  "subtitle.account": "Account",
  "subtitle.version": "Versie",
  "subtitle.officalWebsite": "Officiële website",
  "subtitle.SN": "Serienummer",
  "subtitle.wifiSignal": "WiFi-signaal",
  "subtitle.lastSync": "Laatste synchronisatie",
  "subtitle.switch": "Schakelaar",
  "subtitle.happening": "Bezig",
  "subtitle.restored": "Hersteld",
  "subtitle.details": "Details",
  "subtitle.warn": "Alarm",
  "subtitle.fault": "Fout",
  "subtitle.status": "Status",
  "subtitle.level": "Niveau",
  "subtitle.deviceType": "Apparaattype",
  "subtitle.alarmStartTime": "Alarm starttijd",
  "subtitle.alarmEndTime": "Alarm eindtijd",
  "subtitle.solution": "Oplossing",
  "subtitle.noSolution": "Raadpleeg de gebruikershandleiding of neem direct contact op met de klantenservice.",
  "subtitle.loginIn": "Inloggen...",
  "subtitle.checkVersion": "Controleer updates",
  "subtitle.versionUpgrade": "Versie-update",
  "subtitle.alarmName": "Alarmnaam",
  "subtitle.messageDetail": "Berichtdetails",
  "subtitle.todayConsumption": "Verbruik vandaag",
  "subtitle.totalConsumption": "Totaal verbruik",
  "subtitle.dataloggerSN": "Dataserialnummer",
  "subtitle.configurationGuidance": "Configuratiegids",
  "subtitle.guideVideo": "Instructievideo",
  "subtitle.manualInstuction": "Handleiding",
  "subtitle.manualInstuction4G": "4G-handleiding",
  "subtitle.manualInstuctionMasterControl": "Master-control-handleiding",
  "subtitle.masterControlConfiguration": "Master-control netwerkconfiguratie",
  "subtitle.defaultConfiguration": "Standaard netwerkconfiguratie",
  "subtitle.findEmail": "Herstellen via e-mail",
  "subtitle.findPhone": "Herstellen via telefoon",
  "subtitle.family": "Gezin",
  "subtitle.agent": "Agent",
  "subtitle.endUsers": "Eindgebruikers",
  "subtitle.deviceManagement": "Apparaatbeheer",
  "subtitle.deviceSN": "Apparaat serienummer",
  "subtitle.firmwareVersion": "Firmwareversie",
  "subtitle.alias": "Alias",
  "subtitle.information": "Informatie",
  "subtitle.domainName": "Domeinnaam",
  "subtitle.restartdatalogger": "Herstart datasysteem",
  "subtitle.value": "Waarde",
  "subtitle.customizable": "Aanpasbaar",
  "subtitle.ready": "Lezen",
  "subtitle.deviceDetails": "Apparaat details",
  "subtitle.startAddress": "Startregisteradres",
  "subtitle.endAddress": "Eindregisteradres",
  "subtitle.settingParam": "Parameter instellen",
  "subtitle.tariffType": "Tarieftype",
  "subtitle.fixed": "Vast",
  "subtitle.timeshare": "Tijdstarief",
  "subtitle.addTime": "Tijd toevoegen",
  "subtitle.notAllDay": "Niet de hele dag",
  "subtitle.dealer": "Dealer",
  "subtitle.dealerNumber": "Dealer nummer",
  "subtitle.toggle": "Schakelen",
  "subtitle.environmentalBenefit": "Milieuvriendelijk",
  "subtitle.basicParam": "Basisparameters",
  "subtitle.realTimeParam": "Real-time parameters",
  "subtitle.export": "Exporteren",
  "subtitle.localDebug": "Lokale debug",
  "subtitle.mode": "Modus",
  "subtitle.manuallyAdd": "Handmatig toevoegen",
  "subtitle.AttachTheDevice": "Ondergeschikt apparaat",
  "subtitle.ammeter": "Stroommeter",
  "subtitle.FeederPowerOnTheSameDay": "Voedingsenergie op dezelfde dag",
  "subtitle.BatterySOC": "Batterij SOC",
  "subtitle.DailyChargingCapacityOfTheBattery": "Dagelijkse laadcapaciteit batterij",
  "subtitle.DailyPowerConsumption": "Dagelijks energieverbruik",
  "subtitle.CumulativePowerGeneration": "Cumulatieve energieopwekking",
  "subtitle.total2": "Totaal",
  "subtitle.run": "Uitvoeren",
  "subtitle.StopIt": "Stoppen",
  "subtitle.Optimizer": "Optimalisator",
  "subtitle.DataGateways": "Datagateway",
  "subtitle.dataType": "Datatype",
  "subtitle.Model": "Model",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Opwekking vandaag",
  "subtitle.CurrentPower": "Huidig vermogen",
  "subtitle.AllOptimizerWorkingStatus": "Status alle optimalisatoren",
  "subtitle.WhenClosedAllOptimizersStopWorking": "Na uitschakelen stoppen alle optimalisatoren met werken",
  "subtitle.TheDataGatewayRestarts": "Datagateway herstart",
  "subtitle.Reboot": "Herstarten",
  "subtitle.Restarting": "Bezig met herstarten",
  "subtitle.HardwareVersionNumber": "Hardwareversienummer",
  "subtitle.SoftwareVersionNumber": "Softwareversienummer",
  "subtitle.OutputPower": "Uitgangsvermogen",
  "subtitle.OutputVoltage": "Uitgangsspanning",
  "subtitle.OutputCurrent": "Uitgangsstroom",
  "subtitle.InputPower": "Ingangsvermogen",
  "subtitle.InputVoltage": "Ingangsspanning",
  "subtitle.InputCurrent": "Ingangsstroom",
  "subtitle.OperationalStatus": "Bedrijfsstatus",
  "subtitle.temperature": "Temperatuur",
  "subtitle.DeviceAddress": "Apparaatadres",
  "subtitle.FeederMode": "Voedingsmodus",
  "subtitle.StandbyMode": "Reservevoedingsmodus",
  "subtitle.Off-gridMode": "Eilandmodus",
  "subtitle.TimedChargingAndDischarging": "Getijdenladen en -ontladen",
  "subtitle.WorkingModeSettings": "Werkmodus instellingen",
  "subtitle.DeviceInformation": "Apparaatinformatie",
  "subtitle.HMISoftwareVersion": "HMI softwareversie",
  "subtitle.DSPSoftwareVersion": "DSP softwareversie",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Instellingen laad- en ontlaadtijden",
  "subtitle.ChargingPeriod": "Laadtijd",
  "subtitle.DischargeTimePeriod": "Ontlaadtijd",
  "subtitle.BatteryMinimumSOC(%)": "Minimale batterij SOC(%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Batterij overspanningswaarde(V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Batterij onder spanning drempel(A)",
  "subtitle.ChargingCurrentLimit(A)": "Laadstroom limiet(A)",
  "subtitle.DischargeCurrentLimit(A)": "Ontlaadstroom limiet(A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "Eilandmodus minimale ontlaad SOC(%)",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "Eilandmodus 2 minimale ontlaad SOC(%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Eilandmodus 2 minimale batterijspanning(V)",
  "subtitle.Auto-replenishment": "Automatisch bijvullen",
  "subtitle.BatteryBMSActivationCommand": "Batterij BMS activeringscommando",
  "subtitle.ForcedFullCharge": "Geforceerde volledige oplading",
  "subtitle.ForceCharge2": "Geforceerd laden 2",
  "subtitle.ForceCharge1": "Geforceerd laden 1",
  "subtitle.DischargeEnabled": "Ontladen ingeschakeld",
  "subtitle.ChargingEnabled": "Laden ingeschakeld",
  "subtitle.NumberOfOptimizers": "Aantal optimalisatoren",
  "subtitle.TheNameOfTheDevice": "Naam apparaat",
  "subtitle.GeneralSettings": "Algemene instellingen",
  "subtitle.Anti-backflowSwitch": "Terugstroomschakelaar",
  "subtitle.ReflowPowerLimit(W)": "Terugstroom vermogenslimiet(W)",
  "subtitle.OptimizerNumber": "Optimalisator nummer",
  "subtitle.reset": "Resetten",
  "subtitle.areYouSure": "Weet u zeker dat u wilt resetten?",
  "subtitle.PhysicalView": "Fysieke weergave",
  "subtitle.LogicalView": "Logische weergave",
  "subtitle.LayoutDrawing": "Lay-out tekening",
  "tip.noData": "Geen gegevens beschikbaar",
  "tip.base.maxDistance": "Verste",
  "tip.base.minDistance": "Dichtstbijzijnde",
  "tip.base.maxSize": "Grootste",
  "tip.base.minSize": "Kleinste",
  "tip.request.loading": "Laden",
  "tip.request.netWork": "Netwerkverbinding mislukt, controleer het netwerk",
  "tip.request.connectServerFail": "Kan geen verbinding maken met de server",
  "tip.request.requestTimeout": "Verzoek time-out",
  "tip.validate.choiceCountry": "Selecteer eerst een land",
  "tip.validate.country": "Land kan niet leeg zijn, selecteer een land",
  "tip.validate.timeZone": "Tijdzone kan niet leeg zijn, selecteer een tijdzone",
  "tip.validate.email": "Verkeerde e-mailindeling, voer een geldig e-mailadres in",
  "tip.validate.verification": "Verstuur eerst een verificatiecode",
  "tip.validate.verificationError": "Verificatiecode onjuist, voer een geldige verificatiecode in",
  "tip.validate.passwordFormTip": "Voer een wachtwoord in van 6-20 tekens bestaande uit cijfers en letters",
  "tip.validate.passwordError": "Ongeldige wachtwoordindeling, voer een wachtwoord van 6-20 tekens in bestaande uit cijfers en letters",
  "tip.validate.passwordError2": "Voer een geldig wachtwoord in (wachtwoord mag geen speciale tekens, symbolen en spaties bevatten)",
  "tip.validate.validatePassword": "De twee ingevoerde wachtwoorden komen niet overeen, controleer en probeer opnieuw",
  "tip.validate.confirmAgreement": "Lees en accepteer eerst het privacybeleid",
  "tip.validate.plantName": "Naam van zonne-energiecentrale kan niet leeg zijn, voer een naam in",
  "tip.validate.plantType": "Type zonne-energiecentrale kan niet leeg zijn, selecteer een type",
  "tip.validate.pvCapacity": "PV capaciteit kan niet leeg zijn, voer de capaciteit in",
  "tip.validate.installationDate": "Installatiedatum kan niet leeg zijn, selecteer een datum",
  "tip.validate.city": "Stad kan niet leeg zijn, selecteer een stad",
  "tip.validate.incomeunit": "Valuta kan niet leeg zijn, selecteer een valuta",
  "tip.validate.energyPrice": "Energietarief kan niet leeg zijn, voer een tarief in",
  "tip.validate.firstChoiceCountry": "Selecteer eerst een land",
  "tip.validate.oldPassword": "Oud wachtwoord kan niet leeg zijn, voer het oude wachtwoord in",
  "tip.validate.newPassword": "Nieuw wachtwoord kan niet leeg zijn, voer het nieuwe wachtwoord in",
  "tip.validate.confirmPassword": "Bevestiging wachtwoord kan niet leeg zijn, bevestig het wachtwoord",
  "tip.validate.passwordNotMatch": "De twee ingevoerde wachtwoorden komen niet overeen, controleer en probeer opnieuw",
  "tip.validate.SN1": "Serienummer kan niet leeg zijn",
  "tip.validate.SN2": "Serienummer moet 10 tekens lang zijn",
  "tip.validate.noSocketTimer": "Er is momenteel geen stopcontact tijdschakelaar, klik op toevoegen",
  "tip.validate.cameraPermission": "App heeft cameratoestemming nodig om de data logger via QR-code toe te voegen",
  "tip.validate.searchingState": "Bezig met zoeken naar Bluetooth, klik niet opnieuw",
  "tip.validate.notInTheScope": "Ingevoerde parameters vallen buiten het voorgeschreven bereik",
  "tip.validate.enterDecimal": "Moet {num}-cijferige decimaal of geheel getal zijn",
  "tip.validate.integer": "Moet een geheel getal zijn",
  "tip.validate.phone": "Telefoonnummer ondersteunt alleen China, gebruik voor andere landen e-mail herstel",
  "tip.validate.can`tEmpty": "{param} kan niet leeg zijn",
  "tip.validate.dealerSope": "Dealer nummer bereik is 6~8 cijfers",
  "tip.validate.firstChoicePlant": "Selecteer eerst een zonne-energiecentrale",
  "tip.log.permissionOpen": "Zorg dat locatie- en Bluetooth-machtigingen zijn ingeschakeld",
  "tip.log.openBluetoothSystem": "Open Bluetooth-instellingen",
  "tip.log.openIosBtSystem": "Herstart de Bluetooth-schakelaar",
  "tip.log.openLocationSystem": "Open locatie-instellingen",
  "tip.log.bluetoothAuthorization": "App Bluetooth-machtiging niet ingeschakeld",
  "tip.log.locationAuthorization": "App locatiemachtiging niet ingeschakeld",
  "tip.log.searchSurroundingDevicesPermission": "Zoeken naar nabije apparaten niet geautoriseerd",
  "tip.log.bluetoothNotPermission": "Bluetooth niet ingeschakeld",
  "tip.log.locationNotPermission": "Locatie niet ingeschakeld",
  "tip.log.bluetoothPermission": "Bluetooth ingeschakeld",
  "tip.log.locationPermission": "Locatie ingeschakeld",
  "tip.log.bluetoothException": "Bluetooth-onderbreking, controleer of Bluetooth op het apparaat is ingeschakeld en probeer opnieuw verbinding te maken",
  "tip.log.listeningFailure": "Luisteren naar kenmerkwaarde wijzigingen mislukt, probeer opnieuw Bluetooth-verbinding te maken",
  "tip.log.communicationException": "Bluetooth communicatie mislukt, probeer opnieuw Bluetooth-verbinding te maken",
  "tip.log.reconnect": "Bluetooth opnieuw verbinden",
  "tip.log.connectFail": "Bluetooth-verbinding mislukt",
  "tip.log.connect": "Verbind met Bluetooth",
  "tip.log.bluetoothService": "Schakel Bluetooth-service in",
  "tip.log.locationService": "Schakel locatieservice in",
  "tip.log.notsupport": "Huidig platform ondersteunt Bluetooth-functie aanroep",
  "tip.log.locationNotTurnOn": "Locatie niet ingeschakeld, kan geen Bluetooth zoeken",
  "tip.log.init": "Bluetooth initialisatie",
  "tip.log.searching": "Zoeken naar omringende Bluetooth-apparaten",
  "tip.log.searchFail": "Geen apparaten gevonden, zorg dat Bluetooth op het apparaat is ingeschakeld en klik op vernieuwen",
  "tip.log.stopSearch": "Stop met zoeken naar omringende Bluetooth-apparaten",
  "tip.log.stopSearchFail": "Stoppen met zoeken naar omringende Bluetooth-apparaten mislukt",
  "tip.log.connectSuccess": "Bluetooth-verbinding succesvol",
  "tip.log.setMTUsSuccess": "Instellen maximale overdrachtseenheid succesvol",
  "tip.log.setMTUsFail": "Instellen maximale overdrachtseenheid mislukt",
  "tip.log.closeSuccess": "Bluetooth-verbinding verbroken",
  "tip.log.closeFail": "Verbreken Bluetooth-verbinding mislukt",
  "tip.log.wifiLoadFail": "WiFi-lijst laden mislukt, voer handmatig in",
  "tip.log.bluetoothAbnormal": "Bluetooth-verbinding abnormaal, bezig met opnieuw verbinden",
  "tip.log.getBluetoothServiceSuccess": "Bluetooth-apparaatservice succesvol verkregen",
  "tip.log.getBluetoothServiceFail": "Verkrijgen Bluetooth-apparaatservice mislukt",
  "tip.log.getFeatureValuesSucess": "Succesvol alle kenmerkwaarden verkregen van opgegeven Bluetooth-apparaatservice",
  "tip.log.getFeatureValuesFail": "Verkrijgen kenmerkwaarden van opgegeven Bluetooth-apparaatservice mislukt",
  "tip.log.subscriptionEigenvalueSuccess": "Succesvol notify-functie ingeschakeld voor kenmerkwaarde wijzigingen op Bluetooth-apparaat",
  "tip.log.subscriptionEigenvalueFail": "Inschakelen notify-functie voor kenmerkwaarde wijzigingen op Bluetooth-apparaat mislukt",
  "tip.log.monitoringSuccess": "Succesvol kenmerkwaarde wijzigingen op Bluetooth-apparaat aan het monitoren",
  "tip.log.monitoringFail": "Monitoren kenmerkwaarde wijzigingen op Bluetooth-apparaat mislukt",
  "tip.log.CRC": "CRC-verificatie mislukt",
  "tip.log.queryWiFi": "WiFi-lijst succesvol opgevraagd",
  "tip.log.queryWiFiState": "WiFi-lijst opvraagcommando succesvol verzonden",
  "tip.log.wifiConenct": "Bezig met controleren routerverbinding status",
  "tip.log.wifiFail": "Controleer routeraccount en -wachtwoord en probeer opnieuw te verbinden",
  "tip.log.connectWiFiSuccess": "Routerverbinding succesvol",
  "tip.log.connectWiFiFail": "Routerverbinding mislukt",
  "tip.log.routerAccount": "Routeraccount onjuist",
  "tip.log.routerPassword": "Routerwachtwoord onjuist",
  "tip.log.gettingIP": "Bezig met IP-adres van router ophalen",
  "tip.log.getIPFail": "Ophalen IP-adres van router mislukt",
  "tip.log.queryServerState": "Opvraagcommando apparaat-server interactiestatus succesvol verzonden",
  "tip.log.server03": "Er is 03 data-uitwisseling",
  "tip.log.server04": "Er is 04 data-uitwisseling",
  "tip.log.heartbeat": "Er is hartslag data-uitwisseling",
  "tip.log.noInteraction": "Geen data-uitwisseling",
  "tip.log.bluetoothCommunication": "Bluetooth-communicatie tot stand gebracht",
  "tip.log.connectWiFi": "Verbind met WiFi",
  "tip.log.getWiFiList": "Bezig met opvragen WiFi-lijst",
  "tip.log.wifiName": "WiFi-naam kan niet leeg zijn, selecteer of voer 2.4G WiFi in",
  "tip.log.wifiPasword": "WiFi-wachtwoord kan niet leeg zijn, voer wachtwoord in",
  "tip.log.wifiPasswordError": "WiFi-wachtwoord mag geen speciale tekens bevatten (ǎǐò•♢∝⌒℃℉ etc.)",
  "tip.log.masterControlId": "Master control ID kan niet leeg zijn, voer ID in",
  "tip.addDatalogger.noSearchDevice": "Kan geen apparaat vinden, zorg dat Bluetooth op het apparaat is ingeschakeld",
  "tip.addDatalogger.searchAroundBluetooth": "Bluetooth in de omgeving voor netwerkconfiguratie",
  "tip.addDatalogger.scan": "Scan de QR-code of voer handmatig het serienummer van de data logger in onder de QR-code.",
  "tip.addDatalogger.connectBluetoothFail": "Bluetooth-verbinding mislukt, scan de QR-code of voer handmatig het serienummer van de data logger in en probeer opnieuw te verbinden.",
  "tip.connectWifi.tip1": "Configureer apparaat om aan het netwerk toe te voegen",
  "tip.connectWifi.tip": "Selecteer 2.4G WiFi",
  "tip.connectWifi.devicePower": "Apparaatvermogen",
  "tip.connectWifi.enterSSID": "Voer routeraccount in",
  "tip.connectWifi.enterPassword": "Voer routerwachtwoord in",
  "tip.connectWifi.masterId": "Voer master control ID in",
  "tip.connectWifi.commandSetFail": "Commando instellen mislukt, verbind opnieuw met de data logger",
  "tip.configurationState.connecting": "Verbinden",
  "tip.configurationState.connectFail": "Verbinding mislukt",
  "tip.configurationState.connectSuccess": "Verbinding succesvol",
  "tip.configurationState.wait": "Even geduld",
  "tip.configurationState.addDeviceSuccess": "Apparaat succesvol toegevoegd",
  "tip.home.today": "Dagopwekking",
  "tip.home.month": "Maandopwekking",
  "tip.home.year": "Jaaropwekking",
  "tip.home.total": "Totale opwekking",
  "tip.home.homePower": "Totale huishoudelijke belasting",
  "tip.home.socketPower": "Stopcontact belasting",
  "tip.home.off-gridPower": "Eilandmodus belasting",
  "tip.home.acPower": "Netvermogen",
  "tip.home.on-gridPower": "AC maximaal uitgangsvermogen",
  "tip.home.others": "Overige",
  "tip.home.latestVersion": "Meest recente versie",
  "tip.home.frontEndLoad": "Front-end belasting",
  "tip.home.backEndLoad": "Eilandmodus belasting",
  "tip.energy.choiceDate": "Huidige gegevens alleen tot",
  "tip.energy.explain": "Uitleg",
  "tip.energy.tip1.load": "Energie verbruikt door de belasting",
  "tip.energy.tip1.solar": "Zonne-energie omgezet in elektriciteit voor batterijlading of belastingvoeding",
  "tip.energy.tip1.grid": "Cumulatieve energieverkoop aan het net",
  "tip.energy.tip1.battery": "Cumulatieve energie voor batterijlading",
  "tip.energy.tip2": "=Zonne-energie * energietarief",
  "tip.energy.tip3.title": "Berekeningsnormen maatschappelijke bijdrage",
  "tip.energy.tip3.title2": "1 kWh komt overeen met:",
  "tip.energy.tip3.Co2": "Verminderde CO2-uitstoot:",
  "tip.energy.tip3.coal": "Bespaarde standaardkolen:",
  "tip.energy.tip3.deforestation": "Beschermde bomen:",
  "tip.plant.comprehensive": "Combinatiesortering",
  "tip.plant.totalEnergyMax": "Hoogste totale energie",
  "tip.plant.totalEnergyMin": "Laagste totale energie",
  "tip.plant.realTimePower": "Real-time vermogen",
  "tip.plant.pvcapacityMax": "Hoogste PV capaciteit",
  "tip.plant.pvcapacityMin": "Laagste PV capaciteit",
  "tip.plant.installationDateMax": "Verste installatiedatum",
  "tip.plant.installationDateMin": "Meest recente installatiedatum",
  "tip.plant.paramChoice": "Parameterselectie",
  "tip.plant.filter": "Filteren",
  "tip.plant.addVisitor": "Bezoeker toevoegen",
  "tip.plant.tip": "Tip",
  "tip.plant.visitorTip": "Kan alleen gedeeld worden met geregistreerde gebruikers",
  "tip.plant.name": "Naam",
  "tip.plant.permission": "Machtiging",
  "tip.plant.read-write": "Lezen en schrijven",
  "tip.plant.onlyread": "Alleen lezen",
  "tip.plant.visitor": "Bezoeker",
  "tip.plant.unfollow": "Weet u zeker dat u deze zonne-energiecentrale wilt ontvolgen?",
  "tip.device.power": "Vermogen",
  "tip.device.type": "Type",
  "tip.device.updateTime": "Bijwerkingsdatum",
  "tip.device.powerOnTime": "Inschakeltijd",
  "tip.device.todayEnergy": "Energie vandaag",
  "tip.device.signal": "Signaalsterkte",
  "tip.device.deliveryWarning": "Sorry, dit apparaat is al aan een eindgebruiker geleverd en kan niet worden verwijderd. U kunt eerst naar het centrale beheer gaan, de levering intrekken en dan het apparaat verwijderen.",
  "common.ok": "OK",
  "tip.delDevice": "Weet u zeker dat u dit {device} wilt verwijderen?",
  "tip.currentNoDevice": "Momenteel geen apparaten",
  "tip.currentNoDatalog": "Momenteel geen data logger",
  "tip.messageInfo.storage": "Opslag",
  "tip.messageInfo.inverter": "Omvormer",
  "tip.messageInfo.microInverter": "Micro-omvormer",
  "tip.ops.setDomainName": "Weet u zeker dat u deze domeinnaam wilt instellen?",
  "tip.ops.restartDatalogger": "Weet u zeker dat u de data logger wilt herstarten?",
  "tip.opsLog.addUser": "Eindgebruiker toevoegen",
  "tip.opsLog.bindSuccess": "Koppeling succesvol",
  "tip.opsLog.selectDate": "Selecteer datum",
  "tip.opsLog.start": "Start",
  "tip.opsLog.end": "Einde",
  "tip.opsLog.upgrade": "Upgrade",
  "tip.opsLog.operation": "Bewerking",
  "tip.opsLog.communication": "Communicatie",
  "tip.opsLog.type": "Type",
  "tip.opsLog.content": "Inhoud",
  "tip.opsLog.control": "Controller",
  "tip.opsLog.command": "Commandotype",
  "tip.opsLog.reset": "Resetten",
  "tip.opsLog.serverTime": "Servertijd",
  "tip.opsLog.inverter": "Interval",
  "tip.opsLog.bindAgent": "Dealer koppelen",
  "tip.opsLog.deleteDeviceSN": "Weet u zeker dat u wilt verwijderen?",
  "tip.opsLog.recordLog": "Apparaat dat logboek moet registreren",
  "tip.userLocation": "Gebruiker locatie",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "Netgekoppeld vermogen kan niet hoger zijn dan het maximale vermogen van het geselecteerde productmodel",
  "productEquipment.productModelNumber": "Productmodel",
  "productEquipment.warnMessage": "Alarmbericht",
  "productEquipment.customInstruction": "Aangepaste instructie",
  "productEquipment.firmwareUpdate": "Firmware-upgrade",
  "productEquipment.historicalData": "Historische gegevens",
  "productEquipment.linkageInformation": "Verbindingsinformatie",
  "systemAuthority.systemSettings": "Systeeminstellingen",
  "systemAuthority.authorityManagement": "Machtigingenbeheer",
  "systemAuthority.accountManagement": "Rolbeheer",
  "systemAuthority.Disabled": "Uitgeschakeld",
  "systemAuthority.enable": "Ingeschakeld",
  "org.ChangeSupplier": "Leverancier wijzigen",
  "upload.imageDetail": "Afbeelding details",
  "upload.seeOrigin": "Klik om oorspronkelijk bestand te bekijken",
  "upload.needOpen": "Dit bestand moet mogelijk worden gedownload om te bekijken",
  "upload.knowandSure": "Begrepen en bevestigd",
  "upload.fail": "Upload mislukt",
  "upload.uploadError": "Bestandsupload mislukt, neem contact op met de beheerder",
  "upload.fielExceed": "Bestand overschrijdt aantal limiet",
  "upload.fileSizeExceed": "Upload afbeelding mag niet groter zijn dan",
  "upload.fileTypeError": "Selecteer het juiste bestandsformaat",
  "upload.image": "Afbeelding",
  "common.reset": "Resetten",
  "common.confirm": "Bevestigen",
  "common.cancel": "Annuleren",
  "common.save": "Opslaan",
  "common.delete": "Verwijderen",
  "common.add": "Toevoegen",
  "common.edit": "Bewerken",
  "common.update": "Bijwerken",
  "common.submit": "Indienen",
  "common.tip": "Herinnering",
  "common.success": "Succes",
  "common.fail": "Mislukt",
  "common.password": "Wachtwoord",
  "common.handleFail": "Bewerking mislukt",
  "common.required": "Verplicht veld",
  "common.environmentChange": "Accountomgeving gewijzigd, bevestig om account te vernieuwen of opnieuw in te loggen",
  "common.noPermissions": "Nog geen inhoud, neem snel contact op met de beheerder om dit in te stellen~",
  "common.personalCenter": "Persoonlijk centrum",
  "common.deviceSet": "Apparaatinstellingen",
  "common.productDetail": "Productdetails",
  "validator.bank": "Voer een geldig bankrekeningnummer in",
  "validator.phone": "Voer een geldig mobiel of vast nummer in",
  "validator.email": "Voer een geldig e-mailadres in",
  "validator.password": "Wachtwoord lengte 8-20 tekens, moet minimaal drie van de volgende tekentypen bevatten (cijfers, hoofdletters, kleine letters, Engelse symbolen)",
  "validator.max": "Mag maximaal {num} tekens bevatten",
  "validator.min": "Minimaal {num} tekens invoeren",
  "validator.greater": "Voer een getal groter dan nul in",
  "org.user": "Gebruiker",
  "org.role": "Rol",
  "org.email": "E-mail",
  "org.editorginfo": "Organisatie-informatie bewerken",
  "org.passwordResetTo": "wachtwoord wordt gereset naar",
  "org.pleaseChooseOrg": "Selecteer eerst een organisatie",
  "org.addDept": "Afdeling toevoegen",
  "org.editDept": "Afdeling bewerken",
  "org.passwordResetSuccess": "Wachtwoord resetten succesvol",
  "org.passwordResetFail": "Wachtwoord resetten mislukt",
  "org.deleteTip": "Deze actie zal deze afdeling verwijderen, doorgaan?",
  "org.deleteSuccess": "Verwijderen succesvol",
  "org.parent": "Bovenliggend",
  "org.orgName": "Organisatienaam",
  "org.area": "Land/regio",
  "org.leader": "Verantwoordelijke",
  "org.leaderPhone": "Contactgegevens verantwoordelijke",
  "org.logo": "Organisatielogo",
  "org.namenick": "Naam/bijnaam",
  "org.createTime": "Aanmaaktijd",
  "org.status": "Status",
  "org.action": "Actie",
  "shipment.shippingManagement": "Verzendbeheer",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Categorie",
  "shipment.supplier": "Leverancier",
  "shipment.supplierSN": "Leveranciers SN",
  "shipment.PleaseSelectStatus": "Selecteer status",
  "shipment.MaterialCode": "MDM materiaalcode",
  "shipment.PleaseEnterMaterialCode": "Voer MDM materiaalcode in",
  "shipment.MdmCode": "MDM code",
  "shipment.devType": "Ontwikkelingsmethode",
  "shipment.spread": "Uitklappen",
  "shipment.packUp": "Inklappen",
  "shipment.shippingManagementTemplage": "Verzendbeheer import sjabloon",
  "product.createProduct": "Product aanmaken",
  "product.deviceSubclass": "Apparaat subklasse",
  "product.networkingMode": "Netwerkmodus",
  "product.productImage": "Productafbeelding",
  "product.bluetoothIcon": "Bluetooth-pictogram",
  "product.uploadOneBluetoothIcon": "Er kan slechts één Bluetooth-pictogram worden geüpload",
  "product.UploadUpTo9Photos": "Upload maximaal 9 foto's",
  "product.PleaseEnterSupplier": "Voer leverancier in",
  "product.PleaseUploadNoBackground": "Upload afbeelding zonder achtergrond",
  "person.changePassword": "Wachtwoord wijzigen",
  "person.userName": "Gebruikersnaam",
  "person.company": "Bedrijf",
  "person.newPassword": "Nieuw wachtwoord",
  "person.confirmPassword": "Bevestig wachtwoord",
  "person.userInformation": "Gebruikersinformatie",
  "person.basicInformation": "Basisinformatie",
  "person.address": "Adres",
  "person.phone": "Telefoon",
  "person.confirmChange": "Wijziging bevestigen",
  "weather.clearSky": "Helder",
  "weather.fewClouds": "Licht bewolkt",
  "weather.scatteredClouds": "Verspreide wolken",
  "weather.brokenClouds": "Gebroken wolken",
  "weather.overcastClouds": "Bewolkt",
  "weather.lightRain": "Lichte regen",
  "weather.moderateRain": "Matige regen",
  "weather.heavyRain": "Zware regen",
  "weather.thunderstormWithLightRain": "Onweer met lichte regen",
  "weather.thunderstormWithRain": "Onweer met regen",
  "weather.thunderstormWithHeavyRain": "Onweer met zware regen",
  "weather.lightSnow": "Lichte sneeuw",
  "weather.snow": "Sneeuw",
  "weather.heavySnow": "Zware sneeuw",
  "weather.sleet": "Natte sneeuw",
  "weather.showerRain": "Buien",
  "weather.lightShowerRain": "Lichte buien",
  "weather.heavyShowerRain": "Zware buien",
  "weather.mist": "Mist",
  "weather.smoke": "Rook",
  "weather.haze": "Nevel",
  "weather.dust": "Stof",
  "weather.fog": "Dichte mist",
  "weather.sand": "Zand",
  "weather.ash": "As",
  "weather.squall": "Windstoot",
  "weather.tornado": "Tornado",
  "zh-CN": "Chinees",
  "en-US": "Engels",
  "de-DE": "Duits",
  "fr-FR": "Frans",
  "it-IT": "Italiaans",
  "uk-UA": "Oekraïens",
  "th-TH": "Thai",
  "nl-NL": "Nederlands",
  "device.to": "tot",
  "device.range": "bereik",
  "device.noParamsChange": "Geen parameters gewijzigd, geen verzending nodig",
  "device.timeCopy": "Dubbele tijdsperiode bestaat, wijzig deze",
  "product.havePublished": "Gepubliceerd",
  "product.inDevelopment": "In ontwikkeling",
  "language.management": "Meertaligheidsbeheer",
  "sidebar.roleManagement": "Rolbeheer",
  "user.userEmail": "Gebruikers e-mail",
  "user.agentCode": "Agentcode",
  "user.phoneModel": "Telefoonmodel",
  "user.phoneOs": "Telefoonbesturingssysteem",
  "user.appVersion": "App-versie",
  "user.country": "Land",
  "user.createTime": "Aanmaaktijd",
  "user.loginTime": "Inlogtijd",
  "bTerminal.correlationDeleteTheDevice": "Als dit apparaat wordt verwijderd, zullen ook de daarmee verbonden apparaten worden verwijderd. Wilt u doorgaan?",
  "log.operationEmail": "Bewerking e-mail",
  "log.deviceSn": "Apparaat SN",
  "log.opType": "Bewerkingstype",
  "log.opTime": "Bewerkingstijd",
  "log.operator": "Operator",
  "log.operationDescription": "Bewerkingsbeschrijving",
  "log.content": "Bewerking inhoud",
  "log.params": "Parameters",
  "role.action": "Actie",
  "role.add.select.menu": "Selecteer menu resources",
  "role.addRole": "Rol toevoegen",
  "role.addTip": "Ondersteunt machtigingsconfiguratie voor Web- en B-appgebruikers. Ondersteunt geen machtigingsconfiguratie voor C-appgebruikers.",
  "role.applySuccess": "Indienen succesvol",
  "role.appPermissions": "APP menu machtigingen",
  "role.base": "Basisinformatie",
  "role.edit": "Bewerken",
  "role.exist": "Rol bestaat al",
  "role.info": "Details",
  "role.name": "Rolnaam",
  "role.no": "Rolnummer",
  "role.not.empty": "Rol informatie kan niet leeg zijn",
  "role.per.user": "Elke gebruiker kan slechts één rol toegewezen krijgen",
  "role.permissions": "Gegevens machtigingen",
  "role.status": "Rolstatus",
  "role.submit": "Indienen",
  "role.type": "Roltype",
  "role.typeTip": "Installateurbeheerder: standaardrol voor de verantwoordelijke van de installateurorganisatie, er is er maar één op het hele platform. Installateurrol: rol die de verantwoordelijke van de installateurorganisatie aan medewerkers kan toewijzen, kan er meerdere zijn. Platformrol: rol die door anderen dan installateurs kan worden gebruikt.",
  "role.updateTime": "Bijwerktijd",
  "role.webPermissions": "web menu machtigingen",
  "device.paramRangeErrorDefault": "Gegevensbereik onjuist, invoerbereik moet zijn ",
  "device.paramRangeError": "Gegevensbereik onjuist",
  "plant.dataUpdate": "Gegevens bijwerken",
  "validate.requiredFormat": "Voer in volgens voorbeeldformaat",
  "plant.addStation": "Zonnecentrale toevoegen",
  "product.ProtocolCode": "IoT product-ID",
  "product.IoIDandPlatformSource": "IoT-product-ID en bron van het platform",
  "product.productIdCannotRepeat": "Product-ID mag niet dubbel zijn",
  "product.deviceTypeAccess.maxAddRows": "Je kunt maximaal 2 items toevoegen",
  "product.accessPlatformCannotRepeat": "Platformbron mag niet dubbel voorkomen",
  "product.productId": "Product ID",
  "product.powerType": "Stroombron",
  "product.power": "Nominaal vermogen kW",
  "system.taskCenter": "Taakcentrum",
  "task.name": "Taaknaam",
  "task.type": "Taaktype",
  "task.status": "Status",
  "task.createDate": "Aanmaakdatum",
  "task.progress": "Voltooiingsgraad",
  "task.view": "Bekijken",
  "task.stop": "Onderbreken",
  "task.stopConfirm": "Weet u zeker dat u de taak wilt stoppen?",
  "task.stopSuccess": "Taak stoppen succesvol",
  "task.stopFail": "Taak stoppen mislukt",
  "task.confirm": "Bevestigen",
  "task.cancel": "Annuleren",
  "task.mutipleSearch": "Bulk zoeken",
  "task.mutipleSend": "Bulk verzenden",
  "task.taskDetail": "Taakdetails",
  "task.equipmentList": "Apparaatlijst",
  "task.fileLimit": "Upload alleen xls/xlsx bestanden",
  "task.reChoose": "Wis lijst en selecteer opnieuw",
  "task.tip": "Sleep bestanden hierheen, of",
  "task.upload": "klik om te uploaden",
  "task.templateDownload": "Sjabloon downloaden",
  "task.mutipleHandleParams": "Parameters voor batchverwerking",
  "common.previousStep": "Vorige stap",
  "task.requiredProductModel": "Selecteer het productmodel",
  "task.requiredEquipmentList": "Upload de apparatenlijst",
  "task.equipmentListTip": "Tabelgegevens zijn leeg of upload is mislukt, controleer dit",
  "task.requiredParameter": "Selecteer parameter",
  "task.writeValue": "Waarde schrijven",
  "task.progressRate": "Voltooiingspercentage",
  "task.readTime": "Leestijd",
  "task.sendTime": "Verzendtijd",
  "task.mutipleSearchTemplate": "Batch zoeksjabloon",
  "task.mutipleSendTemplate": "Batch verzendsjabloon",
  "task.uploadSuccess": "Upload succesvol",
  "task.sendSuccess": "Taak succesvol aangemaakt",
  "task.inProgress": "Bezig",
  "task.completed": "Voltooid",
  "task.failed": "Mislukt",
  "task.success": "Succes",
  "system.configureImport": "Configuratie importeren",
  "product.DeviceHlepInstructions": "Apparaathandleiding",
  "product.addDeviceHlepInstructions": "Apparaathandleiding toevoegen",
  "product.deviceInstallationGuideFirst": "Upload installatiehandleidingafbeeldingen om installateurs stap voor stap te begeleiden bij installatie en app-bediening.",
  "product.deviceInstallationGuideSecond": "Advies: opnemen van instructies voor apparaat netwerkmodus, SN QR-code locatie, site setup, apparaat toevoegen, Bluetooth bediening, snelle configuratie, etc.",
  "product.mdnTip": "Haier SN eerste 9 cijfers",
  "product.basicProperties": "Basis eigenschappen",
  "product.specialProperties": "Speciale eigenschappen",
  "product.platformRelated": "Platform gerelateerd",
  "product.specialParam1": "Speciale parameter 1",
  "product.platformParam1": "Platform parameter 1",
  "Firmware.secretType": "Encryptiemethode",
  "common.copySuccess": "Kopiëren gelukt",
  "bTerminal.ModifyTheNameOfTheDevice": "Apparaatnaam wijzigen",
  "bTerminal.changeFailed": "Wijzigen mislukt",
  "bTerminal.OnlyWithin100Characters": "Alleen Chinees/Engels, cijfers binnen 100 tekens",
  "bTerminal.OnlyWithin30Characters": "Alleen Chinees/Engels, cijfers binnen 30 tekens",
  "bTerminal.rename": "Hernoemen",
  "sidebar.prefill": "Beoordeling en feedback",
  "paramters.basicInformation": "Basisinformatie",
  "paramters.DCSide": "DC-zijde",
  "paramters.ACSide": "AC-zijde",
  "paramters.stringCurrent": "String stroom",
  "paramters.moreParamters": "Meer informatie",
  "paramters.debugInformation": "Debug-informatie",
  "paramters.current": "Stroom",
  "paramters.voltage": "Spanning",
  "paramters.power": "Vermogen",
  "paramters.init": "Initialiseren",
  "paramters.wait": "Wachten",
  "paramters.normal": "Normaal",
  "paramters.abnormal": "Fout",
  "paramters.burn": "Branden",
  "system.reportCenter": "Rapportagecentrum",
  "system.reportMonth": "Maandrapport",
  "system.reportYear": "Jaarrapport",
  "system.selfServiceReport": "Zelfservice",
  "system.selfServiceReport.hour": "Uur",
  "system.selfServiceReport.selectPlant": "Selecteer een energiecentrale",
  "system.selfServiceReport.selectYear": "Selecteer jaar",
  "system.selfServiceReport.metricSelection": "Indicatorselectie",
  "system.selfServiceReport.required": "Verplicht",
  "system.selfServiceReport.startTimeCannotBeLater": "Starttijd mag niet later zijn dan eindtijd",
  "system.selfServiceReport.fieldIsRequired": "{field} is verplicht",
  "system.selfServiceReport.hourTimeTooltipLine1": "Uur staat voor de periode van 1 uur die begint bij dat volledige uur",
  "system.selfServiceReport.hourTimeTooltipLine2": "(bijv. 15:00 = 15:00–15:59)",
  "report.exportAll": "Alles exporteren",
  "report.installedCapacity": "Geïnstalleerd vermogen",
  "report.capacityErrorTip": "Foutief bereik voor geïnstalleerd vermogen",
  "report.exportFailed": "Export mislukt, probeer later opnieuw",
  "report.firstChoiceTime": "Selecteer eerst een datum voordat u exporteert",
  "placeholder.selectScope": "Selecteer {scope}",
  "register.accountVerification": "Accountverificatie",
  "register.companyRegistration": "Bedrijfsregistratie",
  "register.staffRegistration": "Medewerkerregistratie",
  "register.companyInfo": "Vul hieronder bedrijfsinformatie in",
  "register.companyFullName": "Volledige bedrijfsnaam",
  "register.installationCountryNotice": "Selecteer zorgvuldig het land voor installateurregistratie. U kunt geen systemen installeren buiten het geregistreerde gebied.",
  "register.detailAddress": "Detailadres",
  "register.postalCode": "Postcode",
  "register.contactName": "Contactpersoon naam",
  "register.contactInfo": "Telefoonnummer of e-mail contactpersoon",
  "register.applyJoinCompany": "Aanvragen om lid te worden",
  "register.companyCodeInfo": "Vul bedrijfscode en persoonlijke informatie in om lid te worden van een geregistreerd bedrijf",
  "register.registrationCode": "Bedrijfsregistratiecode",
  "register.codeHint": "Code verkrijgbaar via bedrijfsbeheerder",
  "register.realName": "Naam",
  "register.accountVerificationInfo": "Kies een methode om accountregistratie te voltooien",
  "register.emailRegistration": "Registratie via e-mail",
  "register.sixDigitCode": "6-cijferige verificatiecode",
  "register.getVerificationCode": "Verificatiecode ontvangen",
  "register.resendAfterSeconds": "{seconds}s voor nieuwe verzending",
  "register.resendAfterMinutes": "{minutes}min voor nieuwe verzending",
  "register.resendAfterMinutesSeconds": "{minutes}min{seconds}s voor nieuwe verzending",
  "register.password6to20": "Wachtwoord 6-20 tekens",
  "register.password8to20": "Wachtwoord 8-20 tekens",
  "register.phoneNumber": "Telefoonnummer",
  "register.phoneRegistration": "Registratie via telefoonnummer",
  "register.optionalEmail": "Optioneel: e-mailadres",
  "register.previousPage": "Vorige pagina",
  "register.goToLogin": "Naar inloggen",
  "register.completeRegistration": "Registratie voltooien",
  "register.accountAlreadyRegistered": "Dit e-mailadres of telefoonnummer is al geregistreerd. Log in of gebruik een ander account.",
  "register.emailAlreadyRegistered": "Dit e-mailadres is al geregistreerd. Log direct in of gebruik een ander account.",
  "register.phoneAlreadyRegistered": "Dit telefoonnummer is al geregistreerd. Log direct in of gebruik een ander account.",
  "register.companyAlreadyRegistered": "Bedrijf '{companyName}' is al geregistreerd",
  "register.companyExistOptions": "U kunt de bedrijfsnaam wijzigen of aanvragen om lid te worden",
  "register.returnToModify": "Terug om te wijzigen",
  "register.companyRegisteredApplyJoin": "Aanvragen om lid te worden",
  "register.companyRegisteredApplyJoinFull": "Bedrijf geregistreerd, aanvragen om lid te worden",
  "register.validation.selectCountry": "Selecteer land/regio",
  "register.validation.selectCity": "Selecteer stad",
  "register.validation.enterDetailAddress": "Voer detailadres in",
  "register.validation.enterCorrectPostalCode": "Voer correcte postcode in",
  "register.validation.enterContactName": "Voer naam contactpersoon in",
  "register.validation.enterRegistrationCode": "Voer registratiecode in",
  "register.validation.enterYourName": "Voer uw naam in",
  "register.validation.enterPassword": "Voer wachtwoord in",
  "register.validation.passwordLength": "Wachtwoord moet 6-20 tekens lang zijn",
  "register.validation.passwordLength8to20": "Wachtwoord moet 8-20 tekens lang zijn",
  "register.validation.passwordComplexity": "Wachtwoord moet minimaal drie verschillende tekentypen bevatten (cijfers, hoofdletters, kleine letters, speciale tekens)",
  "register.validation.enterPasswordAgain": "Voer wachtwoord opnieuw in",
  "register.validation.passwordMismatch": "Wachtwoorden komen niet overeen",
  "register.validation.correctPhoneFormat": "Voer correct telefoonnummerformaat in",
  "register.validation.correctPhoneOrEmailFormat": "Voer correct telefoonnummer of e-mailformaat in",
  "register.validation.correctEmailFormat": "Voer correct e-mailformaat in",
  "register.validation.enterVerificationCode": "Voer verificatiecode in",
  "register.validation.sixDigitNumber": "Verificatiecode moet 6 cijfers zijn",
  "register.validation.enterCompanyName": "Voer bedrijfsnaam in",
  "register.validation.companyRegisteredChooseAction": "Bedrijf is geregistreerd, kies actie",
  "register.message.searchCompanyFailed": "Bedrijf zoeken mislukt",
  "register.message.checkCompanyStatusFailed": "Bedrijfsstatus controleren mislukt",
  "register.message.getCityListFailed": "Stedenlijst ophalen mislukt",
  "register.message.companyRegisteredChooseAction": "Bedrijf is geregistreerd, kies actie",
  "register.message.completeCompanyInfo": "Vul bedrijfsinformatie aan",
  "register.message.completeStaffInfo": "Vul medewerkerinformatie aan",
  "register.message.enterEmailFirst": "Voer eerst e-mailadres in",
  "register.message.correctEmailFormat": "Voer correct e-mailformaat in",
  "register.message.verificationCodeSent": "Verificatiecode verzonden naar: {contact}",
  "register.message.sendVerificationCodeFailed": "Verificatiecode verzenden mislukt",
  "register.message.enterPhoneFirst": "Voer eerst telefoonnummer in",
  "register.message.correctPhoneFormat": "Voer correct telefoonnummerformaat in",
  "register.message.completeAccountInfoAndFixErrors": "Vul accountinformatie aan en herstel fouten",
  "register.message.companyRegistrationSuccess": "Bedrijfsregistratie succesvol!",
  "register.message.companyRegistrationFailed": "Bedrijfsregistratie mislukt",
  "register.message.staffRegistrationSuccess": "Medewerkerregistratie succesvol!",
  "register.message.staffRegistrationFailed": "Medewerkerregistratie mislukt",
  "register.message.phoneRegistrationNotAvailable": "Registratie via telefoonnummer is momenteel niet beschikbaar, blijf op de hoogte.",
  "register.tooltip.title": "Hoe vind ik de bedrijfsregistratiecode?",
  "register.tooltip.appPathTitle": "1. APP weergavepad",
  "register.tooltip.appPathDesc": "In APP-Gebruiker-Klik op profiel-Accountinformatie, vind de bedrijfsregistratiecode.",
  "register.tooltip.webPathTitle": "2. Backend systeem weergavepad",
  "register.tooltip.webPathDesc": "In Web-Organisatiebeheer-Organisatie-informatie, vind de bedrijfsregistratiecode.",
  "registerAccomplish.applicationComplete": "Aanvraag voltooid",
  "registerAccomplish.congratulations": "Gefeliciteerd, registratie voltooid.",
  "registerAccomplish.companyRegisterCodeIs": "Uw bedrijfsregistratiecode is",
  "registerAccomplish.certificationRequired": "Ga naar het certificeringscentrum om te certificeren, anders kunnen apparaten niet geactiveerd worden.",
  "registerAccomplish.greenChannelInfo": "Voor urgente situaties kunt u de snelle route kiezen voor tijdelijke activeringsrechten (2 maanden).",
  "registerAccomplish.certificationCenter": "Certificeringscentrum",
  "registerAccomplish.greenChannel": "Snelle route",
  "registerAccomplish.returnToLogin": "Terug naar loginpagina",
  "registerAccomplish.useHaierEnergyApp": "Gebruik Haier Energy APP om apparaten toe te voegen.",
  "registerAccomplish.applyingGreenChannel": "U vraagt de snelle route aan",
  "registerAccomplish.greenChannelDescription1": "Alleen voor urgente situaties om installaties niet te vertragen.",
  "registerAccomplish.greenChannelDescription2": "Tijdelijke rechten met 2 maanden geldigheid voor apparaatactivering.",
  "registerAccomplish.greenChannelDescription3": "Certificeer binnen 2 maanden in het certificeringscentrum voor permanente rechten.",
  "registerAccomplish.confirmSubmit": "Bevestigen en indienen",
  "registerAccomplish.returnToPrevious": "Terug naar vorige pagina",
  "registerAccomplish.applicationSubmittedSuccessfully": "Uw aanvraag is succesvol ingediend!",
  "registerAccomplish.missingAgentIdParameter": "Ontbrekende agentId parameter, kan snelle route niet aanvragen",
  "registerAccomplish.greenChannelApplicationSuccess": "Snelle route aanvraag succesvol!",
  "registerAccomplish.greenChannelApplicationFailed": "Snelle route aanvraag mislukt",
  "registerAccomplish.enterSystem": "Systeem betreden",
  "registerAccomplish.pleaseLoginFirst": "Log eerst in",
  "org.phoneNumber": "Telefoonnummer",
  "org.certificationStatus": "Certificeringsstatus",
  "org.permission": "Toestemming",
  "org.accountSource": "Accountbron",
  "org.certificationStatusTip": "Alleen rechten voor apparaattoevoeging in Haier Energy app",
  "org.unauthenticated": "Niet gecertificeerd",
  "org.authenticated": "Gecertificeerd",
  "org.noNeedToAuthenticate": "Geen certificering nodig",
  "org.unauthorized": "Niet geautoriseerd",
  "org.authorized": "Geautoriseerd",
  "org.temporaryAuthorization": "Tijdelijke autorisatie",
  "org.remainingDays": "Resterende dagen: {scope} dagen",
  "org.allocated": "Toegewezen",
  "org.registered": "Geregistreerd",
  "org.authorization": "Autorisatie",
  "org.addressDetail": "Detailadres",
  "org.postalCode": "Postcode",
  "org.accountSwitch": "Accountwissel",
  "org.viewAccountInfo": "Accountinformatie bekijken",
  "org.baseInfo": "Basisinformatie",
  "org.certificationInfo": "Certificeringsinformatie",
  "org.restDays": "Resterende dagen",
  "org.applyTime": "Aanvraagtijd",
  "org.certificationTime": "Certificeringstijd",
  "org.registerCode": "Registratiecode",
  "org.registrationTip": "Voer bij registratie de bedrijfsregistratiecode in om lid te worden.",
  "org.authenticationTip": "Dit account is uitgeschakeld, geen autorisatie mogelijk",
  "org.authenticationTip2": "Dit account is al geautoriseerd of tijdelijke autorisatie is nog geldig",
  "org.temporaryAuthorizationTip": "Autorisatie is tijdelijk (standaard 3 maanden)",
  "org.temporaryAuthorizationSuccess": "Autorisatie succesvol",
  "report.allSelect": "Alles selecteren",
  "report.compare": "Vergelijken",
  "report.energy": "Actief vermogen",
  "report.ipv": "DC stroom",
  "report.vpv": "DC spanning",
  "report.fac": "AC frequentie",
  "report.vac": "AC spanning",
  "report.iac": "AC stroom",
  "report.temperature": "Interne temperatuur",
  "report.str_cur": "String stroom",
  "report.inverterCompare": "Omvormer vergelijking",
  "report.inverterCompareTip": "Reeds aan lijst toegevoegd, niet opnieuw toevoegen",
  "report.pleaseChooseInverter": "Selecteer omvormer",
  "report.pleaseChooseCompare": "Selecteer vergelijkingsitem",
  "report.compareItem": "Vergelijkingsitem",
  "system.inverterCompare": "Omvormer parametervergelijking",
  "shipment.deviceSource": "Verzendingsbron",
  "shipment.shippingCustomer": "Verzendklant",
  "shipment.customerContact": "Klantcontactpersoon",
  "shipment.tag": "Label",
  "shipment.addTag": "Label toevoegen",
  "shipment.editTag": "Label bewerken",
  "shipment.tagContent": "Labelinhoud",
  "shipment.tagColor": "Labelkleur",
  "placeholder.selectShippingCustomer": "Selecteer verzendklant",
  "placeholder.enterCustomerContact": "Voer klantcontactpersoon in",
  "placeholder.selectTag": "Selecteer label",
  "placeholder.enterTagContent": "Voer labelinhoud in",
  "placeholder.noResult": "Geen overeenkomende labels",
  "validation.enterTagContent": "Voer labelinhoud in",
  "validation.selectTagColor": "Selecteer labelkleur",
  "shipment.operationRecordTitle": "Bewerkingsrecords",
  "shipment.boundUserWarning": "Sorry, dit apparaat is al gekoppeld aan een gebruiker en de verzendklant kan niet worden bijgewerkt.",
  "shipment.batchBoundUserWarning": "Sorry, de geselecteerde apparaten bevatten apparaten die al aan gebruikers zijn gekoppeld, en de verzendklant kan niet in batch worden bijgewerkt.",
  "shipment.uploadEquipmentListRequired": "Upload het apparatenlijstbestand",
  "shipment.errorDataTipTitle": "Abnormale gegevenswaarschuwing",
  "shipment.downloadImportResult": "Importresultaat downloaden",
  "shipment.downloading": "Downloaden...",
  "shipment.noFailedDataToDownload": "Geen mislukte gegevens beschikbaar om te downloaden",
  "shipment.deleteTagConfirm": "Weet u zeker dat u het label \"{tagName}\" wilt verwijderen?",
  "common.addSuccess": "Succesvol toegevoegd",
  "common.editSuccess": "Succesvol bewerkt",
  "system.intelligentDiagnosis": "Intelligente diagnose",
  "system.ivline": "IV-curve",
  "subtitle.ivlineCreate": "Scan taak",
  "diagnosis.diagnosisTime": "Diagnosetijd",
  "diagnosis.faultQuantity": "Aantal fouten",
  "diagnosis.scanCompleteTime": "Scan voltooiingstijd",
  "diagnosis.scanProgress": "Scan voortgang",
  "diagnosis.newTask": "Nieuwe taak",
  "diagnosis.deleteTask": "Taak verwijderen",
  "diagnosis.deleteTaskSuccess": "Taak succesvol verwijderd",
  "diagnosis.closeAll": "Alles wissen",
  "diagnosis.startScan": "Start scan",
  "diagnosis.pleaseChooseInverter": "Selecteer omvormer",
  "diagnosis.stringSetting": "String instelling",
  "diagnosis.taskSetting": "Taak instellen",
  "diagnosis.batchComponentSetting": "Batch component instelling",
  "diagnosis.componentType": "Component type",
  "diagnosis.maxPower": "Maximaal vermogen (Pmax)",
  "diagnosis.bestWorkingVoltage": "Optimale werkspanning (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Optimale werkstroom (lmpp)",
  "diagnosis.openCircuitVoltage": "Open circuit spanning (Voc)",
  "diagnosis.shortCircuitCurrent": "Kortsluitstroom (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Temperatuurcoëfficiënt maximaal vermogen",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Temperatuurcoëfficiënt open circuit spanning",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Temperatuurcoëfficiënt kortsluitstroom",
  "diagnosis.nominalComponentConversionEfficiency": "Nominale component conversie-efficiëntie",
  "diagnosis.firstYearDecayRate": "Eerste jaar degradatie",
  "diagnosis.yearlyDecayRate": "Jaarlijkse degradatie",
  "diagnosis.fillFactor": "Vul factor",
  "product.maxPvChannels": "Maximaal ondersteunde PV-kanalen",
  "product.componentManufacturer": "Component fabrikant",
  "product.componentType": "Component type",
  "product.ratedPower": "Gespecificeerd vermogen",
  "product.mppVoltage": "MPP spanning",
  "product.mppCurrent": "MPP stroom",
  "product.openCircuitVoltage": "Open circuit spanning",
  "product.shortCircuitCurrent": "Kortsluitstroom",
  "product.maxPowerTempCoeff": "Temperatuurcoëfficiënt maximaal vermogen",
  "product.openVoltageTempCoeff": "Temperatuurcoëfficiënt open circuit spanning",
  "product.shortCurrentTempCoeff": "Temperatuurcoëfficiënt kortsluitstroom",
  "product.componentEfficiency": "Nominale component conversie-efficiëntie",
  "product.firstYearDegradation": "Eerste jaar degradatie",
  "product.annualDegradation": "Jaarlijkse degradatie",
  "product.fillFactor": "Vul factor",
  "product.placeholder.range_0_9999_2dp": "0-9999, twee decimalen",
  "product.placeholder.range_0_99_2dp": "0-99, twee decimalen",
  "product.placeholder.range_0_999_2dp": "0-999, twee decimalen",
  "product.placeholder.range_neg1_1_2dp": "-1-1, twee decimalen",
  "product.rule.range_0_9999_2dp": "Voer getal tussen 0-9999 in, max. twee decimalen",
  "product.rule.range_0_99_2dp": "Voer getal tussen 0-99 in, max. twee decimalen",
  "product.rule.range_0_999_2dp": "Voer getal tussen 0-999 in, max. twee decimalen",
  "product.rule.range_neg1_1_2dp": "Voer getal tussen -1-1 in, max. twee decimalen",
  "product.ivScanSupport": "Ondersteunt IV-curve scan",
  "diagnosis.componentManufacturer": "Component fabrikant",
  "diagnosis.componentAmount": "Aantal componenten",
  "diagnosis.capacity": "String capaciteit",
  "diagnosis.stringAmount": "Aantal strings (panelen)",
  "diagnosis.inverterSerialNumber": "Omvormer serienummer",
  "diagnosis.totalCapacity": "Totale string capaciteit",
  "diagnosis.pleaseFillInAllItems": "Niet alle items ingevuld, controleer",
  "diagnosis.moreParamters": "Meer parameters",
  "diagnosis.envParam": "Omgevingsparameters",
  "diagnosis.startTask": "Taak starten",
  "diagnosis.startTaskSuccess": "Taak succesvol gestart",
  "diagnosis.start": "Starten",
  "diagnosis.noDevice": "Geen apparaten gevonden",
  "register.contactAdminForCode": "Neem contact op met bedrijfsbeheerder voor registratiecode",
  "register.provideCompanyInfoBelow": "Vul hieronder bedrijfsinformatie in",
  "login.success": "Inloggen succesvol",
  "flowData.existingInvTip": "Opmerking:\nExterne omvormer >0 betekent dat zonne-energie wordt opgewekt;\nExterne omvormer <0 betekent dat de externe omvormer stroom verbruikt.",
  "flowData.alert": "Huidige externe omvormer <0, betekent dat de externe omvormer stroom verbruikt.",
  "dialog.confirm": "Begrepen",
  "paramters.deviceTotalInformation": "Apparaat totale informatie",
  "paramters.innerInverter": "Interne omvormer",
  "paramters.outerInverter": "Externe omvormer",
  "paramters.outerInverterFromPvSide": "Van PV-zijde meter",
  "paramters.activePower": "Actief vermogen",
  "paramters.apparentPower": "Schijnbaar vermogen",
  "paramters.reactivePower": "Reactief vermogen",
  "paramters.powerFactor": "Vermogensfactor",
  "paramters.phaseA": "Fase A",
  "paramters.phaseB": "Fase B",
  "paramters.phaseC": "Fase C",
  "paramters.charge": "Opladen",
  "paramters.discharge": "Ontladen",
  "paramters.sell": "Verkopen",
  "paramters.buy": "Kopen",
  "bw_param_ctrl_group_WorkMode": "Werkmodus",
  "bw_param_ctrl_name_GRID_Meter_negate": "Netmeter/CT richting instelling",
  "bw_param_ctrl_name_GridBreake": "Net gebruiksbeperking",
  "bw_param_ctrl_name_BBSOC_lx1": "L1 uitschakel SOC waarde",
  "bw_param_ctrl_name_BBSOC_lx2": "L2 uitschakel SOC waarde",
  "bw_param_ctrl_name_BBSOC_lx3": "L3 uitschakel SOC waarde",
  "bw_param_ctrl_option_ON": "Inschakelen",
  "bw_param_ctrl_name_Systemmode": "Systeem modus",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS reserve SOC",
  "bw_param_ctrl_option_OFF": "Uitschakelen",
  "bw_param_ctrl_option_B5": "Enkelfase 5KW model",
  "bw_param_ctrl_name_InvSub": "Model type",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "Maximaal netinjectie percentage",
  "bw_param_ctrl_option_T4": "Driefase 4KW model",
  "bw_param_ctrl_option_T5": "Driefase 5KW model",
  "bw_param_ctrl_option_T6": "Driefase 6KW model",
  "bw_param_ctrl_option_T8": "Driefase 8KW model",
  "bw_param_ctrl_option_S3": "Enkelfase opslag 3KW model",
  "bw_param_ctrl_option_S5": "Enkelfase opslag 5KW model",
  "bw_param_ctrl_option_S6": "Enkelfase opslag 6KW model",
  "bw_param_ctrl_option_S8": "Enkelfase opslag 8KW model",
  "bw_param_ctrl_option_Grid&PV useCT": "Net en PV gebruiken CT",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "Verhouding maximaal netinjectievermogen tot PV capaciteit (inclusief alle aangesloten PV-systemen)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Net en PV gebruiken meter",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Totale PV capaciteit aangesloten op opslagomvormer",
  "bw_param_ctrl_option_T10": "Driefase 10KW model",
  "bw_param_ctrl_name_DispatchReactivepower": "Reactief vermogen dispatch",
  "bw_param_ctrl_name_Grid_Regulation": "Net regelgeving",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Inschakelen laad/ontlaad tijdsbesturing",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Werkmodus",
  "bw_param_ctrl_note_BatteryReady": "Battery Ready functie, standaard 'met batterij'. Kies 'zonder batterij' als geen batterij is aangesloten of gebruikt.",
  "bw_param_ctrl_option_withBattery": "Met batterij",
  "bw_param_ctrl_name_PV_Meter_negate": "PV-meter omgekeerd aangesloten vlag",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Alleen ontladen tijdsbesturing inschakelen",
  "bw_param_ctrl_name_EMSReset": "EMS herstarten",
  "bw_param_ctrl_name_FactoryReset": "Systeem initialiseren",
  "bw_param_ctrl_name_DSPReset": "DSP herstarten",
  "bw_param_ctrl_group_RemoteReset": "Externe herstart",
  "bw_param_ctrl_option_FactoryReset": "Herstarten",
  "bw_param_ctrl_option_DSPReset": "Herstarten",
  "bw_param_ctrl_option_EMSReset": "Herstarten",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "L1 strategie prioriteit",
  "bw_param_ctrl_name_BBPrio_lx2": "L2 strategie prioriteit",
  "bw_param_ctrl_name_BBPrio_lx3": "L3 strategie prioriteit",
  "bw_param_ctrl_note_BBSOC_lx3": "Prioriteit 3 SOC moet hoger zijn dan prioriteit 1 en 2 SOC",
  "bw_param_ctrl_note_BBSOC_lx1": "Prioriteit 1 SOC moet de laagste zijn van L1, L2, L3",
  "bw_param_ctrl_note_BBSOC_lx2": "Prioriteit 2 SOC moet hoger zijn dan prioriteit 1 SOC",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Backup-Box inschakelen",
  "bw_param_ctrl_name_MeterCTSelect": "Meter/CT installatie optie",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Net gebruikt CT, PV gebruikt meter",
  "bw_param_ctrl_name_ChargeCutSoc": "Laad stop SOC",
  "bw_param_ctrl_option_HybridMode": "Hybride modus",
  "bw_param_ctrl_name_PVCapacityStorage": "PV capaciteit opslagomvormer",
  "bw_param_ctrl_name_DispatchTime": "Dispatch tijd",
  "bw_param_ctrl_name_DispatchStart": "Dispatch (forceer laad/ontlaad) schakelaar",
  "bw_param_ctrl_name_UPSreserveenable": "UPS reserve inschakelen",
  "bw_param_ctrl_option_selfuse": "Zelf gebruik",
  "bw_param_ctrl_option_DCMode": "DC modus",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "Opslagsysteem PV capaciteit",
  "bw_param_ctrl_name_RTC": "Klok instellen",
  "bw_param_ctrl_option_Normal": "Normaal",
  "bw_param_ctrl_group_SystemInfo": "Systeeminformatie",
  "bw_param_ctrl_note_Systemmode": "DC: Nieuwe PV-systemen met hybride omvormers, of opslagomvormers zonder PV. AC: Bestaande PV-systemen met omvormers op het net. Hybrid: Combinatie van directe PV-aansluiting op hybride omvormer en bestaande PV-omvormers op het net.",
  "bw_param_ctrl_group_GridMeterSettings": "Meter instellingen",
  "bw_param_ctrl_option_Forced charging and discharging": "Geforceerd laden en ontladen",
  "bw_param_ctrl_note_ChargeCutSoc": "Maximale SOC laadwaarde voor batterij",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Alleen laden tijdsbesturing inschakelen",
  "bw_param_ctrl_option_Disable": "Uitschakelen",
  "bw_param_ctrl_group_BatterySettings": "Batterij instellingen",
  "bw_param_ctrl_name_BatteryReady": "Batterij inschakeling",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Net gebruikt meter, PV gebruikt CT",
  "bw_param_ctrl_name_DispatchSOC": "Dispatch SOC",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Tijdsbesturing uitschakelen",
  "bw_param_ctrl_option_Enable": "Inschakelen",
  "bw_param_ctrl_option_TOU": "TOU",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Geforceerd laadtijd 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Geforceerd laadtijd 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "Laad/ontlaad instellingen zijn alleen effectief in 'TOU' modus.",
  "bw_param_ctrl_group_GridSafetyConfig": "Net veiligheidsconfiguratie",
  "bw_param_ctrl_group_SystemConfig": "Systeemconfiguratie",
  "bw_param_ctrl_option_ACMode": "AC modus",
  "bw_param_ctrl_option_Reverse": "Omkeren",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "Laad/ontlaad functie niet ingeschakeld",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Laad/ontlaad instellingen",
  "bw_param_ctrl_name_DispatchMode": "Dispatch modus",
  "bw_param_ctrl_note_GridBreake": "Selecteer op basis van daadwerkelijke specificaties van de netstroomonderbreker. Foute waarden kunnen tot uitschakeling leiden.",
  "bw_param_ctrl_note_PVCapacityStorage": "Totale PV capaciteit aangesloten op PV-omvormer.",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Geforceerd ontladen tijd 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Geforceerd ontladen tijd 1",
  "bw_param_ctrl_group_GridDispatch": "Net dispatch",
  "bw_param_ctrl_name_DispatchActivepower": "Actief vermogen dispatch",
  "jl_param_ctrl_group_OnOff": "Omvormer schakelaar",
  "jl_param_ctrl_name_OnOff": "Omvormer schakelaar",
  "jl_param_ctrl_option_PowerOFF": "Uitschakelen",
  "jl_param_ctrl_option_PowerON": "Inschakelen",
  "product.multipleLanguage": "Multi-taal instelling apparaatmodel",
  "product.multipleLanguageNote": "Multi-taal termenbibliotheek apparaatmodel",
  "product.entryCode": "Term code",
  "product.entryValue": "Term waarde",
  "product.endpoint": "Endpoint",
  "product.module": "Module",
  "product.tag": "Label",
  "product.editLanguage": "Bewerk multi-taal",
  "product.addLanguage": "Voeg multi-taal toe",
  "product.maintainInfo": "Onderhoudsinformatie",
  "product.statusChangeSuccess": "Statuswijziging succesvol",
  "product.statusChangeFail": "Statuswijziging mislukt",
  "button.sync": "Synchroniseer taalpakketten",
  "plant.withdrawDelivery": "Levering intrekken",
  "plant.deliverUser": "Gebruiker leveren",
  "plant.withdrawDeliveryTip": "Na intrekking kan de eindgebruiker dit station niet meer beheren. Wees voorzichtig.",
  "plant.undelivered": "Niet geleverd",
  "plant.deliverManage": "Leveringsbeheer",
  "plant.email_format_error": "E-mailformaat fout",
  "plant.deliverUserTip": "Gebruikers kunnen via Haier Energy APP de door u geïnstalleerde apparaten monitoren en bedienen.",
  "plant.enterUserAccount": "Voer het gebruikersaccount in",
  "plant.deliverUserTipUnified": "Opmerking: gebruikers kunnen met telefoonnummer of e-mail inloggen op Haier Energy en via de app uw geinstalleerde apparaten bewaken en bedienen.",
  "plant.placeholderPhoneOrEmail": "Voer telefoonnummer of e-mail in",
  "plant.phoneOrEmailFormatError": "Voer een geldig telefoonnummer of e-mailadres in",
  "plant.deliverSuccess": "Levering succesvol",
  "plant.known": "Begrepen",
  "plant.notRegistered": "Niet geregistreerd",
  "plant.noPermission": "U heeft geen toestemming om levering in te trekken. Alleen platform superbeheerders en installateurbeheerders kunnen dit doen.",
  "plant.scanQRCode": "Laat de eigenaar de onderstaande QR-code scannen",
  "plant.qrCodeExpireTip": "Na ontvangst wordt deze autorisatiecode ongeldig",
  "plant.transferMethod": "Overdrachtsmethode",
  "plant.transferRecord": "Overdrachtsrecords",
  "plant.operationTime": "Tijdstip van bewerking",
  "plant.operator": "Operator",
  "plant.transferType": "Overdrachtstype",
  "plant.userIdentifier": "Gebruikersidentificatie",
  "plant.transferResult": "Overdrachtsresultaat",
  "plant.totalRecordCount": "Totaal {count} records",
  "device.Yield": "Hybride omvormer",
  "device.ExistingINV": "Externe omvormer",
  "sidebar.dictManage": "Woordenboek beheer",
  "subtitle.dictData": "Woordenboekgegevens",
  "dict.dictname": "Woordenboek label",
  "dict.dictnameen": "Woordenboek sleutel",
  "dict.dictdataname": "Gegevens label",
  "dict.dictdatavalue": "Gegevens sleutel",
  "dict.i18nCode": "Taal code",
  "dict.dictsort": "Sortering",
  "dict.addDict": "Woordenboek toevoegen",
  "dict.addDictData": "Woordenboekgegevens toevoegen",
  "dict.editDict": "Woordenboek bewerken",
  "dict.editDictData": "Woordenboekgegevens bewerken",
  "device.otaTabTip": "Na update zal het apparaat kort offline zijn, herstart het apparaat.",
  "product.accessPlatform": "Platform bron",
  "product.valueFilter": "Lege termen",
  "product.multipleEdit": "Batch bewerken",
  "product.mutipleDelete": "Batch verwijderen",
  "setting.type22.restrictCounterCurrent.val1": "Beperk totaal driefasig vermogen",
  "setting.type22.restrictCounterCurrent.val2": "Beperk enkelfasig vermogen",
  "setting.type22.disable": "Uitschakelen",
  "setting.type22.enable": "Inschakelen",
  "setting.type22.meterSelect.str": "StoneRui meter",
  "setting.type22.meterSelect.df": "Dongfan meter",
  "setting.type22.meterSelect.dh": "Donghong meter",
  "setting.type22.meterSelect.zt": "Chint meter",
  "setting.type22.meterSelect.yb": "Yibang",
  "setting.type22.meterSelect.yz": "Yingzhen",
  "setting.type22.meterSelect.nky": "Nengkongyun smart meter",
  "bw_RTparam_name_AFCI_Version": "AFCI versienummer",
  "bw_RTparam_name_allowCharged": "Laad/ontlaad toestaan",
  "bw_RTparam_name_ApparentPOAP_Grid": "Meter A schijnbaar vermogen",
  "bw_RTparam_name_ApparentPOBP_Grid": "Meter B schijnbaar vermogen",
  "bw_RTparam_name_ApparentPOCP_Grid": "Meter C schijnbaar vermogen",
  "bw_RTparam_name_BackupCurrentR": "Backup R-fase stroom",
  "bw_RTparam_name_BackupCurrentS": "Backup S-fase stroom",
  "bw_RTparam_name_BackupCurrentT": "Backup T-fase stroom",
  "bw_RTparam_name_BackupFrequency": "Backup frequentie",
  "bw_RTparam_name_BackupPower": "Backup actief vermogen",
  "bw_RTparam_name_BackupVoltageR": "Backup R-fase spanning",
  "bw_RTparam_name_BackupVoltageS": "Backup S-fase spanning",
  "bw_RTparam_name_BackupVoltageT": "Backup T-fase spanning",
  "bw_RTparam_name_batDcdcVersion": "Batterij DCDC versienummer",
  "bw_RTparam_name_BatteryChargeCut-offVoltage": "Systeem laadafsluit spanning",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Batterij energie van net",
  "bw_RTparam_name_BatteryChargingCurrentLimit": "Batterij laadstroom limiet",
  "bw_RTparam_name_BatteryCurrent": "Batterij stroom",
  "bw_RTparam_name_BatteryDischargeCurrentLimit": "Batterij ontlaadstroom limiet",
  "bw_RTparam_name_BatteryDischargeCut-offVoltage": "Systeem ontlaadafsluit spanning",
  "bw_RTparam_name_BatteryMaxChargePower": "Maximaal toegestaan laadvermogen omvormer",
  "bw_RTparam_name_BatteryMaxDischargePower": "Maximaal toegestaan ontlaadvermogen omvormer",
  "bw_RTparam_name_BatteryMode": "BMS modus",
  "bw_RTparam_name_BatteryModel": "Batterij model",
  "bw_RTparam_name_BatteryNum": "Aantal batterijpakketten",
  "bw_RTparam_name_BatteryPower": "Batterij vermogen",
  "bw_RTparam_name_BatteryRelayStatus": "BMS relais status",
  "bw_RTparam_name_BatteryRunningTime": "Totale looptijd",
  "bw_RTparam_name_BatterySN": "Batterij SN (besturingskast)",
  "bw_RTparam_name_BatterySN1": "Batterijpakket 1 SN",
  "bw_RTparam_name_BatterySN2": "Batterijpakket 2 SN",
  "bw_RTparam_name_BatterySN3": "Batterijpakket 3 SN",
  "bw_RTparam_name_BatterySN4": "Batterijpakket 4 SN",
  "bw_RTparam_name_BatterySN5": "Batterijpakket 5 SN",
  "bw_RTparam_name_BatterySN6": "Batterijpakket 6 SN",
  "bw_RTparam_name_BatterySOC": "Batterij SOC",
  "bw_RTparam_name_BatterySOH": "Batterij SOH",
  "bw_RTparam_name_BatteryStatus": "BMS status",
  "bw_RTparam_name_BatteryVersion": "Batterij versienummer",
  "bw_RTparam_name_BatteryVoltage": "Batterij spanning",
  "bw_RTparam_name_BatWarnningPack": "Exacte foutlocatie batterij",
  "bw_RTparam_name_BB_Version": "Backup Box versienummer",
  "bw_RTparam_name_buy": "Kopen",
  "bw_RTparam_name_charge": "Laad/ontlaad functie niet ingeschakeld",
  "bw_RTparam_name_ChargeCutSoc": "SOC bovengrens",
  "bw_RTparam_name_charging": "Laad toestaan, ontlaad verbieden",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Meter A-fase stroom",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Meter B-fase stroom",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Meter C-fase stroom",
  "bw_RTparam_name_DailyDeviceEnergy": "Dagelijkse totale opwekking",
  "bw_RTparam_name_DailyEnergyfromGrid": "Dagelijkse gekochte energie",
  "bw_RTparam_name_DailyEnergytoGrid": "Dagelijkse verkochte energie",
  "bw_RTparam_name_DataloggerSN": "Serienummer",
  "bw_RTparam_name_DataloggerVersion": "Logger versie",
  "bw_RTparam_name_DataUploadCycle": "Gegevensupload interval",
  "bw_RTparam_name_deviceRunningState": "Apparaat status",
  "bw_RTparam_name_DongleRssi": "Signaalsterkte",
  "bw_RTparam_name_dontBuy": "Niet koop/verkoop",
  "bw_RTparam_name_electricity": "Net gebruikt meter, PV gebruikt CT",
  "bw_RTparam_name_forbidden": "Laad verbieden, ontlaad toestaan",
  "bw_RTparam_name_ForceChargingSOC": "Geforceerd laad SOC",
  "bw_RTparam_name_forced": "Geforceerd laden/ontladen",
  "bw_RTparam_name_forcedCharge": "Geforceerd laden, ontlaad toestaan",
  "bw_RTparam_name_forcedCharging": "Geforceerd laden, ontlaad verbieden",
  "bw_RTparam_name_Frequent_PV": "Meter frequentie",
  "bw_RTparam_name_Fullchargecapacityofbattery": "Volledige laadcapaciteit",
  "bw_RTparam_name_grid": "Net en PV gebruiken meter",
  "bw_RTparam_name_gridCT": "Net gebruikt CT, PV gebruikt meter",
  "bw_RTparam_name_GridCurrentL1": "Net stroom L1",
  "bw_RTparam_name_GridCurrentL2": "Net stroom L2",
  "bw_RTparam_name_GridCurrentL3": "Net stroom L3",
  "bw_RTparam_name_GridFrequency": "Net frequentie",
  "bw_RTparam_name_GridFrequencyINV": "Omvormer netfrequentie (gekoppeld)",
  "bw_RTparam_name_GridLoadPower": "Net belastingsvermogen",
  "bw_RTparam_name_GridPowerL1": "Net actief vermogen L1",
  "bw_RTparam_name_GridPowerL2": "Net actief vermogen L2",
  "bw_RTparam_name_GridPowerL3": "Net actief vermogen L3",
  "bw_RTparam_name_GridStatus": "Net status",
  "bw_RTparam_name_GridTotalActivePower": "Totaal net vermogen (actief)",
  "bw_RTparam_name_GridVoltageL1": "Net spanning L1",
  "bw_RTparam_name_GridVoltageL2": "Net spanning L2",
  "bw_RTparam_name_GridVoltageL3": "Net spanning L3",
  "bw_RTparam_name_InvActivePower": "Omvormer actief vermogen",
  "bw_RTparam_name_InvApparentPower": "Omvormer schijnbaar vermogen",
  "bw_RTparam_name_InvCurrentR": "Omvormer L1-fase stroom",
  "bw_RTparam_name_InvCurrentS": "Omvormer L2-fase stroom",
  "bw_RTparam_name_InvCurrentT": "Omvormer L3-fase stroom",
  "bw_RTparam_name_InverterInternalOperatingAmbientTemperature": "Interne omgevingstemperatuur omvormer",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Master software versie",
  "bw_RTparam_name_InvModuleTemperature": "INV module temperatuur",
  "bw_RTparam_name_InvPowerFactor": "Omvormer vermogensfactor",
  "bw_RTparam_name_InvReactivePower": "Omvormer reactief vermogen",
  "bw_RTparam_name_LANIP": "LAN IP",
  "bw_RTparam_name_Locationofthehighesttemperaturebatterycellinthesystem": "Locatie hoogste temperatuur cel",
  "bw_RTparam_name_Locationofthelowesttemperaturebatterycellinthesystem": "Locatie laagste temperatuur cel",
  "bw_RTparam_name_Mac": "MAC adres",
  "bw_RTparam_name_Maximumcellvoltage": "Hoogste celspanning",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Hoogste batterij temperatuur",
  "bw_RTparam_name_Meter.CTSetting": "Meter/CT",
  "bw_RTparam_name_MeterInstallationLocation": "Meter installatielocatie",
  "bw_RTparam_name_MeterTypeandInstallationLocation": "Meter type en installatielocatie",
  "bw_RTparam_name_Minimumcellvoltage": "Laagste celspanning",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Laagste batterij temperatuur",
  "bw_RTparam_name_noCharging": "Laad/ontlaad verbieden",
  "bw_RTparam_name_offline": "Offline",
  "bw_RTparam_name_online": "Online",
  "bw_RTparam_name_OverDischargeSOC": "Overontlaad SOC",
  "bw_RTparam_name_PackIDofMaxCellTemperature": "ID pakket hoogste cel temperatuur",
  "bw_RTparam_name_PackIDofMaxCellVoltage": "ID pakket hoogste cel spanning",
  "bw_RTparam_name_PackIDofMinCellTemperature": "ID pakket laagste cel temperatuur",
  "bw_RTparam_name_PackIDofMinCellVoltage": "ID pakket laagste cel spanning",
  "bw_RTparam_name_PFOA_Grid": "Meter A vermogensfactor",
  "bw_RTparam_name_PFOB_Grid": "Meter B vermogensfactor",
  "bw_RTparam_name_PFOC_Grid": "Meter C vermogensfactor",
  "bw_RTparam_name_photovoltaics": "Net en PV gebruiken CT",
  "bw_RTparam_name_Positionofthehighestvoltagecellinthesystem": "Locatie hoogste spanning cel",
  "bw_RTparam_name_Positionofthelowestvoltagebatterycellinthesystem": "Locatie laagste spanning cel",
  "bw_RTparam_name_Power-onTime": "Huidige aanlooptijd",
  "bw_RTparam_name_PowerBoardTemperature": "Vermogensmodule temperatuur",
  "bw_RTparam_name_PSSILevel": "Signaalsterkte niveau",
  "bw_RTparam_name_PV1Current": "PV1 real-time stroom",
  "bw_RTparam_name_PV1Power": "PV1 real-time vermogen",
  "bw_RTparam_name_PV1Voltage": "PV1 real-time spanning",
  "bw_RTparam_name_PV2Current": "PV2 real-time stroom",
  "bw_RTparam_name_PV2Power": "PV2 real-time vermogen",
  "bw_RTparam_name_PV2Voltage": "PV2 real-time spanning",
  "bw_RTparam_name_PV3Current": "PV3 real-time stroom",
  "bw_RTparam_name_PV3Power": "PV3 real-time vermogen",
  "bw_RTparam_name_PV3Voltage": "PV3 real-time spanning",
  "bw_RTparam_name_PvBoostTemperature": "Boost module temperatuur",
  "bw_RTparam_name_PVConnectState": "Apparaat status",
  "bw_RTparam_name_PVMeterNegate": "PV-meter omgekeerd aangesloten vlag",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "Meter A actief vermogen",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "Meter B actief vermogen",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Meter C actief vermogen",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Meter A schijnbaar vermogen",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Meter B schijnbaar vermogen",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Meter C schijnbaar vermogen",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Meter A vermogensfactor",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Meter B vermogensfactor",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Meter C vermogensfactor",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Meter A reactief vermogen",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Meter B reactief vermogen",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Meter C reactief vermogen",
  "bw_RTparam_name_ReactivePOAP_Grid": "Meter A reactief vermogen",
  "bw_RTparam_name_ReactivePOBP_Grid": "Meter B reactief vermogen",
  "bw_RTparam_name_ReactivePOCP_Grid": "Meter C reactief vermogen",
  "bw_RTparam_name_RSSI": "Signaalsterkte",
  "bw_RTparam_name_sell": "Verkopen",
  "bw_RTparam_name_SSID": "SSID/Wifi naam",
  "bw_RTparam_name_State": "Dongle status",
  "bw_RTparam_name_Systemmaximumtemperaturecellserialnumber": "Serienummer hoogste temperatuur cel",
  "bw_RTparam_name_Systemmaximumvoltagecellserialnumber": "Serienummer hoogste spanning cel",
  "bw_RTparam_name_Systemminimumtemperaturecellserialnumber": "Serienummer laagste temperatuur cel",
  "bw_RTparam_name_Systemminimumvoltagecellserialnumber": "Serienummer laagste spanning cel",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "Totale opwekking apparaat (incl. PV-meter)",
  "bw_RTparam_name_TodayConsumption": "Dagelijkse verbruik",
  "bw_RTparam_name_TodayGridLoadConsumption": "Dagelijks net belastingsverbruik",
  "bw_RTparam_name_TodayYield": "Dagelijkse opwekking",
  "bw_RTparam_name_TotalActivePower_PV": "Meter actief vermogen (totaal)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Meter schijnbaar vermogen (totaal)",
  "bw_RTparam_name_TotalApparentPower_PV": "Meter schijnbaar vermogen (totaal)",
  "bw_RTparam_name_TotalConsumption": "Cumulatief laadvermogen",
  "bw_RTparam_name_TotalConsumptionEnergy": "Cumulatief energieverbruik",
  "bw_RTparam_name_TotalConsumptionPower": "Totaal verbruiksvermogen",
  "bw_RTparam_name_TotalDevicePower": "Totaal vermogen",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Opgenomen energie",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Teruggestuurde energie",
  "bw_RTparam_name_TotalEnergyfromBattery": "Cumulatief ontladen vermogen",
  "bw_RTparam_name_TotalEnergyfromGrid": "Cumulatief gekocht vermogen",
  "bw_RTparam_name_TotalEnergyInvInput": "Totale omvormer input energie",
  "bw_RTparam_name_TotalEnergyInvOutput": "Totale omvormer output energie",
  "bw_RTparam_name_TotalEnergytoGrid": "Cumulatief verkocht vermogen",
  "bw_RTparam_name_TotalGridLoadConsumption": "Cumulatief net belastingsverbruik",
  "bw_RTparam_name_TotalOperationTime": "Cumulatieve looptijd",
  "bw_RTparam_name_TotalPower": "Totaal vermogen",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Meter vermogensfactor (totaal)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Meter vermogensfactor (totaal)",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Meter vermogensfactor (totaal) 1",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Cumulatieve totale opwekking (intern+extern)",
  "bw_RTparam_name_TotalReactivePower_Grid": "Meter reactief vermogen (totaal)",
  "bw_RTparam_name_TotalReactivePower_PV": "Meter reactief vermogen (totaal)",
  "bw_RTparam_name_TotalRuntime": "PV totale looptijd",
  "bw_RTparam_name_TotalYield": "Cumulatieve opwekking",
  "bw_RTparam_name_UPSReserveSoc": "SOC ondergrens (gekoppeld)",
  "bw_RTparam_name_vatBmsVersion": "Batterijpakket versienummer",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Meter A-fase spanning",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Meter B-fase spanning",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Meter C-fase spanning",
  "bw_RTparam_name_WiFiType": "Netwerk type",
  "org.keyFilter": "Zoek op trefwoord",
  "language.zoneTip": "Deze tijd is Oost-Europa tijd (UTC+8)",
  "shipment.confirmDownload": "Lijst downloaden",
  "shipment.updateCustomer": "Verzendklant bijwerken",
  "shipment.invalidEquipmentList": "Download ongeldige apparatenlijst (10 minuten geldig)? Aantal ongeldige apparaten: ",
  "shipment.fileExpired": "Bestand verlopen",
  "common.maintain": "Onderhoud eerst",
  "screen.platform": "Platform voor Energiebeheer",
  "plantScreen.title": "Installatiebeheer",
  "plantScreen.DailyElectricityGenerated": "Dagelijkse Opgewekte Elektriciteit",
  "plantScreen.DailyElectricityUsed": "Dagelijkse Gebruikte Elektriciteit",
  "plantScreen.DailyElectricityPurchased": "Dagelijkse Gekochte Elektriciteit",
  "plantScreen.DailyElectricitySold": "Dagelijkse Verkochte Elektriciteit",
  "plantScreen.ChargingStatus": "Laadstatus",
  "plantScreen.BatteryLevel": "Batterijniveau",
  "plantScreen.PhotovoltaicStatus": "PV-status",
  "plantScreen.GridStatus": "Netstatus",
  "plantScreen.Charging": "Aan het laden",
  "plantScreen.Discharging": "Aan het ontladen",
  "plantScreen.Generating": "Aan het opwekken",
  "plantScreen.Idle": "Inactief",
  "plantScreen.pvIDLE": "Niet aan het opwekken",
  "plantScreen.BuyingElectricity": "Elektriciteit Kopen",
  "plantScreen.SellingElectricity": "Elektriciteit Verkopen",
  "plantScreen.netdead": "Off-grid",
  "plantScreen.day": "Dag",
  "plantScreen.month": "Maand",
  "plantScreen.year": "Jaar",
  "plantScreen.life": "Totaal",
  "plantScreen.BatterySOC": "Batterij SOC",
  "plantScreen.PowerAnalysis": "Vermogensanalyse",
  "plantScreen.EquivalentRevenue": "Gelijkwaardige Opbrengst",
  "plantScreen.EnergyAnalysis": "Energie-analyse",
  "plantScreen.SocialContribution": "Sociale Bijdrage",
  "plantScreen.Photovoltaic": "Fotovoltaïsch",
  "plantScreen.Grid": "Elektriciteitsnet",
  "plantScreen.Battery": "Accu",
  "plantScreen.Load": "Belasting",
  "plantScreen.Daily": "Dagelijks",
  "plantScreen.Monthly": "Maandelijks",
  "plantScreen.Yearly": "Jaarlijks",
  "plantScreen.Cumulative": "Cumulatief",
  "plantScreen.Unit": "Eenheid",
  "plantScreen.ElectricityGeneration": "Elektriciteitsproductie",
  "plantScreen.ElectricityConsumption": "Elektriciteitsverbruik",
  "plantScreen.ChartSet.explain": "Nota: Vermogen > 0 = Ontladen; Vermogen < 0 = Laden.",
  "plantScreen.ChartSet.Self-consumption": "Zelfconsumptie",
  "plantScreen.ChartSet.GridElectricity": "Netvoeding",
  "plantScreen.ChartSet.Self-Sufficiency": "Zelfvoorziening",
  "plantScreen.ChartSet.PurchasedElectricity": "Gekochte Elektriciteit",
  "plantScreen.ChartSet.PVPower": "PV-vermogen",
  "plantScreen.ChartSet.ConsumptionPower": "Verbruiksvermogen",
  "plantScreen.ChartSet.BatterySOC": "Batterij SOC",
  "plantScreen.ChartSet.BatteryChargingPower": "Accu-laadvermogen",
  "plantScreen.ChartSet.BatteryDischargingPower": "Accu-ontlaadvermogen",
  "plantScreen.ProtectedForest": "Beschermd Bos",
  "plantScreen.CO2Emission": "CO2-uitstoot",
  "plantScreen.Media": "Steenkool",
  "plant.EquivalentBenefit.GridView": "Gelijkwaardig Voordeel = Zelfconsumptie * Inkooptarief + Netvoeding * Verkooptarief",
  "plant.MonitoringScreen": "Monitoring Scherm",
  "plantScreen.ChartSet.explainPower": "Nota: Netvermogen > 0 = Elektriciteit verkopen; Netvermogen < 0 = Elektriciteit kopen.",
  "priceConfig.currentEffectivePrice": "Huidige geldige tarief",
  "priceConfig.currencyUnitLabel": "Valuta-eenheid:",
  "priceConfig.addPrice": "Tarief toevoegen",
  "priceConfig.effectiveTimeLabel": "Geldigheidsperiode",
  "priceConfig.powerPrice": "Energietarief",
  "priceConfig.additionalFees": "Extra kosten",
  "priceConfig.lastUpdateTime": "Laatst bijgewerkt",
  "priceConfig.lastUpdateTimeLabel": "Laatst bijgewerkt",
  "priceConfig.emptyCurrent": "Er is momenteel geen geldig tarief. Klik op de knop om te configureren.",
  "priceConfig.emptyUpcoming": "Geen aankomende tarieven",
  "priceConfig.upcomingTitle": "Aankomend tarief",
  "priceConfig.copyPriceTitle": "Tarief kopiëren",
  "priceConfig.deletePriceTitle": "Tarief verwijderen",
  "priceConfig.deleteConfirmText": "Bevestig het verwijderen van het volgende tarief",
  "priceConfig.otherPrice": "Overige kosten",
  "priceConfig.deleteWarning": "Als dit tarief momenteel geldig is, heeft dit invloed op de opbrengstberekening en de uitvoering van AI-strategieën.",
  "priceConfig.priceTypeLabel": "Type tarief",
  "priceConfig.timeOfUse": "Uurtarief",
  "priceConfig.dynamic": "Dynamisch",
  "priceConfig.timeOfUsePrice": "Uurtarief",
  "priceConfig.dynamicPrice": "Dynamisch tarief",
  "priceConfig.effectiveDatePlaceholder": "Selecteer een ingangsdatum",
  "priceConfig.copyEffectiveDatePlaceholder": "Selecteer een ingangsdatum",
  "priceConfig.nextStep": "Volgende",
  "priceConfig.buyPriceTitle": "Aankooptarief",
  "priceConfig.feedInPriceTitle": "Teruglevertarief",
  "priceConfig.addTimePeriod": "Tijdsinterval toevoegen",
  "priceConfig.electricitySurchargeTitle": "Energie-toeslag",
  "priceConfig.electricitySurchargeTooltip": "Extra toeslag per gekochte kWh.",
  "priceConfig.fixedFeeTitle": "Vast bedrag",
  "priceConfig.fixedFeeTooltip": "Vaste basisvergoeding per facturatieperiode, onafhankelijk van verbruik of vermogen.",
  "priceConfig.hasFeeYes": "Ja",
  "priceConfig.countryLabel": "Land",
  "priceConfig.secondaryRegionLabel": "Regio (niveau 2)",
  "priceConfig.secondaryRegionPlaceholder": "Selecteer een regio (niveau 2)",
  "priceConfig.currencyUnitPlaceholder": "Selecteer een valuta-eenheid",
  "priceConfig.powerMarketLabel": "Stroommarkt",
  "priceConfig.powerMarketPlaceholder": "Selecteer een stroommarkt",
  "priceConfig.electricitySurchargePlaceholder": "Max. 7 gehele cijfers, 8 decimalen, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "Max. 7 gehele cijfers, 8 decimalen, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Voer elektriciteitsprijs in (max. 7 gehele cijfers, 8 decimalen, ≥ 0)",
  "priceConfig.timePlaceholder": "Selecteer tijd",
  "priceConfig.selectEffectiveTimeTip": "Selecteer een geldigheidsperiode",
  "priceConfig.selectPriceTypeTip": "Selecteer een type tarief",
  "priceConfig.selectCountryTip": "Selecteer een land",
  "priceConfig.selectSecondaryRegionTip": "Selecteer een regio (niveau 2)",
  "priceConfig.selectCurrencyUnitTip": "Selecteer een valuta-eenheid",
  "priceConfig.selectPowerMarketTip": "Selecteer een stroommarkt",
  "priceConfig.electricitySurchargeInputTip": "Voer energie-toeslag in (max. 7 gehele cijfers, 8 decimalen, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "Energie-toeslag: maximaal 7 gehele cijfers, 8 decimalen, ≥ 0",
  "priceConfig.fixedFeeInputTip": "Voer vast bedrag in (max. 7 gehele cijfers, 8 decimalen, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "Vast bedrag: maximaal 7 gehele cijfers, 8 decimalen, ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Tijdsintervallen van het aankooptarief moeten 24 uur afdekken",
  "priceConfig.feedInTimeFullDayTip": "Tijdsintervallen van het teruglevertarief moeten 24 uur afdekken",
  "priceConfig.buyTimeNoOverlapTip": "Tijdsintervallen van het aankooptarief mogen niet overlappen",
  "priceConfig.feedInTimeNoOverlapTip": "Tijdsintervallen van het teruglevertarief mogen niet overlappen",
  "priceConfig.loadFail": "Tariefgegevens laden is mislukt",
  "priceConfig.copySelectPriceTip": "Geen tarief geselecteerd, kopiëren is niet mogelijk",
  "priceConfig.copyMissingPlantTip": "Installatie-informatie ontbreekt, tarief kan niet worden gekopieerd",
  "priceConfig.copySuccess": "Succesvol gekopieerd",
  "priceConfig.copyFail": "Kopiëren mislukt",
  "priceConfig.networkTimeout": "Netwerktime-out. Probeer het opnieuw zodra het netwerk hersteld is.",
  "priceConfig.copyUnsupportedTip": "Dit type tarief kan niet worden gekopieerd",
  "priceConfig.deleteSelectPriceTip": "Geen tarief geselecteerd",
  "priceConfig.deleteIdMissingTip": "Tarief-ID kon niet worden opgehaald, verwijderen mislukt",
  "priceConfig.deleteSuccess": "Succesvol verwijderd",
  "priceConfig.deleteFail": "Verwijderen mislukt",
  "priceConfig.missingPlantInfoTip": "Installatie-informatie ontbreekt",
  "priceConfig.confirmGiveUpCreateTip": "Weet u zeker dat u het aanmaken van dit tarief wilt annuleren?",
  "priceConfig.confirmGiveUpEditTip": "Weet u zeker dat u het bewerken van dit tarief wilt annuleren?",
  "priceConfig.pageTitleAdd": "Tarief toevoegen",
  "priceConfig.pageTitleEdit": "Tarief bewerken",
  "priceConfig.pageTitleView": "Tarief bekijken",
  "priceConfig.createSuccess": "Succesvol aangemaakt",
  "priceConfig.editSuccess": "Succesvol bijgewerkt",
  "priceConfig.saveFail": "Opslaan mislukt",
  "priceConfig.dateRangePermanent": "{start} tot onbeperkt",
  "priceConfig.dateRange": "{start} tot {end}",
  "priceConfig.routeTitle": "Elektriciteitsprijs",
  "priceConfig.priceLabel": "Prijs",
  "priceConfig.surchargeLabel": "Toeslag",
  "priceConfig.fixedFeeLabel": "Vast tarief",
  "button.copy": "Kopiëren",
  "common.view": "Bekijken",
  "cookie.necessary": "Strikt noodzakelijke cookies",
  "cookie.performance": "Prestatiecookies",
  "cookie.functional": "Functionele cookies",
  "cookie.targeting": "Targetingcookies",
  "cookie.necessaryExplain": "Deze cookies zijn strikt noodzakelijk voor de werking van de website en kunnen niet in onze systemen worden uitgeschakeld. Ze worden meestal alleen geplaatst naar aanleiding van acties van u die neerkomen op een verzoek om diensten, zoals het instellen van uw privacyvoorkeuren, aanmelden of invullen van formulieren. U kunt uw browser zo instellen dat deze cookies worden geblokkeerd of dat u er een melding over krijgt, maar sommige delen van de site werken dan mogelijk niet. Deze cookies slaan geen persoonlijk identificeerbare informatie op.",
  "cookie.performanceExplain": "Deze cookies stellen ons in staat bezoeken en verkeersbronnen te tellen, zodat we de prestaties van onze site kunnen meten en verbeteren. Ze helpen ons te weten welke pagina's het meest en het minst populair zijn en te zien hoe bezoekers zich door de site verplaatsen. Alle informatie die deze cookies verzamelen is geaggregeerd en daarmee anoniem. Als u deze cookies niet toestaat, weten we niet wanneer u onze site hebt bezocht en kunnen we de prestaties ervan niet monitoren.",
  "cookie.functionalExplain": "Deze cookies zorgen ervoor dat de website verbeterde functionaliteit en personalisatie kan bieden. Ze kunnen worden geplaatst door ons of door externe providers wier services we aan onze pagina's hebben toegevoegd. Als u deze cookies niet toestaat, werken sommige of al deze services mogelijk niet correct.",
  "cookie.targetingExplain": "Deze cookies kunnen via onze site worden geplaatst door onze advertentiepartners. Ze kunnen door die bedrijven worden gebruikt om een profiel van uw interesses op te bouwen en u relevante advertenties op andere sites te tonen. Ze slaan geen directe persoonlijke informatie op, maar zijn gebaseerd op de unieke identificatie van uw browser en internetapparaat. Als u deze cookies niet toestaat, zult u minder gerichte advertenties ervaren.",
  "cookie.necessaryAccount": "ID-verificatie",
  "cookie.necessaryAccountExplain": "Wordt gebruikt om de aanmeldingsstatus van de gebruiker te behouden. Het is een kernfunctie van website-authenticatie en sessiebeheer. Zonder deze cookie worden gebruikersaccounts mogelijk niet correct weergegeven op bezochte pagina's.",
  "cookie.sessionManagement": "Sessiebeheer",
  "cookie.sessionManagementExplain": "Wordt gebruikt om gebruikerssessies uniek te identificeren en kernfuncties zoals gebruikersaanmeldingsstatus, winkelwageninhoud en formuliergegevens te behouden.",
  "cookie.userInfo": "Gebruikersinformatie",
  "cookie.userInfoExplain": "Wordt gebruikt om bedrijfsstatistieken bij te houden zoals paginaweergaven (PV) en unieke bezoekers (UV), systeemverkeer en gebruikersbetrokkenheid te analyseren, om de prioritering van functies en afstemming op kernbehoeften te optimaliseren.",
  "cookie.deviceInfo": "Apparaatinformatie",
  "cookie.deviceInfoExplain": "Lost op basis van verschillende besturingssystemen, apparaatmodellen en browsertypen lay-out- en compatibiliteitsproblemen op verschillende apparaten op en optimaliseert aanpassingsfuncties voor verschillende apparaten.",
  "cookie.pageInfo": "Pagina-informatie",
  "cookie.pageInfoExplain": "Registreert paginatoegangspaden, API-verzoeken en laadtijden van bronnen om prestatieknelpunten, aanvraagfouten en codefouten te identificeren, waardoor het ontwikkelingsteam wordt geholpen bij het snel oplossen van problemen.",
  "cookie.networkInfo": "Netwerkinformatie",
  "cookie.networkInfoExplain": "Analyseert geografische locatie en netwerken van internetproviders (ISP's) om kwaadaardige toegang en abnormaal verkeer te identificeren, waardoor de efficiëntie van contentlevering voor cloudserviceproviders wordt geoptimaliseerd.",
  "cookie.userPreference": "Interfacevoorkeuren",
  "cookie.userPreferenceExplain": "Wordt alleen gebruikt om gebruikersinterfacevoorkeuren vast te leggen om de gebruikerservaring te verbeteren. Het is geen kernfunctie die vereist is voor de werking van de website.",
  "cookie.longTerm": "Lange termijn",
  "cookie.duration180": "180 dagen",
  "cookie.durationSession": "Sessie",
  "cookie.bannerExplain": "Om uw browse-ervaring te optimaliseren, gebruiken we cookies voornamelijk om de aanmeldingsstatus vast te leggen, uw voorkeuren te onthouden en aan te passen aan uw surfgedrag. Door op 'Alles accepteren' te klikken, gaat u akkoord met ons Cookiebeleid.",
  "cookie.acceptNecessary": "Alleen noodzakelijk",
  "cookie.openPreferences": "Voorkeuren instellen",
  "cookie.acceptAll": "Alles accepteren",
  "cookie.cookieSet": "Cookie-instellingen",
  "cookie.cookieSetExplain": "Voor meer informatie, zie",
  "cookie.cookiePolicy": "Cookiebeleid",
  "cookie.cookieCategory": "Cookiecategorie",
  "cookie.cookieName": "Cookienaam",
  "cookie.cookieDescription": "Doel",
  "cookie.cookieDuration": "Geldigheidsduur",
  "cookie.cookieSwitch": "Schakelaar",
  "cookie.savePreferences": "Voorkeuren opslaan",
  "cookie.preferencesTitle": "Cookievoorkeuren",
  "cookie.cookiePolicyText": "Cookiebeleid",
  "common.currentVersion": "Huidige Versie",
  "common.versionUpdateNotice": "Update Notificatie",
  "common.later": "Later",
  "common.immediateUpdate": "Snel Update",
  "sidebar.policyConfig": "Beleidconfiguratie",
  "common.addScope": "{scope} toevoegen",
  "editor.header.title": "Kop",
  "editor.header.text": "Paragraaf",
  "editor.fontSize.title": "Lettergrootte",
  "editor.fontSize.default": "Standaard lettergrootte",
  "editor.fontFamily.title": "Lettertype",
  "editor.fontFamily.default": "Standaard lettertype",
  "editor.bold": "Vet",
  "editor.italic": "Cursief",
  "editor.underline": "Onderstreept",
  "editor.through": "Doorstreept",
  "editor.code": "Inline-code",
  "editor.sub": "Subscript",
  "editor.sup": "Superscript",
  "editor.clearStyle": "Opmaak wissen",
  "editor.color.color": "Tekstkleur",
  "editor.color.bgColor": "Achtergrondkleur",
  "editor.color.default": "Standaardkleur",
  "editor.color.clear": "Kleur wissen",
  "editor.bulletedList": "Opsommingstekenlijst",
  "editor.numberedList": "Genummerde lijst",
  "editor.todo": "Te-doen-lijst",
  "editor.todo.title": "Te doen",
  "editor.emotion.title": "Emoji's",
  "editor.justifyLeft": "Links uitlijnen",
  "editor.justifyRight": "Rechts uitlijnen",
  "editor.justifyCenter": "Midden uitlijnen",
  "editor.justifyJustify": "Uitvullen",
  "editor.indent": "Inspringing vergroten",
  "editor.delIndent": "Inspringing verkleinen",
  "editor.lineHeight.title": "Regelhoogte",
  "editor.lineHeight.default": "Standaard regelhoogte",
  "editor.blockquote": "Citaat",
  "editor.link.insert": "Link invoegen",
  "editor.link.text": "Linktekst",
  "editor.link.url": "Link-URL",
  "editor.link.unLink": "Link verwijderen",
  "editor.link.edit": "Link bewerken",
  "editor.link.view": "Link bekijken",
  "editor.image.netImage": "Webafbeelding",
  "editor.image.delete": "Afbeelding verwijderen",
  "editor.image.edit": "Afbeelding bewerken",
  "editor.image.viewLink": "Link bekijken",
  "editor.image.src": "Afbeeldings-URL",
  "editor.image.desc": "Afbeeldingsbeschrijving",
  "editor.image.link": "Afbeeldingslink",
  "editor.video.insert": "Video invoegen",
  "editor.video.delete": "Video verwijderen",
  "editor.video.uploadVideo": "Video uploaden",
  "editor.video.insertVideo": "Video invoegen",
  "editor.video.videoSrc": "Video-URL",
  "editor.video.videoSrcPlaceHolder": "Voer de video-URL in",
  "editor.video.videoPoster": "Video-poster",
  "editor.video.videoPosterPlaceHolder": "Voer de poster-URL in",
  "editor.video.ok": "OK",
  "editor.video.editSize": "Grootte wijzigen",
  "editor.video.width": "Breedte",
  "editor.video.height": "Hoogte",
  "editor.table.header": "Tabel",
  "editor.table.insertTable": "Tabel invoegen",
  "editor.table.deleteTable": "Tabel verwijderen",
  "editor.table.insertRow": "Rij invoegen",
  "editor.table.deleteRow": "Rij verwijderen",
  "editor.table.insertCol": "Kolom invoegen",
  "editor.table.deleteCol": "Kolom verwijderen",
  "editor.table.widthAuto": "Automatische breedte",
  "editor.table.widthFixed": "Vaste breedte",
  "editor.codeBlock.title": "Codeblok",
  "editor.divider": "Scheidinglijn",
  "editor.emotion": "Emoji's",
  "editor.insertFormula": "Formule invoegen",
  "editor.fullScreen": "Volledig scherm",
  "editor.undo": "Ongedaan maken",
  "editor.redo": "Opnieuw uitvoeren",
  "editor.delete": "Verwijderen",
  "editor.enter": "Enter",
  "editor.ok": "OK",
  "editor.cancel": "Annuleren",
  "editor.uploadImgMaxSize": "Max. afbeeldingsgrootte",
  "editor.uploadImgMaxSizeErr": "Afbeeldingsgrootte is te groot",
  "editor.uploadImgMaxLength": "Max. aantal afbeeldingen",
  "editor.uploadImgMaxLengthErr": "Aantal afbeeldingen is te hoog",
  "editor.uploadVideoMaxSize": "Max. videogrootte",
  "editor.uploadVideoMaxSizeErr": "Videogrootte is te groot",
  "editor.placeholder": "Voer inhoud in...",
  "UserHome.plantFlow.load": "Belasting",
  "UserHome.plantFlow.grid": "Net",
  "UserHome.plantFlow.battery": "Batterij",
  "UserHome.plantFlow.pv": "PV",
  "plant.e-station": "Nul koolstof",
  "DELETE": "Nederland",
  "test.code.update": "test.code.update",
  "plant.running.status.alarm": "Alarm",
  "test.label_G_P_C_L2": "Gen L2 vermogen",
  "device.offline": "Apparaat offline",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "0X3809-F-0607": "PV-aansluiting overtemp. beveiligingsfout",
  "0X3809-F-1103": "Relais zelftest afwijking",
  "0X3809-F-3112": "Netspanningsfasevergrendelingsfout",
  "0X3809-F-3113": "Netfasevolgorde afwijking",
  "0X3809-S-0101": "1. Controleer of de aansluitingen van de PV-modules normaal zijn, en of er schade, stof op het oppervlak of beschaduwing van de modules is.\n2. Controleer of de PV-modules correct zijn aangesloten en of hun spanningsspecificaties boven het bedrijfsspanningsbereik van de omvormer liggen.\n3. Controleer of er een kortsluiting in de PV-modules is.",
  "0X3809-S-0102": "1. Controleer of de aansluitingen van de PV-modules normaal zijn, en of er schade, stof op het oppervlak of beschaduwing van de modules is.\n2. Controleer of de PV-modules correct zijn aangesloten en of hun spanningsspecificaties boven het bedrijfsspanningsbereik van de omvormer liggen.\n3. Controleer of er een kortsluiting in de PV-modules is.",
  "0X3809-S-0103": "1. Controleer of de aansluitingen van de PV-modules normaal zijn, en of er schade, stof op het oppervlak of beschaduwing van de modules is.\n2. Controleer of de PV-modules correct zijn aangesloten en of hun spanningsspecificaties boven het bedrijfsspanningsbereik van de omvormer liggen.\n3. Controleer of er een kortsluiting in de PV-modules is.",
  "0X3809-S-0301": "1. Komt vaak 's ochtends vroeg voor; controleer de reinheid van het PV-paneeloppervlak.\n2. Controleer of de PV-panelen correct zijn aangesloten en of hun spanningsspecificaties het bedrijfsspanningsbereik van de omvormer overschrijden.\n3. Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0302": "1. Komt vaak 's ochtends vroeg voor; controleer de reinheid van het PV-paneeloppervlak.\n2. Controleer of de PV-panelen correct zijn aangesloten en of hun spanningsspecificaties het bedrijfsspanningsbereik van de omvormer overschrijden.\n3. Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0303": "1. Komt vaak 's ochtends vroeg voor; controleer de reinheid van het PV-paneeloppervlak.\n2. Controleer of de PV-panelen correct zijn aangesloten en of hun spanningsspecificaties het bedrijfsspanningsbereik van de omvormer overschrijden.\n3. Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0304": "1. Komt vaak 's ochtends vroeg voor; controleer de reinheid van het PV-paneeloppervlak.\n2. Controleer of de PV-panelen correct zijn aangesloten en of hun spanningsspecificaties het bedrijfsspanningsbereik van de omvormer overschrijden.\n3. Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0501": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0502": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0503": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0504": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0505": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0506": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0507": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0508": "Start de omvormer opnieuw op. Als de fout aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0601": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0602": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0603": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0604": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0605": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0606": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0607": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de luchtkanalen van de koellichaam verstopt zijn\n3. Start de omvormer opnieuw op na afkoeling. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0701": "1. Controleer of de module een aardfout heeft.\n2. Controleer op losse verbindingen in het DC-circuit.\n3. Als er geen problemen worden gevonden in het DC-circuit, schakel de stroom gedurende 5 minuten uit en zet deze vervolgens weer aan. Als het probleem aanhoudt, neem dan contact op met uw leverancier.",
  "0X3809-S-0801": "1. Stuurcircuit defect.\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met uw leverancier.",
  "0X3809-S-0901": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0902": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0903": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0904": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0905": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0906": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-0907": "1. Besturingsbord defect\n2. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-1001": "1. Als dit af en toe voorkomt, kan dit worden veroorzaakt door incidentele storingen in externe leidingen. Het opnieuw opstarten van de omvormer zal de normale werking herstellen.\n2. Als dit vaak voorkomt of gedurende lange tijd niet kan worden hersteld, controleer dan of de aardverbinding van de fotovoltaïsche string betrouwbaar is.",
  "0X3809-S-1002": "1. Als dit af en toe voorkomt, kan dit worden veroorzaakt door incidentele storingen in externe leidingen. Het opnieuw opstarten van de omvormer zal de normale werking herstellen.\n2. Als dit vaak voorkomt of gedurende lange tijd niet kan worden hersteld, controleer dan of de aardverbinding van de fotovoltaïsche string betrouwbaar is.",
  "0X3809-S-1003": "1. Als dit af en toe voorkomt, kan dit worden veroorzaakt door incidentele storingen in externe leidingen. Het opnieuw opstarten van de omvormer zal de normale werking herstellen.\n2. Als dit vaak voorkomt of gedurende lange tijd niet kan worden hersteld, controleer dan of de aardverbinding van de fotovoltaïsche string betrouwbaar is.",
  "0X3809-S-1004": "1. Als dit af en toe voorkomt, kan dit worden veroorzaakt door incidentele storingen in externe leidingen. Het opnieuw opstarten van de omvormer zal de normale werking herstellen.\n2. Als dit vaak voorkomt of gedurende lange tijd niet kan worden hersteld, controleer dan of de aardverbinding van de fotovoltaïsche string betrouwbaar is.",
  "0X3809-S-1101": "1. Controleer of de aardingsdraad aan de AC-zijde onder spanning staat.\n2. Interne relaisstoring.\n3. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1102": "1. Controleer of de aardingsdraad aan de AC-zijde onder spanning staat.\n2. Interne relaisstoring.\n3. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1103": "1. Controleer of de aardingsdraad aan de AC-zijde onder spanning staat.\n2. Interne relaisstoring.\n3. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1201": "1. Interne ventilator beschadigd\n2. Ventilatordetectiecircuit defect\n3. Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier",
  "0X3809-S-1901": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1902": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1903": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1904": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1905": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1906": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-1907": "Schakel de omvormer uit en start hem opnieuw op. Als herstel niet mogelijk is, neem dan contact op met de leverancier.",
  "0X3809-S-3101": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3102": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3103": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3104": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3105": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3106": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3107": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3108": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3109": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3110": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3111": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3112": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3113": "1. Controleer of er een zekeringautomaat in de verdeelkast is uitgeschakeld.\n2. Meet of de werkelijke spanning buiten het bereik van de omvormer valt.\n3. Als de spanning buiten het bereik ligt, kunt u de over- en onder-spanningsbeveiligingswaarden van de omvormer aanpassen.",
  "0X3809-S-3301": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3302": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3303": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3304": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3305": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3306": "1. Controleer het elektriciteitsnet op losse verbindingen.\n2. Pas het frequentiebereik dienovereenkomstig aan.",
  "0X3809-S-3701": "Controleer of de omvormer handmatig is uitgeschakeld.",
  "0X3809-S-3801": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3802": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3803": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3804": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3805": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3806": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3807": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3808": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3809": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3810": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3811": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3812": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3813": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3814": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3815": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3816": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3817": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3818": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3819": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3820": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3901": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3902": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3903": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3904": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3905": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3906": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3907": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3908": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3909": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3910": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3911": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3912": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3913": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3914": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3915": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3916": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3917": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3918": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3919": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-3920": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-4101": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-4201": "Controleer of de N-PE-spanning abnormaal is",
  "0X3809-S-4301": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3809-S-4401": "Schakel de omvormer uit en ontkoppel de in-/uitschakelaars. Start de omvormer na 5 minuten opnieuw op. Als de fout niet is verholpen, neem dan contact op met de leverancier.",
  "0X3807-F-02": "PV2 kortsluiting alarm",
  "0X3807-F-03": "PV lage spanning alarm",
  "0X3807-S-0101": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0102": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0103": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0104": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0105": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0106": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0107": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0108": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0109": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0110": "1. Controleer of de ventilator door vreemde voorwerpen geblokkeerd is\n2. Controleer of de ventilator normaal draait\n3. Start de omvormer opnieuw op; als herstel niet mogelijk is, vervang dan de ventilator",
  "0X3807-S-0401": "Controleer of de meterbedrading incorrect is.",
  "0X3807-S-0402": "Controleer of de meterbedrading incorrect is.",
  "0X3807-S-0404": "Controleer of de meterbedrading incorrect is.",
  "0X3807-S-0408": "Controleer of de meterbedrading incorrect is.",
  "0X3807-S-0416": "Controleer of de meterbedrading incorrect is.",
  "0X3807-S-0500": "1. Als dit af en toe voorkomt, kan dit te wijten zijn aan een tijdelijke netstoring. De omvormer zal weer normaal werken nadat het net normaal is geworden.\n2. Als deze fout vaak wordt gemeld, controleer dan of het net abnormaal is.",
  "0X3807-S-0601": "Controleer na uitschakeling of de modulespanning normaal is. Als opnieuw opstarten het probleem niet oplost, wijst dit op een interne fout in de omvormer.",
  "0X3807-S-02": "Controleer na uitschakeling of de modulespanning normaal is. Als opnieuw opstarten het probleem niet oplost, wijst dit op een interne fout in de omvormer.",
  "0X3807-S-03": "Controleer na uitschakeling of de modulespanning normaal is. Als opnieuw opstarten het probleem niet oplost, wijst dit op een interne fout in de omvormer.",
  "In Alarm": "Alarm actief",
  "device.category.energyStorageCabinet": "Energiestockkast",
  "device.category.commercialRobot": "Commerciële robot",
  "device.category.pvinverter": "Fotovoltaïsche omvormer",
  "collector.upgrade.progress": "Vooruitgang van de verzamelaarsupgrade",
  "device.upgrade.progress": "Voortgang van de apparaatupgrade",
  "failed.to.obtain.firmware": "Kon firmware niet verkrijgen",
  "file.CRC.check.failed": "CRC-controle van bestand mislukt",
  "burning.timed.out": "Branden time-out",
  "burning.failed": "Branden mislukt",
  "shujvabng": "Datastick (Bumai)",
  "50901.ctrl_dianchiguanli": "Battery Manage",
  "bw_param_qqq": "งค่าขนานjklllll",
  "test.label_G_P_C_L1": "Gen L1 vermogen",
  "test.label_G_P_C_L5": "Gen L2 Spanning",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "Gen L2 Spanning",
  "test.label_G_P_C_L4": "Gen L1 Spanning",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "Gen L3 Spanning",
  "test.label_G_P_C_L3": "Gen L3 vermogen",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "Gen L1 Spanning",
  "test.label_G_P_C_L6": "Gen L3 Spanning",
  "bw_param_ctrl_name_ParallelSetting": "Parallelle Status",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "Gen L2 vermogen",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "Gen L1 vermogen",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "Gen L3 vermogen",
  "current.collector.upgrade.progress": "De huidige upgradevoortgang van de verzamelaar is",
  "CSP Plant": "Zonne-thermische centrale",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Grid CT Omkeren Inschakelen",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "PV CT Omkeren Inschakelen",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Grid CT Meter Transformatieverhouding Instelling",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "PV CT Meter Transformatieverhouding Instelling\n",
  "50901.ctrl_Config-Grid Profile.country": "Land / Netstandaard Land",
  "50901.ctrl_Device.meterConfiguration": "Meterconfiguratie",
  "50901.ctrl_WorkMode.workMode": "EMS Werkingsmodus",
  "50901.ctrl_ESS_Advanced_Config-System": "Geavanceerde configuratie - Systeem",
  "50901.ctrl_Config-Grid Profile": "Configuratie - Netparameters",
  "50901.ctrl_Device": "Besturing_Apparaat",
  "50901.ctrl_WorkMode": "Werkingsmodus",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "Instelling van de werkmodus",
  "50901.ctrl_WorkMode-Backup": "Werkingsmodus - Backup",
  "50901.ctrl_WorkMode-economic": "Werkingsmodus - Economisch",
  "50901.ctrl_WorkMode-forceCharge": "Werkingsmodus - Forceer Opladen",
  "50901.ctrl_WorkMode-forceDischarge": "Werkingsmodus - Forceer Ontladen",
  "50901.ctrl_WorkMode-peakMeter": "Werkingsmodus - Piekmeting",
  "50901.ctrl_WorkMode-Selfuse": "Werkingsmodus - Zelfgebruik",
  "50901.ctrl_WorkMode-TOU": "Werkingsmodus - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "TOU-modus - Gereserveerd SOC",
  "50901.ctrl_Device.meterConfiguration.desc": "Beschrijving van de meterconfiguratie",
  "50901.ctrl_Config-Grid Profile.country.desc": "Beschrijving van het land / land van netwerkverbindingstandaard",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Activeren",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Deactiveren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Activeren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Activeren",
  "50901.ctrl_Device.meterConfiguration.0": "Geen meter type",
  "50901.ctrl_Device.meterConfiguration.1": "Configureer netzijde meter",
  "50901.ctrl_Device.meterConfiguration.2": "Configureer PV-meter",
  "50901.ctrl_Device.meterConfiguration.3": "Configureer netzijde + PV-meter",
  "Do_not_connect": "Niet verbinden",
  "connect.type.Do.not.connect": "Niet verbinden",
  "platformType.web": "Web",
  "50901.Backup": "Back-Up / Reserve",
  "50901.Battery": "Accu / Batterij",
  "50901.ClockSetting": "Klok Instellen",
  "50901.Connection": "Communicatieverbinding",
  "50901.ctrl_Config": "Communicatieverbinding Bediening",
  "50901.ctrl_Config.Device.checkTime.desc": "Beschrijving apparaattijd",
  "50901.ctrl_Dry_Contact": "Droogcontact Instelling",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent.desc": "Nominale stroom EV-lader",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "Nominale stroom hoofdschakelaar",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.desc": "Timermodus - Accu SOC inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc.desc": "Timermodus - Accu start SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc.desc": "Timermodus - Accu stop SOC",
  "50901.ctrl_ESS_Advanced_Config": "Geavanceerde Configuratie",
  "50901.ctrl_Safety": "Veiligheidsvoorschriften",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc.desc": "TOU-modus gereserveerde SOC",
  "50901.DCI": "Dc-Isolatie",
  "50901.Device": "Apparaat",
  "50901.economic": "Economische Modus",
  "50901.EPS": "Noodstroomvoorziening",
  "50901.forceCharge": "Forceer Laden",
  "50901.forceDischarge": "Forceer Ontladen",
  "50901.FRT": "Frequentie-Doorrijdvermogen",
  "50901.FW": "Frequentiedrift",
  "50901.Gateway": "Gateway",
  "50901.Generator": "Generator",
  "50901.Grid Profile": "Netparameters",
  "50901.otaHttpUrl.otaHttpUrl.desc": "Beschrijving upgrade-opdracht",
  "50901.peakMeter": "Piekmeting",
  "50901.PV": "Chint Enkelfasig",
  "50901.RCD": "Aardlekschakelaar / Aardlekbeveiliging",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Beschrijving Dsp-Versie (Hoofd U-Versie)",
  "50901.real_time.dTSReset.desc": "Beschrijving data stick reset",
  "50901.real_time.数据分析_AC光伏功率.tag": "Ac Pv-Vermogen",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Ac Pv-Reactief Vermogen",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Ac Pv-Actief Vermogen",
  "50901.real_time.数据分析_AC光伏电压.tag": "Ac Pv-Spanning",
  "50901.real_time.数据分析_AC光伏电流.tag": "Ac Pv-Stroom",
  "50901.real_time.数据分析_EPS功率.tag": "Eps-Vermogen",
  "50901.real_time.数据分析_EPS电压.tag": "Eps-Spanning",
  "50901.real_time.数据分析_EPS电流.tag": "Eps-Stroom",
  "50901.real_time.数据分析_单体SOC.tag": "Cel-SOC",
  "50901.real_time.数据分析_发电机功率.tag": "Generatorvermogen",
  "50901.real_time.数据分析_发电机电压.tag": "Generatorspanning",
  "50901.real_time.数据分析_发电机电流.tag": "Generatorstroom",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Hybride Omvormer Pv-Vermogen",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Hybride Omvormer Pv-Spanning",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Hybride Omvormer Pv-Stroom",
  "50901.real_time.数据分析_电池包.tag": "Accupakket",
  "50901.real_time.数据分析_电网功率.tag": "Netvermogen",
  "50901.real_time.数据分析_电网电压.tag": "Netspanning",
  "50901.real_time.数据分析_电网电流.tag": "Netstroom",
  "50901.RPC": "Nee",
  "50901.RR": "Veranderingssnelheid",
  "50901.RT": "Betekenis Van Enumeratiewaarde 0",
  "50901.Settings": "Werkingsmodus",
  "50901.Settings-Load_Control": "Lastregeling",
  "50901.Settings-Manual_Control": "Betekenis Van Enumeratiewaarde 0",
  "50901.Switch": "Modusomschakeling",
  "50901.System": "Betekenis Van Enumeratiewaarde 0",
  "50901.VRT": "Betekenis Van Enumeratiewaarde 0",
  "50901.VW": "Spanningsdrift",
  "50901.ctrl_Config.Device.networkingType.desc": "Beschrijving net aansluiting type",
  "50901.fault.arcFault.desc": "Beschrijving vlamboogfout",
  "50901.fault.arcSelfTestFault.desc": "Beschrijving vlamboog zelftestfout",
  "50901.fault.armCommunicationFault.desc": "Beschrijving ARM-communicatiefout",
  "50901.fault.auxiliaryPowerAbnormality.desc": "Beschrijving hulpvoeding abnormaal",
  "50901.Fault.batteryCapacityAbnormality.desc": "Beschrijving accucapaciteit abnormaal",
  "50901.Fault.batteryFault.desc": "Beschrijving accufout",
  "50901.Fault.batteryForceChargeRequest.desc": "Beschrijving accu forceer laadaanvraag",
  "50901.Fault.bmsCanCommunicationAbnormality.desc": "Beschrijving BMS CAN-communicatie abnormaal",
  "50901.fault.busbarAbnormality.desc": "Beschrijving DC-tussenkring abnormaal",
  "50901.fault.cmpssBiasCalculationError.desc": "Beschrijving CMPSS-offset berekeningsfout",
  "50901.fault.comparatorFault.desc": "Beschrijving comparatorfout",
  "50901.fault.driveAbnormality.desc": "Beschrijving aansturing abnormaal",
  "50901.Fault.dspPwrCommunicationAbnormality.desc": "Beschrijving DSP-voeding communicatie abnormaal",
  "50901.Fault.dspSafCommunicationAbnormality.desc": "Beschrijving DSP-beveiligde communicatie abnormaal",
  "50901.Fault.dtsCommunicationAbnormality.desc": "Beschrijving DTS-communicatie abnormaal",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.desc": "Beschrijving DTU1 RS485-communicatie abnormaal",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.desc": "Beschrijving DTU2 RS485-communicatie abnormaal",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.desc": "Beschrijving DTU3 RS485-communicatie abnormaal",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.desc": "Beschrijving DTU4 RS485-communicatie abnormaal",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.desc": "Beschrijving DTU5 RS485-communicatie abnormaal",
  "50901.fault.e2rpomFault.desc": "Beschrijving EEPROM-fout",
  "50901.fault.emergencyStopSwitchStatus.desc": "Beschrijving noodstop",
  "50901.fault.epsOverload.desc": "Beschrijving EPS-overbelasting",
  "50901.fault.epsRelayProtection.desc": "Beschrijving EPS-relais beveiliging",
  "50901.fault.epsVoltageAbnormality.desc": "Beschrijving EPS-spanning abnormaal",
  "50901.Fault.evCharger1CommunicationAbnormality.desc": "Beschrijving EV-lader 1 communicatie abnormaal",
  "50901.Fault.evCharger1Fault.desc": "Beschrijving fout lader 1",
  "50901.Fault.evCharger2CommunicationAbnormality.desc": "Beschrijving EV-lader 2 communicatie abnormaal",
  "50901.Fault.evCharger2Fault.desc": "Beschrijving fout lader 2",
  "50901.fault.fanFault.desc": "Beschrijving ventilatordefect",
  "50901.Fault.fanSpeedAbnormality.desc": "Beschrijving ventilatorsnelheid abnormaal",
  "50901.fault.fiveVoltPowerSupplyFault.desc": "Beschrijving fout 5V-voeding",
  "50901.fault.flashCommunicationFault.desc": "Beschrijving flash geheugen communicatiefout",
  "50901.fault.frequencyVariationRateOutOfRange.desc": "Beschrijving frequentie veranderingssnelheid overschreden",
  "50901.fault.genAbnormality.desc": "Beschrijving generator abnormaal",
  "50901.fault.genOverload.desc": "Beschrijving generator overbelasting",
  "50901.fault.genPortOvercurrent.desc": "Beschrijving generatoraansluiting overstroom",
  "50901.fault.genRelayAFault.desc": "Beschrijving generator A relaisfout",
  "50901.fault.genRelayBFault.desc": "Beschrijving generator B relaisfout",
  "50901.fault.gridCurrentDcOffsetOutOfRange.desc": "Beschrijving netstroom DC-offset overschreden",
  "50901.fault.gridMeter.desc": "Beschrijving netmeter communicatiefout",
  "50901.Fault.gridMeterCommunicationAbnormality.desc": "Beschrijving netmeter communicatie abnormaal",
  "50901.Fault.gridMeterTypeError.desc": "Beschrijving netmeter typefout",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.desc": "Beschrijving eilandspanning DC-offset overschreden",
  "50901.fault.gridOverfrequency.desc": "Beschrijving net overfrequentie",
  "50901.fault.gridOvervoltage.desc": "Beschrijving net overspanning",
  "50901.fault.gridPortOvercurrent.desc": "Beschrijving netaansluiting overstroom",
  "50901.fault.gridPowerOutage.desc": "Beschrijving netstoring / netuitval",
  "50901.fault.gridRelayProtection.desc": "Beschrijving netrelais beveiliging",
  "50901.fault.gridUnderfrequency.desc": "Beschrijving net onderfrequentie",
  "50901.fault.gridUndervoltage.desc": "Beschrijving net onderspanning",
  "50901.fault.gridVoltageAbnormality.desc": "Beschrijving netspanning abnormaal",
  "50901.Fault.hmidCommunicationAbnormality.desc": "Beschrijving HMI-communicatie abnormaal",
  "50901.Fault.hmidMachineFault.desc": "Beschrijving HMI-apparaatfout",
  "50901.fault.insulationFault.desc": "Beschrijving isolatiefout",
  "50901.fault.interruptOverflow.desc": "Beschrijving interrupt overflow",
  "50901.fault.inverterCanCommunicationFailed.desc": "Beschrijving omvormer CAN-communicatiefout",
  "50901.fault.inverterCommunicationFailed.desc": "Beschrijving omvormer communicatiefout",
  "50901.fault.kmRelayFault.desc": "Beschrijving KM-relaisfout",
  "50901.fault.lineToEarthFault.desc": "Beschrijving aardfout (fase-aarde)",
  "50901.fault.loadRelayAFault.desc": "Beschrijving last A relaisfout",
  "50901.fault.loadRelayBFault.desc": "Beschrijving last B relaisfout",
  "50901.fault.lowAmbientTemperature.desc": "Beschrijving omgevingstemperatuur te laag",
  "50901.Fault.lowDtuVersion.desc": "Beschrijving DTU-versie te laag",
  "50901.fault.machineTypeMismatch.desc": "Beschrijving model komt niet overeen",
  "50901.Fault.masterSlaveCommunicationAbnormality.desc": "Beschrijving master-slave communicatie abnormaal",
  "50901.fault.meterWiringAbnormality.desc": "Beschrijving meterbedrading abnormaal",
  "50901.fault.microelectronicFault.desc": "Beschrijving micro-elektronicafout",
  "50901.fault.neutralWireNotConnected.desc": "Beschrijving nulleider niet aangesloten",
  "50901.fault.neutralWireToEarthFault.desc": "Beschrijving nulleider-aarde fout",
  "50901.fault.overTemperature.desc": "Beschrijving overtemperatuur",
  "50901.fault.overtemperatureAlarm.desc": "Beschrijving oververhittingsalarm",
  "50901.fault.pllLockFailed.desc": "Beschrijving PLL-vergrendelingsfout",
  "50901.fault.preSynchronizationFailed.desc": "Beschrijving fout tijdens voorsynchronisatie",
  "50901.fault.pvFault.desc": "Beschrijving PV-fout",
  "50901.Fault.pvMeterCommunicationAbnormality.desc": "Beschrijving PV-meter communicatie abnormaal",
  "50901.Fault.pvMeterTypeError.desc": "Beschrijving PV-meter typefout",
  "50901.fault.pvPortOvercurrent.desc": "Beschrijving PV-aansluiting overstroom",
  "50901.fault.pvRelayAbFault.desc": "Beschrijving PV-AB relaisfout",
  "50901.fault.pvVoltageExceedingBusVoltage.desc": "Beschrijving PV-spanning overschrijdt tussenkringspanning",
  "50901.fault.rcdFault.desc": "Beschrijving RCD-fout / Aardlekschakelaarfout",
  "50901.fault.rcdSelfTestFault.desc": "Beschrijving RCD-zelftestfout",
  "50901.fault.reconnectionFailed.desc": "Beschrijving heraansluitingsfout",
  "50901.fault.samplingBiasAbnormality.desc": "Beschrijving afwijking sampling-offset",
  "50901.fault.shutDown.desc": "Beschrijving systeemuitschakeling",
  "50901.Fault.slaveWrongBatteryConnection.desc": "Beschrijving slave accu aansluitfout",
  "50901.fault.smartloadPortOvercurrent.desc": "Beschrijving smart load aansluiting overstroom",
  "50901.fault.spiCommunicationFault.desc": "Beschrijving SPI-communicatiefout",
  "50901.Fault.sustainedNegativeLoad.desc": "Beschrijving aanhoudende negatieve last",
  "50901.fault.temperatureAbnormality.desc": "Beschrijving temperatuur abnormaal",
  "50901.fault.tenMinuteOvervoltage.desc": "Beschrijving 10-minuten overspanning",
  "50901.fault.threePointThreeVoltPowerSupplyFault.desc": "Beschrijving fout 3.3V-voeding",
  "50901.fault.twelveVoltPowerSupplyFault.desc": "Beschrijving fout 12V-voeding",
  "50901.fault.versionMismatch.desc": "Beschrijving versie conflict / versie niet passend",
  "50901.fault.wiringAbnormality.desc": "Beschrijving bedrading abnormaal",
  "50901.real_time.12vAuxiliaryVoltageSampling.desc": "Beschrijving 12V hulpspanning sampling",
  "50901.real_time.12vOutputVoltageSampling.desc": "Beschrijving 12V uitgangsspanning sampling",
  "50901.real_time.3_3vAuxiliaryVoltageSampling.desc": "Beschrijving 3.3V hulpspanning sampling",
  "50901.real_time.5vAuxiliaryVoltageSampling.desc": "Beschrijving 5V hulpspanning sampling",
  "50901.real_time.afciVersion.desc": "Beschrijving AFCI-versie",
  "50901.real_time.ambientTemperatureSampling.desc": "Beschrijving omgevingstemperatuur sampling",
  "50901.real_time.appSoftwareVersion.desc": "Beschrijving APP-softwareversie",
  "50901.real_time.batteryChargePower.desc": "Beschrijving accu cumulatieve laadcapaciteit",
  "50901.real_time.batteryConnectionStatus.desc": "Beschrijving accu aansluitstatus",
  "50901.real_time.batteryCurrent.desc": "Beschrijving accustroom",
  "50901.real_time.batteryDailyChargeEnergy.desc": "Beschrijving accu dagelijkse laadcapaciteit",
  "50901.real_time.batteryDailyDischargeEnergy.desc": "Beschrijving accu dagelijkse ontlaadcapaciteit",
  "50901.real_time.batteryDischargePower.desc": "Beschrijving accu cumulatieve ontlaadcapaciteit",
  "50901.real_time.batteryModuleNum.desc": "Beschrijving accu celaantal (cellen in serie per module)",
  "50901.real_time.batteryPower.desc": "Beschrijving accuvermogen (laden/ontladen)",
  "50901.real_time.batteryPowerWholeSystem.desc": "Beschrijving accu totaal vermogen (gehele systeem)",
  "50901.real_time.batterySoc.desc": "Beschrijving accu-SOC",
  "50901.real_time.batteryToLoadPower.desc": "Beschrijving accu-naar-last vermogen",
  "50901.real_time.batterytotCap.desc": "Beschrijving accu totaal geïnstalleerde capaciteit",
  "50901.real_time.batteryType_04.desc": "Beschrijving accutype",
  "50901.real_time.batteryVoltage.desc": "Beschrijving accuspanning",
  "50901.real_time.batteryWorkingStatus.desc": "Beschrijving Accustatus",
  "50901.real_time.bootSoftwareVersion.desc": "Beschrijving bootloader-softwareversie",
  "50901.real_time.communicationStickHardwareVersion.desc": "Beschrijving communicatiestick hardwareversie",
  "50901.real_time.communicationStickSn.desc": "Beschrijving communicatiestick SN",
  "50901.real_time.communicationStickSoftwareVersion.desc": "Beschrijving communicatiestick softwareversie",
  "50901.real_time.dailyBatteryToLoadEnergy.desc": "Beschrijving vandaag accu-naar-last energie",
  "50901.real_time.dailyExportEnergyToGrid.desc": "Beschrijving vandaag verkochte energie",
  "50901.real_time.dailyGridToLoadEnergy.desc": "Beschrijving vandaag net-naar-last energie",
  "50901.real_time.dailyImportEnergyFromGrid.desc": "Beschrijving vandaag ingekochte energie",
  "50901.real_time.dailyPvToBatteryEnegry.desc": "Beschrijving vandaag PV-naar-accu energie",
  "50901.real_time.dailyPvToGridEnegry.desc": "Beschrijving vandaag PV-naar-net energie",
  "50901.real_time.dailyPvToLoadEnegry.desc": "Beschrijving vandaag PV-naar-last energie",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.desc": "Beschrijving DRM-status (voor Australië/Duitsland/Oostenrijk)",
  "50901.real_time.dspVersionAuxiliaryUVersion.desc": "Beschrijving DSP-versie (Hulp U-versie)",
  "50901.real_time.externalFanSpeed1.desc": "Beschrijving buitenste ventilatorsnelheid 1",
  "50901.real_time.externalFanSpeed2.desc": "Beschrijving buitenste ventilatorsnelheid 2",
  "50901.real_time.externalFanSpeed3.desc": "Beschrijving buitenste ventilatorsnelheid 3",
  "50901.real_time.externalFanSpeed4.desc": "Beschrijving buitenste ventilatorsnelheid 4",
  "50901.real_time.firmwareBuildTimeDateHour.desc": "Beschrijving firmware bouwtijd (dag/uur)",
  "50901.real_time.firmwareBuildTimeYearMonth.desc": "Beschrijving firmware bouwtijd (jaar & maand)",
  "50901.real_time.firmwareCrc.desc": "Beschrijving firmware CRC",
  "50901.real_time.firmwareEndAddressHigh.desc": "Beschrijving firmware eindadres (hoog)",
  "50901.real_time.firmwareEndAddressLow.desc": "Beschrijving firmware eindadres (laag)",
  "50901.real_time.firmwareInformationCrc.desc": "Beschrijving firmware info CRC",
  "50901.real_time.firmwareStartAddressHigh.desc": "Beschrijving firmware startadres (hoog)",
  "50901.real_time.firmwareStartAddressLow.desc": "Beschrijving firmware startadres (laag)",
  "50901.real_time.generatorCurrentA.desc": "Beschrijving generator fase A stroom",
  "50901.real_time.generatorCurrentB.desc": "Beschrijving generator fase B stroom",
  "50901.real_time.generatorCurrentC.desc": "Beschrijving generator fase C stroom",
  "50901.real_time.generatorDailyYield.desc": "Beschrijving generator dagelijkse opbrengst",
  "50901.real_time.generatorPower.desc": "Beschrijving generatorvermogen",
  "50901.real_time.generatorPowerA.desc": "Beschrijving generator fase A vermogen",
  "50901.real_time.generatorPowerB.desc": "Beschrijving generator fase B vermogen",
  "50901.real_time.generatorPowerC.desc": "Beschrijving generator fase C vermogen",
  "50901.real_time.generatorTotalYield.desc": "Beschrijving generator cumulatieve opbrengst",
  "50901.real_time.gridBuyPower.desc": "Beschrijving cumulatieve ingekochte energie",
  "50901.real_time.gridCurrentA.desc": "Beschrijving netzijde fase A stroom",
  "50901.real_time.gridCurrentB.desc": "Beschrijving netzijde fase B stroom",
  "50901.real_time.gridCurrentC.desc": "Beschrijving netzijde fase C stroom",
  "50901.real_time.gridMeasurementOfRadiatorTemperature.desc": "Beschrijving netzijde koellichaam temperatuur",
  "50901.real_time.gridMeterSerialNumber.desc": "Beschrijving netzijde meter serienummer",
  "50901.real_time.gridPower.desc": "Beschrijving netzijde vermogen",
  "50901.real_time.gridPowerA.desc": "Beschrijving netzijde fase A vermogen",
  "50901.real_time.gridPowerB.desc": "Beschrijving netzijde fase B vermogen",
  "50901.real_time.gridPowerC.desc": "Beschrijving netzijde fase C vermogen",
  "50901.real_time.gridPowerFactor.desc": "Beschrijving netzijde arbeidsfactor",
  "50901.real_time.gridPowerFactorA.desc": "Beschrijving netzijde fase A arbeidsfactor",
  "50901.real_time.gridPowerFactorB.desc": "Beschrijving netzijde fase B arbeidsfactor",
  "50901.real_time.gridPowerFactorC.desc": "Beschrijving netzijde fase C arbeidsfactor",
  "50901.real_time.gridPowerWholeSystem.desc": "Beschrijving net totaal vermogen (gehele systeem)",
  "50901.real_time.gridReactivePower.desc": "Beschrijving netzijde reactief vermogen",
  "50901.real_time.gridReactivePowerA.desc": "Beschrijving netzijde fase A reactief vermogen",
  "50901.real_time.gridReactivePowerB.desc": "Beschrijving netzijde fase B reactief vermogen",
  "50901.real_time.gridReactivePowerC.desc": "Beschrijving netzijde fase C reactief vermogen",
  "50901.real_time.gridSellPower.desc": "Beschrijving cumulatieve verkochte energie",
  "50901.real_time.gridTotalFrequency.desc": "Beschrijving netzijde frequentie",
  "50901.real_time.gridVoltageA.desc": "Beschrijving netzijde fase A spanning",
  "50901.real_time.gridVoltageB.desc": "Beschrijving netzijde fase B spanning",
  "50901.real_time.gridVoltageC.desc": "Beschrijving netzijde fase C spanning",
  "50901.real_time.hoymilesSerialNumber.desc": "Beschrijving Hoymiles serienummer",
  "50901.real_time.internalFanSpeed1.desc": "Beschrijving binnenste ventilatorsnelheid 1",
  "50901.real_time.internalFanSpeed2.desc": "Beschrijving binnenste ventilatorsnelheid 2",
  "50901.real_time.internalFanSpeed3.desc": "Beschrijving binnenste ventilatorsnelheid 3",
  "50901.real_time.inverterHardwareVersion.desc": "Beschrijving omvormer hardwareversie",
  "50901.real_time.inverterModelNumber.desc": "Beschrijving omvormer modelnummer",
  "50901.real_time.inverterSideRadiatorTemperature.desc": "Beschrijving omvormer zijde koellichaam temperatuur",
  "50901.real_time.inverterTemp.desc": "Beschrijving omvormer interne bedrijfstemperatuur",
  "50901.real_time.loadEnergy.desc": "Beschrijving last dagelijks energieverbruik",
  "50901.real_time.loadPowerWholeSystem.desc": "Beschrijving last totaal vermogen (gehele systeem)",
  "50901.real_time.macAddr.desc": "Beschrijving MAC-adres",
  "50901.real_time.materType.desc": "Beschrijving metertype",
  "50901.real_time.maxCellSoc.desc": "Beschrijving maximale cel-SOC",
  "50901.real_time.maxCellSocCellId.desc": "Beschrijving maximale cel-SOC overeenkomstige index",
  "50901.real_time.maxCellTemperature.desc": "Beschrijving maximale celtemperatuur",
  "50901.real_time.maxCellTemperatureCellId.desc": "Beschrijving maximale celtemperatuur overeenkomstige index",
  "50901.real_time.maxCellVoltage.desc": "Beschrijving maximale celspanning",
  "50901.real_time.maxCellVoltageCellId.desc": "Beschrijving maximale celspanning overeenkomstige index",
  "50901.real_time.MaxChargeCurrent.desc": "Beschrijving maximale laadstroom",
  "50901.real_time.MaxDisChargeCurrent.desc": "Beschrijving maximale ontlaadstroom",
  "50901.real_time.meterFlag.desc": "Beschrijving meter flag",
  "50901.real_time.minCellSoc.desc": "Beschrijving minimale cel-SOC",
  "50901.real_time.minCellSocCellId.desc": "Beschrijving minimale cel-SOC overeenkomstige index",
  "50901.real_time.minCellTemperature.desc": "Beschrijving minimale celtemperatuur",
  "50901.real_time.minCellTemperatureCellId.desc": "Beschrijving minimale celtemperatuur overeenkomstige index",
  "50901.real_time.minCellVoltage.desc": "Beschrijving minimale celspanning",
  "50901.real_time.minCellVoltageCellId.desc": "Beschrijving minimale celspanning overeenkomstige index",
  "50901.real_time.mpptTemp.desc": "Beschrijving PV-zijde koellichaam temperatuur",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "Beschrijving accupakket laad-/ontlaadcyclus aantal",
  "50901.real_time.oemModelName.desc": "Beschrijving OEM modelnaam",
  "50901.real_time.oemSerialNumber.desc": "Beschrijving OEM serienummer",
  "50901.real_time.packCurrent.desc": "Beschrijving accupakket stroom",
  "50901.real_time.packNum.desc": "Beschrijving parallel aantal (aantal accupakketten)",
  "50901.real_time.packPower.desc": "Beschrijving accupakket vermogen",
  "50901.real_time.packSoc.desc": "Beschrijving accupakket SOC",
  "50901.real_time.packSoh.desc": "Beschrijving accupakket SOH",
  "50901.real_time.packVoltage.desc": "Beschrijving accupakket spanning",
  "50901.real_time.powerGeneration.desc": "Beschrijving PV cumulatieve opbrengst",
  "50901.real_time.pv1RealTimePower.desc": "Beschrijving PV1 realtime vermogen",
  "50901.real_time.pv2RealTimePower.desc": "Beschrijving PV2 realtime vermogen",
  "50901.real_time.pv3RealTimePower.desc": "Beschrijving PV3 realtime vermogen",
  "50901.real_time.pv4RealTimePower.desc": "Beschrijving PV4 realtime vermogen",
  "50901.real_time.pvDailyYield.desc": "Beschrijving PV dagelijkse opbrengst",
  "50901.real_time.pvMeterConnectionStatus.desc": "Beschrijving PV-meter verbindingsstatus",
  "50901.real_time.pvMeterCurrentA.desc": "Beschrijving PV-meter fase A stroom",
  "50901.real_time.pvMeterCurrentB.desc": "Beschrijving PV-meter fase B stroom",
  "50901.real_time.pvMeterCurrentC.desc": "Beschrijving PV-meter fase C stroom",
  "50901.real_time.pvMeterDailyYield.desc": "Beschrijving externe omvormer dagelijkse opbrengst",
  "50901.real_time.pvMeterFrequency.desc": "Beschrijving PV-meter frequentie",
  "50901.real_time.pvMeterPhaseAActivePower.desc": "Beschrijving PV-meter fase A actief vermogen",
  "50901.real_time.pvMeterPhaseAPowerFactor.desc": "Beschrijving PV-meter fase A arbeidsfactor",
  "50901.real_time.pvMeterPhaseAReactivePower.desc": "Beschrijving PV-meter fase A reactief vermogen",
  "50901.real_time.pvMeterPhaseBActivePower.desc": "Beschrijving PV-meter fase B actief vermogen",
  "50901.real_time.pvMeterPhaseBPowerFactor.desc": "Beschrijving PV-meter fase B arbeidsfactor",
  "50901.real_time.pvMeterPhaseBReactivePower.desc": "Beschrijving PV-meter fase B reactief vermogen",
  "50901.real_time.pvMeterPhaseCActivePower.desc": "Beschrijving PV-meter fase C actief vermogen",
  "50901.real_time.pvMeterPhaseCPowerFactor.desc": "Beschrijving PV-meter fase C arbeidsfactor",
  "50901.real_time.pvMeterPhaseCReactivePower.desc": "Beschrijving PV-meter fase C reactief vermogen",
  "50901.real_time.pvMeterPower.desc": "Beschrijving PV-meter vermogen",
  "50901.real_time.pvMeterPowerA.desc": "Beschrijving PV-meter fase A vermogen",
  "50901.real_time.pvMeterPowerB.desc": "Beschrijving PV-meter fase B vermogen",
  "50901.real_time.pvMeterPowerC.desc": "Beschrijving PV-meter fase C vermogen",
  "50901.real_time.pvMeterSerialNumber.desc": "Beschrijving PV-meter serienummer",
  "50901.real_time.pvMeterTotalYield.desc": "Beschrijving externe omvormer cumulatieve opbrengst",
  "50901.real_time.pvMeterVoltageA.desc": "Beschrijving PV-meter fase A spanning",
  "50901.real_time.pvMeterVoltageB.desc": "Beschrijving PV-meter fase B spanning",
  "50901.real_time.pvMeterVoltageC.desc": "Beschrijving PV-meter fase C spanning",
  "50901.real_time.pvPower.desc": "Beschrijving PV-vermogen",
  "50901.real_time.pvPowerWholeSystem.desc": "Beschrijving PV totaal vermogen (gehele systeem)",
  "50901.real_time.pvToBatteryPower.desc": "Beschrijving PV-naar-accu vermogen",
  "50901.real_time.pvToGridPower.desc": "Beschrijving PV-naar-net vermogen",
  "50901.real_time.pvToLoadPower.desc": "Beschrijving PV-naar-last vermogen",
  "50901.real_time.relayStatus.desc": "Beschrijving relaisstatus",
  "50901.real_time.relaySupplyVoltageSampling.desc": "Beschrijving relais voedingsspanning sampling",
  "50901.real_time.rssi.desc": "Beschrijving signaalsterkte",
  "50901.real_time.soh.desc": "Beschrijving SOH",
  "50901.real_time.ssid.desc": "Beschrijving SSID",
  "50901.real_time.totalBatteryToLoadEnergy.desc": "Beschrijving cumulatieve accu-naar-last energie",
  "50901.real_time.totalGridToLoadEnergy.desc": "Beschrijving cumulatieve net-naar-last energie",
  "50901.real_time.totalLoadEnergy.desc": "Beschrijving last cumulatief energieverbruik",
  "50901.real_time.totalPvToBatteryEnegry.desc": "Beschrijving cumulatieve PV-naar-accu energie",
  "50901.real_time.totalPvToGridEnegry.desc": "Beschrijving cumulatieve PV-naar-net energie",
  "50901.real_time.totalPvToLoadEnegry.desc": "Beschrijving cumulatieve PV-naar-last energie",
  "50901.warning.batteryHighVoltageAlarm.desc": "Beschrijving accu overspanningsalarm",
  "50901.warning.batteryLowVoltageAlarm.desc": "Beschrijving accu onderspanning",
  "50901.warning.batteryPackChargeHighVoltageAlarm.desc": "Beschrijving accupakket laad-overspanningsalarm",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.desc": "Beschrijving accupakket ontlaad-onderspanningsalarm",
  "50901.warning.canCommunicationTimeout.desc": "Beschrijving CAN-communicatie timeout",
  "50901.warning.chargeHighTemperatureAlarm.desc": "Beschrijving laad hoge temperatuur alarm",
  "50901.warning.chargeLowTemperatureAlarm.desc": "Beschrijving laad lage temperatuur alarm",
  "50901.warning.dischargeHighTemperatureAlarm.desc": "Beschrijving ontlaad hoge temperatuur alarm",
  "50901.warning.dischargeLowTemperatureAlarm.desc": "Beschrijving ontlaad lage temperatuur alarm",
  "50901.warning.hardwareProtection.desc": "Beschrijving hardwarebeveiliging",
  "50901.warning.inputOvervoltageAlarm.desc": "Beschrijving ingang overspanningsalarm",
  "50901.warning.lowBatteryEnergy.desc": "Beschrijving accucapaciteit te laag",
  "50901..absoluteTime.desc": "Beschrijving absolute tijd",
  "50901..batteryHealing.desc": "Beschrijving accu herstel",
  "50901..connectionRouterStatus.desc": "Beschrijving router verbindingsstatus",
  "50901..connectionServerStatus.desc": "Beschrijving clouddienst verbindingsstatus",
  "50901..dfs.desc": "Beschrijving capaciteitenset / Capability Set",
  "50901..dspVersionMainUVersion.desc": "Beschrijving DSP-versie (Hoofd U-versie)",
  "50901..timeZone.desc": "Beschrijving tijdzone",
  "50901.ctrl_Config.ClockSetting.ClockSetting.desc": "Beschrijving klok instelling",
  "50901.ctrl_Config.ClockSetting.clockSetting_day.desc": "Beschrijving klok instelling - dag",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour.desc": "Beschrijving klok instelling - uur",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute.desc": "Beschrijving klok instelling - minuut",
  "50901.ctrl_Config.ClockSetting.clockSetting_month.desc": "Beschrijving klok instelling - maand",
  "50901.ctrl_Config.ClockSetting.clockSetting_second.desc": "Beschrijving klok instelling - seconde",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday.desc": "Beschrijving klok instelling - weekdag",
  "50901.ctrl_Config.ClockSetting.clockSetting_year.desc": "Beschrijving klok instelling - jaar",
  "50901.ctrl_Config.Device.masterSlave.desc": "Beschrijving master/slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold.desc": "Beschrijving omgevingstemperatuur drempel",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold.desc": "Beschrijving printplaat omgevingstemperatuur drempel",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress.desc": "Beschrijving gateway communicatieadres",
  "50901.ctrl_WorkMode.Backup.backupSoc.desc": "Beschrijving gereserveerde SOC",
  "50901.ctrl_WorkMode.economic.economicModeSoc.desc": "Beschrijving economische modus SOC",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber.desc": "Beschrijving economische modus datumindex",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1.desc": "Beschrijving sectie 1 piek starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2.desc": "Beschrijving sectie 1 piek starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1.desc": "Beschrijving sectie 1 piek starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2.desc": "Beschrijving sectie 1 piek starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1.desc": "Beschrijving sectie 1 piek stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2.desc": "Beschrijving sectie 1 piek stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1.desc": "Beschrijving sectie 1 piek stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2.desc": "Beschrijving sectie 1 piek stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section1StartDay.desc": "Beschrijving sectie 1 startdag",
  "50901.ctrl_WorkMode.economic.section1StartMonth.desc": "Beschrijving sectie 1 startmaand",
  "50901.ctrl_WorkMode.economic.section1StopDay.desc": "Beschrijving sectie 1 stopdag",
  "50901.ctrl_WorkMode.economic.section1StopMonth.desc": "Beschrijving sectie 1 stopmaand",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1.desc": "Beschrijving sectie 1 dal starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2.desc": "Beschrijving sectie 1 dal starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1.desc": "Beschrijving sectie 1 dal starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2.desc": "Beschrijving sectie 1 dal starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1.desc": "Beschrijving sectie 1 dal stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2.desc": "Beschrijving sectie 1 dal stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1.desc": "Beschrijving sectie 1 dal stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2.desc": "Beschrijving sectie 1 dal stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.desc": "Beschrijving sectie 1 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.desc": "Beschrijving sectie 1 weekbereik 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1.desc": "Beschrijving sectie 2 piek starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2.desc": "Beschrijving sectie 2 piek starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1.desc": "Beschrijving sectie 2 piek starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2.desc": "Beschrijving sectie 2 piek starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1.desc": "Beschrijving sectie 2 piek stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2.desc": "Beschrijving sectie 2 piek stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1.desc": "Beschrijving sectie 2 piek stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2.desc": "Beschrijving sectie 2 piek stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section2StartDay.desc": "Beschrijving sectie 2 startdag",
  "50901.ctrl_WorkMode.economic.section2StartMonth.desc": "Beschrijving sectie 2 startmaand",
  "50901.ctrl_WorkMode.economic.section2StopDay.desc": "Beschrijving sectie 2 stopdag",
  "50901.ctrl_WorkMode.economic.section2StopMonth.desc": "Beschrijving sectie 2 stopmaand",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1.desc": "Beschrijving sectie 2 dal starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2.desc": "Beschrijving sectie 2 dal starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1.desc": "Beschrijving sectie 2 dal starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2.desc": "Beschrijving sectie 2 dal starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1.desc": "Beschrijving sectie 2 dal stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2.desc": "Beschrijving sectie 2 dal stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1.desc": "Beschrijving sectie 2 dal stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2.desc": "Beschrijving sectie 2 dal stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.desc": "Beschrijving sectie 2 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange2.desc": "Beschrijving sectie 2 weekbereik 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1.desc": "Beschrijving sectie 3 piek starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2.desc": "Beschrijving sectie 3 piek starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1.desc": "Beschrijving sectie 3 piek starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2.desc": "Beschrijving sectie 3 piek starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1.desc": "Beschrijving sectie 3 piek stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2.desc": "Beschrijving sectie 3 piek stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1.desc": "Beschrijving sectie 3 piek stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2.desc": "Beschrijving sectie 3 piek stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section3StartDay.desc": "Beschrijving sectie 3 startdag",
  "50901.ctrl_WorkMode.economic.section3StartMonth.desc": "Beschrijving sectie 3 startmaand",
  "50901.ctrl_WorkMode.economic.section3StopDay.desc": "Beschrijving sectie 3 stopdag",
  "50901.ctrl_WorkMode.economic.section3StopMonth.desc": "Beschrijving sectie 3 stopmaand",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1.desc": "Beschrijving sectie 3 dal starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2.desc": "Beschrijving sectie 3 dal starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1.desc": "Beschrijving sectie 3 dal starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2.desc": "Beschrijving sectie 3 dal starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1.desc": "Beschrijving sectie 3 dal stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2.desc": "Beschrijving sectie 3 dal stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1.desc": "Beschrijving sectie 3 dal stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2.desc": "Beschrijving sectie 3 dal stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.desc": "Beschrijving sectie 3 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.desc": "Beschrijving sectie 3 weekbereik 2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1.desc": "Beschrijving sectie 4 piek starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2.desc": "Beschrijving sectie 4 piek starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1.desc": "Beschrijving sectie 4 piek starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2.desc": "Beschrijving sectie 4 piek starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1.desc": "Beschrijving sectie 4 piek stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2.desc": "Beschrijving sectie 4 piek stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1.desc": "Beschrijving sectie 4 piek stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2.desc": "Beschrijving sectie 4 piek stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section4StartDay.desc": "Beschrijving sectie 4 startdag",
  "50901.ctrl_WorkMode.economic.section4StartMonth.desc": "Beschrijving sectie 4 startmaand",
  "50901.ctrl_WorkMode.economic.section4StopDay.desc": "Beschrijving sectie 4 stopdag",
  "50901.ctrl_WorkMode.economic.section4StopMonth.desc": "Beschrijving sectie 4 stopmaand",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1.desc": "Beschrijving sectie 4 dal starttijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2.desc": "Beschrijving sectie 4 dal starttijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1.desc": "Beschrijving sectie 4 dal starttijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2.desc": "Beschrijving sectie 4 dal starttijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1.desc": "Beschrijving sectie 4 dal stoptijd 1 - uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2.desc": "Beschrijving sectie 4 dal stoptijd 2 - uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1.desc": "Beschrijving sectie 4 dal stoptijd 1 - minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2.desc": "Beschrijving sectie 4 dal stoptijd 2 - minuut",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.desc": "Beschrijving sectie 4 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.desc": "Beschrijving sectie 4 weekbereik 2",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc.desc": "Beschrijving forceer laad-SOC",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower.desc": "Beschrijving maximaal laadvermogen",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc.desc": "Beschrijving forceer ontlaad-SOC",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower.desc": "Beschrijving maximaal ontlaadvermogen",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower.desc": "Beschrijving piekmeter vermogen",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc.desc": "Beschrijving piekmeter SOC",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc.desc": "Beschrijving eigenverbruik SOC",
  "50901.ctrl_WorkMode.Switch.workMode.desc": "Beschrijving EMS werkingsmodus",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange.desc": "Beschrijving TOU-modus tijdsbereik",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH.desc": "Beschrijving gebruiksduur tijd1 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin.desc": "Beschrijving gebruiksduur tijd1 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH.desc": "Beschrijving gebruiksduur tijd1 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin.desc": "Beschrijving gebruiksduur tijd1 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH.desc": "Beschrijving gebruiksduur tijd1 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin.desc": "Beschrijving gebruiksduur tijd1 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH.desc": "Beschrijving gebruiksduur tijd1 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin.desc": "Beschrijving gebruiksduur tijd1 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH.desc": "Beschrijving gebruiksduur tijd2 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin.desc": "Beschrijving gebruiksduur tijd2 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH.desc": "Beschrijving gebruiksduur tijd2 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin.desc": "Beschrijving gebruiksduur tijd2 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH.desc": "Beschrijving gebruiksduur tijd2 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin.desc": "Beschrijving gebruiksduur tijd2 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH.desc": "Beschrijving gebruiksduur tijd2 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin.desc": "Beschrijving gebruiksduur tijd2 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH.desc": "Beschrijving gebruiksduur tijd3 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin.desc": "Beschrijving gebruiksduur tijd3 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH.desc": "Beschrijving gebruiksduur tijd3 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin.desc": "Beschrijving gebruiksduur tijd3 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH.desc": "Beschrijving gebruiksduur tijd3 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin.desc": "Beschrijving gebruiksduur tijd3 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH.desc": "Beschrijving gebruiksduur tijd3 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin.desc": "Beschrijving gebruiksduur tijd3 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH.desc": "Beschrijving gebruiksduur tijd4 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin.desc": "Beschrijving gebruiksduur tijd4 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH.desc": "Beschrijving gebruiksduur tijd4 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin.desc": "Beschrijving gebruiksduur tijd4 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH.desc": "Beschrijving gebruiksduur tijd4 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin.desc": "Beschrijving gebruiksduur tijd4 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH.desc": "Beschrijving gebruiksduur tijd4 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin.desc": "Beschrijving gebruiksduur tijd4 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc.desc": "Beschrijving ontlaad afschakelvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH.desc": "Beschrijving gebruiksduur tijd5 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin.desc": "Beschrijving gebruiksduur tijd5 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH.desc": "Beschrijving gebruiksduur tijd5 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin.desc": "Beschrijving gebruiksduur tijd5 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH.desc": "Beschrijving gebruiksduur tijd5 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin.desc": "Beschrijving gebruiksduur tijd5 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH.desc": "Beschrijving gebruiksduur tijd5 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin.desc": "Beschrijving gebruiksduur tijd5 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH.desc": "Beschrijving gebruiksduur tijd6 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin.desc": "Beschrijving gebruiksduur tijd6 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH.desc": "Beschrijving gebruiksduur tijd6 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin.desc": "Beschrijving gebruiksduur tijd6 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH.desc": "Beschrijving gebruiksduur tijd6 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin.desc": "Beschrijving gebruiksduur tijd6 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH.desc": "Beschrijving gebruiksduur tijd6 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin.desc": "Beschrijving gebruiksduur tijd6 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH.desc": "Beschrijving gebruiksduur tijd7 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin.desc": "Beschrijving gebruiksduur tijd7 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH.desc": "Beschrijving gebruiksduur tijd7 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin.desc": "Beschrijving gebruiksduur tijd7 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH.desc": "Beschrijving gebruiksduur tijd7 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin.desc": "Beschrijving gebruiksduur tijd7 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH.desc": "Beschrijving gebruiksduur tijd7 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin.desc": "Beschrijving gebruiksduur tijd7 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH.desc": "Beschrijving gebruiksduur tijd8 laadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin.desc": "Beschrijving gebruiksduur tijd8 laadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower.desc": "Beschrijving laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH.desc": "Beschrijving gebruiksduur tijd8 laadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin.desc": "Beschrijving gebruiksduur tijd8 laadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc.desc": "Beschrijving laad afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH.desc": "Beschrijving gebruiksduur tijd8 ontlaadeinde - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin.desc": "Beschrijving gebruiksduur tijd8 ontlaadeinde - minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower.desc": "Beschrijving ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH.desc": "Beschrijving gebruiksduur tijd8 ontlaadstart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin.desc": "Beschrijving gebruiksduur tijd8 ontlaadstart - min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc.desc": "Beschrijving ontlaad afschakelcapaciteit",
  "50901.real_time.bmsSoftwareVersion.desc": "Beschrijving BMS-versie - Software",
  "50901.real_time.commAddress10Slave9.desc": "Beschrijving communicatieadres 10 (slave 9)",
  "50901.real_time.commAddress1Master.desc": "Beschrijving communicatieadres 1 (master)",
  "50901.real_time.commAddress2Slave1.desc": "Beschrijving communicatieadres 2 (slave 1)",
  "50901.real_time.commAddress3Slave2.desc": "Beschrijving communicatieadres 3 (slave 2)",
  "50901.real_time.commAddress3Slave3.desc": "Beschrijving communicatieadres 4 (slave 3)",
  "50901.real_time.commAddress4Slave4.desc": "Beschrijving communicatieadres 5 (slave 4)",
  "50901.real_time.commAddress6Slave6.desc": "Beschrijving communicatieadres 6 (slave 5)",
  "50901.real_time.commAddress7Slave6.desc": "Beschrijving communicatieadres 7 (slave 6)",
  "50901.real_time.commAddress8Slave7.desc": "Beschrijving communicatieadres 8 (slave 7)",
  "50901.real_time.commAddress9Slave8.desc": "Beschrijving communicatieadres 9 (slave 8)",
  "50901.real_time.epsCurrentA.desc": "Beschrijving EPS-zijde fase A stroom",
  "50901.real_time.epsCurrentB.desc": "Beschrijving EPS-zijde fase B stroom",
  "50901.real_time.epsCurrentC.desc": "Beschrijving EPS-zijde fase C stroom",
  "50901.real_time.epsPower.desc": "Beschrijving EPS-zijde vermogen",
  "50901.real_time.epsPowerA.desc": "Beschrijving EPS-zijde fase A vermogen",
  "50901.real_time.epsPowerB.desc": "Beschrijving EPS-zijde fase B vermogen",
  "50901.real_time.epsPowerC.desc": "Beschrijving EPS-zijde fase C vermogen",
  "50901.real_time.epsVoltageA.desc": "Beschrijving EPS-zijde fase A spanning",
  "50901.real_time.epsVoltageB.desc": "Beschrijving EPS-zijde fase B spanning",
  "50901.real_time.epsVoltageC.desc": "Beschrijving EPS-zijde fase C spanning",
  "50901.real_time.essAccessPoint.desc": "Beschrijving ESS-toegangspunt",
  "50901.real_time.generatorConnectionStatus.desc": "Beschrijving generator verbindingsstatus",
  "50901.real_time.generatorVoltageA.desc": "Beschrijving generator fase A spanning",
  "50901.real_time.generatorVoltageB.desc": "Beschrijving generator fase B spanning",
  "50901.real_time.generatorVoltageC.desc": "Beschrijving generator fase C spanning",
  "50901.real_time.invAcFrequency.desc": "Beschrijving omvormer AC-uitgangsfrequentie",
  "50901.real_time.inverCombinedActivePower.desc": "Beschrijving omvormer AC-uitgangsvermogen",
  "50901.real_time.invRatedPower.desc": "Beschrijving nominaal vermogen",
  "50901.real_time.invRunningtime.desc": "Beschrijving INV-bedrijfstijd (Hoymiles: Normale bedrijfstijd)",
  "50901.real_time.machineSnMaster.desc": "Beschrijving master eenheid SN",
  "50901.real_time.machineSnSlave1.desc": "Beschrijving slave 1 SN",
  "50901.real_time.machineSnSlave2.desc": "Beschrijving slave 2 SN",
  "50901.real_time.machineSnSlave3.desc": "Beschrijving slave 3 SN",
  "50901.real_time.machineSnSlave4.desc": "Beschrijving slave 4 SN",
  "50901.real_time.machineSnSlave5.desc": "Beschrijving slave 5 SN",
  "50901.real_time.machineSnSlave6.desc": "Beschrijving slave 6 SN",
  "50901.real_time.machineSnSlave7.desc": "Beschrijving slave 7 SN",
  "50901.real_time.machineSnSlave8.desc": "Beschrijving slave 8 SN",
  "50901.real_time.machineSnSlave9.desc": "Beschrijving slave 9 SN",
  "50901.real_time.numberOfUnits.desc": "Beschrijving aantal eenheden",
  "50901.real_time.phaseAOfInverterActivePower.desc": "Beschrijving omvormer AC-zijde fase A vermogen",
  "50901.real_time.phaseAOfInverterSideCurrent.desc": "Beschrijving omvormer AC-zijde fase A stroom",
  "50901.real_time.phaseAOfInverterSideVoltage.desc": "Beschrijving omvormer AC-zijde fase A spanning",
  "50901.real_time.phaseBOfInverterActivePower.desc": "Beschrijving omvormer AC-zijde fase B vermogen",
  "50901.real_time.phaseBOfInverterSideCurrent.desc": "Beschrijving omvormer AC-zijde fase B stroom",
  "50901.real_time.phaseBOfInverterSideVoltage.desc": "Beschrijving omvormer AC-zijde fase B spanning",
  "50901.real_time.phaseCOfInverterActivePower.desc": "Beschrijving omvormer AC-zijde fase C vermogen",
  "50901.real_time.phaseCOfInverterSideCurrent.desc": "Beschrijving omvormer AC-zijde fase C stroom",
  "50901.real_time.phaseCOfInverterSideVoltage.desc": "Beschrijving omvormer AC-zijde fase C spanning",
  "50901.real_time.pv1Current.desc": "Beschrijving PV1 stroom",
  "50901.real_time.pv1Power.desc": "Beschrijving PV1 vermogen",
  "50901.real_time.pv1Voltage.desc": "Beschrijving PV1 spanning",
  "50901.real_time.pv2Current.desc": "Beschrijving PV2 stroom",
  "50901.real_time.pv2Power.desc": "Beschrijving PV2 vermogen",
  "50901.real_time.pv2Voltage.desc": "Beschrijving PV2 spanning",
  "50901.real_time.pv3Current.desc": "Beschrijving PV3 stroom",
  "50901.real_time.pv3Power.desc": "Beschrijving PV3 vermogen",
  "50901.real_time.pv3Voltage.desc": "Beschrijving PV3 spanning",
  "50901.real_time.pv4Current.desc": "Beschrijving PV4 stroom",
  "50901.real_time.pv4Power.desc": "Beschrijving PV4 vermogen",
  "50901.real_time.pv4Voltage.desc": "Beschrijving PV4 spanning",
  "50901.real_time.pvConnectionStatus.desc": "Beschrijving PV-verbindingsstatus",
  "50901.real_time.serviceEntranceBreakerCurrent.desc": "Beschrijving service entrance stroomonderbreker stroom",
  "50901.real_time.workStatus.desc": "Beschrijving bedrijfsstatus",
  "50901..antiIslandingEnable.desc": "Beschrijving anti-eilandvorming inschakelen",
  "50901..apcEn.desc": "Beschrijving APC inschakelen",
  "50901..apcPwrLmt.desc": "Beschrijving APC-vermogensgrens",
  "50901..apcRamp.desc": "Beschrijving APC-helling / stijgsnelheid",
  "50901..drmEnable.desc": "Beschrijving DRM inschakelen",
  "50901..fixPfTr.desc": "Beschrijving FixPF_Tr tijd",
  "50901..functionCode.desc": "Beschrijving functiecode",
  "50901..fwDelayTime.desc": "Beschrijving FW-vertragingstijd",
  "50901..fwOverFdroop.desc": "Beschrijving FW overfrequente droopcoëfficiënt",
  "50901..fwUnderFdroop.desc": "Beschrijving FW onderfrequente droopcoëfficiënt",
  "50901..gcfExportHardTime.desc": "Beschrijving GCF export harde limiet tijd",
  "50901..gcfGenerationHardLimitRatio.desc": "Beschrijving GCF opwekking harde limiet verhouding",
  "50901..gcfGenerationHardTime.desc": "Beschrijving GCF opwekking harde limiet tijd",
  "50901..gcfGenerationSoftLimitRatio.desc": "Beschrijving GCF opwekking zachte limiet verhouding",
  "50901..gcfImportHardTime.desc": "Beschrijving GCF import harde limiet tijd",
  "50901..gcfImportLimitRatio.desc": "Beschrijving GCF import limiet verhouding",
  "50901..gcfReconnectionTime.desc": "Beschrijving GCF heraansluitingstijd",
  "50901..gridLevel2LimitTimeScale.desc": "Beschrijving net secundaire grenswaarde tijdschaal",
  "50901..permitEnable.desc": "Beschrijving toestemming inschakelen",
  "50901..phaseOrderInverseDisable.desc": "Beschrijving fasesequentie omgekeerd uitschakelen",
  "50901..pqFuncCode.desc": "Beschrijving PQ-functiecode",
  "50901..pqP1.desc": "Beschrijving PQ_P1",
  "50901..pqP2.desc": "Beschrijving PQ_P2",
  "50901..pqP3.desc": "Beschrijving PQ_P3",
  "50901..pqP4.desc": "Beschrijving PQ_P4",
  "50901..pqP5.desc": "Beschrijving PQ_P5",
  "50901..pqP6.desc": "Beschrijving PQ_P6",
  "50901..pqQ1.desc": "Beschrijving PQ_Q1",
  "50901..pqQ2.desc": "Beschrijving PQ_Q2",
  "50901..pqQ3.desc": "Beschrijving PQ_Q3",
  "50901..pqQ4.desc": "Beschrijving PQ_Q4",
  "50901..pqQ5.desc": "Beschrijving PQ_Q5",
  "50901..pqQ6.desc": "Beschrijving PQ_Q6",
  "50901..pqTr.desc": "Beschrijving PQ_Tr tijd",
  "50901..relayU16NlineRlyTestDis.desc": "Beschrijving relais N test uitschakelen",
  "50901..rpaP1.desc": "Beschrijving RPA_P1",
  "50901..rpaP2.desc": "Beschrijving RPA_P2",
  "50901..rpaQ1.desc": "Beschrijving RPA_Q1",
  "50901..rpaQ2.desc": "Beschrijving RPA_Q2",
  "50901..vvTr.desc": "Beschrijving VV_Tr tijd",
  "50901..wattRegulationPriority.desc": "Beschrijving watt prioriteit",
  "50901..wpfTr.desc": "Beschrijving WPF_Tr tijd",
  "50901.ctrl_Config.Battery.absorptionVoltage.desc": "Beschrijving absorptiespanning",
  "50901.ctrl_Config.Battery.batteryCapacity.desc": "Beschrijving BMS-capaciteit",
  "50901.ctrl_Config.Battery.endChargeVoltage.desc": "Beschrijving laadeindspanning",
  "50901.ctrl_Config.Battery.endOfChargeCurrent.desc": "Beschrijving laadeindstroom",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout.desc": "Beschrijving equalisatielading timeout",
  "50901.ctrl_Config.Battery.equalizationEnable.desc": "Beschrijving equalisatie inschakelen",
  "50901.ctrl_Config.Battery.equalizationIntervalDays.desc": "Beschrijving equalisatie interval dagen",
  "50901.ctrl_Config.Battery.equalizationTime.desc": "Beschrijving equalisatietijd",
  "50901.ctrl_Config.Battery.equalizationVoltage.desc": "Beschrijving equalisatiespanning",
  "50901.ctrl_Config.Battery.floatVoltage.desc": "Beschrijving druppellaadspanning / floatspanning",
  "50901.ctrl_Config.Battery.initialResistance.desc": "Beschrijving initiële weerstand",
  "50901.ctrl_Config.Battery.maximumChargeLimit.desc": "Beschrijving maximale laadstroom/-vermogen grenswaarde",
  "50901.ctrl_Config.Battery.maximumDischargeLimit.desc": "Beschrijving maximale ontlaadstroom/-vermogen grenswaarde",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor.desc": "Beschrijving temperatuurcorrectiecoëfficiënt",
  "50901.ctrl_Config.Connection.dtu_comm_enable.desc": "Beschrijving DTU-communicatie inschakelen",
  "50901.ctrl_Config.Device.arcFaultClear.desc": "Beschrijving vlamboogfout wissen",
  "50901.ctrl_Config.Device.batActivate.desc": "Beschrijving accu activering",
  "50901.ctrl_Config.Device.batteryBalancing.desc": "Beschrijving accu balancering",
  "50901.ctrl_Config.Device.clearFault.desc": "Beschrijving fout wissen",
  "50901.ctrl_Config.Device.parallelNetworking.desc": "Beschrijving parallel netwerk",
  "50901.ctrl_Config.Device.restartSystem.desc": "Beschrijving systeemherstart",
  "50901.ctrl_Config.Device.restoreDefault.desc": "Beschrijving standaardwaarden herstellen",
  "50901.ctrl_Config.Device.selfTest.desc": "Beschrijving zelftest",
  "50901.ctrl_Config.Device.systemPowerOnOff.desc": "Beschrijving systeem aan/uit",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH.desc": "Beschrijving generatorregeling - laadeindtijd - uur",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin.desc": "Beschrijving generatorregeling - laadeindtijd - minuut",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Beschrijving Generatorregeling - Laadstarttijd - Uur",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Beschrijving Generatorregeling - Laadstarttijd - Minuut",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Beschrijving Generator Uitschakel Accucapaciteit",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.desc": "Beschrijving generatormodus",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Beschrijving Generator Start Accucapaciteit",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Beschrijving Generator Oefenmodus Frequentie",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.desc": "Beschrijving generator oefenmodus",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Beschrijving Generator Oefenmodus Looptijd",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH.desc": "Beschrijving generator oefenmodus starttijd - uur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin.desc": "Beschrijving generator oefenmodus starttijd - minuut",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Beschrijving Generator Oefenmodus Starttijd",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH.desc": "Beschrijving stand-by tijd 1 einde - uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin.desc": "Beschrijving stand-by tijd 1 einde - minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH.desc": "Beschrijving stand-by tijd 1 start - uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin.desc": "Beschrijving stand-by tijd 1 start - minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH.desc": "Beschrijving stand-by tijd 2 einde - uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin.desc": "Beschrijving stand-by tijd 2 einde - minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH.desc": "Beschrijving stand-by tijd 2 start - uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin.desc": "Beschrijving stand-by tijd 2 start - minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Beschrijving Stand-By Tijd Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.desc": "Beschrijving lastregelmodus",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.desc": "Beschrijving lastregeling maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.desc": "Beschrijving lastregeling dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.desc": "Beschrijving lastregeling woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.desc": "Beschrijving lastregeling donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.desc": "Beschrijving lastregeling vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.desc": "Beschrijving lastregeling zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.desc": "Beschrijving lastregeling zondag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.desc": "Beschrijving handmatige modus schakelaar",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower.desc": "Beschrijving lastmodus lastvermogen drempel",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime.desc": "Beschrijving lastregeling minimale inschakeltijd",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc.desc": "Beschrijving eilandmodus bescherming SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1.desc": "Beschrijving tijdsbereik 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.desc": "Beschrijving maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.desc": "Beschrijving dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.desc": "Beschrijving woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.desc": "Beschrijving donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.desc": "Beschrijving vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.desc": "Beschrijving zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.desc": "Beschrijving zondag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour.desc": "Beschrijving timer 1 einde - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2.desc": "Beschrijving timer 1 einde_2 - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3.desc": "Beschrijving tijdslot 1 einde - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute.desc": "Beschrijving timer 1 einde - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2.desc": "Beschrijving timer 1 einde_2 - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3.desc": "Beschrijving tijdslot 1 einde - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min.desc": "Beschrijving timer 1 start - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2.desc": "Beschrijving timer 1 start_2 - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3.desc": "Beschrijving tijdslot 1 start - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour.desc": "Beschrijving timer 2 einde - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2.desc": "Beschrijving timer 2 einde_2 - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3.desc": "Beschrijving tijdslot 2 einde - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes.desc": "Beschrijving timer 2 einde - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2.desc": "Beschrijving timer 2 einde_2 - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3.desc": "Beschrijving tijdslot 2 einde - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes.desc": "Beschrijving timer 2 start - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2.desc": "Beschrijving timer 2 start_2 - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3.desc": "Beschrijving tijdslot 2 start - minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour.desc": "Beschrijving timer 1 start - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2.desc": "Beschrijving timer 1 start_2 - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3.desc": "Beschrijving tijdslot 1 start - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour.desc": "Beschrijving timer 2 start - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2.desc": "Beschrijving timer 2 start_2 - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3.desc": "Beschrijving tijdslot 2 start - uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.desc": "Beschrijving maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.desc": "Beschrijving dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.desc": "Beschrijving woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.desc": "Beschrijving donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.desc": "Beschrijving vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.desc": "Beschrijving zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.desc": "Beschrijving zondag",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.desc": "Beschrijving droogcontact werkingsmodus",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Beschrijving Piek Accu Max. Ontlaadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Beschrijving Piek Netinvoedingsvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Beschrijving Accu Max. Laadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Beschrijving Accu Max. Ontlaadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Beschrijving Loodzuur Accu Onderhoudstijd",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Beschrijving Maximale Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Beschrijving Minimale Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Beschrijving Vermogenscompensatie",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Beschrijving Rsvd Reservevermogen",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Beschrijving Bypass Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Beschrijving Eps-Modus",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Beschrijving Pv-Modus Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq.desc": "Beschrijving generator frequentiBovengrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt.desc": "Beschrijving generator spanning bovengrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq.desc": "Beschrijving generator frequentie ondergrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt.desc": "Beschrijving generator spanning ondergrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power.desc": "Beschrijving generator-naar-accu laadvermogen bij meervoudig parallelbedrijf",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Beschrijving Globale Scan Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Beschrijving Netvermogen Beperken",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Beschrijving Mid / Gateway Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Beschrijving Driefasen Onbalans Inschakelen",
  "50901.ctrl_Safety.DCI.dciEnable.desc": "Beschrijving DCI inschakelen",
  "50901.ctrl_Safety.DCI.lowerLimit.desc": "Beschrijving DCI onderste grenswaarde stroom",
  "50901.ctrl_Safety.DCI.lowerTime.desc": "Beschrijving DCI onderste grenswaarde tijd",
  "50901.ctrl_Safety.DCI.upperLimit.desc": "Beschrijving DCI bovenste grenswaarde stroom",
  "50901.ctrl_Safety.DCI.upperTime.desc": "Beschrijving DCI bovenste grenswaarde tijd",
  "50901.ctrl_Safety.FRT.frtFuncCode.desc": "Beschrijving FRT-functiecode",
  "50901.ctrl_Safety.FRT.frtHighLimit1.desc": "Beschrijving frequentie bovengrens 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time.desc": "Beschrijving frequentie bovengrens 1 duur",
  "50901.ctrl_Safety.FRT.frtHighLimit2.desc": "Beschrijving frequentie bovengrens 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time.desc": "Beschrijving frequentie bovengrens 2 duur",
  "50901.ctrl_Safety.FRT.frtHighLimit3.desc": "Beschrijving frequentie bovengrens 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time.desc": "Beschrijving frequentie bovengrens 3 duur",
  "50901.ctrl_Safety.FRT.frtLowLimit1.desc": "Beschrijving frequentie ondergrens 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time.desc": "Beschrijving frequentie ondergrens 1 duur",
  "50901.ctrl_Safety.FRT.frtLowLimit2.desc": "Beschrijving frequentie ondergrens 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time.desc": "Beschrijving frequentie ondergrens 2 duur",
  "50901.ctrl_Safety.FRT.frtLowLimit3.desc": "Beschrijving frequentie ondergrens 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time.desc": "Beschrijving frequentie ondergrens 3 duur",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.desc": "Beschrijving FW accu modus verschil inschakelen",
  "50901.ctrl_Safety.FW.fwEnable.desc": "Beschrijving FW inschakelen",
  "50901.ctrl_Safety.FW.fwFuncCode.desc": "Beschrijving FW-functiecode",
  "50901.ctrl_Safety.FW.fwOverEndFreq.desc": "Beschrijving FW overfrequente eindfrequentie",
  "50901.ctrl_Safety.FW.fwOverStartFreq.desc": "Beschrijving FW overfrequente startfrequentie",
  "50901.ctrl_Safety.FW.fwOverTransFreq.desc": "Beschrijving FW overfrequente overgangsfrequentie",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency.desc": "Beschrijving FW herstel frequentie ondergrens",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime.desc": "Beschrijving FW herstel stabilisatietijd",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency.desc": "Beschrijving FW herstel frequentie bovengrens",
  "50901.ctrl_Safety.FW.fwTr.desc": "Beschrijving FW_Tr tijd",
  "50901.ctrl_Safety.FW.fwUnderEndFreq.desc": "Beschrijving FW onderfrequente eindfrequentie",
  "50901.ctrl_Safety.FW.fwUnderStartFreq.desc": "Beschrijving FW onderfrequente startfrequentie",
  "50901.ctrl_Safety.FW.fwUnderStopFreq.desc": "Beschrijving FW onderfrequente stopfrequentie",
  "50901.ctrl_Safety.RCD.continueLimitTime.desc": "Beschrijving RCD continue limiet tijd",
  "50901.ctrl_Safety.RCD.continueLimitValue.desc": "Beschrijving RCD continue limiet stroom",
  "50901.ctrl_Safety.RCD.rcdEnable.desc": "Beschrijving RCD inschakelen",
  "50901.ctrl_Safety.RCD.step1LimitTime.desc": "Beschrijving RCD stap 1 limiet tijd",
  "50901.ctrl_Safety.RCD.step1LimitValue.desc": "Beschrijving RCD stap 1 limiet stroom",
  "50901.ctrl_Safety.RCD.step2LimitTime.desc": "Beschrijving RCD stap 2 limiet tijd",
  "50901.ctrl_Safety.RCD.step2LimitValue.desc": "Beschrijving RCD stap 2 limiet stroom",
  "50901.ctrl_Safety.RCD.step3LimitTime.desc": "Beschrijving RCD stap 3 limiet tijd",
  "50901.ctrl_Safety.RCD.step3LimitValue.desc": "Beschrijving RCD stap 3 limiet stroom",
  "50901.ctrl_Safety.RPC.gcfEn.desc": "Beschrijving GCF inschakelen",
  "50901.ctrl_Safety.RPC.gcfFuncCode.desc": "Beschrijving GCF-functiecode",
  "50901.ctrl_Safety.RPC.rpcMode.desc": "Beschrijving RP-modus",
  "50901.ctrl_Safety.RPC.rpcPf.desc": "Beschrijving RPC arbeidsfactor PF",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio.desc": "Beschrijving RPC reactief vermogen verhouding",
  "50901.ctrl_Safety.RPC.rpcTr.desc": "Beschrijving RPC_Tr tijd",
  "50901.ctrl_Safety.RPC.vvFuncCode.desc": "Beschrijving Volt-Var-functiecode",
  "50901.ctrl_Safety.RPC.vvLockIn.desc": "Beschrijving VV inschakelwaarde",
  "50901.ctrl_Safety.RPC.vvLockOut.desc": "Beschrijving VV uitschakelwaarde",
  "50901.ctrl_Safety.RPC.vvQ1.desc": "Beschrijving reactief vermogen setpoint_Q1",
  "50901.ctrl_Safety.RPC.vvQ2.desc": "Beschrijving reactief vermogen setpoint_Q2",
  "50901.ctrl_Safety.RPC.vvQ3.desc": "Beschrijving reactief vermogen setpoint_Q3",
  "50901.ctrl_Safety.RPC.vvQ4.desc": "Beschrijving reactief vermogen setpoint_Q4",
  "50901.ctrl_Safety.RPC.vvV1.desc": "Beschrijving spanning setpoint_V1",
  "50901.ctrl_Safety.RPC.vvV2.desc": "Beschrijving spanning setpoint_V2",
  "50901.ctrl_Safety.RPC.vvV3.desc": "Beschrijving spanning setpoint_V3",
  "50901.ctrl_Safety.RPC.vvV4.desc": "Beschrijving spanning setpoint_V4",
  "50901.ctrl_Safety.RPC.vvVref.desc": "Beschrijving Volt-Var referentiewaarde (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr.desc": "Beschrijving Volt-Var referentiewaarde Tr tijd",
  "50901.ctrl_Safety.RPC.wpfFuncCode.desc": "Beschrijving WPF-functiecode",
  "50901.ctrl_Safety.RPC.wpfLockIn.desc": "Beschrijving WPF inschakelwaarde",
  "50901.ctrl_Safety.RPC.wpfLockOut.desc": "Beschrijving WPF uitschakelwaarde",
  "50901.ctrl_Safety.RPC.wpfMinPFOver.desc": "Beschrijving WPF overbelasting minimale PF",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder.desc": "Beschrijving WPF onderbelasting minimale PF",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio.desc": "Beschrijving WPF vermogen einde verhouding",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio.desc": "Beschrijving WPF vermogen start verhouding",
  "50901.ctrl_Safety.RR.rrFuncCode.desc": "Beschrijving RR-functiecode",
  "50901.ctrl_Safety.RR.rrRurNm.desc": "Beschrijving RR_RUR_NM",
  "50901.ctrl_Safety.RR.rrRurSs.desc": "Beschrijving RR_RUR_SS",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue.desc": "Beschrijving RT frequentie herstel bovengrens",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue.desc": "Beschrijving RT frequentie herstel ondergrens",
  "50901.ctrl_Safety.RT.rtFuncCode.desc": "Beschrijving RT-functiecode",
  "50901.ctrl_Safety.RT.rtNMTime.desc": "Beschrijving RT_NM tijd",
  "50901.ctrl_Safety.RT.rtSRTTime.desc": "Beschrijving RT_SRT tijd",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue.desc": "Beschrijving RT spanning herstel bovengrens",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue.desc": "Beschrijving RT spanning herstel ondergrens",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage.desc": "Beschrijving 10-minuten gemiddelde spanning",
  "50901.ctrl_Safety.VRT.vrtEn.desc": "Beschrijving VRT inschakelen",
  "50901.ctrl_Safety.VRT.vrtFuncCode.desc": "Beschrijving VRT-functiecode",
  "50901.ctrl_Safety.VRT.vrtHighLimit.desc": "Beschrijving VRT hoge spanning drempel",
  "50901.ctrl_Safety.VRT.vrtLowLimit.desc": "Beschrijving VRT lage spanning drempel",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime.desc": "Beschrijving VRT herstel stabilisatietijd",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime.desc": "Beschrijving momentane overspanningsduur",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage.desc": "Beschrijving momentane overspanningsdrempel",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1.desc": "Beschrijving spanning bovengrens 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time.desc": "Beschrijving spanning bovengrens 1 duur",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2.desc": "Beschrijving spanning bovengrens 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time.desc": "Beschrijving spanning bovengrens 2 duur",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3.desc": "Beschrijving spanning bovengrens 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time.desc": "Beschrijving spanning bovengrens 3 duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1.desc": "Beschrijving spanning ondergrens 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time.desc": "Beschrijving spanning ondergrens 1 duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2.desc": "Beschrijving spanning ondergrens 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time.desc": "Beschrijving spanning ondergrens 2 duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3.desc": "Beschrijving spanning ondergrens 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time.desc": "Beschrijving spanning ondergrens 3 duur",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.desc": "Beschrijving VW accu modus verschil inschakelen",
  "50901.ctrl_Safety.VW.vwEnable.desc": "Beschrijving VW inschakelen",
  "50901.ctrl_Safety.VW.vwFuncCode.desc": "Beschrijving VW-functiecode",
  "50901.ctrl_Safety.VW.vwOverEndVolt.desc": "Beschrijving VW overspanning eindspanning",
  "50901.ctrl_Safety.VW.vwOverKPVolt.desc": "Beschrijving VW overspanning KP-spanning / coëfficiëntspanning",
  "50901.ctrl_Safety.VW.vwOverStartVolt.desc": "Beschrijving VW overspanning startspanning",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage.desc": "Beschrijving VW herstelspanning ondergrens",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime.desc": "Beschrijving VW herstel stabilisatietijd",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage.desc": "Beschrijving VW herstelspanning bovengrens",
  "50901.ctrl_Safety.VW.vwTr.desc": "Beschrijving VW_Tr tijd",
  "50901.ctrl_Safety.VW.vwUnderEndVolt.desc": "Beschrijving VW onderspanning eindspanning",
  "50901.ctrl_Safety.VW.vwUnderKPVolt.desc": "Beschrijving VW onderspanning KP-spanning / coëfficiëntspanning",
  "50901.ctrl_Safety.VW.vwUnderStartVolt.desc": "Beschrijving VW onderspanning startspanning",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio.desc": "Beschrijving GCF export harde limiet verhouding",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio.desc": "Beschrijving GCF export zachte limiet verhouding",
  "50901.real_time.BatteryModel.desc": "Beschrijving accumodel",
  "50901.real_time.cfgMultPcsBmsFlag.desc": "Beschrijving BMS-vlag",
  "50901.real_time.inverterSn.desc": "Beschrijving omvormer SN",
  "50901..brightness.desc": "Beschrijving displayhelderheid",
  "50901.ctrl_Config.Device.networkingType.1": "Wifi",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Beschrijving Generatoraansluiting Modus",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Beschrijving Generatorlocatie",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Beschrijving Generator Uitschakelvertraging",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Beschrijving Generator Synchronisatietijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Beschrijving Generatortype",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Beschrijving Maximale Looptijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Beschrijving Minimale Looptijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Beschrijving Bedrijfsbeveiligingsinterval",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Beschrijving Net Ct Reverse Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Beschrijving Net Ct Windingverhouding Instelling",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Beschrijving Metermodel",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Beschrijving Pv Ct Reverse Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Beschrijving Pv Ct Windingverhouding Instelling",
  "50901.fault.arcFault.00": "Uitschakelen",
  "50901.fault.arcFault.01": "Inschakelen",
  "50901.fault.arcSelfTestFault.00": "Uitschakelen",
  "50901.fault.arcSelfTestFault.01": "Inschakelen",
  "50901.fault.armCommunicationFault.00": "Uitschakelen",
  "50901.fault.armCommunicationFault.01": "Inschakelen",
  "50901.fault.auxiliaryPowerAbnormality.00": "Uitschakelen",
  "50901.fault.auxiliaryPowerAbnormality.01": "Inschakelen",
  "50901.Fault.batteryCapacityAbnormality.00": "Uitschakelen",
  "50901.Fault.batteryCapacityAbnormality.01": "Inschakelen",
  "50901.Fault.batteryFault.00": "Uitschakelen",
  "50901.Fault.batteryFault.01": "Inschakelen",
  "50901.Fault.batteryForceChargeRequest.00": "Uitschakelen",
  "50901.Fault.batteryForceChargeRequest.01": "Inschakelen",
  "50901.Fault.bmsCanCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.bmsCanCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.busbarAbnormality.00": "Uitschakelen",
  "50901.fault.busbarAbnormality.01": "Inschakelen",
  "50901.fault.cmpssBiasCalculationError.00": "Uitschakelen",
  "50901.fault.cmpssBiasCalculationError.01": "Inschakelen",
  "50901.fault.comparatorFault.00": "Uitschakelen",
  "50901.fault.comparatorFault.01": "Inschakelen",
  "50901.fault.driveAbnormality.00": "Uitschakelen",
  "50901.fault.driveAbnormality.01": "Inschakelen",
  "50901.Fault.dspPwrCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dspPwrCommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dspSafCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dspSafCommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtsCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtsCommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.e2rpomFault.00": "Uitschakelen",
  "50901.fault.e2rpomFault.01": "Inschakelen",
  "50901.fault.emergencyStopSwitchStatus.00": "Uitschakelen",
  "50901.fault.emergencyStopSwitchStatus.01": "Inschakelen",
  "50901.fault.epsOverload.00": "Uitschakelen",
  "50901.fault.epsOverload.01": "Inschakelen",
  "50901.fault.epsRelayProtection.00": "Uitschakelen",
  "50901.fault.epsRelayProtection.01": "Inschakelen",
  "50901.fault.epsVoltageAbnormality.00": "Uitschakelen",
  "50901.fault.epsVoltageAbnormality.01": "Inschakelen",
  "50901.Fault.evCharger1CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.evCharger1CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.evCharger1Fault.00": "Uitschakelen",
  "50901.Fault.evCharger1Fault.01": "Inschakelen",
  "50901.Fault.evCharger2CommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.evCharger2CommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.evCharger2Fault.00": "Uitschakelen",
  "50901.Fault.evCharger2Fault.01": "Inschakelen",
  "50901.fault.fanFault.00": "Uitschakelen",
  "50901.fault.fanFault.01": "Inschakelen",
  "50901.Fault.fanSpeedAbnormality.00": "Uitschakelen",
  "50901.Fault.fanSpeedAbnormality.01": "Inschakelen",
  "50901.fault.fiveVoltPowerSupplyFault.00": "Uitschakelen",
  "50901.fault.fiveVoltPowerSupplyFault.01": "Inschakelen",
  "50901.fault.flashCommunicationFault.00": "Uitschakelen",
  "50901.fault.flashCommunicationFault.01": "Inschakelen",
  "50901.fault.frequencyVariationRateOutOfRange.00": "Uitschakelen",
  "50901.fault.frequencyVariationRateOutOfRange.01": "Inschakelen",
  "50901.fault.genAbnormality.00": "Uitschakelen",
  "50901.fault.genAbnormality.01": "Inschakelen",
  "50901.fault.genOverload.00": "Uitschakelen",
  "50901.fault.genOverload.01": "Inschakelen",
  "50901.fault.genPortOvercurrent.00": "Uitschakelen",
  "50901.fault.genPortOvercurrent.01": "Inschakelen",
  "50901.fault.genRelayAFault.00": "Uitschakelen",
  "50901.fault.genRelayAFault.01": "Inschakelen",
  "50901.fault.genRelayBFault.00": "Uitschakelen",
  "50901.fault.genRelayBFault.01": "Inschakelen",
  "50901.fault.gridCurrentDcOffsetOutOfRange.00": "Uitschakelen",
  "50901.fault.gridCurrentDcOffsetOutOfRange.01": "Inschakelen",
  "50901.fault.gridMeter.00": "Uitschakelen",
  "50901.fault.gridMeter.01": "Inschakelen",
  "50901.Fault.gridMeterCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.gridMeterCommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.gridMeterTypeError.00": "Uitschakelen",
  "50901.Fault.gridMeterTypeError.01": "Inschakelen",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.00": "Uitschakelen",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.01": "Inschakelen",
  "50901.fault.gridOverfrequency.00": "Uitschakelen",
  "50901.fault.gridOverfrequency.01": "Inschakelen",
  "50901.fault.gridOvervoltage.00": "Uitschakelen",
  "50901.fault.gridOvervoltage.01": "Inschakelen",
  "50901.fault.gridPortOvercurrent.00": "Uitschakelen",
  "50901.fault.gridPortOvercurrent.01": "Inschakelen",
  "50901.fault.gridPowerOutage.00": "Uitschakelen",
  "50901.fault.gridPowerOutage.01": "Inschakelen",
  "50901.fault.gridRelayProtection.00": "Uitschakelen",
  "50901.fault.gridRelayProtection.01": "Inschakelen",
  "50901.fault.gridUnderfrequency.00": "Uitschakelen",
  "50901.fault.gridUnderfrequency.01": "Inschakelen",
  "50901.fault.gridUndervoltage.00": "Uitschakelen",
  "50901.fault.gridUndervoltage.01": "Inschakelen",
  "50901.fault.gridVoltageAbnormality.00": "Uitschakelen",
  "50901.fault.gridVoltageAbnormality.01": "Inschakelen",
  "50901.Fault.hmidCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.hmidCommunicationAbnormality.01": "Inschakelen",
  "50901.Fault.hmidMachineFault.00": "Uitschakelen",
  "50901.Fault.hmidMachineFault.01": "Inschakelen",
  "50901.fault.insulationFault.00": "Uitschakelen",
  "50901.fault.insulationFault.01": "Inschakelen",
  "50901.fault.interruptOverflow.00": "Uitschakelen",
  "50901.fault.interruptOverflow.01": "Inschakelen",
  "50901.fault.inverterCanCommunicationFailed.00": "Uitschakelen",
  "50901.fault.inverterCanCommunicationFailed.01": "Inschakelen",
  "50901.fault.inverterCommunicationFailed.00": "Uitschakelen",
  "50901.fault.inverterCommunicationFailed.01": "Inschakelen",
  "50901.fault.kmRelayFault.00": "Uitschakelen",
  "50901.fault.kmRelayFault.01": "Inschakelen",
  "50901.fault.lineToEarthFault.00": "Uitschakelen",
  "50901.fault.lineToEarthFault.01": "Inschakelen",
  "50901.fault.loadRelayAFault.00": "Uitschakelen",
  "50901.fault.loadRelayAFault.01": "Inschakelen",
  "50901.fault.loadRelayBFault.00": "Uitschakelen",
  "50901.fault.loadRelayBFault.01": "Inschakelen",
  "50901.fault.lowAmbientTemperature.00": "Uitschakelen",
  "50901.fault.lowAmbientTemperature.01": "Inschakelen",
  "50901.Fault.lowDtuVersion.00": "Uitschakelen",
  "50901.Fault.lowDtuVersion.01": "Inschakelen",
  "50901.fault.machineTypeMismatch.00": "Uitschakelen",
  "50901.fault.machineTypeMismatch.01": "Inschakelen",
  "50901.Fault.masterSlaveCommunicationAbnormality.00": "Uitschakelen",
  "50901.Fault.masterSlaveCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.meterWiringAbnormality.00": "Uitschakelen",
  "50901.fault.meterWiringAbnormality.01": "Inschakelen",
  "50901.fault.microelectronicFault.00": "Uitschakelen",
  "50901.fault.microelectronicFault.01": "Inschakelen",
  "50901.fault.neutralWireNotConnected.00": "Uitschakelen",
  "50901.fault.neutralWireNotConnected.01": "Inschakelen",
  "50901.real_time.relayStatus.02": "Generator A Voeding",
  "50901.real_time.relayStatus.03": "Generator A Voeding",
  "50901.real_time.relayStatus.04": "Generator B Voeding",
  "50901.real_time.relayStatus.05": "Generator B Voeding",
  "50901.real_time.relayStatus.06": "Generator Ab Voeding",
  "50901.real_time.relayStatus.07": "Generator Ab Voeding",
  "50901.real_time.relayStatus.08": "Kritieke Last A Voeding",
  "50901.real_time.relayStatus.09": "Kritieke Last A Voeding",
  "50901.real_time.relayStatus.10": "Kritieke Last B Voeding",
  "50901.real_time.relayStatus.14": "Gereserveerd",
  "50901.real_time.relayStatus.15": "Gereserveerd",
  "50901.warning.batteryHighVoltageAlarm.00": "Uitschakelen",
  "50901.warning.batteryHighVoltageAlarm.01": "Inschakelen",
  "50901.warning.batteryLowVoltageAlarm.00": "Uitschakelen",
  "50901.warning.batteryLowVoltageAlarm.01": "Inschakelen",
  "50901.warning.batteryPackChargeHighVoltageAlarm.00": "Uitschakelen",
  "50901.warning.batteryPackChargeHighVoltageAlarm.01": "Inschakelen",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.00": "Uitschakelen",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.01": "Inschakelen",
  "50901.warning.canCommunicationTimeout.00": "Uitschakelen",
  "50901.warning.canCommunicationTimeout.01": "Inschakelen",
  "50901.warning.chargeHighTemperatureAlarm.00": "Uitschakelen",
  "50901.warning.chargeHighTemperatureAlarm.01": "Inschakelen",
  "50901.warning.chargeLowTemperatureAlarm.00": "Uitschakelen",
  "50901.warning.chargeLowTemperatureAlarm.01": "Inschakelen",
  "50901.warning.dischargeHighTemperatureAlarm.00": "Uitschakelen",
  "50901.warning.dischargeHighTemperatureAlarm.01": "Inschakelen",
  "50901.warning.dischargeLowTemperatureAlarm.00": "Uitschakelen",
  "50901.warning.dischargeLowTemperatureAlarm.01": "Inschakelen",
  "50901.warning.hardwareProtection.00": "Uitschakelen",
  "50901.warning.hardwareProtection.01": "Inschakelen",
  "50901.warning.inputOvervoltageAlarm.00": "Uitschakelen",
  "50901.warning.inputOvervoltageAlarm.01": "Inschakelen",
  "50901.warning.lowBatteryEnergy.00": "Uitschakelen",
  "50901.warning.lowBatteryEnergy.01": "Inschakelen",
  "50901..connectionRouterStatus.0": "Niet Verbonden",
  "50901..connectionRouterStatus.1": "Verbonden",
  "50901..connectionRouterStatus.3": "Niet Verbonden",
  "50901..connectionServerStatus.0": "Niet Verbonden",
  "50901..connectionServerStatus.1": "Verbonden",
  "50901..connectionServerStatus.2": "Verbonden",
  "50901..connectionServerStatus.3": "Niet Verbonden",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "Nee",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Ja",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Uitschakelen",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Inschakelen",
  "50901.ctrl_Config.Device.arcFaultClear.0": "Nee",
  "50901.ctrl_Config.Device.arcFaultClear.1": "Ja",
  "50901.ctrl_Config.Device.batActivate.0": "Nee",
  "50901.ctrl_Config.Device.batActivate.1": "Ja",
  "50901.ctrl_Config.Device.batteryBalancing.0": "Nee",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Ja",
  "50901.ctrl_Config.Device.clearFault.0": "Nee",
  "50901.ctrl_Config.Device.clearFault.1": "Ja",
  "50901.ctrl_Config.Device.masterSlave.0": "Enkel Apparaat / Single Unit",
  "50901.ctrl_Config.Device.masterSlave.1": "Master",
  "50901.ctrl_Config.Device.masterSlave.2": "Slave",
  "50901.ctrl_Config.Device.parallelNetworking.0": "Ongeldig",
  "50901.ctrl_Config.Device.parallelNetworking.1": "Netwerken / Netwerkvorming",
  "50901.ctrl_Config.Device.parallelNetworking.2": "Netwerk ontbinden",
  "50901.ctrl_Config.Device.restartSystem.0": "Nee",
  "50901.ctrl_Config.Device.restartSystem.1": "Ja",
  "50901.ctrl_Config.Device.restoreDefault.0": "Nee",
  "50901.ctrl_Config.Device.restoreDefault.1": "Ja",
  "50901.ctrl_Config.Device.selfTest.0": "Nee",
  "50901.ctrl_Config.Device.selfTest.1": "Ja",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "Systeem Stoppen",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "Systeem Starten",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Uit",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Handmatig",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Automatisch",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "Geen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Wekelijks",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Om De 2 Weken",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Om De 3 Weken",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Om De 4 Weken",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "Nee",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Ja",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Handmatig",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Tijdmodus",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Slimme Last",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Off-Grid Slimme Last",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Ev-Lader",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "Nee",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Ja",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "Geen / None",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Aardfout",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Lastregeling",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Generator",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "Nee",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Ja",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Uitgeschakeld",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Noodstroomvoorziening (Eps)",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Onderbrekingsvrije Voeding (Ups)",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "Nee",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Ja",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.0": "Maandag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.1": "Dinsdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.2": "Woensdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.3": "Donderdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.4": "Vrijdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.5": "Zaterdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.6": "Zondag",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.01": "Beschrijving enum-waarde 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.01": "Beschrijving enum-waarde 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.01": "Beschrijving enum-waarde 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.01": "Beschrijving enum-waarde 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.01": "Beschrijving enum-waarde 2",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.00": "Beschrijving enum-waarde 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.01": "Beschrijving enum-waarde 1",
  "50901.real_time.batteryConnectionStatus.00": "Nee",
  "50901.real_time.batteryConnectionStatus.01": "Ja",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.00": "Geen accu",
  "50901.real_time.batteryType_04.01": "Lithium-accu",
  "50901.real_time.batteryType_04.02": "Loodzuur-accu",
  "50901.real_time.batteryWorkingStatus.00": "Stand-By",
  "50901.real_time.batteryWorkingStatus.01": "Laden",
  "50901.real_time.batteryWorkingStatus.02": "Ontladen",
  "50901.real_time.cfgMultPcsBmsFlag.00": "Nee",
  "50901.real_time.cfgMultPcsBmsFlag.01": "Ja",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Vermogenslimiet Opgeheven, Standaardmodus",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Omvormervermogen 0, Eilandbedrijf",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Laadvermogen Pc=0, Niet Eilandbedrijf",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Laadvermogen Pc<50%Pn Nominaal Vermogen",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Laadvermogen Pc<75%Pn Nominaal Vermogen && Reactief Vermogen Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Laadvermogen Pc, Geen Limiet",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Ontlaadvermogen P=0, Niet Eilandbedrijf",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Ontlaadvermogen P<50%Pn Nominaal Vermogen",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Ontlaadvermogen P<75%Pn Nominaal Vermogen && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Ontlaadvermogen P, Geen Limiet",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Laadvermogen Pc<50%Pn Nominaal Vermogen --> Laadvermogen Verlaagd Naar 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Laadvermogen Pc<50%Pn Nominaal Vermogen && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Ontlaadvermogen P<50%Pn Nominaal Vermogen --> Ontlaadvermogen Verlaagd Naar 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Laadvermogen Pc<50%Pn Nominaal Vermogen && Q=-Qmax",
  "50901.real_time.materType.0": "Geen netmeter",
  "50901.real_time.materType.1": "CHINT Enkelfasig",
  "50901.real_time.materType.2": "CHINT Enkelfasig",
  "50901.real_time.materType.3": "CHINT Tweedelig / Split-phase",
  "50901.real_time.materType.5": "Meetmodule",
  "50901.real_time.materType.6": "Acrel Enkel circuit",
  "50901.real_time.materType.7": "Acrel Dubbel circuit",
  "50901.real_time.meterFlag.0": "Offline",
  "50901.real_time.meterFlag.1": "Online",
  "50901.real_time.meterFlag.3": "Gateway-Communicatie Normaal",
  "50901.real_time.meterFlag.4": "Gateway-Communicatie Verbroken",
  "50901.real_time.relayStatus.00": "Km1 Voeding",
  "50901.real_time.relayStatus.01": "Km1 Voeding",
  "50901.real_time.relayStatus.11": "Kritieke Last B Voeding",
  "50901.real_time.relayStatus.12": "Gereserveerd",
  "50901.real_time.relayStatus.13": "Gereserveerd",
  "50901.real_time.workStatus.00": "Voedingsinitialisatie",
  "50901.real_time.workStatus.01": "Stand-By-Modus",
  "50901.real_time.workStatus.02": "Netkoppelingstest",
  "50901.real_time.workStatus.03": "Netgekoppelde Modus",
  "50901.real_time.workStatus.04": "Foutmodus",
  "50901.real_time.workStatus.05": "Off-Grid Modus / Eilandmodus",
  "50901.real_time.workStatus.06": "Bypass-Modus",
  "50901..antiIslandingEnable.0": "Uitschakelen",
  "50901..antiIslandingEnable.1": "Inschakelen",
  "50901..apcEn.0": "Uitschakelen",
  "50901..apcEn.1": "Inschakelen",
  "50901..drmEnable.0": "Uitschakelen",
  "50901..drmEnable.1": "Inschakelen",
  "50901..permitEnable.0": "Uitschakelen",
  "50901..permitEnable.1": "Inschakelen",
  "50901..phaseOrderInverseDisable.00": "Uitschakelen",
  "50901..phaseOrderInverseDisable.01": "Inschakelen",
  "50901..relayU16NlineRlyTestDis.00": "Uitschakelen",
  "50901..relayU16NlineRlyTestDis.01": "Inschakelen",
  "50901.ctrl_Config.Device.checkTime": "Apparaattijd",
  "50901.ctrl_Config.Device.networkingType": "Net Aansluiting Type",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549 (Standaard)",
  "50901.ctrl_Config.Grid Profile.country.18": "USHECO_Rule14 (Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208 (Vs)",
  "50901.ctrl_Config.Grid Profile.country.29": "LX_US_50HZ (VS-test)",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220 (Vs)",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V (Vs)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V (Vs)",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547 (Vs)",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Nominale Stroom Ev-Lader",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Nominale Stroom Hoofdschakelaar",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Timermodus - Accu Soc Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Timermodus - Accu Start Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Timermodus - Accu Stop Soc",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Verboden",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "Externe Pv",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "Externe Generator",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Forceer Start",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Lokale Bediening",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "Geen",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Generatorzijde",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Netzijde",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Handmatig",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "Geen Meter Gebruikt",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Enkelfasige Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Tweefasige Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Driefasige Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Slimme Meter (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Stroomtransformator (Ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Acrel Enkelfasige Meter",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Acrel Tweefasige Meter",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Inschakelen",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Uitschakelen",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Inschakelen",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Uitschakelen",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Inschakelen",
  "50901.ctrl_Safety.FW.fwEnable.0": "Uitschakelen",
  "50901.ctrl_Safety.FW.fwEnable.1": "Inschakelen",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Uitschakelen",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Inschakelen",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Uitschakelen",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Inschakelen",
  "50901.ctrl_Safety.RPC.rpcMode.00": "Uitschakelen",
  "50901.ctrl_Safety.RPC.rpcMode.01": "Vaste arbeidsfactor, PF-modus",
  "50901.ctrl_Safety.RPC.rpcMode.02": "Vast reactief vermogen, Q-modus",
  "50901.ctrl_Safety.RPC.rpcMode.03": "PF(P)-curve, PF(P)-modus",
  "50901.ctrl_Safety.RPC.rpcMode.04": "W",
  "50901.ctrl_Safety.RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Uitschakelen",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Inschakelen",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Uitschakelen",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Inschakelen",
  "50901.ctrl_Safety.VW.vwEnable.0": "Uitschakelen",
  "50901.ctrl_Safety.VW.vwEnable.1": "Inschakelen",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Tou-Modus Gereserveerde Soc",
  "50901.fault.arcFault": "Vlamboogfout",
  "50901.fault.arcSelfTestFault": "Vlamboog zelftestfout",
  "50901.fault.armCommunicationFault": "ARM-communicatiefout",
  "50901.fault.auxiliaryPowerAbnormality": "Hulpvoeding abnormaal",
  "50901.Fault.batteryCapacityAbnormality": "Accucapaciteit Abnormaal",
  "50901.Fault.batteryFault": "Accufout",
  "50901.Fault.batteryForceChargeRequest": "Accu Forceer Laadaanvraag",
  "50901.Fault.bmsCanCommunicationAbnormality": "Bms Can-Communicatie Abnormaal",
  "50901.fault.busbarAbnormality": "DC-tussenkring abnormaal",
  "50901.fault.cmpssBiasCalculationError": "CMPSS-offset berekeningsfout",
  "50901.fault.comparatorFault": "Comparatorfout",
  "50901.fault.driveAbnormality": "Aansturing abnormaal",
  "50901.Fault.dspPwrCommunicationAbnormality": "Dsp-Voeding Communicatie Abnormaal",
  "50901.Fault.dspSafCommunicationAbnormality": "Dsp-Beveiligde Communicatie Abnormaal",
  "50901.Fault.dtsCommunicationAbnormality": "Dts-Communicatie Abnormaal",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485-Communicatie Abnormaal",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485-Communicatie Abnormaal",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485-Communicatie Abnormaal",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485-Communicatie Abnormaal",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485-Communicatie Abnormaal",
  "50901.fault.e2rpomFault": "EEPROM-fout",
  "50901.fault.emergencyStopSwitchStatus": "Noodstop",
  "50901.fault.epsOverload": "EPS-overbelasting",
  "50901.fault.epsRelayProtection": "EPS-relais beveiliging",
  "50901.fault.epsVoltageAbnormality": "EPS-spanning abnormaal",
  "50901.Fault.evCharger1CommunicationAbnormality": "Ev-Lader 1 Communicatie Abnormaal",
  "50901.Fault.evCharger1Fault": "Fout Lader 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "Ev-Lader 2 Communicatie Abnormaal",
  "50901.Fault.evCharger2Fault": "Fout Lader 2",
  "50901.fault.fanFault": "Ventilatordefect",
  "50901.Fault.fanSpeedAbnormality": "Ventilatorsnelheid Abnormaal",
  "50901.fault.fiveVoltPowerSupplyFault": "Fout 5V-Voeding",
  "50901.fault.flashCommunicationFault": "Flash geheugen communicatiefout",
  "50901.fault.frequencyVariationRateOutOfRange": "Frequentie veranderingssnelheid overschreden",
  "50901.fault.genAbnormality": "Generator abnormaal",
  "50901.fault.genOverload": "Generator overbelasting",
  "50901.fault.genPortOvercurrent": "Generatoraansluiting Overstroom",
  "50901.fault.genRelayAFault": "Generator A Relaisfout",
  "50901.fault.genRelayBFault": "Generator B Relaisfout",
  "50901.fault.gridCurrentDcOffsetOutOfRange": "Netstroom DC-offset overschreden",
  "50901.fault.gridMeter": "Netmeter Communicatiefout",
  "50901.Fault.gridMeterCommunicationAbnormality": "Netmeter Communicatie Abnormaal",
  "50901.Fault.gridMeterTypeError": "Netmeter Typefout",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange": "Eilandspanning DC-offset overschreden",
  "50901.fault.gridOverfrequency": "Net overfrequentie",
  "50901.fault.gridOvervoltage": "Net overspanning",
  "50901.fault.gridPortOvercurrent": "Netaansluiting Overstroom",
  "50901.fault.gridPowerOutage": "Netstoring / netuitval",
  "50901.fault.gridRelayProtection": "Netrelais beveiliging",
  "50901.fault.gridUnderfrequency": "Net onderfrequentie",
  "50901.fault.gridUndervoltage": "Net onderspanning",
  "50901.fault.gridVoltageAbnormality": "Netspanning abnormaal",
  "50901.Fault.hmidCommunicationAbnormality": "Hmi-Communicatie Abnormaal",
  "50901.Fault.hmidMachineFault": "Hmi-Apparaatfout",
  "50901.fault.insulationFault": "Isolatiefout",
  "50901.fault.interruptOverflow": "Interrupt overflow",
  "50901.fault.inverterCanCommunicationFailed": "Omvormer Can-Communicatiefout",
  "50901.fault.inverterCommunicationFailed": "Omvormer Communicatiefout",
  "50901.fault.kmRelayFault": "Km-Relaisfout",
  "50901.fault.lineToEarthFault": "Aardfout (fase-aarde)",
  "50901.fault.loadRelayAFault": "Last A Relaisfout",
  "50901.fault.loadRelayBFault": "Last B Relaisfout",
  "50901.fault.lowAmbientTemperature": "Omgevingstemperatuur te laag",
  "50901.Fault.lowDtuVersion": "Dtu-Versie Te Laag",
  "50901.fault.machineTypeMismatch": "Model komt niet overeen",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Master-Slave Communicatie Abnormaal",
  "50901.fault.meterWiringAbnormality": "Meterbedrading abnormaal",
  "50901.fault.microelectronicFault": "Micro-elektronicafout",
  "50901.fault.neutralWireNotConnected": "Nulleider niet aangesloten",
  "50901.fault.neutralWireToEarthFault": "Nulleider-aarde fout",
  "50901.fault.overTemperature": "Overtemperatuur",
  "50901.fault.overtemperatureAlarm": "Oververhittingsalarm",
  "50901.fault.pllLockFailed": "PLL-vergrendelingsfout",
  "50901.fault.preSynchronizationFailed": "Fout tijdens voorsynchronisatie",
  "50901.fault.pvFault": "PV-fout",
  "50901.Fault.pvMeterCommunicationAbnormality": "Pv-Meter Communicatie Abnormaal",
  "50901.Fault.pvMeterTypeError": "Pv-Meter Typefout",
  "50901.fault.pvPortOvercurrent": "Pv-Aansluiting Overstroom",
  "50901.fault.pvRelayAbFault": "Pv-Ab Relaisfout",
  "50901.fault.pvVoltageExceedingBusVoltage": "PV-spanning overschrijdt tussenkringspanning",
  "50901.fault.rcdFault": "RCD-fout / Aardlekschakelaarfout",
  "50901.fault.rcdSelfTestFault": "RCD-zelftestfout",
  "50901.fault.reconnectionFailed": "Her-aansluitingsfout",
  "50901.fault.samplingBiasAbnormality": "Afwijking sampling-offset",
  "50901.fault.shutDown": "Systeemuitschakeling",
  "50901.Fault.slaveWrongBatteryConnection": "Slave Accu Aansluitfout",
  "50901.fault.smartloadPortOvercurrent": "Smart Load Aansluiting Overstroom",
  "50901.fault.spiCommunicationFault": "SPI-communicatiefout",
  "50901.Fault.sustainedNegativeLoad": "Aanhoudende Negatieve Last",
  "50901.fault.temperatureAbnormality": "Temperatuur abnormaal",
  "50901.fault.tenMinuteOvervoltage": "10-minuten overspanning",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "Fout 3.3V-Voeding",
  "50901.fault.twelveVoltPowerSupplyFault": "Fout 12V-Voeding",
  "50901.fault.versionMismatch": "Versie conflict / versie niet passend",
  "50901.fault.wiringAbnormality": "Bedrading abnormaal",
  "50901.otaHttpUrl.otaHttpUrl": "Upgrade-opdracht",
  "50901.real_time.12vAuxiliaryVoltageSampling": "12V Hulpspanning Sampling",
  "50901.real_time.12vOutputVoltageSampling": "12V Uitgangsspanning Sampling",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "3.3V Hulpspanning Sampling",
  "50901.real_time.5vAuxiliaryVoltageSampling": "5V Hulpspanning Sampling",
  "50901.real_time.ambientTemperatureSampling": "Omgevingstemperatuur Sampling",
  "50901.real_time.appSoftwareVersion": "App-Softwareversie",
  "50901.real_time.batteryDailyChargeEnergy": "Accu Dagelijkse Laadcapaciteit",
  "50901.real_time.batteryDailyDischargeEnergy": "Accu Dagelijkse Ontlaadcapaciteit",
  "50901.real_time.batteryModuleNum": "Accu celaantal (cellen in serie per module)",
  "50901.real_time.batteryPowerWholeSystem": "Accu totaal vermogen (gehele systeem)",
  "50901.real_time.batteryToLoadPower": "Accu-naar-last vermogen",
  "50901.real_time.bootSoftwareVersion": "Bootloader-Softwareversie",
  "50901.real_time.communicationStickHardwareVersion": "Communicatiestick Hardwareversie",
  "50901.real_time.communicationStickSn": "Communicatiestick Sn",
  "50901.real_time.communicationStickSoftwareVersion": "Communicatiestick softwareversie",
  "50901.real_time.copy_dspVersionMainUVersion": "Dsp-Versie (Hoofd U-Versie)",
  "50901.real_time.dailyBatteryToLoadEnergy": "Vandaag accu-naar-last energie",
  "50901.real_time.dailyExportEnergyToGrid": "Vandaag verkochte energie",
  "50901.real_time.dailyGridToLoadEnergy": "Vandaag net-naar-last energie",
  "50901.real_time.dailyImportEnergyFromGrid": "Vandaag ingekochte energie",
  "50901.real_time.dailyPvToBatteryEnegry": "Vandaag PV-naar-accu energie",
  "50901.real_time.dailyPvToGridEnegry": "Vandaag PV-naar-net energie",
  "50901.real_time.dailyPvToLoadEnegry": "Vandaag PV-naar-last energie",
  "50901.real_time.dTSReset": "Data Stick Reset",
  "50901.real_time.firmwareBuildTimeDateHour": "Firmware Bouwtijd (Dag/Uur)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Firmware Bouwtijd (Jaar & Maand)",
  "50901.real_time.firmwareCrc": "Firmware Crc",
  "50901.real_time.firmwareEndAddressHigh": "Firmware Eindadres (Hoog)",
  "50901.real_time.firmwareEndAddressLow": "Firmware Eindadres (Laag)",
  "50901.real_time.firmwareInformationCrc": "Firmware Info Crc",
  "50901.real_time.firmwareStartAddressHigh": "Firmware Startadres (Hoog)",
  "50901.real_time.firmwareStartAddressLow": "Firmware Startadres (Laag)",
  "50901.real_time.generatorDailyYield": "Generator dagelijkse opbrengst",
  "50901.real_time.generatorPower": "Generatorvermogen",
  "50901.real_time.generatorPowerA": "Generator fase A vermogen",
  "50901.real_time.generatorPowerB": "Generator fase B vermogen",
  "50901.real_time.generatorPowerC": "Generator fase C vermogen",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Netzijde Koellichaam Temperatuur",
  "50901.real_time.gridMeterSerialNumber": "Netzijde Meter Serienummer",
  "50901.real_time.gridPowerWholeSystem": "Net totaal vermogen (gehele systeem)",
  "50901.real_time.hoymilesSerialNumber": "Hoymiles Serienummer",
  "50901.real_time.inverterHardwareVersion": "Omvormer Hardwareversie",
  "50901.real_time.inverterModelNumber": "Omvormer Modelnummer",
  "50901.real_time.loadEnergy": "Last dagelijks energieverbruik",
  "50901.real_time.loadPowerWholeSystem": "Last totaal vermogen (gehele systeem)",
  "50901.real_time.macAddr": "Mac-Adres",
  "50901.real_time.materType": "Metertype",
  "50901.real_time.maxCellSoc": "Maximale cel-SOC",
  "50901.real_time.maxCellSocCellId": "Maximale cel-SOC overeenkomstige index",
  "50901.real_time.maxCellTemperature": "Maximale Celtemperatuur",
  "50901.real_time.maxCellTemperatureCellId": "Maximale celtemperatuur overeenkomstige index",
  "50901.real_time.maxCellVoltage": "Maximale Celspanning",
  "50901.real_time.maxCellVoltageCellId": "Maximale celspanning overeenkomstige index",
  "50901.real_time.minCellSoc": "Minimale cel-SOC",
  "50901.real_time.minCellSocCellId": "Minimale cel-SOC overeenkomstige index",
  "50901.real_time.minCellTemperature": "Minimale Celtemperatuur",
  "50901.real_time.minCellTemperatureCellId": "Minimale celtemperatuur overeenkomstige index",
  "50901.real_time.minCellVoltage": "Minimale Celspanning",
  "50901.real_time.minCellVoltageCellId": "Minimale celspanning overeenkomstige index",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack": "Accupakket laad-/ontlaadcyclus aantal",
  "50901.real_time.oemModelName": "Oem Modelnaam",
  "50901.real_time.oemSerialNumber": "Oem Serienummer",
  "50901.real_time.packCurrent": "Accupakket stroom",
  "50901.real_time.packPower": "Accupakket vermogen",
  "50901.real_time.packSoc": "Accupakket SOC",
  "50901.real_time.packSoh": "Accupakket SOH",
  "50901.real_time.packVoltage": "Accupakket spanning",
  "50901.real_time.pv1RealTimePower": "PV1 realtime vermogen",
  "50901.real_time.pv2RealTimePower": "PV2 realtime vermogen",
  "50901.real_time.pv3RealTimePower": "PV3 realtime vermogen",
  "50901.real_time.pv4RealTimePower": "PV4 realtime vermogen",
  "50901.real_time.pvMeterSerialNumber": "Pv-Meter Serienummer",
  "50901.real_time.pvPower": "Pv-Vermogen",
  "50901.real_time.pvPowerWholeSystem": "PV totaal vermogen (gehele systeem)",
  "50901.real_time.pvToBatteryPower": "PV-naar-accu vermogen",
  "50901.real_time.pvToGridPower": "PV-naar-net vermogen",
  "50901.real_time.pvToLoadPower": "PV-naar-last vermogen",
  "50901.real_time.relayStatus": "Relaisstatus",
  "50901.real_time.relaySupplyVoltageSampling": "Relais Voedingsspanning Sampling",
  "50901.real_time.rssi": "Signaalsterkte",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryHighVoltageAlarm": "Accu Overspanningsalarm",
  "50901.warning.batteryLowVoltageAlarm": "Accu Onderspanning",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Accupakket Laad-Overspanningsalarm",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Accupakket Ontlaad-Onderspanningsalarm",
  "50901.warning.canCommunicationTimeout": "CAN-communicatie time-out",
  "50901.warning.chargeHighTemperatureAlarm": "Laad Hoge Temperatuur Alarm",
  "50901.warning.chargeLowTemperatureAlarm": "Laad Lage Temperatuur Alarm",
  "50901.warning.dischargeHighTemperatureAlarm": "Ontlaad Hoge Temperatuur Alarm",
  "50901.warning.dischargeLowTemperatureAlarm": "Ontlaad Lage Temperatuur Alarm",
  "50901.warning.hardwareProtection": "Hardwarebeveiliging",
  "50901.warning.inputOvervoltageAlarm": "Ingang Overspanningsalarm",
  "50901.warning.lowBatteryEnergy": "Accucapaciteit te laag",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Klok Instellen",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Klok Instellen - Dag",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Klok Instellen - Uur",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Klok Instellen - Minuut",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Klok Instellen - Maand",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Klok Instellen - Seconde",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Klok Instellen - Weekdag",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Klok Instellen - Jaar",
  "50901.ctrl_Config.Device.masterSlave": "Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Omgevingstemperatuur Drempel",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Pcb Omgevingstemperatuur Drempel",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Gateway Communicatieadres",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Gebruiksperiode 1 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Gebruiksperiode 1 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Gebruiksperiode 1 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Gebruiksperiode 1 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Gebruiksperiode 1 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Gebruiksperiode 1 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Gebruiksperiode 2 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Gebruiksperiode 2 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Gebruiksperiode 2 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Gebruiksperiode 2 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Gebruiksperiode 2 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Gebruiksperiode 2 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Gebruiksperiode 3 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Gebruiksperiode 3 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Gebruiksperiode 3 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Gebruiksperiode 3 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Gebruiksperiode 3 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Gebruiksperiode 3 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Gebruiksperiode 4 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Gebruiksperiode 4 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Gebruiksperiode 4 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Gebruiksperiode 4 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Gebruiksperiode 4 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Gebruiksperiode 4 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Ontlaad Afschakelvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Gebruiksperiode 5 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Gebruiksperiode 5 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Gebruiksperiode 5 Laadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Gebruiksperiode 5 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Gebruiksperiode 5 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Gebruiksperiode 5 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Gebruiksperiode 5 Ontlaadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Gebruiksperiode 5 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Gebruiksperiode 6 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Gebruiksperiode 6 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Gebruiksperiode 6 Laadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Gebruiksperiode 6 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Gebruiksperiode 6 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Gebruiksperiode 6 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Gebruiksperiode 6 Ontlaadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Gebruiksperiode 6 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Gebruiksperiode 7 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Gebruiksperiode 7 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Gebruiksperiode 7 Laadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Gebruiksperiode 7 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Gebruiksperiode 7 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Gebruiksperiode 7 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Gebruiksperiode 7 Ontlaadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Gebruiksperiode 7 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Gebruiksperiode 8 Laadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Gebruiksperiode 8 Laadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Laadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Gebruiksperiode 8 Laadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Gebruiksperiode 8 Laadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Laad Afschakelcapaciteit",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Gebruiksperiode 8 Ontlaadeinde - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Gebruiksperiode 8 Ontlaadeinde - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Ontlaadvermogen",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Gebruiksperiode 8 Ontlaadstart - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Gebruiksperiode 8 Ontlaadstart - Minuut",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Ontlaad Afschakelcapaciteit",
  "50901.real_time.afciVersion": "Afci-Versie",
  "50901.real_time.batteryChargePower": "Accu Cumulatieve Laadcapaciteit",
  "50901.real_time.batteryConnectionStatus": "Accu Aansluitstatus",
  "50901.real_time.batteryCurrent": "Accustroom",
  "50901.real_time.batteryDischargePower": "Accu Cumulatieve Ontlaadcapaciteit",
  "50901.real_time.batteryPower": "Accuvermogen (Laden/Ontladen)",
  "50901.real_time.batterySoc": "Accu-Soc",
  "50901.real_time.batterytotCap": "Accu totaal geïnstalleerde capaciteit",
  "50901.real_time.batteryType_04": "Accutype",
  "50901.real_time.batteryVoltage": "Accuspanning",
  "50901.real_time.batteryWorkingStatus": "Accustatus",
  "50901.real_time.bmsSoftwareVersion": "BMS-versie - Software",
  "50901.real_time.commAddress10Slave9": "Communicatieadres 10 (Slave 9)",
  "50901.real_time.commAddress1Master": "Communicatieadres 1 (Master)",
  "50901.real_time.commAddress2Slave1": "Communicatieadres 2 (Slave 1)",
  "50901.real_time.commAddress3Slave2": "Communicatieadres 3 (Slave 2)",
  "50901.real_time.commAddress3Slave3": "Communicatieadres 4 (Slave 3)",
  "50901.real_time.commAddress4Slave4": "Communicatieadres 5 (Slave 4)",
  "50901.real_time.commAddress6Slave6": "Communicatieadres 6 (Slave 5)",
  "50901.real_time.commAddress7Slave6": "Communicatieadres 7 (Slave 6)",
  "50901.real_time.commAddress8Slave7": "Communicatieadres 8 (Slave 7)",
  "50901.real_time.commAddress9Slave8": "Communicatieadres 9 (Slave 8)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "Drm-Status (Voor Australië/Duitsland/Oostenrijk)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Dsp-Versie (Hulp U-Versie)",
  "50901.real_time.epsCurrentA": "Eps-Zijde Fase A Stroom",
  "50901.real_time.epsCurrentB": "Eps-Zijde Fase B Stroom",
  "50901.real_time.epsCurrentC": "Eps-Zijde Fase C Stroom",
  "50901.real_time.epsPower": "Eps-Zijde Vermogen",
  "50901.real_time.epsPowerA": "Eps-Zijde Fase A Vermogen",
  "50901.real_time.epsPowerB": "Eps-Zijde Fase B Vermogen",
  "50901.real_time.epsPowerC": "Eps-Zijde Fase C Vermogen",
  "50901.real_time.epsVoltageA": "Eps-Zijde Fase A Spanning",
  "50901.real_time.epsVoltageB": "Eps-Zijde Fase B Spanning",
  "50901.real_time.epsVoltageC": "Eps-Zijde Fase C Spanning",
  "50901.real_time.essAccessPoint": "Ess-Toegangspunt",
  "50901.real_time.externalFanSpeed1": "Buitenste Ventilatorsnelheid 1",
  "50901.real_time.externalFanSpeed2": "Buitenste Ventilatorsnelheid 2",
  "50901.real_time.externalFanSpeed3": "Buitenste Ventilatorsnelheid 3",
  "50901.real_time.externalFanSpeed4": "Buitenste Ventilatorsnelheid 4",
  "50901.real_time.generatorConnectionStatus": "Generator Verbindingsstatus",
  "50901.real_time.generatorCurrentA": "Generator Fase A Stroom",
  "50901.real_time.generatorCurrentB": "Generator Fase B Stroom",
  "50901.real_time.generatorCurrentC": "Generator Fase C Stroom",
  "50901.real_time.generatorTotalYield": "Generator cumulatieve opbrengst",
  "50901.real_time.generatorVoltageA": "Generator Fase A Spanning",
  "50901.real_time.generatorVoltageB": "Generator Fase B Spanning",
  "50901.real_time.generatorVoltageC": "Generator Fase C Spanning",
  "50901.real_time.gridBuyPower": "Cumulatieve ingekochte energie",
  "50901.real_time.gridCurrentA": "Netzijde Fase A Stroom",
  "50901.real_time.gridCurrentB": "Netzijde Fase B Stroom",
  "50901.real_time.gridCurrentC": "Netzijde Fase C Stroom",
  "50901.real_time.gridPower": "Netzijde Vermogen",
  "50901.real_time.gridPowerA": "Netzijde Fase A Vermogen",
  "50901.real_time.gridPowerB": "Netzijde Fase B Vermogen",
  "50901.real_time.gridPowerC": "Netzijde Fase C Vermogen",
  "50901.real_time.gridPowerFactor": "Netzijde Arbeidsfactor",
  "50901.real_time.gridPowerFactorA": "Netzijde Fase A Arbeidsfactor",
  "50901.real_time.gridPowerFactorB": "Netzijde Fase B Arbeidsfactor",
  "50901.real_time.gridPowerFactorC": "Netzijde Fase C Arbeidsfactor",
  "50901.real_time.gridReactivePower": "Netzijde Reactief Vermogen",
  "50901.real_time.gridReactivePowerA": "Netzijde Fase A Reactief Vermogen",
  "50901.real_time.gridReactivePowerB": "Netzijde Fase B Reactief Vermogen",
  "50901.real_time.gridReactivePowerC": "Netzijde Fase C Reactief Vermogen",
  "50901.real_time.gridSellPower": "Cumulatieve verkochte energie",
  "50901.real_time.gridTotalFrequency": "Netzijde Frequentie",
  "50901.real_time.gridVoltageA": "Netzijde Fase A Spanning",
  "50901.real_time.gridVoltageB": "Netzijde Fase B Spanning",
  "50901.real_time.gridVoltageC": "Netzijde Fase C Spanning",
  "50901.real_time.internalFanSpeed1": "Binnenste Ventilatorsnelheid 1",
  "50901.real_time.internalFanSpeed2": "Binnenste Ventilatorsnelheid 2",
  "50901.real_time.internalFanSpeed3": "Binnenste Ventilatorsnelheid 3",
  "50901.real_time.invAcFrequency": "Omvormer AC-uitgangsfrequentie",
  "50901.real_time.inverCombinedActivePower": "Omvormer AC-uitgangsvermogen",
  "50901.real_time.inverterSideRadiatorTemperature": "Omvormer Zijde Koellichaam Temperatuur",
  "50901.real_time.inverterTemp": "Omvormer Interne Bedrijfstemperatuur",
  "50901.real_time.invRatedPower": "Nominaal Vermogen",
  "50901.real_time.invRunningtime": "Inv-Bedrijfstijd (Hoymiles: Normale Bedrijfstijd)",
  "50901.real_time.machineSnMaster": "Master Eenheid Sn",
  "50901.real_time.machineSnSlave1": "Slave 1 Sn",
  "50901.real_time.machineSnSlave2": "Slave 2 Sn",
  "50901.real_time.machineSnSlave3": "Slave 3 Sn",
  "50901.real_time.machineSnSlave4": "Slave 4 Sn",
  "50901.real_time.machineSnSlave5": "Slave 5 Sn",
  "50901.real_time.machineSnSlave6": "Slave 6 Sn",
  "50901.real_time.machineSnSlave7": "Slave 7 Sn",
  "50901.real_time.machineSnSlave8": "Slave 8 Sn",
  "50901.real_time.machineSnSlave9": "Slave 9 Sn",
  "50901.real_time.MaxChargeCurrent": "Maximale Laadstroom",
  "50901.real_time.MaxDisChargeCurrent": "Maximale Ontlaadstroom",
  "50901.real_time.meterFlag": "Meter Flag",
  "50901.real_time.mpptTemp": "Pv-Zijde Koellichaam Temperatuur",
  "50901.real_time.numberOfUnits": "Aantal Eenheden",
  "50901.real_time.packNum": "Parallel Aantal (Aantal Accupakketten)",
  "50901.real_time.phaseAOfInverterActivePower": "Omvormer AC-zijde fase A vermogen",
  "50901.real_time.phaseAOfInverterSideCurrent": "Omvormer AC-zijde fase A stroom",
  "50901.real_time.phaseAOfInverterSideVoltage": "Omvormer AC-zijde fase A spanning",
  "50901.real_time.phaseBOfInverterActivePower": "Omvormer AC-zijde fase B vermogen",
  "50901.real_time.phaseBOfInverterSideCurrent": "Omvormer AC-zijde fase B stroom",
  "50901.real_time.phaseBOfInverterSideVoltage": "Omvormer AC-zijde fase B spanning",
  "50901.real_time.phaseCOfInverterActivePower": "Omvormer AC-zijde fase C vermogen",
  "50901.real_time.phaseCOfInverterSideCurrent": "Omvormer AC-zijde fase C stroom",
  "50901.real_time.phaseCOfInverterSideVoltage": "Omvormer AC-zijde fase C spanning",
  "50901.real_time.powerGeneration": "PV cumulatieve opbrengst",
  "50901.real_time.pv1Current": "Pv1 Stroom",
  "50901.real_time.pv1Power": "Pv1 Vermogen",
  "50901.real_time.pv1Voltage": "Pv1 Spanning",
  "50901.real_time.pv2Current": "Pv2 Stroom",
  "50901.real_time.pv2Power": "Pv2 Vermogen",
  "50901.real_time.pv2Voltage": "Pv2 Spanning",
  "50901.real_time.pv3Current": "Pv3 Stroom",
  "50901.real_time.pv3Power": "Pv3 Vermogen",
  "50901.real_time.pv3Voltage": "Pv3 Spanning",
  "50901.real_time.pv4Current": "Pv4 Stroom",
  "50901.real_time.pv4Power": "Pv4 Vermogen",
  "50901.real_time.pv4Voltage": "Pv4 Spanning",
  "50901.real_time.pvConnectionStatus": "Pv-Verbindingsstatus",
  "50901.real_time.pvDailyYield": "Pv Dagelijkse Opbrengst",
  "50901.real_time.pvMeterConnectionStatus": "Pv-Meter Verbindingsstatus",
  "50901.real_time.pvMeterCurrentA": "Pv-Meter Fase A Stroom",
  "50901.real_time.pvMeterCurrentB": "Pv-Meter Fase B Stroom",
  "50901.real_time.pvMeterCurrentC": "Pv-Meter Fase C Stroom",
  "50901.real_time.pvMeterDailyYield": "Externe omvormer dagelijkse opbrengst",
  "50901.real_time.pvMeterFrequency": "Pv-Meter Frequentie",
  "50901.real_time.pvMeterPhaseAActivePower": "Pv-Meter Fase A Actief Vermogen",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Pv-Meter Fase A Arbeidsfactor",
  "50901.real_time.pvMeterPhaseAReactivePower": "Pv-Meter Fase A Reactief Vermogen",
  "50901.real_time.pvMeterPhaseBActivePower": "Pv-Meter Fase B Actief Vermogen",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Pv-Meter Fase B Arbeidsfactor",
  "50901.real_time.pvMeterPhaseBReactivePower": "Pv-Meter Fase B Reactief Vermogen",
  "50901.real_time.pvMeterPhaseCActivePower": "Pv-Meter Fase C Actief Vermogen",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Pv-Meter Fase C Arbeidsfactor",
  "50901.real_time.pvMeterPhaseCReactivePower": "Pv-Meter Fase C Reactief Vermogen",
  "50901.real_time.pvMeterPower": "Pv-Meter Vermogen",
  "50901.real_time.pvMeterPowerA": "Pv-Meter Fase A Vermogen",
  "50901.real_time.pvMeterPowerB": "Pv-Meter Fase B Vermogen",
  "50901.real_time.pvMeterPowerC": "Pv-Meter Fase C Vermogen",
  "50901.real_time.pvMeterTotalYield": "Externe omvormer cumulatieve opbrengst",
  "50901.real_time.pvMeterVoltageA": "Pv-Meter Fase A Spanning",
  "50901.real_time.pvMeterVoltageB": "Pv-Meter Fase B Spanning",
  "50901.real_time.pvMeterVoltageC": "Pv-Meter Fase C Spanning",
  "50901.real_time.serviceEntranceBreakerCurrent": "Service Entrance Stroomonderbreker Stroom",
  "50901.real_time.soh": "Soh",
  "50901.real_time.totalBatteryToLoadEnergy": "Cumulatieve accu-naar-last energie",
  "50901.real_time.totalGridToLoadEnergy": "Cumulatieve net-naar-last energie",
  "50901.real_time.totalLoadEnergy": "Last cumulatief energieverbruik",
  "50901.real_time.totalPvToBatteryEnegry": "Cumulatieve PV-naar-accu energie",
  "50901.real_time.totalPvToGridEnegry": "Cumulatieve PV-naar-net energie",
  "50901.real_time.totalPvToLoadEnegry": "Cumulatieve PV-naar-last energie",
  "50901.real_time.workStatus": "Bedrijfsstatus",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Absorptiespanning",
  "50901.ctrl_Config.Battery.batteryCapacity": "BMS-capaciteit",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Laadeindspanning",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Laadeindstroom",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Equalisatielading Time-Out",
  "50901.ctrl_Config.Battery.equalizationEnable": "Equalisatie Inschakelen",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Equalisatie Interval Dagen",
  "50901.ctrl_Config.Battery.equalizationTime": "Equalisatietijd",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Equalisatiespanning",
  "50901.ctrl_Config.Battery.floatVoltage": "Druppellaadspanning / Floatspanning",
  "50901.ctrl_Config.Battery.initialResistance": "Initiële Weerstand",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Maximale Laadstroom/-Vermogen Grenswaarde",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Maximale Ontlaadstroom/-Vermogen Grenswaarde",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Temperatuurcorrectiecoëfficiënt",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Dtu-Communicatie Inschakelen",
  "50901.ctrl_Config.Device.arcFaultClear": "Vlamboogfout wissen",
  "50901.ctrl_Config.Device.batActivate": "Accu Activering",
  "50901.ctrl_Config.Device.batteryBalancing": "Accu Balancering",
  "50901.ctrl_Config.Device.clearFault": "Fout wissen",
  "50901.ctrl_Config.Device.parallelNetworking": "Parallel netwerk",
  "50901.ctrl_Config.Device.restartSystem": "Systeemherstart",
  "50901.ctrl_Config.Device.restoreDefault": "Standaardwaarden Herstellen",
  "50901.ctrl_Config.Device.selfTest": "Zelftest",
  "50901.ctrl_Config.Device.systemPowerOnOff": "Systeem Aan/Uit",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Generatorregeling - Laadeindtijd - Uur",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Generatorregeling - Laadeindtijd - Minuut",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Generatorregeling - Laadstarttijd - Uur",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Generatorregeling - Laadstarttijd - Minuut",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Generator Uitschakel Accucapaciteit",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Generatormodus",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Generator Start Accucapaciteit",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Generator Oefenmodus Frequentie",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Generator Oefenmodus",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Generator Oefenmodus Looptijd",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Generator Oefenmodus Starttijd - Uur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Generator Oefenmodus Starttijd - Minuut",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Generator Oefenmodus Starttijd",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Stand-By Tijd 1 Einde - Uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Stand-By Tijd 1 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Stand-By Tijd 1 Start - Uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Stand-By Tijd 1 Start - Minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Stand-By Tijd 2 Einde - Uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Stand-By Tijd 2 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Stand-By Tijd 2 Start - Uur",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Stand-By Tijd 2 Start - Minuut",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Stand-By Tijd Inschakelen",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Lastregelmodus",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Lastregeling Maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Lastregeling Dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Lastregeling Woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Lastregeling Donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Lastregeling Vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Lastregeling Zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Lastregeling Zondag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Handmatige Modus Schakelaar",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Lastmodus Lastvermogen Drempel",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Lastregeling Minimale Inschakeltijd",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Eilandmodus Bescherming Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Tijdsbereik 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20": "Maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "Vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Zondag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Timer 1 Einde - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Timer 1 Einde_2 - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Tijdslot 1 Einde - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Timer 1 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Timer 1 Einde_2 - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Tijdslot 1 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Timer 1 Start - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Timer 1 Start_2 - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Tijdslot 1 Start - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Timer 2 Einde - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Timer 2 Einde_2 - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Tijdslot 2 Einde - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Timer 2 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Timer 2 Einde_2 - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Tijdslot 2 Einde - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Timer 2 Start - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Timer 2 Start_2 - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Tijdslot 2 Start - Minuut",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Timer 1 Start - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Timer 1 Start_2 - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Tijdslot 1 Start - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Timer 2 Start - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Timer 2 Start_2 - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Tijdslot 2 Start - Uur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Maandag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Dinsdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Woensdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Donderdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "Vrijdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Zaterdag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Zondag",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Droogcontact Werkingsmodus",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Piek Accu Max. Ontlaadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Piek Netinvoedingsvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Accu Max. Laadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Accu Max. Ontlaadvermogen",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Loodzuur Accu Onderhoudstijd",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Maximale Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Minimale Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Vermogenscompensatie",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Rsvd Reservevermogen",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Bypass Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Eps-Modus",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Pv-Modus Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Generator Frequentie Bovengrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Generator Spanning Bovengrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Generator Frequentie Ondergrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Generator Spanning Ondergrens",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Generator-Naar-Accu Laadvermogen Bij Meervoudig Parallelbedrijf",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Globale Scan Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Netvermogen Beperken",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Driefasen Onbalans Inschakelen",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio": "GCF export harde limiet verhouding",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Gereserveerde Soc",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Economische Modus Soc",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Economische Modus Datumindex",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Sectie 1 Piek Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Sectie 1 Piek Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Sectie 1 Piek Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Sectie 1 Piek Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Sectie 1 Piek Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Sectie 1 Piek Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Sectie 1 Piek Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Sectie 1 Piek Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section1StartDay": "Sectie 1 Startdag",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Sectie 1 Startmaand",
  "50901.ctrl_WorkMode.economic.section1StopDay": "Sectie 1 Stopdag",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Sectie 1 Stopmaand",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Sectie 1 Dal Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Sectie 1 Dal Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Sectie 1 Dal Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Sectie 1 Dal Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Sectie 1 Dal Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Sectie 1 Dal Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Sectie 1 Dal Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Sectie 1 Dal Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section1WeekRange1": "Sectie 1 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2": "Sectie 1 weekbereik 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Sectie 2 Piek Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Sectie 2 Piek Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Sectie 2 Piek Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Sectie 2 Piek Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Sectie 2 Piek Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Sectie 2 Piek Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Sectie 2 Piek Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Sectie 2 Piek Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section2StartDay": "Sectie 2 Startdag",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Sectie 2 Startmaand",
  "50901.ctrl_WorkMode.economic.section2StopDay": "Sectie 2 Stopdag",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Sectie 2 Stopmaand",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Sectie 2 Dal Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Sectie 2 Dal Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Sectie 2 Dal Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Sectie 2 Dal Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Sectie 2 Dal Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Sectie 2 Dal Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Sectie 2 Dal Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Sectie 2 Dal Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section2WeekRange1": "Sectie 2 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange2": "Sectie 2 weekbereik 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Sectie 3 Piek Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Sectie 3 Piek Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Sectie 3 Piek Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Sectie 3 Piek Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Sectie 3 Piek Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Sectie 3 Piek Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Sectie 3 Piek Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Sectie 3 Piek Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section3StartDay": "Sectie 3 Startdag",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Sectie 3 Startmaand",
  "50901.ctrl_WorkMode.economic.section3StopDay": "Sectie 3 Stopdag",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Sectie 3 Stopmaand",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Sectie 3 Dal Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Sectie 3 Dal Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Sectie 3 Dal Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Sectie 3 Dal Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Sectie 3 Dal Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Sectie 3 Dal Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Sectie 3 Dal Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Sectie 3 Dal Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section3WeekRange1": "Sectie 3 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Sectie 3 Weekbereik 2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Sectie 4 Piek Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Sectie 4 Piek Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Sectie 4 Piek Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Sectie 4 Piek Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Sectie 4 Piek Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Sectie 4 Piek Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Sectie 4 Piek Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Sectie 4 Piek Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section4StartDay": "Sectie 4 Startdag",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Sectie 4 Startmaand",
  "50901.ctrl_WorkMode.economic.section4StopDay": "Sectie 4 Stopdag",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Sectie 4 Stopmaand",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Sectie 4 Dal Starttijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Sectie 4 Dal Starttijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Sectie 4 Dal Starttijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Sectie 4 Dal Starttijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Sectie 4 Dal Stoptijd 1 - Uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Sectie 4 Dal Stoptijd 2 - Uur",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Sectie 4 Dal Stoptijd 1 - Minuut",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Sectie 4 Dal Stoptijd 2 - Minuut",
  "50901.ctrl_WorkMode.economic.section4WeekRange1": "Sectie 4 weekbereik 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Sectie 4 Weekbereik 2",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Forceer Laad-Soc",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Maximaal Laadvermogen",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Forceer Ontlaad-Soc",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Maximaal Ontlaadvermogen",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Piekmeter Vermogen",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Piekmeter Soc",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Eigenverbruik Soc",
  "50901.ctrl_WorkMode.Switch.workMode": "Ems Werkingsmodus",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Tou-Modus Tijdsbereik",
  "50901.real_time.BatteryModel": "Accumodel",
  "50901.real_time.cfgMultPcsBmsFlag": "BMS-vlag",
  "50901.real_time.inverterSn": "Omvormer Sn",
  "50901.ctrl_Config.Grid Profile.country": "Land/Net Aansluitnorm",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Generatoraansluiting Modus",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Generatorlocatie",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Generator Uitschakelvertraging",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Generator Synchronisatietijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Generatortype",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Maximale Looptijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Minimale Looptijd",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Bedrijfsbeveiligingsinterval",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Metertype",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Mid / Gateway Inschakelen",
  "50901.ctrl_Safety.DCI.dciEnable": "Dci Inschakelen",
  "50901.ctrl_Safety.DCI.lowerLimit": "Dci Onderste Grenswaarde Stroom",
  "50901.ctrl_Safety.DCI.lowerTime": "Dci Onderste Grenswaarde Tijd",
  "50901.ctrl_Safety.DCI.upperLimit": "Dci Bovenste Grenswaarde Stroom",
  "50901.ctrl_Safety.DCI.upperTime": "Dci Bovenste Grenswaarde Tijd",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Frt-Functiecode",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Frequentie Bovengrens 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Frequentie Bovengrens 1 Duur",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Frequentie Bovengrens 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Frequentie Bovengrens 2 Duur",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Frequentie Bovengrens 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Frequentie Bovengrens 3 Duur",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Frequentie Ondergrens 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Frequentie Ondergrens 1 Duur",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Frequentie Ondergrens 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Frequentie Ondergrens 2 Duur",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Frequentie Ondergrens 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Frequentie Ondergrens 3 Duur",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Fw Accu Modus Verschil Inschakelen",
  "50901.ctrl_Safety.FW.fwEnable": "Fw Inschakelen",
  "50901.ctrl_Safety.FW.fwFuncCode": "Fw-Functiecode",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Fw Overfrequente Eindfrequentie",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Fw Overfrequente Startfrequentie",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Fw Overfrequente Overgangsfrequentie",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Fw Herstel Frequentie Ondergrens",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Fw Herstel Stabilisatietijd",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Fw Herstel Frequentie Bovengrens",
  "50901.ctrl_Safety.FW.fwTr": "Fw_Tr Tijd",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Fw Onderfrequente Eindfrequentie",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Fw Onderfrequente Startfrequentie",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Fw Onderfrequente Stopfrequentie",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Rcd Continue Limiet Tijd",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Rcd Continue Limiet Stroom",
  "50901.ctrl_Safety.RCD.rcdEnable": "Rcd Inschakelen",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Rcd Stap 1 Limiet Tijd",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Rcd Stap 1 Limiet Stroom",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Rcd Stap 2 Limiet Tijd",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Rcd Stap 2 Limiet Stroom",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Rcd Stap 3 Limiet Tijd",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Rcd Stap 3 Limiet Stroom",
  "50901.ctrl_Safety.RPC.gcfEn": "Gcf Inschakelen",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Gcf-Functiecode",
  "50901.ctrl_Safety.RPC.rpcMode": "Rp-Modus",
  "50901.ctrl_Safety.RPC.rpcPf": "Rpc Arbeidsfactor Pf",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Rpc Reactief Vermogen Verhouding",
  "50901.ctrl_Safety.RPC.rpcTr": "Rpc_Tr Tijd",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Volt-Var-Functiecode",
  "50901.ctrl_Safety.RPC.vvLockIn": "Vv Inschakelwaarde",
  "50901.ctrl_Safety.RPC.vvLockOut": "Vv Uitschakelwaarde",
  "50901.ctrl_Safety.RPC.vvQ1": "Reactief Vermogen Setpoint_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Reactief Vermogen Setpoint_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Reactief Vermogen Setpoint_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Reactief Vermogen Setpoint_Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Spanning Setpoint_V1",
  "50901.ctrl_Safety.RPC.vvV2": "Spanning Setpoint_V2",
  "50901.ctrl_Safety.RPC.vvV3": "Spanning Setpoint_V3",
  "50901.ctrl_Safety.RPC.vvV4": "Spanning Setpoint_V4",
  "50901.ctrl_Safety.RPC.vvVref": "Volt-Var Referentiewaarde (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Volt-Var Referentiewaarde Tr Tijd",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Wpf-Functiecode",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Wpf Inschakelwaarde",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Wpf Uitschakelwaarde",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Wpf Overbelasting Minimale Pf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Wpf Onderbelasting Minimale Pf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Wpf Vermogen Einde Verhouding",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Wpf Vermogen Start Verhouding",
  "50901.ctrl_Safety.RR.rrFuncCode": "Rr-Functiecode",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Rt Frequentie Herstel Bovengrens",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Rt Frequentie Herstel Ondergrens",
  "50901.ctrl_Safety.RT.rtFuncCode": "Rt-Functiecode",
  "50901.ctrl_Safety.RT.rtNMTime": "Rt_Nm Tijd",
  "50901.ctrl_Safety.RT.rtSRTTime": "Rt_Srt Tijd",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Rt Spanning Herstel Bovengrens",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Rt Spanning Herstel Ondergrens",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "10-Minuten Gemiddelde Spanning",
  "50901.ctrl_Safety.VRT.vrtEn": "Vrt Inschakelen",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Vrt-Functiecode",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Vrt Hoge Spanning Drempel",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Vrt Lage Spanning Drempel",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Vrt Herstel Stabilisatietijd",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Momentane Overspanningsduur",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Momentane Overspanningsdrempel",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Spanning Bovengrens 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Spanning Bovengrens 1 Duur",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Spanning Bovengrens 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Spanning Bovengrens 2 Duur",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Spanning Bovengrens 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Spanning Bovengrens 3 Duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Spanning Ondergrens 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Spanning Ondergrens 1 Duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Spanning Ondergrens 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Spanning Ondergrens 2 Duur",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Spanning Ondergrens 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Spanning Ondergrens 3 Duur",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Vw Accu Modus Verschil Inschakelen",
  "50901.ctrl_Safety.VW.vwEnable": "Vw Inschakelen",
  "50901.ctrl_Safety.VW.vwFuncCode": "Vw-Functiecode",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Vw Overspanning Eindspanning",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Vw Overspanning Kp-Spanning / Coëfficiëntspanning",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Vw Overspanning Startspanning",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Vw Herstelspanning Ondergrens",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Vw Herstel Stabilisatietijd",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Vw Herstelspanning Bovengrens",
  "50901.ctrl_Safety.VW.vwTr": "Vw_Tr Tijd",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Vw Onderspanning Eindspanning",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Vw Onderspanning Kp-Spanning / Coëfficiëntspanning",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Vw Onderspanning Startspanning",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio": "GCF export zachte limiet verhouding",
  "50901.Selfuse": "Eigenverbruik",
  "50901.TOU": "Variabel Tarief",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Beschrijving meterconfiguratie",
  "50901.ctrl_Config.Grid Profile.country.desc": "Beschrijving land/net aansluitnorm",
  "50901.ctrl_Config.Device.meterConfiguration.0": "Geen Metertype",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Netmeter Geconfigureerd",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Pv-Meter Geconfigureerd",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Net + Pv-Meter Geconfigureerd",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Eigenverbruik",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Economische Modus",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Back-Upmodus",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Off-Grid Modus / Eilandmodus",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Forceer Laadmodus",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Forceer Ontlaadmodus",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Piekbesparende Modus / Piek Scheren",
  "50901.ctrl_WorkMode.Switch.workMode.7": "TOU-modus",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Uitschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Inschakelen",
  "50901.ctrl_Config.Device.meterConfiguration": "Meterconfiguratie",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Net Ct Reverse Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Net Ct Windingverhouding Instelling",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Pv Ct Reverse Inschakelen",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Pv Ct Windingverhouding Instelling",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Start Lading Gebruiksperiode 1 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Start Ontlading Gebruiksperiode 1 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Start Lading Gebruiksperiode 2 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Start Ontlading Gebruiksperiode 2 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Start Lading Gebruiksperiode 3 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Start Ontlading Gebruiksperiode 3 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Start Lading Gebruiksperiode 4 - Uur",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Start Ontlading Gebruiksperiode 4 - Uur",
  "50901.ctrl_Config.Grid Profile.country.0": "สหภาพยุโรป EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.10": "ออสเตรเลีย AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "ฟิลิปปินส์ PH",
  "50901.ctrl_Config.Grid Profile.country.12": "บราซิล BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "ปากีสถาน PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "ไทย THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "อิตาลี IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "โคลอมเบีย CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "สหราชอาณาจักร UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "ออสเตรเลีย AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "สหราชอาณาจักร UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "เอกวาดอร์ EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "สโลวีเนีย SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "ฝรั่งเศส FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "สเปน ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "สเปน ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "ลิทัวเนีย LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.28": "ไทย THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "ออสเตรีย AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.31": "สหราชอาณาจักร UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "สหราชอาณาจักร UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "สหราชอาณาจักร UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "สหราชอาณาจักร UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "เวียดนาม VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "ปานามา PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "บราซิล BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "เปอร์โตริโก LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "เปอร์โตริโก LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "โปแลนด์ PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "อินเดีย IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "โรมาเนีย RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "จีน CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "อิรัก IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.46": "ซาอุดีอาระเบีย SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "ศรีลังกา LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "เช็ก CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "เบลเยียม BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "เอสโตเนีย EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "เนเธอร์แลนด์ NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "ยูเครน UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "แคนาดา CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "แคนาดา CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "มาเลเซีย MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "อินโดนีเซีย ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "แอฟริกาใต้ ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "สวีเดน SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "กรีซ GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "ลักเซมเบิร์ก LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "ฮังการี HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "ไอร์แลนด์ IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "แซมเบีย ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "ครื่องกำเนิดไฟฟ้า GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "เครื่องกำเนิดไฟฟ้า GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "ซาอุดีอาระเบีย SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "เซอร์เบีย SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "สวิตเซอร์แลนด์ CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "เลบานอน LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "ชิลี CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "ซีเรีย SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "ออสเตรเลีย AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "ออสเตรเลีย AU_AS4777_C",
  "alarm.trigger.condition": "geactiveerd door het apparaat",
  "alarm.iot": "IoT",
  "module.alarmInfo": "Alarm Info",
  "edit.failed": "Bewerken mislukt",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "tag_test_3": "tag_test_3",
  "Transit_Warehouse": "Transitmagazijn",
  "bw_Param_strl_option_GridUseMeter": "Het elektriciteitsnet gebruikt elektriciteitsmeters",
  "bw_Param_strl_option_GridUseCT": "Het elektriciteitsnet gebruikt CT",
  "50901.fault.dSPSAFcomparatorFault": "Comparatorfout",
  "50901.fault.dSPPWRfanFault": "Ventilatorfout",
  "50901.fault.dSPPWRgridRelayProtection": "Netrelaisbeveiliging geactiveerd",
  "50901.fault.dSPPWRmachineTypeMismatch": "Machinetype Niet Overeenkomend",
  "50901.fault.dSPSAFbatteryFault": "Batterijfout",
  "50901.fault.dSPSAFfanFault": "Ventilatorfout",
  "50901.fault.dSPSAFgridRelayProtection": "Netrelaisbeveiliging Geactiveerd",
  "50901.fault.dSPPWRbatteryFault": "Batterijzijde Fout",
  "50901.fault.dSPPWRcomparatorFault": "Comparatorfout",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Hulpvoeding Afwijking",
  "50901.fault.dSPSAFmachineTypeMismatch": "Machinetype Niet Overeenkomend",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Sampling Bias Afwijking",
  "50901.fault.canCommunicationTimeout": "Can Communicatie Timeout",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Hulpvoeding abnormaal",
  "50901.fault.dSPSAFarmCommunicationFault": "Arm Communicatiefout",
  "50901.fault.dSPSAFspiCommunicationFault": "Spi Communicatiefout",
  "50901.fault.dSPSAFversionMismatch": "Versie Niet Overeenkomend",
  "50901.fault.dSPPWRarmCommunicationFault": "Arm Communicatiefout",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Sampling Bias Afwijking",
  "50901.fault.dSPPWRspiCommunicationFault": "Spi Communicatiefout",
  "50901.fault.dSPPWRversionMismatch": "Versie Niet Overeenkomend (Software/Hardware Versie Inconsistentie)",
  "50901.fault.hardwareProtection": "Hardwarebeveiliging Geactiveerd",
  "50901.fault.lowBatteryEnergy": "Lage Batterij-energie",
  "50901.fault.dSPPWRgridRelayProtection.0": "Uitschakelen",
  "50901.fault.dSPPWRgridRelayProtection.1": "Inschakelen",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Uitschakelen",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Inschakelen",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Uitschakelen",
  "50901.fault.dSPPWRbatteryFault.1": "Inschakelen",
  "50901.fault.dSPPWRcomparatorFault.0": "Uitschakelen",
  "50901.fault.dSPPWRcomparatorFault.1": "Inschakelen",
  "50901.fault.dSPPWRfanFault.0": "Uitschakelen",
  "50901.fault.dSPPWRfanFault.1": "Inschakelen",
  "50901.fault.canCommunicationTimeout.1": "Inschakelen",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Uitschakelen",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Inschakelen",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Uitschakelen",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Inschakelen",
  "50901.fault.dSPPWRbatteryFault.0": "Uitschakelen",
  "50901.fault.canCommunicationTimeout.0": "Uitschakelen",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Inschakelen",
  "50901.fault.hardwareProtection.1": "Inschakelen",
  "50901.fault.lowBatteryEnergy.0": "Uitschakelen",
  "50901.fault.lowBatteryEnergy.1": "Inschakelen",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Inschakelen",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Uitschakelen",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Inschakelen",
  "50901.fault.dSPSAFversionMismatch.0": "Uitschakelen",
  "50901.fault.dSPSAFversionMismatch.1": "Inschakelen",
  "50901.fault.hardwareProtection.0": "Uitschakelen",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Uitschakelen",
  "50901.fault.dSPSAFgridRelayProtection.1": "Inschakelen",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Uitschakelen",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Inschakelen",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Uitschakelen",
  "50901.fault.dSPSAFbatteryFault.0": "Uitschakelen",
  "50901.fault.dSPSAFbatteryFault.1": "Inschakelen",
  "50901.fault.dSPSAFcomparatorFault.0": "Uitschakelen",
  "50901.fault.dSPSAFcomparatorFault.1": "Inschakelen",
  "50901.fault.dSPSAFfanFault.0": "Uitschakelen",
  "50901.fault.dSPSAFfanFault.1": "Inschakelen",
  "50901.fault.dSPPWRversionMismatch.0": "Uitschakelen",
  "50901.fault.dSPPWRversionMismatch.1": "Inschakelen",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Inschakelen",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Uitschakelen",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Inschakelen",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Uitschakelen",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Inschakelen",
  "50901.fault.dSPSAFgridRelayProtection.0": "Uitschakelen",
  "50901..数据分析_电网功率.tag": "Netvermogen",
  "50901..数据分析_单体SOC.tag": "Cel-Soc",
  "50901..数据分析_发电机功率.tag": "Generator vermogen",
  "50901..数据分析_混逆光伏功率.tag": "Hybride Omvormer Pv-Vermogen",
  "50901..数据分析_电池包.tag": "Batterijpakket",
  "50901..数据分析_电网电压.tag": "Netspanning",
  "50901..数据分析_电网电流.tag": "Stroom van het elektriciteitsnet",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Soc-Inschakelmodus Voor Warmtepompbatterijen 0: Uitschakelen 1: Inschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Maximaal Netinvoedingsvermogen Van De Warmtepomp",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "Wanneer De Eenmalige Bedrijfstijd Deze Waarde Bereikt, Wordt De Besturingsmodus Van De Warmtepomp Uitgeschakeld",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "Wanneer De Batterij-Soc Deze Waarde Bereikt, Wordt De Besturingsmodus Van De Warmtepomp Ingeschakeld",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Lees, schrijf, meld.",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "Er Kunnen Maximaal 4 Bedrijfsperioden Worden Ingesteld",
  "50901.Fault": "Fout",
  "50901.Fault.arcFault.0": "Uitschakelen",
  "50901.Fault.arcFault.1": "Inschakelen",
  "50901.Fault.arcSelfTestFault.0": "Uitschakelen",
  "50901.Fault.arcSelfTestFault.1": "Inschakelen",
  "50901.Fault.batteryCapacityAbnormality.0": "Disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Uitschakelen",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Inschakelen",
  "50901.Fault.busbarAbnormality.0": "Uitschakelen",
  "50901.Fault.busbarAbnormality.1": "Inschakelen",
  "50901.Fault.cmpssBiasCalculationError.0": "Uitschakelen",
  "50901.Fault.cmpssBiasCalculationError.1": "Inschakelen",
  "50901.Fault.driveAbnormality.0": "Uitschakelen",
  "50901.Fault.driveAbnormality.1": "Inschakelen",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Inschakelen",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "Uitschakelen",
  "50901.Fault.dtsCommunicationAbnormality.1": "Inschakelen",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "Uitschakelen",
  "50901.Fault.e2rpomFault.1": "Inschakelen",
  "50901.Fault.epsOverload.0": "Uitschakelen",
  "50901.Fault.epsOverload.1": "Inschakelen",
  "50901.Fault.epsRelayProtection.0": "Uitschakelen",
  "50901.Fault.epsRelayProtection.1": "Inschakelen",
  "50901.Fault.epsVoltageAbnormality.0": "Uitschakelen",
  "50901.Fault.epsVoltageAbnormality.1": "Inschakelen",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.Fault.evCharger2Fault.0": "Disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "Uitschakelen",
  "50901.Fault.fanSpeedAbnormality.1": "Enable",
  "50901.Fault.flashCommunicationFault.0": "Uitschakelen",
  "50901.Fault.flashCommunicationFault.1": "Inschakelen",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Uitschakelen",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Inschakelen",
  "50901.Fault.genAbnormality.0": "Uitschakelen",
  "50901.Fault.genAbnormality.1": "Inschakelen",
  "50901.Fault.genOverload.0": "Uitschakelen",
  "50901.Fault.genOverload.1": "Inschakelen",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "Enable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Uitschakelen",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Inschakelen",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Inschakelen",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "Enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Uitschakelen",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Inschakelen",
  "50901.Fault.gridOverfrequency.0": "Uitschakelen",
  "50901.Fault.gridOverfrequency.1": "Inschakelen",
  "50901.Fault.gridOvervoltage.0": "Uitschakelen",
  "50901.Fault.gridOvervoltage.1": "Inschakelen",
  "50901.fault.gridPortOvercurrent.0": "Uitschakelen",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.Fault.gridPowerOutage.0": "Uitschakelen",
  "50901.Fault.gridPowerOutage.1": "Inschakelen",
  "50901.Fault.gridUnderfrequency.0": "Uitschakelen",
  "50901.Fault.gridUnderfrequency.1": "Inschakelen",
  "50901.Fault.gridUndervoltage.0": "Uitschakelen",
  "50901.Fault.gridUndervoltage.1": "Inschakelen",
  "50901.Fault.gridVoltageAbnormality.0": "Uitschakelen",
  "50901.Fault.gridVoltageAbnormality.1": "Inschakelen",
  "50901.Fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "Enable",
  "50901.Fault.insulationFault.0": "Uitschakelen",
  "50901.Fault.insulationFault.1": "Inschakelen",
  "50901.Fault.interruptOverflow.0": "Uitschakelen",
  "50901.Fault.interruptOverflow.1": "Inschakelen",
  "50901.fault.inverterCanCommunicationFailed.0": "Disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.Fault.lineToEarthFault.0": "Uitschakelen",
  "50901.Fault.lineToEarthFault.1": "Inschakelen",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "Inschakelen",
  "50901.fault.loadRelayBFault.0": "Disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "Uitschakelen",
  "50901.Fault.lowAmbientTemperature.1": "Inschakelen",
  "50901.Fault.lowDtuVersion.0": "Disable",
  "50901.Fault.lowDtuVersion.1": "Inschakelen",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "Uitschakelen",
  "50901.Fault.meterWiringAbnormality.1": "Inschakelen",
  "50901.Fault.microelectronicFault.0": "Uitschakelen",
  "50901.Fault.microelectronicFault.1": "Inschakelen",
  "50901.Fault.neutralWireNotConnected.0": "Uitschakelen",
  "50901.Fault.neutralWireNotConnected.1": "Inschakelen",
  "50901.Fault.neutralWireToEarthFault.0": "Uitschakelen",
  "50901.Fault.neutralWireToEarthFault.1": "Inschakelen",
  "50901.Fault.overTemperature.0": "Uitschakelen",
  "50901.Fault.overTemperature.1": "Inschakelen",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "Enable",
  "50901.Fault.pllLockFailed.0": "Uitschakelen",
  "50901.Fault.pllLockFailed.1": "Inschakelen",
  "50901.Fault.preSynchronizationFailed.0": "Uitschakelen",
  "50901.Fault.preSynchronizationFailed.1": "Inschakelen",
  "50901.Fault.pvFault.0": "Uitschakelen",
  "50901.Fault.pvFault.1": "Inschakelen",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Uitschakelen",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "Enable",
  "50901.fault.pvRelayAbFault.0": "Disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Uitschakelen",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Inschakelen",
  "50901.Fault.rcdFault.0": "Uitschakelen",
  "50901.Fault.rcdFault.1": "Inschakelen",
  "50901.Fault.rcdSelfTestFault.0": "Uitschakelen",
  "50901.Fault.rcdSelfTestFault.1": "Inschakelen",
  "50901.Fault.reconnectionFailed.0": "Uitschakelen",
  "50901.Fault.reconnectionFailed.1": "Inschakelen",
  "50901.Fault.shutDown.0": "Uitschakelen",
  "50901.Fault.shutDown.1": "Inschakelen",
  "50901.Fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "Enable",
  "50901.Fault.sustainedNegativeLoad.0": "Uitschakelen",
  "50901.Fault.sustainedNegativeLoad.1": "Inschakelen",
  "50901.Fault.temperatureAbnormality.0": "Uitschakelen",
  "50901.Fault.temperatureAbnormality.1": "Inschakelen",
  "50901.Fault.tenMinuteOvervoltage.0": "Uitschakelen",
  "50901.Fault.tenMinuteOvervoltage.1": "Inschakelen",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.Fault.wiringAbnormality.0": "Uitschakelen",
  "50901.Fault.wiringAbnormality.1": "Inschakelen",
  "50901.HeatPump": "Warmtepompbediening",
  "50901.real_time": "Betekenis Van Enumeratiewaarde 0",
  "50901.warning": "Warmtepompbediening",
  "50901.warning.batteryHighVoltageAlarm.0": "Uitschakelen",
  "50901.warning.batteryHighVoltageAlarm.1": "Inschakelen",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Uitschakelen",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Uitschakelen",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "Enable",
  "50901..cfgMultPcsBmsFlag.0": "Nee",
  "50901..cfgMultPcsBmsFlag.1": "Ja",
  "50901..hpTime2WeekRange1.0": "Uitschakelen",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "Enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "Inschakelen",
  "50901..hpTime2WeekRange4.0": "Uitschakelen",
  "50901..hpTime2WeekRange4.1": "Enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "Disable",
  "50901..hpTime2WeekRange6.1": "Inschakelen",
  "50901..hpTime2WeekRange7.0": "Uitschakelen",
  "50901..hpTime2WeekRange7.1": "Enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "Disable",
  "50901..hpTime3WeekRange2.1": "Inschakelen",
  "50901..hpTime3WeekRange3.0": "Uitschakelen",
  "50901..hpTime3WeekRange3.1": "Enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "Disable",
  "50901..hpTime3WeekRange5.1": "Inschakelen",
  "50901..hpTime3WeekRange6.0": "Uitschakelen",
  "50901..hpTime3WeekRange6.1": "Enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "Enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "Inschakelen",
  "50901..hpTime4WeekRange2.0": "Uitschakelen",
  "50901..hpTime4WeekRange2.1": "Enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "Disable",
  "50901..hpTime4WeekRange4.1": "Inschakelen",
  "50901..hpTime4WeekRange5.0": "Uitschakelen",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "Disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "Disable",
  "50901..hpTime4WeekRange7.1": "Inschakelen",
  "50901..materType.0": "Geen Netzijdige Meter",
  "50901..materType.1": "Eenfase",
  "50901..materType.2": "Chint Enkelfasig",
  "50901..materType.3": "De splitste fase",
  "50901..materType.5": "Meeteenheid",
  "50901..materType.6": "Enkelweg Ancore",
  "50901..materType.7": "De dubbele weg van Ancore",
  "50901..section1WeekRange1.0": "maandag",
  "50901..section1WeekRange1.1": "Dinsdag",
  "50901..section1WeekRange1.2": "Woensdag",
  "50901..section1WeekRange1.3": "donderdag",
  "50901..section1WeekRange1.4": "Vrijdag",
  "50901..section1WeekRange1.5": "Zaterdag",
  "50901..section1WeekRange1.6": "Zondag",
  "50901..section1WeekRange2.0": "Betekenis Van Enumeratiewaarde 0",
  "50901..section1WeekRange2.1": "Betekenis Van Enumeratiewaarde 1",
  "50901..section2WeekRange1.0": "Betekenis Van Enumeratiewaarde 0",
  "50901..section2WeekRange1.1": "Betekenis Van Enumeratiewaarde 2",
  "50901..section3WeekRange1.0": "Betekenis Van Enumeratiewaarde 0",
  "50901..section3WeekRange1.1": "Betekenis Van Enumeratiewaarde 2",
  "50901..section4WeekRange1.0": "Betekenis Van Enumeratiewaarde 0",
  "50901..section4WeekRange1.1": "De betekenis van de waarde 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "Nee.",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Ja",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "Vermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "Vermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "Vermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "Vermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "Vermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "Nee.",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Ja",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Controle van warmtepompen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Niet mogelijk.",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "De betekenis van 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Betekenis Van Enumeratiewaarde 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Inschakelen",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Uitschakelen",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Niet mogelijk.",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "Vermogen",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "De betekenis van 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Betekenis Van Enumeratiewaarde 1",
  "50901.fault.emergencyStopSwitchStatus.0": "Disable",
  "50901.fault.emergencyStopSwitchStatus.1": "Inschakelen",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Uitschakelen",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "Enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "Inschakelen",
  "50901.fault.gridMeter.0": "Uitschakelen",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "Enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "Inschakelen",
  "50901.fault.pvPortOvercurrent.0": "Uitschakelen",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.real_time.batteryConnectionStatus.0": "Nee.",
  "50901.real_time.batteryConnectionStatus.1": "Ja",
  "50901.real_time.batteryType_04.0": "Geen Batterij",
  "50901.real_time.batteryType_04.1": "Lithium batterij",
  "50901.real_time.batteryType_04.2": "Loodzuurbatterij",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "7",
  "50901.real_time.packNum.15": "4",
  "50901.real_time.packNum.16383": "14",
  "50901.real_time.packNum.2047": "11",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "2",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "15",
  "50901.real_time.packNum.4095": "12",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "6",
  "50901.real_time.packNum.65535": "16",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "13",
  "50901..parallelNetworking.0": "Ongeldig",
  "50901..parallelNetworking.1": "Netwerken Bezig",
  "50901..parallelNetworking.2": "Netwerk Ontbinden",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901..relayU16NlineRlyTestDis.0": "Uitschakelen",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901.ctrl_Config.ClockSetting.clockSet": "Instelling van de klok",
  "50901.ctrl_Config.Device.arcfaultClear.0": "Nee",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Ja",
  "50901.ctrl_Config.Device.clearfault.0": "Nee",
  "50901.ctrl_Config.Device.clearfault.1": "Ja",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Dry node generator opladen",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Generatoren voor droge knooppunten1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Droogcontact Generator Standby 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Starttijd generator oefenmodus",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Warmtepompperiode 1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Warmtepomp Tijdsperiode 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Warmtepompperiode 3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Warmtepompperiode 4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Droogcontact Timer 1 Periode 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Droog knooppunt timing 1 uur 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Droog knooppunt timing 2 uur periode1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Droogcontact Timer 2 Periode 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Droogknoopperiode1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Droog knooppunt tijd2",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Uitschakelen",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Pf(P)-Curve, Pf(P)-Modus",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Modusknooppunt Periode 1 Dal 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Modus knooppunt tijd 1 laag 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Modus knooppunt tijd 1 piek 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Modusknooppunt Periode 1 Piek 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Modus knooppunt tijd 2 laag 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Modus knooppunt tijd 2 laag 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Modusknooppunt Periode 2 Piek 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Modus knooppunt tijd 2 piek 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Modusknooppunt Periode 3 Dal 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Modus knooppunt tijd 3 laag 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Modus knooppunt tijd 3 piek 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Modusknooppunt Periode 3 Piek 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Modus knooppunt tijd 4 laag 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Modusknooppunt Periode 4 Dal 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Modus knooppunt tijd 4 piek 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Modus knooppunt tijd 4 piek 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Modusknooppunt Periode 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Modus knooppunt tijd2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Modusknooppunt Periode 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Modus knooppunt tijd4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Tijdsverdeling knooppunt tijd 1 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Periodetarief Knooppunt Periode 1 Ontladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Tijdsverdeling knooppunt tijd 2 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Tijdsverdeling knooppunt tijd 2 ontlading",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Periodetarief Knooppunt Periode 3 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Tijdsverdeling knooppunt tijd 3 ontlading",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Tijdsverdeling knooppunt tijd 4 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Periodetarief Knooppunt Periode 4 Ontladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Tijdsverdeling knooppunt tijd 5 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Periodetarief Knooppunt Periode 5 Ontladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Tijdsverdeling knooppunt tijd 6 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Tijdsverdeling knooppunt tijd 6 ontlading",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Periodetarief Knooppunt Periode 7 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Tijdsverdeling knooppunt tijd 7 ontlading",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Tijdsverdeling knooppunt tijd 8 opladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Periodetarief Knooppunt Periode 8 Ontladen",
  "50901.Fault.arcFault": "Vlamboogfout",
  "50901.Fault.arcSelfTestFault": "Vlamboog Zelftestfout",
  "50901.Fault.busbarAbnormality": "Dc-Tussenkring Abnormaal",
  "50901.Fault.cmpssBiasCalculationError": "Cmpss-Offset Berekeningsfout",
  "50901.Fault.driveAbnormality": "Aansturing Abnormaal",
  "50901.Fault.e2rpomFault": "Eeprom-Fout",
  "50901.Fault.epsOverload": "Eps-Overbelasting",
  "50901.Fault.epsRelayProtection": "Eps-Relais Beveiliging",
  "50901.Fault.epsVoltageAbnormality": "Eps-Spanning Abnormaal",
  "50901.Fault.flashCommunicationFault": "Flash Geheugen Communicatiefout",
  "50901.Fault.frequencyVariationRateOutOfRange": "Frequentie Veranderingssnelheid Overschreden",
  "50901.Fault.genAbnormality": "Generator Abnormaal",
  "50901.Fault.genOverload": "Generator Overbelasting",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Netstroom Dc-Offset Overschreden",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Eilandspanning Dc-Offset Overschreden",
  "50901.Fault.gridOverfrequency": "Net Overfrequentie",
  "50901.Fault.gridOvervoltage": "Net Overspanning",
  "50901.Fault.gridPowerOutage": "Netstoring / Netuitval",
  "50901.Fault.gridUnderfrequency": "Net Onderfrequentie",
  "50901.Fault.gridUndervoltage": "Net Onderspanning",
  "50901.Fault.gridVoltageAbnormality": "Netspanning Abnormaal",
  "50901.Fault.insulationFault": "Isolatiefout",
  "50901.Fault.interruptOverflow": "Interrupt Overflow",
  "50901.Fault.lineToEarthFault": "Aardfout (Fase-Aarde)",
  "50901.Fault.lowAmbientTemperature": "Omgevingstemperatuur Te Laag",
  "50901.Fault.meterWiringAbnormality": "Meterbedrading Abnormaal",
  "50901.Fault.microelectronicFault": "Micro-Elektronicafout",
  "50901.Fault.neutralWireNotConnected": "Nulleider Niet Aangesloten",
  "50901.Fault.neutralWireToEarthFault": "Nulleider-Aarde Fout",
  "50901.Fault.overTemperature": "Overtemperatuur",
  "50901.Fault.pllLockFailed": "Pll-Vergrendelingsfout",
  "50901.Fault.preSynchronizationFailed": "Fout Tijdens Voorsynchronisatie",
  "50901.Fault.pvFault": "Pv-Fout",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Pv-Spanning Overschrijdt Tussenkringspanning",
  "50901.Fault.rcdFault": "Rcd-Fout / Aardlekschakelaarfout",
  "50901.Fault.rcdSelfTestFault": "Rcd-Zelftestfout",
  "50901.Fault.reconnectionFailed": "Her-Aansluitingsfout",
  "50901.Fault.shutDown": "Systeemuitschakeling",
  "50901.Fault.temperatureAbnormality": "Temperatuur Abnormaal",
  "50901.Fault.tenMinuteOvervoltage": "10-Minuten Overspanning",
  "50901.Fault.wiringAbnormality": "Bedrading Abnormaal",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Communicatie Stick Software Versie",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "Warmtepomp BattSoc detectiemodus",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Warmtepomp sluiten Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Warmtepomp Vertragingsdetectietijdslimiet",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Maximaal feedback vermogen van de warmtepomp",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "Maximale werktijd van de warmtepomp per dag",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Warmtepomp Maximale Tijd Detectie Inschakelen",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Minimale werktijd van de warmtepomp",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Warmtepomp Startvermogen",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Warmtepomp starten Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Warmtepompvoeding",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Warmtepomp Tijd 1 Einde - Dag",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Warmtepomp tijd 1 einde -",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Warmtepomp Tijd 1 Start - Dag",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Warmtepomptijd 1 start-maand",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Warmtepomptijd 1 weke1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Warmtepomp Tijd 1 Week 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Warmtepomptijd 1 weke3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Warmtepomptijd 1 weke4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Warmtepomp Tijd 1 Week 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Warmtepomptijd 1 weken6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Warmtepomptijd 1 weke7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Werkwijze warmtepomp",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Warmtepomp Bedrijfstijd",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Maandag groep 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Eerste groep dinsdag 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Periode 4 Groep 1 Woensdag",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Deel 4 groep 1 donderdag",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Vrijdag van groep 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Periode 4 Groep 1 Zaterdag",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Eerste groep zaterdag 4",
  "50901.real_time.copy_bmsSoftwareVersion": "BMS-versie - Software",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Omvormer Arm-Versie",
  "50901.real_time.previous_gridPower": "Netzijde Vermogen",
  "50901.ctrl_Config.Device.arcfaultClear": "Boogfout Verhelpen",
  "50901.ctrl_Config.Device.clearfault": "Fout Wissen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Zondag",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Gcf Export Harde Limietratio",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "Gcf Export Zachte Limietratio",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Periode 1 Groep 1 Maandag",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Periode 1 Groep 1 Dinsdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Periode 1 Groep 1 Woensdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Periode 1 Groep 1 Donderdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Periode 1 Groep 1 Vrijdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Periode 1 Groep 1 Zaterdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Periode 1 Groep 1 Zondag",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Periode 1 Groep 2 Maandag",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Periode 1 Groep 2 Dinsdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Periode 1 Groep 2 Woensdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Periode 1 Groep 2 Donderdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Periode 1 Groep 2 Vrijdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Periode 1 Groep 2 Zaterdag",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Periode 1 Groep 2 Zondag",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Periode 2 Groep 1 Maandag",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Periode 2 Groep 1 Dinsdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Periode 2 Groep 1 Woensdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Periode 2 Groep 1 Donderdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Periode 2 Groep 1 Vrijdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Periode 2 Groep 1 Zaterdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Periode 2 Groep 1 Zondag",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Periode 2 Groep 2 Maandag",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Periode 2 Groep 2 Dinsdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Periode 2 Groep 2 Woensdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Periode 2 Groep 2 Donderdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Periode 2 Groep 2 Vrijdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Periode 2 Groep 2 Zaterdag",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Periode 2 Groep 2 Zondag",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Periode 3 Groep 1 Maandag",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Periode 3 Groep 1 Dinsdag",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Periode 3 Groep 1 Woensdag",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Periode 3 Groep 1 Donderdag",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Periode 3 Groep 1 Vrijdag",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Periode 3 Groep 1 Zaterdag",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Periode 3 Groep 1 Zondag",
  "50901.real_time.batteryCapacity": "Geïnstalleerde Batterijcapaciteit",
  "bw_param_ctrl_group_ParallelSetting": "Parallelle Instellingen",
  "50901.real_time.batteryWorkingStatus.1": "Standby",
  "ywt.60419.meterTPower": "T-fase vermogen van de elektrische meter",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "Laadopdracht succesvol uitgevoerd",
  "ai.message.charge.title.fail": "Laadopdracht mislukt",
  "ai.message.charge.content.success": "Laadopdracht succesvol uitgevoerd. AI-strategie werkt normaal.",
  "ai.message.charge.content.fail": "Laadopdracht mislukt (3 autom. pogingen). AI zal het later opnieuw proberen. Handmatige bediening mogelijk na uitschakelen AI-modus.",
  "ai.message.discharge.title.success": "Ontlaadopdracht succesvol uitgevoerd",
  "ai.message.discharge.title.fail": "Ontlaadopdracht mislukt",
  "ai.message.discharge.content.success": "Ontlaadopdracht succesvol uitgevoerd. AI-strategie werkt normaal.",
  "ai.message.discharge.content.fail": "Ontlaadopdracht mislukt (3 autom. pogingen). AI zal het later opnieuw proberen. Handmatige bediening mogelijk na uitschakelen AI-modus.",
  "50901.fault.evCharger1CommunicationAbnormality": "Ev-Lader 1 Communicatie Abnormaal",
  "50901.fault.bmsCanCommunicationAbnormality": "Bms Can-Communicatie Abnormaal",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485-Communicatie Abnormaal",
  "50901.fault.gridMeterTypeError": "Netmeter Typefout",
  "50901.fault.lowDtuVersion": "Dtu-Versie Te Laag",
  "50901.fault.gridMeterCommunicationAbnormality": "Netmeter Communicatie Abnormaal",
  "50901.fault.pvMeterTypeError": "Pv-Meter Typefout",
  "50901.fault.dspPwrCommunicationAbnormality": "Dsp-Voeding Communicatie Abnormaal",
  "50901.fault.evCharger2CommunicationAbnormality": "Ev-Lader 2 Communicatie Abnormaal",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485-Communicatie Abnormaal",
  "50901.fault.dtsCommunicationAbnormality": "Dts-Communicatie Abnormaal",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485-Communicatie Abnormaal",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485-Communicatie Abnormaal",
  "50901.fault.pvMeterCommunicationAbnormality": "Pv-Meter Communicatie Abnormaal",
  "50901.fault.slaveWrongBatteryConnection": "Slave Accu Aansluitfout",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485-Communicatie Abnormaal",
  "50901.fault.dspSafCommunicationAbnormality": "Dsp-Beveiligde Communicatie Abnormaal",
  "50901.fault.sustainedNegativeLoad": "Aanhoudende Negatieve Last",
  "50901.fault.hmidMachineFault": "Hmi-Apparaatfout",
  "50901.fault.evCharger1Fault": "Fout Lader 1",
  "50901.fault.evCharger2Fault": "Fout Lader 2",
  "50901.fault.fanSpeedAbnormality": "Ventilatorsnelheid Abnormaal",
  "50901.fault.masterSlaveCommunicationAbnormality": "Master-Slave Communicatie Abnormaal",
  "50901.fault.batteryCapacityAbnormality": "Accucapaciteit Abnormaal",
  "50901.fault.batteryForceChargeRequest": "Accu Forceer Laadaanvraag",
  "50901.fault.hmidCommunicationAbnormality": "Hmi-Communicatie Abnormaal",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Generator start op dit tijdstip periodiek",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Generator start op dit tijdstip periodiek",
  "50901.fault.loadRelayAfault.0": "Uitschakelen",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Uitschakelen",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Inschakelen",
  "50901.fault.genRelayAfault.0": "Uitschakelen",
  "50901.fault.genRelayAfault.1": "Inschakelen",
  "50901.fault.genRelayBfault.0": "Uitschakelen",
  "50901.fault.genRelayBfault.1": "Inschakelen",
  "50901.fault.kmRelayfault.0": "Uitschakelen",
  "50901.fault.kmRelayfault.1": "Inschakelen",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Inschakelen",
  "50901.fault.loadRelayAfault.1": "Inschakelen",
  "50901.fault.loadRelayBfault.0": "Uitschakelen",
  "50901.fault.loadRelayBfault.1": "Inschakelen",
  "50901.fault.pvRelayAbfault.0": "Uitschakelen",
  "50901.fault.pvRelayAbfault.1": "Inschakelen",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Uitschakelen",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Inschakelen",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Inschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Uitschakelen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Inschakelen",
  "50901.fault.loadRelayAfault": "Storing relais belasting A",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "3,3V voeding defect",
  "50901.fault.pvRelayAbfault": "PV AB relaisstoring",
  "50901.fault.twelveVoltPowerSupplyfault": "12V voeding defect",
  "50901.fault.loadRelayBfault": "Storing relais belasting B",
  "50901.fault.kmRelayfault": "KM-relaisstoring",
  "50901.fault.genRelayBfault": "Generator B relaisstoring",
  "50901.fault.genRelayAfault": "Generator A relaisstoring",
  "50901.fault.fiveVoltPowerSupplyfault": "5V voeding defect",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Starttijd generatortrainingsmodus donderdag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Starttijd generatortrainingsmodus woensdag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Starttijd generatortrainingsmodus vrijdag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Starttijd generatortrainingsmodus zaterdag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Starttijd generatortrainingsmodus dinsdag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Starttijd generatortrainingsmodus zondag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Starttijd generatortrainingsmodus maandag",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.gridMeterTypeError.0": "Uitschakelen",
  "50901.fault.gridMeterTypeError.1": "Inschakelen",
  "50901.fault.lowDtuVersion.0": "Uitschakelen",
  "50901.fault.lowDtuVersion.1": "Inschakelen",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.pvMeterTypeError.0": "Uitschakelen",
  "50901.fault.pvMeterTypeError.1": "Inschakelen",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dtsCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtsCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.slaveWrongBatteryConnection.0": "Uitschakelen",
  "50901.fault.slaveWrongBatteryConnection.1": "Inschakelen",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Inschakelen",
  "50901.fault.dspSafCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.dspSafCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.sustainedNegativeLoad.0": "Uitschakelen",
  "50901.fault.sustainedNegativeLoad.1": "Inschakelen",
  "50901.fault.hmidMachineFault.0": "Uitschakelen",
  "50901.fault.hmidMachineFault.1": "Inschakelen",
  "50901.fault.evCharger1Fault.0": "Uitschakelen",
  "50901.fault.evCharger1Fault.1": "Inschakelen",
  "50901.fault.evCharger2Fault.0": "Uitschakelen",
  "50901.fault.evCharger2Fault.1": "Inschakelen",
  "50901.fault.fanSpeedAbnormality.0": "Uitschakelen",
  "50901.fault.fanSpeedAbnormality.1": "Inschakelen",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.batteryCapacityAbnormality.0": "Uitschakelen",
  "50901.fault.batteryCapacityAbnormality.1": "Inschakelen",
  "50901.fault.batteryForceChargeRequest.0": "Uitschakelen",
  "50901.fault.batteryForceChargeRequest.1": "Inschakelen",
  "50901.fault.hmidCommunicationAbnormality.0": "Uitschakelen",
  "50901.fault.hmidCommunicationAbnormality.1": "Inschakelen",
  "50901.fault.batteryFault": "Accufout",
  "50901.fault.fanFault.0": "Uitschakelen",
  "50901.fault.armCommunicationFault.1": "Inschakelen",
  "50901.fault.batteryFault.0": "Uitschakelen",
  "50901.fault.batteryFault.1": "Inschakelen",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Beschrijving Ev-Lader 1 Communicatie Abnormaal",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Beschrijving Bms Can-Communicatie Abnormaal",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Beschrijving Dtu3 Rs485-Communicatie Abnormaal",
  "50901.fault.gridMeterTypeError.desc": "Beschrijving Netmeter Typefout",
  "50901.fault.lowDtuVersion.desc": "Beschrijving Dtu-Versie Te Laag",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Beschrijving Netmeter Communicatie Abnormaal",
  "50901.fault.pvMeterTypeError.desc": "Beschrijving Pv-Meter Typefout",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Beschrijving Dsp-Voeding Communicatie Abnormaal",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Beschrijving Ev-Lader 2 Communicatie Abnormaal",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Beschrijving Dtu5 Rs485-Communicatie Abnormaal",
  "50901.fault.dtsCommunicationAbnormality.desc": "Beschrijving Dts-Communicatie Abnormaal",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Beschrijving Dtu4 Rs485-Communicatie Abnormaal",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Beschrijving Dtu1 Rs485-Communicatie Abnormaal",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Beschrijving Pv-Meter Communicatie Abnormaal",
  "50901.fault.slaveWrongBatteryConnection.desc": "Beschrijving Slave Accu Aansluitfout",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Beschrijving Dtu2 Rs485-Communicatie Abnormaal",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Beschrijving Dsp-Beveiligde Communicatie Abnormaal",
  "50901.fault.sustainedNegativeLoad.desc": "Beschrijving Aanhoudende Negatieve Last",
  "50901.fault.hmidMachineFault.desc": "Beschrijving Hmi-Apparaatfout",
  "50901.fault.evCharger1Fault.desc": "Beschrijving Fout Lader 1",
  "50901.fault.evCharger2Fault.desc": "Beschrijving Fout Lader 2",
  "50901.fault.fanSpeedAbnormality.desc": "Beschrijving Ventilatorsnelheid Abnormaal",
  "50901.fault.batteryFault.desc": "Beschrijving Accufout",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Beschrijving Master-Slave Communicatie Abnormaal",
  "50901.fault.batteryCapacityAbnormality.desc": "Beschrijving Accucapaciteit Abnormaal",
  "50901.fault.batteryForceChargeRequest.desc": "Beschrijving Accu Forceer Laadaanvraag",
  "50901.fault.hmidCommunicationAbnormality.desc": "Beschrijving Hmi-Communicatie Abnormaal",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.gridMeterTypeError.00": "Uitschakelen",
  "50901.fault.gridMeterTypeError.01": "Inschakelen",
  "50901.fault.lowDtuVersion.00": "Uitschakelen",
  "50901.fault.lowDtuVersion.01": "Inschakelen",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.pvMeterTypeError.00": "Uitschakelen",
  "50901.fault.pvMeterTypeError.01": "Inschakelen",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dtsCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtsCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.slaveWrongBatteryConnection.00": "Uitschakelen",
  "50901.fault.slaveWrongBatteryConnection.01": "Inschakelen",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Inschakelen",
  "50901.fault.dspSafCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.dspSafCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.sustainedNegativeLoad.00": "Uitschakelen",
  "50901.fault.sustainedNegativeLoad.01": "Inschakelen",
  "50901.fault.hmidMachineFault.00": "Uitschakelen",
  "50901.fault.hmidMachineFault.01": "Inschakelen",
  "50901.fault.evCharger1Fault.00": "Uitschakelen",
  "50901.fault.evCharger1Fault.01": "Inschakelen",
  "50901.fault.evCharger2Fault.00": "Uitschakelen",
  "50901.fault.evCharger2Fault.01": "Inschakelen",
  "50901.fault.fanSpeedAbnormality.00": "Uitschakelen",
  "50901.fault.fanSpeedAbnormality.01": "Inschakelen",
  "50901.fault.batteryFault.00": "Uitschakelen",
  "50901.fault.batteryFault.01": "Inschakelen",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Inschakelen",
  "50901.fault.batteryCapacityAbnormality.00": "Uitschakelen",
  "50901.fault.batteryCapacityAbnormality.01": "Inschakelen",
  "50901.fault.batteryForceChargeRequest.00": "Uitschakelen",
  "50901.fault.batteryForceChargeRequest.01": "Inschakelen",
  "50901.fault.hmidCommunicationAbnormality.00": "Uitschakelen",
  "50901.fault.hmidCommunicationAbnormality.01": "Inschakelen",
  "alarm.excDesc.2047494139783155712": "ARM-communicatiestoring",
  "alarm.name.2047494139783155712": "ARM-communicatiestoring",
  "plant.create.type.0": "Installateur",
  "plant.create.type.1": "Eindgebruiker",
  "not.configured": "Niet geconfigureerd",
  "10001.quickset.note1": "1. Zelfverbruiksmodus: De aanbevolen instelling is de zelfverbruiksmodus. Deze modus maximaliseert het gebruik van PV-opwekking voor huishoudelijke elektriciteit of slaat deze op in batterijen voor huishoudelijk gebruik. 2. Terugleverprioriteitsmodus: Deze modus kan prioriteit geven aan het leveren van stroom aan het net wanneer aan de belasting is voldaan, gebruikt in gebieden met subsidie voor teruglevering aan het net. 3. Piekvermogenbegrenzingsmodus: Na het instellen van de zelfverbruiks- of terugleverprioriteitsmodus kan netpiekbegrenzing ook worden geselecteerd wanneer de lokale netbeheerder de elektriciteitsprijs baseert op het piekvermogen van het systeem. Klanten kunnen deze piekbegrenzing inschakelen om het piekverbruiksvermogen op het netaansluitpunt te vermijden. 4. Off-grid-modus: Deze modus wordt alleen gebruikt voor pure off-grid en wordt niet aanbevolen voor standaard opslagsystemen. Houd er rekening mee dat als deze modus wordt ingeschakeld in de netgekoppelde toestand, de werkinglogica van de machine verstoord raakt en \"Off-grid\" wordt weergegeven. 5. Tijdsgebruik: Als u onder de zelfverbruiks-, terugleverprioriteits- of piekvermogenbegrenzingsmodus handmatig het laden en ontladen van de batterij op tijd wilt regelen, gebruik dan de tijdsgebruikschakelaar en de volgende instelpunten. De optie \"Netladen toestaan\" in deze drie modies wordt aanbevolen ingeschakeld (als uitgeschakeld, zal de omvormer de batterij niet geforceerd laden en kan de batterij in slaapstand gaan).",
  "10001.quickset.note2": "1. Zelfverbruikmodus: De aanbevolen instelling is de zelfverbruikmodus. Deze modus maximaliseert het gebruik van zonne-energie voor huishoudelijk verbruik of slaat deze op in batterijen voor later huishoudelijk gebruik.\n2. Prioriteit aan teruglevering: Deze modus geeft prioriteit aan het terugleveren van stroom aan het net wanneer aan de belasting is voldaan. Dit wordt gebruikt in gebieden met subsidie op teruglevering aan het net.\n3. Piekbesparingsmodus: Na het instellen van de zelfverbruikmodus of prioriteit aan teruglevering, kan netpiekbesparing worden geselecteerd wanneer het lokale energiebedrijf de elektriciteitsprijs baseert op het piekverbruik van het systeem. Klanten kunnen deze piekbesparing selecteren om piekverbruik op het aansluitpunt op het net te vermijden.\n4. Off-gridmodus: Deze modus is uitsluitend bedoeld voor pure off-gridsystemen en wordt niet aanbevolen voor standaard opslagsystemen. Let op: als deze modus wordt ingeschakeld terwijl het systeem op het net is aangesloten, raakt de werking van het apparaat verstoord en wordt \"Off-grid\" weergegeven.\n5. Tijdsgebruik: Als u bij zelfverbruikmodus, prioriteit aan teruglevering of piekbesparingsmodus het laden en ontladen van de batterij handmatig op tijd wilt regelen, gebruik dan de tijdsgebruikschakelaar en de volgende instelpunten. Het wordt afgeraden om \"Netladen toestaan\" in deze 3 modi in te schakelen (indien uitgeschakeld, zal de omvormer de batterij niet dwingend opladen en kan de batterij in slaapstand gaan).",
  "10001.quickset.note3": "1. Zelfverbruikmodus: De aanbevolen instelling is de zelfverbruikmodus. Deze modus maximaliseert het gebruik van zonne-energie voor huishoudelijk verbruik of slaat deze op in batterijen voor later huishoudelijk gebruik.\n2. Prioriteit aan teruglevering: Deze modus geeft prioriteit aan het terugleveren van stroom aan het net wanneer aan de belasting is voldaan. Dit wordt gebruikt in gebieden met subsidie op teruglevering aan het net.\n3. Off-gridmodus: Deze modus is uitsluitend bedoeld voor pure off-gridsystemen en wordt niet aanbevolen voor standaard opslagsystemen. Let op: als deze modus wordt ingeschakeld terwijl het systeem op het net is aangesloten, raakt de werking van het apparaat verstoord en wordt \"Off-grid\" weergegeven.\n4. Tijdsgebruik: Als u bij zelfverbruikmodus, prioriteit aan teruglevering of piekbesparingsmodus het laden en ontladen van de batterij handmatig op tijd wilt regelen, gebruik dan de tijdsgebruikschakelaar en de volgende instelpunten. Het wordt afgeraden om \"Netladen toestaan\" in deze 3 modi in te schakelen (indien uitgeschakeld, zal de omvormer de batterij niet dwingend opladen en kan de batterij in slaapstand gaan).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "China",
  "json.50901.workmode.timeSection": "Tijdsdeel",
  "json.device.dryWorking": "Droog werken",
  "device.dryWorking": "Droog werken",
  "51002.ctrl_antireverse": "Anti-terugstroomregeling",
  "51002.ctrl_inverter": "Regeling",
  "51002.null.数据分析_实时监控_PV.tag": "Realtimebewaking_PV",
  "51002.real_time": "Realtimebewaking",
  "51002.real_time.Energy_PV1.desc": "PV1 geaccumuleerde energie",
  "51002.real_time.Energy_PV2.desc": "PV2 geaccumuleerde energie",
  "51002.real_time.Energy_PV3.desc": "PV3 geaccumuleerde energie",
  "51002.real_time.Energy_PV4.desc": "PV4 geaccumuleerde energie",
  "51002.real_time.gridTotalFrequency.desc": "Totale netfrequentie",
  "51002.real_time.inverterTemp.desc": "Omvormertemperatuur",
  "51002.real_time.pvPower.desc": "PV-uitgangsvermogen",
  "51002.real_time.stRelayoN.desc": "Relaisverbindingsstatus",
  "51002.real_time.workStatus.desc": "Bedrijfsstatus",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Netgegevens",
  "51002.real_time.数据分析_实时监控_P.tag": "PV-uitgangsvermogen",
  "51002.real_time.数据分析_实时监控_PV.tag": "PV",
  "51002.real_time.数据分析_实时监控_TP.tag": "Omvormertemperatuur",
  "51002.warning": "Alarm",
  "51002.warning.stAbnorm_Ris.desc": "Isolatie-impedantieafwijking",
  "51002.warning.stErrAccess_EEPROM.desc": "EEPROM-toegangsafwijking",
  "51002.warning.stErrOP_Relay.desc": "Netzijde relaisafwijking",
  "51002.warning.stHW_Fault.desc": "Omvormer hardwarebeveiliging",
  "51002.warning.stOV_Fgrid.desc": "Netzijde overfrequentiebeveiliging",
  "51002.warning.stOV_Temp.desc": "Omvormer overtemperatuurbeveiliging",
  "51002.warning.stOV_Vgrid.desc": "Netzijde overspanningsbeveiliging",
  "51002.warning.stPV1_OV.desc": "PV-ingang 1 overspanning",
  "51002.warning.stPV1_UV.desc": "PV-ingang 1 onderspanning",
  "51002.warning.stPV2_OV.desc": "PV-ingang 2 overspanning",
  "51002.warning.stPV2_UV.desc": "PV-ingang 2 onderspanning",
  "51002.warning.stPV3_OV.desc": "PV-ingang 3 overspanning",
  "51002.warning.stPV3_UV.desc": "PV-ingang 3 onderspanning",
  "51002.warning.stPV4_OV.desc": "PV-ingang 4 overspanning",
  "51002.warning.stPV4_UV.desc": "PV-ingang 4 onderspanning",
  "51002.warning.stUV_Fgrid.desc": "Netzijde onderfrequentiebeveiliging",
  "51002.warning.stUV_Vgrid.desc": "Netzijde onderspanningsbeveiliging",
  "51002..gridtype.desc": "Netnorm",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Uitschakelen",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Inschakelen",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Uitschakelen",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Inschakelen",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Uitschakelen",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Inschakelen",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Uitschakelen",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Inschakelen",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Uitschakelen",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Inschakelen",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Uitschakelen",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Inschakelen",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Uitschakelen",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Inschakelen",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Uitschakelen",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Inschakelen",
  "51002.real_time.stRelayoN.0": "Verbreken",
  "51002.real_time.stRelayoN.1": "Sluiten",
  "51002.real_time.workStatus.0": "Uitschakelen",
  "51002.real_time.workStatus.1": "Inschakelen",
  "51002.warning.stAbnorm_Ris.0": "Normale werking",
  "51002.warning.stAbnorm_Ris.1": "Alarm activeren",
  "51002.warning.stErrAccess_EEPROM.0": "Normale werking",
  "51002.warning.stErrAccess_EEPROM.1": "Alarm activeren",
  "51002.warning.stErrOP_Relay.0": "Normale werking",
  "51002.warning.stErrOP_Relay.1": "Alarm activeren",
  "51002.warning.stHW_Fault.0": "Normale werking",
  "51002.warning.stHW_Fault.1": "Alarm activeren",
  "51002.warning.stOV_Fgrid.0": "Normale werking",
  "51002.warning.stOV_Fgrid.1": "Alarm activeren",
  "51002.warning.stOV_Temp.0": "Normale werking",
  "51002.warning.stOV_Temp.1": "Alarm activeren",
  "51002.warning.stOV_Vgrid.0": "Normale werking",
  "51002.warning.stOV_Vgrid.1": "Alarm activeren",
  "51002.warning.stPV1_OV.0": "Normale werking",
  "51002.warning.stPV1_OV.1": "Alarm activeren",
  "51002.warning.stPV1_UV.0": "Normale werking",
  "51002.warning.stPV1_UV.1": "Alarm activeren",
  "51002.warning.stPV2_OV.0": "Normale werking",
  "51002.warning.stPV2_OV.1": "Alarm activeren",
  "51002.warning.stPV2_UV.0": "Normale werking",
  "51002.warning.stPV2_UV.1": "Alarm activeren",
  "51002.warning.stPV3_OV.0": "Normale werking",
  "51002.warning.stPV3_OV.1": "Alarm activeren",
  "51002.warning.stPV3_UV.0": "Normale werking",
  "51002.warning.stPV3_UV.1": "Alarm activeren",
  "51002.warning.stPV4_OV.0": "Normale werking",
  "51002.warning.stPV4_OV.1": "Alarm activeren",
  "51002.warning.stPV4_UV.0": "Normale werking",
  "51002.warning.stPV4_UV.1": "Alarm activeren",
  "51002.warning.stUV_Fgrid.0": "Normale werking",
  "51002.warning.stUV_Fgrid.1": "Alarm activeren",
  "51002.warning.stUV_Vgrid.0": "Normale werking",
  "51002.warning.stUV_Vgrid.1": "Alarm activeren",
  "51002.ctrl_inverter.ena10mVs1Prot": "Inschakelen 10-minuten niveau 1 netzijde gemiddelde overspanningsbeveiliging",
  "51002.ctrl_inverter.enaINVTR.0": "Uitschakelen",
  "51002.ctrl_inverter.enaINVTR.1": "Inschakelen",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Uitschakelen",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Inschakelen",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "ZelfTest-functieschakelaar systeembeveiligingsinterface",
  "51002.real_time.Energy_PV1": "PV1 cumulatieve energieopwekking",
  "51002.real_time.Energy_PV2": "PV2 cumulatieve energieopwekking",
  "51002.real_time.Energy_PV3": "PV3 cumulatieve energieopwekking",
  "51002.real_time.Energy_PV4": "PV4 cumulatieve energieopwekking",
  "51002.real_time.Firmware_ver": "Firmwareversienummer",
  "51002.real_time.Fn": "Netfrequentie bij netaansluiting",
  "51002.real_time.gridTotalFrequency": "Totale frequentie",
  "51002.real_time.Iacrms": "Netzijde stroom RMS-waarde",
  "51002.real_time.inverterTemp": "Omvormertemperatuur",
  "51002.real_time.Ipv1": "PV1-ingangsstroom",
  "51002.real_time.Ipv2": "PV2-ingangsstroom",
  "51002.real_time.Ipv3": "PV3-ingangsstroom",
  "51002.real_time.Ipv4": "PV4-ingangsstroom",
  "51002.real_time.Ipvmax": "Maximale PV-ingangsstroom",
  "51002.real_time.Irmsmax": "Maximale netaansluitstroom RMS-waarde",
  "51002.real_time.Pn": "Maximaal netaangesloten actief vermogen",
  "51002.real_time.powerGeneration": "Totale energieopwekking",
  "51002.real_time.Powpvmax": "Maximaal PV-ingangsvermogen",
  "51002.real_time.pvPower": "PV-uitgangsvermogen",
  "51002.real_time.stRelayoN": "Relaisverbindingsstatus",
  "51002.real_time.Tempmax": "Maximale bedrijfstemperatuur",
  "51002.real_time.Un": "Netaansluiting nominale spanning RMS-waarde",
  "51002.real_time.Vacrms": "Netzijde spanning RMS-waarde",
  "51002.real_time.Vmpptmax": "Maximale MPPT-spanning",
  "51002.real_time.Vmpptmin": "Minimale MPPT-spanning",
  "51002.real_time.Vpv1": "PV1-ingangsspanning",
  "51002.real_time.Vpv2": "PV2-ingangsspanning",
  "51002.real_time.Vpv3": "PV3-ingangsspanning",
  "51002.real_time.Vpv4": "PV4-ingangsspanning",
  "51002.real_time.workStatus": "Bedrijfsstatus",
  "51002.warning.stAbnorm_Ris": "Isolatie-impedantieafwijking",
  "51002.warning.stErrAccess_EEPROM": "EEPROM-toegangsafwijking",
  "51002.warning.stErrOP_Relay": "Netzijde relaisafwijkingbeveiliging",
  "51002.warning.stHW_Fault": "Omvormer hardwarebeveiliging",
  "51002.warning.stOV_Fgrid": "Netzijde overfrequentiebeveiliging",
  "51002.warning.stOV_Temp": "Omvormer overtemperatuurbeveiliging",
  "51002.warning.stOV_Vgrid": "Netzijde overspanningsbeveiliging",
  "51002.warning.stPV1_OV": "PV-ingang 1 overspanning",
  "51002.warning.stPV1_UV": "PV-ingang 1 onderspanning",
  "51002.warning.stPV2_OV": "PV-ingang 2 overspanning",
  "51002.warning.stPV2_UV": "PV-ingang 2 onderspanning",
  "51002.warning.stPV3_OV": "PV-ingang 3 overspanning",
  "51002.warning.stPV3_UV": "PV-ingang 3 onderspanning",
  "51002.warning.stPV4_OV": "PV-ingang 4 overspanning",
  "51002.warning.stPV4_UV": "PV-ingang 4 onderspanning",
  "51002.warning.stUV_Fgrid": "Netzijde onderfrequentiebeveiliging",
  "51002.warning.stUV_Vgrid": "Netzijde onderspanningsbeveiliging",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Anti-terugvermogen limiet percentage waarde",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Anti-terugstroom inschakelen",
  "51002.ctrl_inverter.enaAPP_PWSET": "Gebruikersvermogensinstelling inschakelen",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Frequentie-offset vermogensregeling inschakelen",
  "51002.ctrl_inverter.enaINVTR": "Omvormer externe aan/uit",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Isolatie-impedantieafwijking beveiliging inschakelen",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "Eerstelijns overspanningsderating inschakelen",
  "51002.ctrl_inverter.enaOVTPWDN": "Overtemperatuurderating inschakelen",
  "51002.ctrl_inverter.enaRestoretodefault": "Standaard beveiligingswaarden en functieschakelaars herstellen",
  "51002.ctrl_inverter.powersetUserApp": "Gebruikersvermogenslimietpercentage",
  "bw_param_ctrl_option_BackupMode": "Noodstroommodus",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Netvoorrang",
  "50657.fault.comStatus": " Communicatiestatus",
  "50657.fault.comStatus.00": " Verbroken",
  "50657.fault.comStatus.01": " Verbonden",
  "50657.realtime.FADE": "Voorwaartse diepdal actieve energie",
  "50657.realtime.FAFE": "Voorwaartse vlakke actieve energie",
  "50657.realtime.FAFE_PSD": "Voorwaartse vlakke actieve energie (vorige facturatiedag)",
  "50657.realtime.FAPE": "Voorwaartse piek actieve energie",
  "50657.realtime.FAPE_PSD": "Voorwaartse piek actieve energie (vorige facturatiedag)",
  "50657.realtime.FAPVE": "Voorwaartse piek-dal actieve ener",
  "50657.realtime.FAPVE_PSD": "Voorwaartse piek-dal actieve energie (vorige facturatiedag)",
  "50657.realtime.FASE": "Voorwaartse scherpe piek actieve energie",
  "50657.realtime.FASE_PSD": "Voorwaartse scherpe piek actieve energie (vorige facturatiedag)",
  "50657.realtime.FAVE": "Voorwaartse dal actieve energie",
  "50657.realtime.FAVE_PSD": "Voorwaartse dal actieve energie (vorige facturatiedag)",
  "50657.realtime.FTAE": "Totale voorwaartse actieve energie",
  "50657.realtime.FTAE_PSD": "Totale voorwaartse actieve energie (vorige facturatiedag",
  "50657.realtime.Fr": "Frequentie",
  "50657.realtime.Ia": "Fase A stroom",
  "50657.realtime.Ib": "Fase B stroom",
  "50657.realtime.Ic": "Fase C stroom",
  "50657.realtime.P": "Totale actief vermogen",
  "50657.realtime.Pa": "Totale actief vermogen fase A",
  "50657.realtime.Pb": "Totale actief vermogen fase B",
  "50657.realtime.Pc": "Totale actief vermogen fase C",
  "50657.realtime.Pf": "Totale vermogensfactor",
  "50657.realtime.Pfa": "Vermogensfactor fase A",
  "50657.realtime.Pfb": "Vermogensfactor fase B",
  "50657.realtime.Pfc": "Vermogensfactor fase C",
  "50657.realtime.Q": "Totale reactief vermogen",
  "50657.realtime.Qa": "Totale reactief vermogen fase A",
  "50657.realtime.Qb": "Totale reactief vermogen fase B",
  "50657.realtime.Qc": "Totale reactief vermogen fase C",
  "50657.realtime.RADE": "Achterwaartse diepdal actieve energie",
  "50657.realtime.RAFE": "Achterwaartse vlakke actieve energie",
  "50657.realtime.RAPE": "Achterwaartse piek actieve energie",
  "50657.realtime.RASE": "Achterwaartse scherpe piek actieve energie",
  "50657.realtime.RAVE": "Achterwaartse dal actieve energie",
  "50657.realtime.RTAE": "Totale achterwaartse actieve energie",
  "50657.realtime.S": "Totale schijnvermogen",
  "50657.realtime.Sa": "Schijnvermogen fase A",
  "50657.realtime.Sb": "Schijnvermogen fase B",
  "50657.realtime.Sc": "Schijnvermogen fase C",
  "50657.realtime.T": "Temperatuur",
  "50657.realtime.Ua": "Fase A spanning",
  "50657.realtime.Uab": "Lijnspanning AB",
  "50657.realtime.Ub": "Fase B spanning",
  "50657.realtime.Ubc": "Lijnspanning BC",
  "50657.realtime.Uc": "Fase C spanning",
  "50657.realtime.Uca": "Lijnspanning CA",
  "50657.realtime.Z0": "Nulreeksimpedantie",
  "50657.realtime.Zf": "Voorwaartse impedantie",
  "bw_param_ctrl_note_DispatchActivepower": "Het instellen van deze gegevens op een positief getal geeft de noodzaak tot ontladen aan, terwijl het instellen op een negatief getal de noodzaak tot laden aangeeft.",
  "bw_param_ctrl_option_PhaseOrderResume": "Resetten",
  "bw_param_ctrl_option_single": "Niet Parallelle Modus (Enkele Modus)",
  "bw_param_ctrl_option_Slave": "Slave in Parallelle Modus",
  "bw_param_ctrl_group_SpecialSetting": "Speciale Instellingen",
  "bw_param_ctrl_option_host": "Master in Parallelle Modus",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Geforceerd Laden/Ontladen",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "Net gebruikt smartmeter met CT + Externe pv gebruikt inline meter",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Net gebruikt inline meter + Geen externe pv",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Tijdsperiode Controle Uitschakelen",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Alleen Laad Tijdsperiode Controle Inschakelen",
  "bw_RTparam_name_TotalApparentPower_Grid": "Meter Schijnbaar Vermogen (Totaal)",
  "bw_param_ctrl_note_DSPReset": "Wanneer de foutinformatie niet overeenkomt met de werkelijke situatie, kan dit worden hersteld door de DSP opnieuw op te starten. Als de APP bijvoorbeeld een foutmelding geeft over het verlies van de aarddraad, maar de aarddraad die op de omvormer is aangesloten niet is losgekoppeld, kan dit worden hersteld door de DSP opnieuw op te starten.",
  "bw_param_ctrl_note_EMSReset": "Wanneer abnormale gegevensverzameling optreedt, reset het EMS om het systeem te herstellen.",
  "bw_param_ctrl_note_FactoryReset": "Als u alle parameters van de omvormer op standaardwaarden wilt instellen, kan deze functie worden gebruikt.",
  "bw_param_ctrl_name_PhaseOrderResume": "Fasevolgorde Hervatten",
  "bw_param_ctrl_option_Grid&PVuseCT": "Net & PV Gebruik CT",
  "bw_param_outage_soc_setting": "SOC-instelling bij stroomonderbreking",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "Veiligheidsnorminstellingen",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Prioriteit voor opbrengst laadstation",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "c": "Nederland",
  "test.chuneng": "chuneng",
  "Manual": "Handmatig",
  "System": "Systeem",
  "Processed": "Verwerkt",
  "Critical": "Kritisch",
  "Urgent": "Dringend",
  "Severe": "Ernstig",
  "General": "Algemeen",
  "Reminder": "Herinnering",
  "welcome": "Welkom terug",
  "device.operatingDataInfoTip": "",
  "dynamic.price.not.exist": "Kan de dynamische stroomprijs niet ophalen",
  "product.pleaseUploadAtLeastOneImage": "",
  "device.importTemplateDownload": "Importsjabloon downloaden",
  "device.snNumber": "SN-nummer",
  "device.enterSnCode": "Voer de SN-code in",
  "device.enterSupplierSN": "Voer de leveranciers-SN in",
  "device.deviceModelLabel": "Apparaatmodel",
  "device.importTip": "Importeer de bijbehorende centralecode, apparaatnaam, SN-nummer en MDM-code",
  "device.importTip2": "Importeer de bijbehorende apparaatnaam, SN-nummer en MDM-code",
  "device.keepAtLeastOneRow": "Houd ten minste één rij over",
  "device.importSuccessWithCount": "{count} apparaatgegevensrecords succesvol geïmporteerd",
  "device.fillAllRequiredFields": "Vul alle verplichte velden volledig in",
  "device.enterPlantCode": "Voer de centralecode in",
  "device.plantCodeLabel": "Centralecode",
  "device.supplierSNLabel": "Leveranciers-SN",
  "device.importTemplateEmpty": "Importsjabloon is leeg",
  "product.syncIotI18n": "Synchroniseer Qingluo IoT-modelitems",
  "product.confirmSyncIotI18n": "Weet u zeker dat u de Qingluo IoT-modelitems wilt synchroniseren?",
  "alarmInfo.time": "Waarschuwingstijd",
  "alarmInfo.duration": "Duur van de waarschuwing",
  "alarmInfo.level": "Waarschuwingsniveau",
  "alarmInfo.triggerCondition": "Triggeringsvoorwaarden",
  "alarmInfo.reason": "Waarschuwingen",
  "alarmInfo.handleTime": "Verwerkingstijd",
  "alarmInfo.handleType": "Type verwerking",
  "plant.plantCategory": "Type centrale",
  "plant.plantCode": "Codering van de centrale",
  "plant.energyStorageCapacity": "Energieopslagcapaciteit",
  "plant.energyStoragePower": "Energieopslagvermogen",
  "plant.gridConnectionMode": "Hoe te surfen",
  "plant.img": "Afbeeldingen van de centrale",
  "device.realTimeMonitoring": "Real-time bewaking",
  "device.propertyName": "Eigenschapsnaam",
  "device.issueCommand": "Afzenden",
  "device.history": "Geschiedenis",
  "device.properName": "Naam",
  "device.daterange": "Aangepast",
  "device.near24h": "Bijna 24 uur",
  "device.date": "Vandaag",
  "device.near3d": "Bijna drie dagen.",
  "device.chartModule": "Grafiekmodule",
  "device.lineChart": "Curvingsdiagram",
  "device.barChart": "Pillardiagram",
  "device.dateRangeDayError": "De datum moet binnen {scope} dagen liggen.",
  "device.SOCHistoryData": "Historische gegevens",
  "device.paramSave": "Uitgeven van parameters",
  "common.deleteTip": "Verwijderen van {scope}?",
  "product.deleteConfirm": "Weet u zeker dat u het product {productName} wilt verwijderen?",
  "upgrade.upgradeSN": "Upgrade van SN",
  "upgrade.datalogSN": "Loggegevens SN",
  "upgrade.upgradeType": "Upgrade Type",
  "upgrade.fileAddress": "Bestandsadres",
  "upgrade.plantTime": "Tijd van de centrale",
  "upgrade.timeUTC8": "Tijd (UTC+8)",
  "upgrade.timeServer": "Tijd (server)",
  "upgrade.content": "Inhoud",
  "upgrade.account": "rekening",
  "upgrade.devicesSN": "Apparatuur SN",
  "firmware.secretType": "Geheime Type",
  "product.ratedPowerOnTheACSide": "Nominaal vermogen aan de AC-zijde (kW)",
  "product.ratedPowerOnTheDCSide": "Nominaal vermogen aan de DC-zijde (kW)",
  "product.energyStoragePower": "Energiespeichervermogen (kW)",
  "product.energyStorageCapacity": "Energiespeicherkapaciteit (kWh)",
  "iot.device.register.failed": "Registratie van IoT-apparaat mislukt",
  "common.title": "Kolomweergave-instellingen",
  "common.fixedLeft": "Links vastzetten",
  "common.fixedRight": "Rechts vastzetten",
  "common.notFixed": "Niet vastzetten",
  "common.unfix": "Vastzetten ongedaan maken",
  "common.resetSuccess": "Kolominstellingen succesvol gereset",
  "alarmInfo.exceptionDesc": "Uitzonderingsbeschrijving",
  "alarmInfo.suggestion": "Verwerkingssuggestie",
  "language.syncIot": "IoT-alarm synchroniseren",
  "language.syncSuccess": "Qingluo IoT-alarmconfiguratie succesvol gesynchroniseerd",
  "plant.saveTimezoneTip": "Het wijzigen van de tijdzone kan leiden tot:\nHiaten of overlappingen in apparaatgegevensgrafieken (duurt enkele uren)\nLokale apparaattaken kunnen in de war raken en mogelijk kort offline zijn",
  "plant.deviceCount": "Aantal geïnstalleerde apparaten",
  "common.rangeErrorTip": "{scope} bereik onjuist, bevestig alstublieft",
  "expired": "verlopen",
  "due.today": "vandaag in orde",
  "sidebar.bulletinBoard": "Installatie",
  "sidebar.dataQuery": "Gegevensquery",
  "plant.electrovalence": "Tariefconfiguratie",
  "plant.energy_management": "Energiebeheer",
  "plant.energy_todayStrategy": "Strategie van vandaag",
  "plant.energy_PeakShavingAndValleyFilling": "Piekshaving & Dalvulling",
  "plant.energy_ValidTime": "Geldige tijd",
  "plant.energy_Charging": "Opladen",
  "plant.energy_Discharging": "Ontladen",
  "plant.energy_SelectStartTime": "Starttijd selecteren",
  "plant.energy_StrategyName": "Strategienaam",
  "plant.energy_StrategyType": "Strategietype",
  "plant.energy_Status": "Status",
  "plant.energy_No": "Nr.",
  "plant.energy_StartDate": "Startdatum",
  "plant.energy_EndDate": "Einddatum",
  "plant.energy_AddStrategy": "Strategie toevoegen",
  "plant.energy_EffectiveTime": "Ingangsdatum",
  "plant.energy_SelectStrategy": "Strategie selecteren",
  "plant.energy_SelectCorrespondingStrategy": "Bijbehorende strategie selecteren",
  "plant.energy_ConfirmAndDeploy": "Bevestigen & implementeren",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Bevestig, sla op en implementeer de strategie.",
  "plant.energy_Cancel": "Annuleren",
  "plant.energy_PleaseConfirmStrategyDeletion": "Bevestig het verwijderen van de strategie.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "Als er geen andere strategie is, voer dan de handmatige strategie uit.",
  "plant.energy_PriorityChargingTime": "Prioritaire laadtijd",
  "plant.energy_PriorityDischargingTime": "Prioritaire ontlaadtijd",
  "plant.energy_PVConsumptionPeriod": "PV-verbruiksperiode",
  "plant.energy_StartTime": "Starttijd",
  "plant.energy_EndTime": "Eindtijd",
  "plant.energy_ChargingPower": "Laadvermogen",
  "plant.energy_DischargingPower": "Ontlaadvermogen",
  "plant.energy_SOCUpperLimit": "SOC bovengrens",
  "plant.energy_SOCLowerLimit": "SOC ondergrens",
  "plant.energy_Action": "Actie",
  "plant.energy_AddTimePeriod": "Tijdsperiode toevoegen",
  "plant.energy_ChargingStatus": "Laadstatus",
  "plant.energy_DischargingPower_kW": "Ontlaadvermogen (kW)",
  "plant.energy_copyStrategy": "Strategie kopiëren",
  "plant.energy_examine": "Bekijken",
  "plant.energy_delete": "Verwijderen",
  "plant.energy_edit": "Bewerken",
  "plant.energy_basicInfo": "Basisinformatie",
  "plant.energy_PriorityChargingDischargingTime": "Prioritaire laad- en ontlaadtijd",
  "plant.energy_PeakShavingAtLeastOne": "Houd minimaal één item aan.",
  "plant.energy_overlapTime": "Periode mogen niet overlappen.",
  "plant.energy_cover24hour": "De periodes moeten 24 uur beslaan.",
  "plant.energy_PleaseConfirmStrategyModification": "Bevestig de strategiewijziging.",
  "plant.energy_Strategy": "Strategie",
  "plant.energy_cutOff_SOC": "Stop-SOC",
  "plant.energy_EditStrategy": "Strategie bewerken",
  "plant.energy_ExamineStrategy": "Strategie bekijken",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Prioritaire laadperiode: Laadt de accu op met overtollig PV-vermogen en (daluren) netstroom om de ingestelde SOC-waarde te bereiken; de accu ontlaadt niet.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Prioritaire ontlaadperiode: Overtollig PV laadt de accu op. Bij onvoldoende PV ontlaadt de accu eerst, tot de ingestelde SOC-limiet; netvoeding is secundair.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) PV-verbruiksperiode: PV-energie heeft prioriteit voor verbruik, daarna voor het opladen van de accu (tot SOC bovengrens), en ten slotte wordt overtollige energie gelimiteerd of gevoed. Bij onvoldoende PV ontlaadt de accu eerst (tot SOC ondergrens), gevolgd door netvoeding.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Andere perioden: PV-energie heeft prioriteit voor verbruik, daarna voor het opladen van de accu (tot SOC bovengrens), en ten slotte wordt overtollige energie gelimiteerd of gevoed. De accu ontlaadt niet.",
  "plant.energy_peak_shaving_valley_filling_explain": "Een strategie die het opladen/ontladen van de accu plant om pieken af te vlakken en dalen op te vullen, om zo een gebalanceerd gebruik van middelen te bereiken.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "PV-energie heeft prioriteit voor verbruik, daarna voor accuverbruik, en ten slotte wordt de PV-productie gelimiteerd om teruglevering te voorkomen. Bij onvoldoende PV ontlaadt de accu eerst, gevolgd door netvoeding.",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "PV-energie heeft prioriteit voor verbruik, daarna voor accuverbruik, en ten slotte wordt overtollige energie gevoed. Bij onvoldoende PV ontlaadt de accu eerst, gevolgd door netvoeding.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Integreert multidimensionale doelen zoals tijdgebonden tarieven, PV-verbruik, piek-dalarbitrage, PV- en belastingsprognoses en vraagbeheer. Onder de voorwaarde van een stabiele microgridwerking berekent en bepaalt een AI-robot intelligent de optimale planning voor energieopslag en regelbare belastingen, waardoor de totale opbrengst van de site wordt gemaximaliseerd.",
  "plant.energy_manual_mode_explain": "Momenteel is er geen dispatch-strategie voor PV en energieopslag. Ga naar de apparaatpagina voor handmatige bediening.",
  "plant.energy_SOCUpperLowerLimits": "SOC Boven- en Ondergrenzen",
  "plant.energy_ChargeDischargePower": "Laad- en Ontlaadvermogen",
  "plant.energy_ChargeDischargeStatus": "Laad- en Ontlaadstatus",
  "system.physicalModels": "Objectmodelbeheer",
  "subtitle.physicalModelsDetail": "Objectmodeldetails",
  "physicalModels.functionSet": "Functieset",
  "physicalModels.minItemsTip": "Minimaal {scope} item(s) moeten behouden blijven",
  "physicalModels.conflictTip": "Conflictperiode: {scope}",
  "physicalModels.name": "Configuratienaam",
  "physicalModels.jsonCorrect": "JSON-indeling is correct",
  "physicalModels.jsonCorrectTip": "JSON-indeling is correct (validatieservice niet verbonden)",
  "physicalModels.jsonInCorrect": "JSON-indeling is onjuist",
  "physicalModels.deleteFailed": "Verwijderen mislukt",
  "physicalModels.loadPreviewFailed": "Laden van voorbeeldconfiguratie mislukt",
  "physicalModels.configEditor": "Configuratie-editor",
  "physicalModels.selectTemplate": "Selecteer vooraf ingestelde sjabloon",
  "physicalModels.jsonConfig": "JSON-configuratie",
  "physicalModels.realTimePreview": "Real-time voorbeeld",
  "physicalModels.checkJsonFormat": "Controleer of het JSON-formaat correct is",
  "physicalModels.readDataStructure": "Gegevensstructuur lezen",
  "physicalModels.userBehaviorData": "Onbewerkte gebruikersgedragsgegevens",
  "physicalModels.actualDataData": "Werkelijk verzonden gegevens",
  "physicalModels.ready": "Gereed",
  "physicalModels.previewConfigLoaded": "Voorbeeldconfiguratie geladen",
  "physicalModels.pasteFromClipboard": "Geplakt van klembord",
  "physicalModels.pasteFromClipboardTip": "Voeg het apparaat-SN toe na het browserpad, bijvoorbeeld:",
  "physicalModels.error": "Fout",
  "plant.createType": "Aangemaakt door",
  "physicalModels.jsonComplete": "JSON-aanvulling",
  "physicalModels.jsonCompleteTip": "Als de JSON is opgeslagen, kan opnieuw aanvullen productieproblemen veroorzaken. Wees voorzichtig.",
  "physicalModels.maxItemsTip": "Maximaal {scope} item(s) zijn toegestaan",
  "physicalModels.Empty": "{scope} mag niet leeg zijn",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "PV-vermogen",
  "plantScreen.singleSiteScree.GridImportPower": "Nettoevoervermogen",
  "plantScreen.singleSiteScree.GridExportPower": "Netterugleververmogen",
  "plantScreen.singleSiteScree.ChargingPower": "Laadvermogen",
  "plantScreen.singleSiteScree.DischargingPower": "Ontlaadvermogen",
  "plantScreen.singleSiteScree.LoadPower": "Belastingsvermogen",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Zelfconsumptiegraad",
  "plantScreen.ChartSet.GenerationPower": "Opwekkingsvermogen",
  "plantScreen.ChartSet.DayAheadForecast": "Day-ahead voorspelling",
  "plantScreen.ChartSet.RealTimeForecast": "Real-time voorspelling",
  "plantScreen.ChartSet.RealTimeScheduling": "Real-time planning",
  "plantScreen.ChartSet.DayAheadScheduling": "Day-ahead planning",
  "plantScreen.PlantInfo": "Installatiegegevens",
  "plantScreen.PhotovoltaicCapacity": "PV-geïnstalleerd vermogen",
  "plantScreen.StorageCapacity": "Batterijcapaciteit",
  "plantScreen.EnergyDispatch": "Energieplanning",
  "plantScreen.SelfGenerationRate": "Zelfopwekkingsgraad",
  "plantScreen.DailyStorageCharging": "Dagelijks geladen energie",
  "plantScreen.DailyStorageDischarging": "Dagelijks ontladen energie",
  "plantScreen.DailyElectricitySold2": "Dagelijks verkochte elektriciteit",
  "plantScreen.ChartSet.Storage": "Energieopslag",
  "plantScreen.ChartSet.Solar": "PV",
  "plantScreen.ChartSet.Load": "Belasting",
  "plantScreen.ChartSet.ChargeDischargePower": "Laad-/ontlaadvermogen",
  "plantScreen.coal": "Steenkool",
  "physicalModels.missingIoTIdTip": "Ontbrekende IoTId of virtualId, controleer alstublieft",
  "org.authCompanyName": "Gecertificeerde bedrijfsnaam",
  "org.serviceAddress": "Serviceadres",
  "org.servicePhone": "Servicetelefoon",
  "org.serviceEmail": "Service-e-mail",
  "org.companyLogo": "Bedrijfslogo",
  "org.websiteUrl": "Website-URL",
  "org.partnerId": "Partner-ID",
  "org.serviceAgreement": "Serviceovereenkomst",
  "org.serviceCertificate": "Certificaat",
  "physicalModels.slotId": "Advertentie-ID",
  "report.dataQuery.maxDevicesWarning": "U kunt maximaal 10 apparaten selecteren",
  "report.dataQuery.maxParamsWarning": "U kunt maximaal 10 parameters selecteren",
  "report.dataQuery.selectDeviceAndParamsFirst": "Selecteer eerst apparaten en parameters",
  "report.dataQuery.chartTitle": "Vergelijking van bedrijfstrends (meerdere reeksen)",
  "report.dataQuery.selectDevice": "Apparaat selecteren",
  "report.dataQuery.placeholderSelectDevice": "Selecteer een apparaat",
  "report.dataQuery.tabByModel": "Op model",
  "report.dataQuery.tabByStation": "Op centrale",
  "report.dataQuery.modelGroupName": "Modelnaam",
  "report.dataQuery.noMore": "Niet meer beschikbaar",
  "report.dataQuery.selectedDevicesFooter": "Geselecteerd {current} / 10 apparaten",
  "report.dataQuery.selectedDevicesShort": "Geselecteerde apparaten",
  "report.dataQuery.clear": "Wissen",
  "report.dataQuery.noDeviceSelectedYet": "Nog geen apparaat geselecteerd",
  "report.dataQuery.selectParamsTitle": "Parameters selecteren (max. 10)",
  "report.dataQuery.maxParamsHint": "Maximaal 10 parameters tegelijk",
  "report.dataQuery.searchParamsPlaceholder": "Parameters zoeken",
  "report.dataQuery.noMatchingParams": "Geen overeenkomende parameters",
  "report.dataQuery.selectDeviceFirst": "Selecteer eerst een apparaat",
  "report.dataQuery.placeholderDeviceSn": "Voer het serienummer van het apparaat in",
  "report.dataQuery.placeholderModelName": "Voer de modelnaam in",
  "report.dataQuery.placeholderStationName": "Voer de naam van de centrale in",
  "report.dataQuery.selectedDevicesSummary": "{count} apparaten geselecteerd",
  "report.dataQuery.startAnalysis": "Analyse starten",
  "report.dataQuery.emptyGuide": "Klik linksboven op «Apparaat selecteren», kies tot 10 apparaten om te analyseren, selecteer vervolgens parameters en een tijdsbereik om te starten",
  "report.dataQuery.noDataHint": "Geen gegevens om weer te geven voor de huidige query. Pas apparaten, parameters of het tijdsbereik aan en probeer opnieuw",
  "report.dataQuery.tableTitle": "Vergelijking van bedrijfsgegevens van meerdere apparaten",
  "report.dataQuery.peakLabel": "Piek:",
  "report.dataQuery.peakColor": "Rood",
  "report.dataQuery.valleyLabel": "Dal:",
  "report.dataQuery.valleyColor": "Blauw",
  "report.dataQuery.timeByDay": "Per dag",
  "report.dataQuery.timeByWeek": "Per week",
  "report.dataQuery.timeByMonth": "Per maand",
  "report.dataQuery.timeByCustom": "Aangepast",
  "report.dataQuery.highlightNone": "Geen markering",
  "report.dataQuery.highlightCol": "Kolomverschillen markeren",
  "report.dataQuery.highlightRow": "Rijverschillen markeren",
  "report.dataQuery.weekdayMon": "ma",
  "report.dataQuery.weekdayTue": "di",
  "report.dataQuery.weekdayWed": "wo",
  "report.dataQuery.weekdayThu": "do",
  "report.dataQuery.weekdayFri": "vr",
  "report.dataQuery.weekdaySat": "za",
  "report.dataQuery.weekdaySun": "zo",
  "report.dataQuery.axisMonthDay": "Dag {n}",
  "plant.statisticalCycle": "Statistische cyclus",
  "plant.stationTopology": "Stationstopologie",
  "plant.topologyConfig": "Topologieconfiguratie",
  "plant.projectName": "Projectnaam",
  "plant.topologyUrl": "Topologie-URL",
  "plant.topologyMap": "Topologiekaart",
  "plant.topologyPlaceholder": "Voer de topologie-URL in",
  "plant.addScopeSuccess": "{scope} succesvol toegevoegd",
  "plant.updateScopeSuccess": "{scope} succesvol bewerkt",
  "plant.topologyUrlFormatError": "Fout in formaat van topologie-URL",
  "report.dataQuery.maxCurvesWarning": "De selectie overschrijdt 10 curves",
  "report.dataQuery.maxCurvesLimitHint": "Er kunnen maximaal 10 curves worden geselecteerd",
  "report.dataQuery.selectParamsHeading": "Parameters selecteren",
  "ota.don.upgrade": "Dongle-upgrade",
  "device.ota.tip.newversion": "De huidige versie is de nieuwste en vereist geen updates.",
  "device.button.cancel": "OK",
  "org.accountNumber": "Gebruikersaccountnummer",
  "org.accountName": "Gebruikersaccountnaam",
  "org.description": "Beschrijving van elektriciteitsgebruiker",
  "org.creditCode": "Sociaal kredietcode",
  "plant.deptName": "Organisatienaam",
  "plant.businessScope": "Industrieel en commercieel",
  "plant.withdrawBusinessDeliveryTip": "Na het intrekken van de levering kunnen {scope} gebruikers deze elektriciteitscentrale niet meer beheren. Wees voorzichtig.",
  "mapScreen.RevenueInfo": "Inkomsteninformatie",
  "mapScreen.MonthlyRevenue": "Maandelijkse inkomsten",
  "mapScreen.YearlyRevenue": "Jaarlijkse inkomsten",
  "mapScreen.CumulativeRevenue": "Cumulatieve inkomsten",
  "mapScreen.CarbonIndicator": "Koolstofindicatoren",
  "mapScreen.StorageInfo": "Opslaginformatie",
  "mapScreen.MonthlyChargeDischarge": "Maandelijkse lading/ontlading",
  "mapScreen.YearlyChargeDischarge": "Jaarlijkse lading/ontlading",
  "mapScreen.TotalPlants": "Aantal centrales",
  "mapScreen.PvInstalledCapacity": "PV geïnstalleerd vermogen",
  "mapScreen.StorageInstalledCapacity": "Opslag geïnstalleerd vermogen",
  "mapScreen.ChargingPileCapacity": "Laadpaal vermogen",
  "mapScreen.Residential": "Residentieel",
  "mapScreen.Commercial": "Commercieel",
  "mapScreen.PlantCount": "Totaal {count} centrales",
  "mapScreen.NewEnergyPower": "Hernieuwbare-energievermogen",
  "mapScreen.GenerationInfo": "Opwekkingsinformatie",
  "mapScreen.MonthlyGeneration": "Maandelijkse opwekking",
  "mapScreen.YearlyGeneration": "Jaarlijkse opwekking",
  "mapScreen.ChargingPileInfo": "Laadpaalinformatie",
  "mapScreen.MonthlyConsumption": "Maandelijks verbruik",
  "mapScreen.YearlyConsumption": "Jaarlijks verbruik",
  "mapScreen.GridConnectionInfo": "Netaansluitingsinformatie",
  "mapScreen.MonthlyPurchaseFeedin": "Maandelijkse inkoop/teruglevering",
  "mapScreen.YearlyPurchaseFeedin": "Jaarlijkse inkoop/teruglevering",
  "mapScreen.CO2Reduction": "CO2-reductie",
  "mapScreen.SaveCoal": "Bespaarde kolen",
  "mapScreen.TreePlanting": "Geplante bomen",
  "mapScreen.SelectCountry": "Selecteer land",
  "mapScreen.BackToPrev": "Terug naar vorige niveau",
  "mapScreen.Revenue": "Inkomsten",
  "mapScreen.ChargeAmount": "Laadhoeveelheid",
  "mapScreen.DischargeAmount": "Ontlaadhoeveelheid",
  "mapScreen.GenerationAmount": "Opwekkingshoeveelheid",
  "mapScreen.ConsumptionAmount": "Verbruikshoeveelheid",
  "mapScreen.PowerGeneration": "Opwekkingsvermogen",
  "mapScreen.PurchaseAmount": "Inkoophoeveelheid",
  "mapScreen.GridSellAmount": "Netteruglevering",
  "mapScreen.title": "Platform voor Energiebeheer",
  "mapScreen.PlantMonthlyRevenue": "Maandelijkse inkomsten",
  "mapScreen.PlantYearlyRevenue": "Jaarlijkse inkomsten",
  "mapScreen.PlantCumulativeRevenue": "Cumulatieve inkomsten",
  "physicalModels.tagGroup": "Tag-groep",
  "device.expandAll": "Alles uitklappen",
  "device.collapseAll": "Alles inklappen",
  "common.deleteSuccess": "Succesvol verwijderd",
  "device.systemTime": "Systeemtijd",
  "device.traceId": "Trace-ID",
  "device.collectorSn": "Collector-SN",
  "device.functionCode": "Functiecode",
  "device.encryptedStr": "Versleuteld bericht",
  "device.decryptedStr": "Ontsleuteld bericht",
  "device.dateRangeErrorScope": "De datumbereik moet binnen {scope} dagen vallen",
  "common.noMore": "Niet meer",
  "common.unloginOrExpired": "Niet ingelogd of login verlopen",
  "common.serverError": "Serverfout, probeer het later opnieuw",
  "common.requestFailed": "Verzoek mislukt",
  "common.backendError": "Fout bij verbinding met backend-interface",
  "common.timeout": "Time-out bij systeeminterface-verzoek",
  "common.systemInterface": "Systeeminterface",
  "common.contains": "Bevat",
  "common.columnSetting": "Kolominstellingen",
  "product.skipShipmentCheck": "Verzendcontrole overslaan",
  "system.mapScreen": "Groot scherm",
  "settingDrawer.title": "Lay-outinstellingen",
  "settingDrawer.themeMode": "Themodus",
  "settingDrawer.darkTheme": "Donker thema",
  "settingDrawer.lightTheme": "Licht thema",
  "settingDrawer.themeColor": "Themakleur",
  "settingDrawer.navMode": "Navigatiemodus",
  "settingDrawer.sideMenu": "Zijmenu-indeling",
  "settingDrawer.topMenu": "Bovenmenu-indeling",
  "settingDrawer.mixMenu": "Gemengde indeling",
  "settingDrawer.columnMenu": "Kolomindeling",
  "settingDrawer.drawerMenu": "Lade-indeling",
  "settingDrawer.layoutSetting": "Lay-outinstellingen",
  "settingDrawer.contentWidth": "Inhoudsbreedte",
  "settingDrawer.contentWidthFixed": "Vast",
  "settingDrawer.contentWidthFluid": "Vloeiend",
  "settingDrawer.fixedHeader": "Vaste koptekst",
  "settingDrawer.fixedSidebar": "Vaste zijbalk",
  "settingDrawer.hideFooter": "Voettekst verbergen",
  "settingDrawer.multiTab": "Multitab-modus",
  "settingDrawer.sidebarColorfulIcon": "Kleurrijke pictogrammen in zijbalk",
  "settingDrawer.searchMode": "Zoekcomponentmodus",
  "settingDrawer.searchModeHeader": "Nieuwe versie",
  "settingDrawer.searchModeForm": "Oude versie",
  "settingDrawer.systemConfig": "Systeemconfiguratie",
  "settingDrawer.systemTitle": "Systeemtitel",
  "settingDrawer.systemCopyright": "Auteursrechtinformatie",
  "settingDrawer.systemVersion": "Systeemversie",
  "settingDrawer.systemVersionPlaceholder": "Versienummer",
  "settingDrawer.tableStyle": "Tabelstijl",
  "settingDrawer.tableSize": "Tabelgrootte",
  "settingDrawer.tableSizeDefault": "Standaard",
  "settingDrawer.tableSizeMiddle": "Gemiddeld",
  "settingDrawer.tableSizeSmall": "Compact",
  "settingDrawer.tableBordered": "Rand weergeven",
  "settingDrawer.tableFixHeader": "Koptekst vastzetten",
  "settingDrawer.tableHeaderBold": "Vetgedrukte koptekst",
  "settingDrawer.tableResizable": "Kolommen aanpasbaar in breedte",
  "settingDrawer.tableRowSelection": "Rijselectie",
  "settingDrawer.tableHeaderBgColor": "Achtergrondkleur koptekst",
  "settingDrawer.tableHeight": "Tabelhoogte",
  "settingDrawer.pageSize": "Paginagrootte",
  "settingDrawer.pageSizeUnit": "Items/pagina",
  "settingDrawer.showTotal": "Totaal weergeven",
  "settingDrawer.showSizeChanger": "Groottekiezer weergeven",
  "settingDrawer.showQuickJumper": "Snelle springer weergeven",
  "settingDrawer.tableStripe": "Zebrastrepen",
  "settingDrawer.tableShowHeader": "Koptekst weergeven",
  "settingDrawer.saveTableConfig": "Tabelconfiguratie opslaan",
  "settingDrawer.reset": "Reset",
  "settingDrawer.configManagement": "Configuratiebeheer",
  "settingDrawer.saveAll": "Alle configuraties opslaan",
  "settingDrawer.exportConfig": "Configuratie exporteren",
  "settingDrawer.importConfig": "Configuratie importeren",
  "settingDrawer.resetAll": "Alle configuraties resetten",
  "settingDrawer.msg.initFail": "Systeeminitialisatie mislukt, vernieuw de pagina en probeer het opnieuw",
  "settingDrawer.msg.configInitFail": "Configuratie-initialisatie mislukt",
  "settingDrawer.msg.themeChangeFail": "Themaschakeling mislukt",
  "settingDrawer.msg.colorChangeFail": "Themakleurwijziging mislukt",
  "settingDrawer.msg.searchModeSwitched": "Geschakeld naar {mode} zoeken",
  "settingDrawer.msg.searchModeSwitchFail": "Wisselen van zoekcomponent mislukt",
  "settingDrawer.msg.navModeSwitched": "Geschakeld naar {mode}-modus",
  "settingDrawer.msg.navSide": "Zijbalk",
  "settingDrawer.msg.navTop": "Bovenmenu",
  "settingDrawer.msg.navMix": "Gemengd",
  "settingDrawer.msg.navModeSwitchFail": "Wijziging van navigatiemodus mislukt",
  "settingDrawer.msg.layoutSwitchFail": "Layoutwisseling mislukt",
  "settingDrawer.msg.settingUpdateFail": "Instellingen bijwerken mislukt",
  "settingDrawer.msg.tableStoreNotInit": "Tabelconfiguratieopslag niet geïnitialiseerd",
  "settingDrawer.msg.tableConfigSaved": "Tabelconfiguratie opgeslagen",
  "settingDrawer.msg.tableConfigSaveFail": "Tabelconfiguratie opslaan mislukt",
  "settingDrawer.msg.tableConfigReset": "Tabelconfiguratie gereset",
  "settingDrawer.msg.tableConfigResetFail": "Tabelconfiguratie resetten mislukt",
  "settingDrawer.msg.systemConfigUpdated": "Systeemconfiguratie bijgewerkt",
  "settingDrawer.msg.systemConfigUpdateFailStore": "Systeemconfiguratie bijwerken mislukt: Store niet geïnitialiseerd",
  "settingDrawer.msg.systemConfigUpdateFail": "Systeemconfiguratie bijwerken mislukt",
  "settingDrawer.msg.allConfigSaved": "Alle configuraties opgeslagen",
  "settingDrawer.msg.configSaveFail": "Configuratie opslaan mislukt",
  "settingDrawer.msg.configExported": "Configuratie geëxporteerd",
  "settingDrawer.msg.configExportFail": "Configuratie exporteren mislukt",
  "settingDrawer.msg.configImportConfirmTitle": "Bevestig import van configuratie",
  "settingDrawer.msg.configImportConfirmContent": "Importeren van configuratie zal alle huidige instellingen overschrijven. Doorgaan?",
  "settingDrawer.msg.confirm": "Bevestigen",
  "settingDrawer.msg.cancel": "Annuleren",
  "settingDrawer.msg.configImported": "Configuratie succesvol geïmporteerd",
  "settingDrawer.msg.configFileInvalid": "Ongeldig configuratiebestandsformaat",
  "settingDrawer.msg.resetConfirmTitle": "Reset bevestigen",
  "settingDrawer.msg.resetConfirmContent": "Reset zal alle aangepaste configuraties wissen en de standaardstatus herstellen. Doorgaan?",
  "settingDrawer.msg.allConfigReset": "Alle configuraties gereset"
}
